import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AdminLoginDto = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type AdminLoginResponse = {
  __typename?: 'AdminLoginResponse';
  accessToken: Scalars['String']['output'];
  adminUser: AdminUser;
  refreshToken: Scalars['String']['output'];
};

/** Admin user permissions */
export enum AdminPermission {
  CreateAppointments = 'CREATE_APPOINTMENTS',
  CreateClinics = 'CREATE_CLINICS',
  CreateDoctors = 'CREATE_DOCTORS',
  CreatePatients = 'CREATE_PATIENTS',
  CreateProviders = 'CREATE_PROVIDERS',
  CreateUsers = 'CREATE_USERS',
  DeleteAppointments = 'DELETE_APPOINTMENTS',
  DeleteClinics = 'DELETE_CLINICS',
  DeleteDoctors = 'DELETE_DOCTORS',
  DeletePatients = 'DELETE_PATIENTS',
  DeleteProviders = 'DELETE_PROVIDERS',
  DeleteUsers = 'DELETE_USERS',
  ManageAdmins = 'MANAGE_ADMINS',
  ManageMyAppointments = 'MANAGE_MY_APPOINTMENTS',
  ManageSettings = 'MANAGE_SETTINGS',
  UpdateAppointments = 'UPDATE_APPOINTMENTS',
  UpdateClinics = 'UPDATE_CLINICS',
  UpdateDoctors = 'UPDATE_DOCTORS',
  UpdatePatients = 'UPDATE_PATIENTS',
  UpdateProviders = 'UPDATE_PROVIDERS',
  UpdateUsers = 'UPDATE_USERS',
  ViewAppointments = 'VIEW_APPOINTMENTS',
  ViewClinics = 'VIEW_CLINICS',
  ViewDoctors = 'VIEW_DOCTORS',
  ViewInsurance = 'VIEW_INSURANCE',
  ViewLogs = 'VIEW_LOGS',
  ViewMyAppointments = 'VIEW_MY_APPOINTMENTS',
  ViewPatients = 'VIEW_PATIENTS',
  ViewProviders = 'VIEW_PROVIDERS',
  ViewSystem = 'VIEW_SYSTEM',
  ViewUsers = 'VIEW_USERS'
}

/** Admin user roles */
export enum AdminRole {
  Admin = 'ADMIN',
  Doctor = 'DOCTOR',
  Manager = 'MANAGER',
  Nurse = 'NURSE',
  Operator = 'OPERATOR',
  SuperAdmin = 'SUPER_ADMIN'
}

export type AdminUser = {
  __typename?: 'AdminUser';
  avatar_url?: Maybe<Scalars['String']['output']>;
  clinic?: Maybe<Clinic>;
  clinic_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  doctor?: Maybe<Doctor>;
  doctor_id?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_super_admin: Scalars['Boolean']['output'];
  last_login_at?: Maybe<Scalars['DateTime']['output']>;
  last_login_ip?: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  permissions: Array<AdminPermission>;
  phone_number?: Maybe<Scalars['String']['output']>;
  role?: Maybe<AdminRole>;
  role_id?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  userRole?: Maybe<AdminUserRole>;
};

export type AdminUserRole = {
  __typename?: 'AdminUserRole';
  adminUsers: Array<AdminUser>;
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_system_role: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<AdminUserRolePermission>;
  updated_at: Scalars['DateTime']['output'];
};

export type AdminUserRolePermission = {
  __typename?: 'AdminUserRolePermission';
  permission: AdminPermission;
  role: AdminUserRole;
  role_id: Scalars['ID']['output'];
};

export type AgoraLinkResponse = {
  __typename?: 'AgoraLinkResponse';
  appId: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  link: Scalars['String']['output'];
  role: Scalars['String']['output'];
  token: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  webLink: Scalars['String']['output'];
};

export type AgoraTokenResponse = {
  __typename?: 'AgoraTokenResponse';
  appId: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  expiresAt: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  token: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type AppUser = {
  __typename?: 'AppUser';
  addresses: Array<AppUserAddress>;
  age?: Maybe<Scalars['Float']['output']>;
  birthdate?: Maybe<Scalars['Date']['output']>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_reason?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  external_user_id?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  ic_number?: Maybe<Scalars['String']['output']>;
  ic_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insuranceCoupons: Array<InsuranceCoupon>;
  is_deleted: Scalars['Boolean']['output'];
  language_preference: Scalars['String']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  patients: Array<Patient>;
  phone_number?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type AppUserAddress = {
  __typename?: 'AppUserAddress';
  app_user: AppUser;
  app_user_id: Scalars['String']['output'];
  block?: Maybe<Scalars['String']['output']>;
  building_name?: Maybe<Scalars['String']['output']>;
  contact_name: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  display_name: Scalars['String']['output'];
  district: Scalars['String']['output'];
  floor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  override_address?: Maybe<Scalars['String']['output']>;
  phone_number: Scalars['String']['output'];
  postal_code: Scalars['String']['output'];
  region: Scalars['String']['output'];
  street_address: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  type: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type Appointment = {
  __typename?: 'Appointment';
  agoraLink?: Maybe<AppointmentAgoraLinkResponse>;
  app_user?: Maybe<AppUser>;
  app_user_id: Scalars['String']['output'];
  appointment_notes?: Maybe<Scalars['String']['output']>;
  booking_source: Scalars['String']['output'];
  cancelled_at?: Maybe<Scalars['DateTime']['output']>;
  cancelled_by?: Maybe<Scalars['String']['output']>;
  cancelled_reason?: Maybe<Scalars['String']['output']>;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  confirmation_sent: Scalars['Boolean']['output'];
  confirmed_at?: Maybe<Scalars['DateTime']['output']>;
  consultation_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  date: Scalars['Date']['output'];
  delivery_address?: Maybe<AppUserAddress>;
  delivery_address_id?: Maybe<Scalars['String']['output']>;
  delivery_note?: Maybe<Scalars['String']['output']>;
  diagnosis?: Maybe<Scalars['String']['output']>;
  doctor_notes?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Float']['output'];
  emergency_contact?: Maybe<Scalars['String']['output']>;
  expected_time_range?: Maybe<Scalars['String']['output']>;
  follow_up_date?: Maybe<Scalars['Date']['output']>;
  follow_up_required: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insuranceClaims?: Maybe<Array<InsuranceClaim>>;
  insuranceCoupon?: Maybe<InsuranceCoupon>;
  insurance_claim_id?: Maybe<Scalars['String']['output']>;
  internal_remark?: Maybe<Scalars['String']['output']>;
  jdExpressOrders?: Maybe<Array<JdExpressOrder>>;
  language_preference?: Maybe<Scalars['String']['output']>;
  medical_history_reviewed: Scalars['Boolean']['output'];
  otherStatuses?: Maybe<Scalars['JSON']['output']>;
  patient?: Maybe<Patient>;
  patient_email?: Maybe<Scalars['String']['output']>;
  patient_feedback?: Maybe<Scalars['String']['output']>;
  patient_id?: Maybe<Scalars['String']['output']>;
  patient_phone?: Maybe<Scalars['String']['output']>;
  patient_rating?: Maybe<Scalars['Float']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_status: Scalars['String']['output'];
  prescription?: Maybe<Scalars['String']['output']>;
  priority: Scalars['String']['output'];
  provider?: Maybe<Provider>;
  provider_id?: Maybe<Scalars['String']['output']>;
  quality_score?: Maybe<Scalars['Float']['output']>;
  questionnaire?: Maybe<Scalars['JSON']['output']>;
  queue_number?: Maybe<Scalars['Int']['output']>;
  reminder_sent: Scalars['Boolean']['output'];
  rescheduled_from?: Maybe<Scalars['String']['output']>;
  rescheduled_to?: Maybe<Scalars['String']['output']>;
  reservation_type: Scalars['String']['output'];
  scheduled_at?: Maybe<Scalars['DateTime']['output']>;
  sfExpressOrders?: Maybe<Array<SfExpressOrder>>;
  special_instructions?: Maybe<Scalars['String']['output']>;
  started_at?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  time: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<Array<Transaction>>;
  treatment_plan?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  vital_signs?: Maybe<VitalSigns>;
};

export type AppointmentAgoraLinkResponse = {
  __typename?: 'AppointmentAgoraLinkResponse';
  appId: Scalars['String']['output'];
  appointmentId: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  link: Scalars['String']['output'];
  role: Scalars['String']['output'];
  token: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  webLink: Scalars['String']['output'];
};

export type AppointmentDocument = {
  __typename?: 'AppointmentDocument';
  appointment?: Maybe<Appointment>;
  appointment_id: Scalars['String']['output'];
  bucket_path: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deletion_reason?: Maybe<Scalars['String']['output']>;
  document_type: Scalars['String']['output'];
  download_url: Scalars['String']['output'];
  file_hash?: Maybe<Scalars['String']['output']>;
  file_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mime_type: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  original_name: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  uploadedByUser: Scalars['String']['output'];
  uploaded_by: Scalars['String']['output'];
  uploaded_by_user?: Maybe<AppUser>;
};

export type AppointmentFilterDto = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchOverrideFilters?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppointmentStats = {
  __typename?: 'AppointmentStats';
  cancelled?: Maybe<Scalars['Int']['output']>;
  completed?: Maybe<Scalars['Int']['output']>;
  confirmed?: Maybe<Scalars['Int']['output']>;
  in_progress?: Maybe<Scalars['Int']['output']>;
  no_show?: Maybe<Scalars['Int']['output']>;
  scheduled?: Maybe<Scalars['Int']['output']>;
};

export type AppointmentSummaryReportItem = {
  __typename?: 'AppointmentSummaryReportItem';
  address?: Maybe<Scalars['String']['output']>;
  appUserPhone?: Maybe<Scalars['String']['output']>;
  appointmentDateTime?: Maybe<Scalars['String']['output']>;
  appointmentId?: Maybe<Scalars['String']['output']>;
  chineseName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  deliveryWaybill?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  doctorName?: Maybe<Scalars['String']['output']>;
  englishName?: Maybe<Scalars['String']['output']>;
  extraMed?: Maybe<Scalars['Boolean']['output']>;
  firstnameEn?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hkid?: Maybe<Scalars['String']['output']>;
  lastnameEn?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  transactionTotal?: Maybe<Scalars['Float']['output']>;
  waybillNo?: Maybe<Scalars['String']['output']>;
};

export type BatchCreateInsuranceCouponsDto = {
  count: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type BindInsurancePolicyDto = {
  name: Scalars['String']['input'];
  policyNumber: Scalars['String']['input'];
};

export type BookingSchedule = {
  __typename?: 'BookingSchedule';
  createdAt: Scalars['String']['output'];
  fromDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  schedule: DaySchedule;
  toDate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ChangePasswordDto = {
  confirm_password: Scalars['String']['input'];
  current_password: Scalars['String']['input'];
  new_password: Scalars['String']['input'];
};

export type ChangePasswordResponseDto = {
  __typename?: 'ChangePasswordResponseDto';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CheckPhoneDto = {
  country_code?: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type CheckPhoneResponseDto = {
  __typename?: 'CheckPhoneResponseDto';
  exists: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  phoneRegisteredWithDifferentTenant: Scalars['Boolean']['output'];
};

export type ClaimBreakdownItem = {
  __typename?: 'ClaimBreakdownItem';
  amount: Scalars['Float']['output'];
  category: CoverageType;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type ClaimsExportItem = {
  __typename?: 'ClaimsExportItem';
  appointmentDate?: Maybe<Scalars['String']['output']>;
  appointmentId: Scalars['String']['output'];
  approvedAmount?: Maybe<Scalars['String']['output']>;
  claimId: Scalars['String']['output'];
  clinicName?: Maybe<Scalars['String']['output']>;
  doctorName?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  policyName?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
};

export type Clinic = {
  __typename?: 'Clinic';
  address: Scalars['String']['output'];
  appointment_booking_enabled?: Maybe<Scalars['Boolean']['output']>;
  building_name?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  district: Scalars['String']['output'];
  district_id?: Maybe<Scalars['Float']['output']>;
  district_name?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emergency_services?: Maybe<Scalars['Boolean']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  facilities?: Maybe<Array<Scalars['String']['output']>>;
  floor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  iframe?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Scalars['String']['output']>>;
  internal_name: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name_en: Scalars['String']['output'];
  name_zh_cn: Scalars['String']['output'];
  name_zh_hk: Scalars['String']['output'];
  online_consultation_enabled?: Maybe<Scalars['Boolean']['output']>;
  operating_hours?: Maybe<WorkingHours>;
  phone_number: Scalars['String']['output'];
  postal_code: Scalars['String']['output'];
  providers: Array<Provider>;
  region: Scalars['String']['output'];
  registration_number?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Scalars['String']['output']>>;
  status: Scalars['String']['output'];
  tags: Array<EntityTag>;
  tenant: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  walk_in_enabled?: Maybe<Scalars['Boolean']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

export type CoverageDetails = {
  __typename?: 'CoverageDetails';
  freeConsultations?: Maybe<Scalars['Int']['output']>;
  freeConsultationsPerMonth?: Maybe<Scalars['Int']['output']>;
  freeConsultationsPerWeek?: Maybe<Scalars['Int']['output']>;
  freeConsultationsPerYear?: Maybe<Scalars['Int']['output']>;
  remainingCoverageAmount?: Maybe<Scalars['JSON']['output']>;
};

export type CoverageItem = {
  __typename?: 'CoverageItem';
  copayment_amount?: Maybe<Scalars['Float']['output']>;
  coverage_amount?: Maybe<Scalars['Float']['output']>;
  coverage_times_per_month?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: CoverageType;
};

/** Coverage type for insurance policies */
export enum CoverageType {
  Consultation = 'CONSULTATION',
  Delivery = 'DELIVERY',
  DiagnosticTest = 'DIAGNOSTIC_TEST',
  LabTest = 'LAB_TEST',
  Medication = 'MEDICATION',
  Other = 'OTHER',
  Surgery = 'SURGERY'
}

export type CreateAddressDto = {
  app_user_id?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['String']['input']>;
  building_name?: InputMaybe<Scalars['String']['input']>;
  contact_name: Scalars['String']['input'];
  display_name: Scalars['String']['input'];
  district: Scalars['String']['input'];
  floor?: InputMaybe<Scalars['String']['input']>;
  is_default?: Scalars['Boolean']['input'];
  override_address?: InputMaybe<Scalars['String']['input']>;
  phone_number: Scalars['String']['input'];
  postal_code?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  street_address: Scalars['String']['input'];
  tenant?: Scalars['String']['input'];
  type: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdminUserDto = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  clinic_id?: InputMaybe<Scalars['String']['input']>;
  doctor_id?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdminUserRoleDto = {
  description: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  permission_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateAppointmentDocumentDto = {
  appointmentId: Scalars['String']['input'];
  bucketPath: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  downloadUrl: Scalars['String']['input'];
  fileHash?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  originalName: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  uploadedBy: Scalars['String']['input'];
};

export type CreateAppointmentDto = {
  app_user_id: Scalars['String']['input'];
  appointment_notes?: InputMaybe<Scalars['String']['input']>;
  booking_source?: Scalars['String']['input'];
  claimBreakdown?: InputMaybe<Scalars['JSON']['input']>;
  consultation_type?: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  delivery_address_id?: InputMaybe<Scalars['String']['input']>;
  delivery_note?: InputMaybe<Scalars['String']['input']>;
  duration?: Scalars['Float']['input'];
  emergency_contact?: InputMaybe<Scalars['String']['input']>;
  expected_time_range?: InputMaybe<Scalars['String']['input']>;
  insurancePolicyId?: InputMaybe<Scalars['String']['input']>;
  insurance_claim_id?: InputMaybe<Scalars['String']['input']>;
  internal_remark?: InputMaybe<Scalars['String']['input']>;
  language_preference?: InputMaybe<Scalars['String']['input']>;
  medical_history_reviewed?: Scalars['Boolean']['input'];
  medications_current?: InputMaybe<Array<Scalars['String']['input']>>;
  patient_email?: InputMaybe<Scalars['String']['input']>;
  patient_id?: InputMaybe<Scalars['String']['input']>;
  patient_phone?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  priority?: Scalars['String']['input'];
  provider_id?: InputMaybe<Scalars['String']['input']>;
  questionnaire?: InputMaybe<Scalars['JSON']['input']>;
  reservation_type?: Scalars['String']['input'];
  special_instructions?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant?: Scalars['String']['input'];
  time: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  transaction_items?: InputMaybe<Array<TransactionItemInput>>;
  type?: Scalars['String']['input'];
  vital_signs?: InputMaybe<VitalSignsInput>;
};

export type CreateAppointmentResponse = {
  __typename?: 'CreateAppointmentResponse';
  appointment: Appointment;
  transaction: Transaction;
};

export type CreateBookingScheduleInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  schedule: DayScheduleInput;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClinicDto = {
  address: Scalars['String']['input'];
  appointment_booking_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  building_name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  district: Scalars['String']['input'];
  district_id?: InputMaybe<Scalars['Float']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  emergency_services?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  facilities?: InputMaybe<Array<Scalars['String']['input']>>;
  floor?: InputMaybe<Scalars['String']['input']>;
  iframe?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  internal_name?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name_en: Scalars['String']['input'];
  name_zh_cn?: InputMaybe<Scalars['String']['input']>;
  name_zh_hk: Scalars['String']['input'];
  online_consultation_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number: Scalars['String']['input'];
  postal_code?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  registration_number?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant?: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  walk_in_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDoctorDto = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  consultation_fee?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience_years?: InputMaybe<Scalars['Float']['input']>;
  first_name_en: Scalars['String']['input'];
  first_name_zh_cn: Scalars['String']['input'];
  first_name_zh_hk: Scalars['String']['input'];
  is_available_for_emergency?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name_en: Scalars['String']['input'];
  last_name_zh_cn: Scalars['String']['input'];
  last_name_zh_hk: Scalars['String']['input'];
  license_number: Scalars['String']['input'];
  max_daily_appointments?: InputMaybe<Scalars['Float']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  qualification?: InputMaybe<Scalars['String']['input']>;
  specialization: Scalars['String']['input'];
  status?: Scalars['String']['input'];
  tenant?: Scalars['String']['input'];
  time_zone?: InputMaybe<Scalars['String']['input']>;
  title?: Scalars['String']['input'];
};

export type CreateInsuranceClaimItemDto = {
  amount: Scalars['String']['input'];
  approvedAmount: Scalars['String']['input'];
  category: Scalars['String']['input'];
  name: Scalars['String']['input'];
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInsuranceClaimResultDto = {
  appointmentId: Scalars['String']['input'];
  claimResultDetails: Scalars['JSON']['input'];
  isActive?: Scalars['Boolean']['input'];
  items?: InputMaybe<Array<CreateInsuranceClaimItemDto>>;
  name: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type CreateInsurancePlanDto = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  payor: Scalars['String']['input'];
  planDetails: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

export type CreateInsurancePolicyDto = {
  appUserId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  payor: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  policyDetails: Scalars['JSON']['input'];
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInsuranceProviderContractDto = {
  isActive?: Scalars['Boolean']['input'];
  planId: Scalars['String']['input'];
};

export type CreateJdExpressOrderFromAppointmentDto = {
  appointmentId: Scalars['String']['input'];
  deliveryContactId?: InputMaybe<Scalars['String']['input']>;
  expressTypeId?: InputMaybe<Scalars['Float']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  overrideAddress?: InputMaybe<Scalars['String']['input']>;
  payMethod?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePatientDto = {
  allergies?: InputMaybe<Array<Scalars['String']['input']>>;
  app_user_id: Scalars['String']['input'];
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  birthdate?: InputMaybe<Scalars['DateTime']['input']>;
  blood_type?: InputMaybe<Scalars['String']['input']>;
  chronic_conditions?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_name?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_phone?: InputMaybe<Scalars['String']['input']>;
  first_name_en: Scalars['String']['input'];
  first_name_zh_hk: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  identity_document_number: Scalars['String']['input'];
  identity_document_type?: InputMaybe<Scalars['String']['input']>;
  language_preferences?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name_en: Scalars['String']['input'];
  last_name_zh_hk: Scalars['String']['input'];
  medications?: InputMaybe<Array<Scalars['String']['input']>>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  relationship_to_owner?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProviderDto = {
  clinic_id: Scalars['String']['input'];
  consultation_fee?: InputMaybe<Scalars['Float']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  doctor_id: Scalars['String']['input'];
  employment_type: Scalars['String']['input'];
  end_date?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  specialization_at_clinic?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  status?: Scalars['String']['input'];
  tenant?: Scalars['String']['input'];
};

export type CreateScheduleDto = {
  advance_booking_days?: InputMaybe<Scalars['Float']['input']>;
  auto_confirm_hours?: InputMaybe<Scalars['Float']['input']>;
  booking_window_end?: InputMaybe<Scalars['String']['input']>;
  booking_window_start?: InputMaybe<Scalars['String']['input']>;
  cancellation_hours?: InputMaybe<Scalars['Float']['input']>;
  confirmation_required?: InputMaybe<Scalars['Boolean']['input']>;
  default_appointment_duration?: InputMaybe<Scalars['Float']['input']>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  insurance_restrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  is_available_for_telemedicine?: InputMaybe<Scalars['Boolean']['input']>;
  is_available_for_walk_in?: InputMaybe<Scalars['Boolean']['input']>;
  max_appointments_per_day?: InputMaybe<Scalars['Float']['input']>;
  max_notice_days?: InputMaybe<Scalars['Float']['input']>;
  min_notice_hours?: InputMaybe<Scalars['Float']['input']>;
  patient_type_restrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  priority?: InputMaybe<Scalars['Float']['input']>;
  reminder_hours?: InputMaybe<Array<Scalars['Float']['input']>>;
  requires_approval?: InputMaybe<Scalars['Boolean']['input']>;
  reschedule_hours?: InputMaybe<Scalars['Float']['input']>;
  same_day_booking?: InputMaybe<Scalars['Boolean']['input']>;
  schedule?: InputMaybe<WorkingHoursInput>;
  send_reminders?: InputMaybe<Scalars['Boolean']['input']>;
  service_restrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: Scalars['String']['input'];
  tenant?: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  to_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateSfExpressOrderFromAppointmentDto = {
  appointmentId: Scalars['String']['input'];
  deliveryContactId?: InputMaybe<Scalars['String']['input']>;
  expressTypeId?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  overrideAddress?: InputMaybe<Scalars['String']['input']>;
  payMethod?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateTransactionDto = {
  amount: Scalars['Float']['input'];
  appointment_id: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  completed_at?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discount_amount?: InputMaybe<Scalars['Float']['input']>;
  final_amount?: InputMaybe<Scalars['Float']['input']>;
  gateway_response?: InputMaybe<Scalars['JSON']['input']>;
  gateway_transaction_id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  original_amount?: InputMaybe<Scalars['Float']['input']>;
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  processed_at?: InputMaybe<Scalars['DateTime']['input']>;
  processing_fee?: InputMaybe<Scalars['Float']['input']>;
  refund_reason?: InputMaybe<Scalars['String']['input']>;
  refunded_at?: InputMaybe<Scalars['DateTime']['input']>;
  refunded_by?: InputMaybe<Scalars['String']['input']>;
  status?: Scalars['String']['input'];
  subcategory?: InputMaybe<Scalars['String']['input']>;
  tax_amount?: InputMaybe<Scalars['Float']['input']>;
  transaction_reference?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type CreateUserDto = {
  birthdate?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  ic_number?: InputMaybe<Scalars['String']['input']>;
  ic_type?: InputMaybe<Scalars['String']['input']>;
  language_preference?: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number: Scalars['String']['input'];
  tenant?: Scalars['String']['input'];
};

export type CreateUserWithVerificationDto = {
  birthdate?: InputMaybe<Scalars['String']['input']>;
  china_life_registration_token?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  ic_number?: InputMaybe<Scalars['String']['input']>;
  ic_type?: InputMaybe<Scalars['String']['input']>;
  language_preference?: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  tenant?: Scalars['String']['input'];
  verification_id: Scalars['String']['input'];
};

export type DaySchedule = {
  __typename?: 'DaySchedule';
  friday: Array<TimeRange>;
  monday: Array<TimeRange>;
  saturday: Array<TimeRange>;
  sunday: Array<TimeRange>;
  thursday: Array<TimeRange>;
  tuesday: Array<TimeRange>;
  wednesday: Array<TimeRange>;
};

export type DayScheduleInput = {
  friday: Array<TimeRangeInput>;
  monday: Array<TimeRangeInput>;
  saturday: Array<TimeRangeInput>;
  sunday: Array<TimeRangeInput>;
  thursday: Array<TimeRangeInput>;
  tuesday: Array<TimeRangeInput>;
  wednesday: Array<TimeRangeInput>;
};

export type DefaultDeliveryContactInfo = {
  __typename?: 'DefaultDeliveryContactInfo';
  address: Scalars['String']['output'];
  contact: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
};

export type DeleteAppointmentDocumentDto = {
  deletionReason?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['String']['input'];
};

export type DeleteDocumentDto = {
  bucketPath: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};

export type DeleteDocumentResponse = {
  __typename?: 'DeleteDocumentResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteJdExpressOrderDto = {
  orderId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteSfExpressOrderDto = {
  orderId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryContact = {
  __typename?: 'DeliveryContact';
  address: Scalars['String']['output'];
  contact: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
};

export type DeliveryContactInput = {
  address: Scalars['String']['input'];
  contact: Scalars['String']['input'];
  id: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
};

export type DeviceInfoInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
};

export type Doctor = {
  __typename?: 'Doctor';
  avatar_url?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  consultation_fee?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  experience_years?: Maybe<Scalars['Float']['output']>;
  first_name_en: Scalars['String']['output'];
  first_name_zh_cn: Scalars['String']['output'];
  first_name_zh_hk: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_available_for_emergency?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  last_name_en: Scalars['String']['output'];
  last_name_zh_cn: Scalars['String']['output'];
  last_name_zh_hk: Scalars['String']['output'];
  license_number: Scalars['String']['output'];
  max_daily_appointments?: Maybe<Scalars['Float']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  providers: Array<Provider>;
  qualification?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  specialization: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<EntityTag>;
  tenant: Scalars['String']['output'];
  time_zone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_reviews?: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['DateTime']['output'];
  working_hours?: Maybe<WorkingHours>;
};

export type Document = {
  __typename?: 'Document';
  appointmentId: Scalars['String']['output'];
  bucketPath: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  originalName: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy: Scalars['String']['output'];
};

export type EntityTag = {
  __typename?: 'EntityTag';
  assigned_by?: Maybe<Scalars['String']['output']>;
  assigned_reason?: Maybe<Scalars['String']['output']>;
  auto_assigned?: Maybe<Scalars['Boolean']['output']>;
  confidence_score?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['DateTime']['output'];
  entity_id: Scalars['String']['output'];
  entity_type: Scalars['String']['output'];
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  is_featured?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tag: Tag;
  tag_id: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ExpressOrdersResponse = {
  __typename?: 'ExpressOrdersResponse';
  jdExpressOrders: Array<JdExpressOrder>;
  sfExpressOrders: Array<SfExpressOrder>;
};

export type FcmToken = {
  __typename?: 'FCMToken';
  createdAt: Scalars['DateTime']['output'];
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type FcmTokenStats = {
  __typename?: 'FCMTokenStats';
  activeTokens: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
  uniqueUsers: Scalars['Int']['output'];
};

export type FeeBreakdownItem = {
  __typename?: 'FeeBreakdownItem';
  amount: Scalars['Float']['output'];
  category: CoverageType;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type GenerateLinkInput = {
  channelName: Scalars['String']['input'];
  role: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};

export type GenerateTokenInput = {
  channelName: Scalars['String']['input'];
  privilegeExpiredTs?: InputMaybe<Scalars['Int']['input']>;
  role: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};

export type GetAppointmentAgoraLinkInput = {
  appointmentId: Scalars['ID']['input'];
};

export type HkDistrictDto = {
  __typename?: 'HKDistrictDto';
  code: Scalars['String']['output'];
  name_en: Scalars['String']['output'];
  name_zh_cn: Scalars['String']['output'];
  name_zh_hk: Scalars['String']['output'];
};

export type HkRegionDto = {
  __typename?: 'HKRegionDto';
  code: Scalars['String']['output'];
  districts: Array<HkDistrictDto>;
  name_en: Scalars['String']['output'];
  name_zh_cn: Scalars['String']['output'];
  name_zh_hk: Scalars['String']['output'];
};

export type HkRegionsAndDistrictsResponseDto = {
  __typename?: 'HKRegionsAndDistrictsResponseDto';
  regions: Array<HkRegionDto>;
};

export type InsuranceClaim = {
  __typename?: 'InsuranceClaim';
  appointmentId: Scalars['String']['output'];
  claimResultDetails: InsuranceClaimResultDetails;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  items: Array<InsuranceClaimItem>;
  policyId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InsuranceClaimItem = {
  __typename?: 'InsuranceClaimItem';
  amount: Scalars['String']['output'];
  approvedAmount: Scalars['String']['output'];
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  insuranceClaimId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  transaction?: Maybe<Transaction>;
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InsuranceClaimResultDetails = {
  __typename?: 'InsuranceClaimResultDetails';
  approved_amount?: Maybe<Scalars['String']['output']>;
  rejected_amount?: Maybe<Scalars['String']['output']>;
  rejected_reason?: Maybe<Scalars['String']['output']>;
};

export type InsuranceCoupon = {
  __typename?: 'InsuranceCoupon';
  appUser?: Maybe<AppUser>;
  appUserId?: Maybe<Scalars['String']['output']>;
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  payor: Scalars['String']['output'];
  plan?: Maybe<InsurancePlan>;
  planId: Scalars['String']['output'];
  policyDetails: InsurancePolicyDetails;
  startDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InsuranceEligibilityCheckResult = {
  __typename?: 'InsuranceEligibilityCheckResult';
  copaymentAmount?: Maybe<Scalars['Float']['output']>;
  coverageDetails: CoverageDetails;
  insurancePolicyId: Scalars['ID']['output'];
};

/** Insurance payor types */
export enum InsurancePayor {
  ChinaLifeVip = 'CHINA_LIFE_VIP',
  Demo = 'DEMO',
  DemoCoupon = 'DEMO_COUPON',
  Townhealth = 'TOWNHEALTH',
  TownhealthPass = 'TOWNHEALTH_PASS'
}

export type InsurancePlan = {
  __typename?: 'InsurancePlan';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  payor: Scalars['String']['output'];
  planDetails: InsurancePolicyDetails;
  type: InsurancePlanType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Insurance plan types */
export enum InsurancePlanType {
  Coupon = 'COUPON',
  Policy = 'POLICY'
}

export type InsurancePolicy = {
  __typename?: 'InsurancePolicy';
  appUser?: Maybe<AppUser>;
  appUserId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  payor: Scalars['String']['output'];
  plan?: Maybe<InsurancePlan>;
  planId: Scalars['String']['output'];
  policyDetails: InsurancePolicyDetails;
  policyNumber?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InsurancePolicyDetails = {
  __typename?: 'InsurancePolicyDetails';
  copayment_amount?: Maybe<Scalars['Int']['output']>;
  coverage?: Maybe<Array<CoverageItem>>;
  free_consultations?: Maybe<Scalars['Int']['output']>;
  free_consultations_per_month?: Maybe<Scalars['Int']['output']>;
  free_consultations_per_week?: Maybe<Scalars['Int']['output']>;
  free_consultations_per_year?: Maybe<Scalars['Int']['output']>;
  townhealth_enrollment_id?: Maybe<Scalars['String']['output']>;
  townhealth_telemed?: Maybe<Scalars['JSON']['output']>;
};

export type InsuranceProviderContract = {
  __typename?: 'InsuranceProviderContract';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  insuranceProviderContractTags: Array<InsuranceProviderContractTag>;
  isActive: Scalars['Boolean']['output'];
  planId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InsuranceProviderContractTag = {
  __typename?: 'InsuranceProviderContractTag';
  createdAt: Scalars['DateTime']['output'];
  insuranceProviderContract: InsuranceProviderContract;
  insuranceProviderContractId: Scalars['String']['output'];
  tag: Tag;
  tagId: Scalars['String']['output'];
};

export type JdExpressAppointmentOrderApiResponseDto = {
  __typename?: 'JdExpressAppointmentOrderApiResponseDto';
  data?: Maybe<JdExpressOrderResponseDto>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMsg?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type JdExpressCloudPrintWaybillApiResponseDto = {
  __typename?: 'JdExpressCloudPrintWaybillApiResponseDto';
  data?: Maybe<JdExpressCloudPrintWaybillResponseDto>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMsg?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type JdExpressCloudPrintWaybillInput = {
  fileType?: InputMaybe<Scalars['String']['input']>;
  sync?: InputMaybe<Scalars['Boolean']['input']>;
  templateCode?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  waybillNo: Scalars['String']['input'];
};

export type JdExpressCloudPrintWaybillResponseDto = {
  __typename?: 'JdExpressCloudPrintWaybillResponseDto';
  fileSize?: Maybe<Scalars['Float']['output']>;
  generateTime?: Maybe<Scalars['String']['output']>;
  pdfBase64?: Maybe<Scalars['String']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  templateCode?: Maybe<Scalars['String']['output']>;
  waybillNo?: Maybe<Scalars['String']['output']>;
};

export type JdExpressOrder = {
  __typename?: 'JdExpressOrder';
  api_error_msg?: Maybe<Scalars['String']['output']>;
  api_result_code?: Maybe<Scalars['String']['output']>;
  appointment?: Maybe<Appointment>;
  appointment_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Date']['output'];
  error_code?: Maybe<Scalars['String']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_retry_at?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  msg_digest: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  partner_id: Scalars['String']['output'];
  processed_at?: Maybe<Scalars['DateTime']['output']>;
  request_data: Scalars['JSON']['output'];
  request_id: Scalars['String']['output'];
  response_data?: Maybe<Scalars['JSON']['output']>;
  retry_count?: Maybe<Scalars['Float']['output']>;
  service_code: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timestamp: Scalars['Float']['output'];
  tracking_number?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Date']['output'];
  waybill_no?: Maybe<Scalars['String']['output']>;
};

export type JdExpressOrderResponseDto = {
  __typename?: 'JdExpressOrderResponseDto';
  destCode?: Maybe<Scalars['String']['output']>;
  estimatedDelivery?: Maybe<Scalars['String']['output']>;
  filterResult?: Maybe<Scalars['Float']['output']>;
  freight?: Maybe<Scalars['Float']['output']>;
  insuranceFee?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  originCode?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  totalFee?: Maybe<Scalars['Float']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  waybillNo?: Maybe<Scalars['String']['output']>;
};

export type JdExpressPrecheckApiResponseDto = {
  __typename?: 'JdExpressPrecheckApiResponseDto';
  data?: Maybe<JdExpressPrecheckResponseDto>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMsg?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type JdExpressPrecheckResponseDto = {
  __typename?: 'JdExpressPrecheckResponseDto';
  calWeight?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deliveryPromiseTime?: Maybe<Scalars['Float']['output']>;
  endStationCode?: Maybe<Scalars['String']['output']>;
  endStationName?: Maybe<Scalars['String']['output']>;
  freightPre?: Maybe<Scalars['Float']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  startStationCode?: Maybe<Scalars['String']['output']>;
  startStationName?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalFreightPre?: Maybe<Scalars['Float']['output']>;
};

export type LoginByPhoneDto = {
  china_life_registration_token?: InputMaybe<Scalars['String']['input']>;
  country_code?: Scalars['String']['input'];
  otp_code: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type LoginByPhonePasswordDto = {
  country_code?: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type LoginDto = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type LoginResponseDto = {
  __typename?: 'LoginResponseDto';
  access_token: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  refresh_token: Scalars['String']['output'];
  refresh_token_expires_at: Scalars['DateTime']['output'];
  success: Scalars['Boolean']['output'];
  user: AppUser;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateAdminUser: AdminUser;
  addTagToClinic: Scalars['Boolean']['output'];
  addTagToDoctor: Scalars['Boolean']['output'];
  addTagToProvider: Scalars['Boolean']['output'];
  adminCreateAddress: AppUserAddress;
  adminDeleteAddress: Scalars['Boolean']['output'];
  adminLogin: AdminLoginResponse;
  adminRefreshToken: AdminLoginResponse;
  adminSetDefaultAddress: AppUserAddress;
  adminUpdateAddress: AppUserAddress;
  authenticateSfExpress: SfExpressAuthResponseDto;
  batchCreateInsuranceCoupons: Array<InsuranceCoupon>;
  bindInsurancePolicy: InsurancePolicy;
  cancelAppointment: Appointment;
  changePassword: ChangePasswordResponseDto;
  cleanupExpiredFCMTokens: Scalars['Float']['output'];
  cloudPrintJdExpressWaybill: JdExpressCloudPrintWaybillApiResponseDto;
  cloudPrintSfExpressWaybill: SfExpressCloudPrintWaybillApiResponseDto;
  cloudPrintSfExpressWaybillsBatch: Array<SfExpressCloudPrintWaybillApiResponseDto>;
  completeAppointment: Appointment;
  confirmAppointment: Appointment;
  createAddress: AppUserAddress;
  createAdminUser: AdminUser;
  createAdminUserRole: AdminUserRole;
  createAppointment: CreateAppointmentResponse;
  createAppointmentDocument: AppointmentDocument;
  createBookingSchedule: BookingSchedule;
  createClinic: Clinic;
  createDoctor: Doctor;
  createInsuranceClaimResult: InsuranceClaim;
  createInsurancePlan: InsurancePlan;
  createInsurancePolicy: InsurancePolicy;
  createInsuranceProviderContract: InsuranceProviderContract;
  createJdExpressOrderFromAppointment: JdExpressAppointmentOrderApiResponseDto;
  createPatient: Patient;
  createProvider: Provider;
  createSchedule: ProviderSchedule;
  createSfExpressOrder: SfExpressOrderApiResponseDto;
  createSfExpressOrderFromAppointment: SfExpressOrderResponse;
  createSimpleSfExpressOrder: SfExpressOrderApiResponseDto;
  createTransaction: Transaction;
  createUser: AppUser;
  createUserWithVerification: LoginResponseDto;
  deactivateAdminUser: AdminUser;
  deactivateAppointmentLinks: Scalars['Boolean']['output'];
  deactivateUserFCMTokens: Scalars['Float']['output'];
  deleteAddress: Scalars['Boolean']['output'];
  deleteAdminUser: Scalars['Boolean']['output'];
  deleteAdminUserRole: Scalars['Boolean']['output'];
  deleteAppointmentDocument: Scalars['Boolean']['output'];
  deleteBookingSchedule: Scalars['Boolean']['output'];
  deleteClinic: Scalars['Boolean']['output'];
  deleteDoctor: Scalars['Boolean']['output'];
  deleteDocument: DeleteDocumentResponse;
  deleteInsuranceClaimResult: Scalars['Boolean']['output'];
  deleteInsurancePlan: Scalars['Boolean']['output'];
  deleteInsurancePolicy: Scalars['Boolean']['output'];
  deleteInsuranceProviderContract: Scalars['Boolean']['output'];
  deleteJdExpressOrder: Scalars['Boolean']['output'];
  deletePatient: Scalars['Boolean']['output'];
  deleteProvider: Scalars['Boolean']['output'];
  deleteSchedule: Scalars['Boolean']['output'];
  deleteSfExpressOrder: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  generateAgoraLink: AgoraLinkResponse;
  generateAgoraToken: AgoraTokenResponse;
  login: LoginResponseDto;
  loginByPhone: LoginResponseDto;
  loginByPhonePassword: LoginResponseDto;
  markAppointmentNoShow: Appointment;
  precheckJdExpressOrderFromAppointment: JdExpressPrecheckApiResponseDto;
  refreshToken: LoginResponseDto;
  registerFCMToken: FcmToken;
  removeAppointment: Appointment;
  removeTagFromClinic: Scalars['Boolean']['output'];
  removeTagFromDoctor: Scalars['Boolean']['output'];
  removeTagFromProvider: Scalars['Boolean']['output'];
  removeTransaction: Transaction;
  requestPasswordReset: PasswordResetResponseDto;
  rescheduleAppointment: Appointment;
  resetAdminUserPassword: ResetPasswordResponseDto;
  resetPassword: PasswordResetResponseDto;
  restoreUser: SoftDeleteUserResponseDto;
  sendOtp: OtpResponseDto;
  sendPushNotification: PushNotificationResult;
  setAllowTeleconsultation: Scalars['Boolean']['output'];
  setAppointmentEntryBufferMinutes: Scalars['Boolean']['output'];
  setBookingDaysLimit: Scalars['Boolean']['output'];
  setBookingOpenHours: Scalars['Boolean']['output'];
  setCloseBufferMinutes: Scalars['Boolean']['output'];
  setDefaultAddress: AppUserAddress;
  setDefaultDeliveryContactInfo: Scalars['Boolean']['output'];
  setDeliveryContactList: Scalars['Boolean']['output'];
  setQueueNumberThreshold: Scalars['Boolean']['output'];
  setRemoteAreaDeliveryExtraFee: Scalars['Boolean']['output'];
  setTeleconsultationFee: Scalars['Boolean']['output'];
  setTeleconsultationLeadTime: Scalars['Boolean']['output'];
  softDeleteUser: SoftDeleteUserResponseDto;
  startAppointment: Appointment;
  unregisterFCMToken: Scalars['Boolean']['output'];
  updateAddress: AppUserAddress;
  updateAdminUser: AdminUser;
  updateAdminUserRole: AdminUserRole;
  updateAppointment: Appointment;
  updateAppointmentDocument: AppointmentDocument;
  updateBookingSchedule: BookingSchedule;
  updateClinic: Clinic;
  updateDoctor: Doctor;
  updateDoctorJoinStatus: Appointment;
  updateDoctorRating: Doctor;
  updateInsuranceClaimResult: InsuranceClaim;
  updateInsurancePlan: InsurancePlan;
  updateInsurancePolicy: InsurancePolicy;
  updateInsuranceProviderContract: InsuranceProviderContract;
  updateJoinStatus: Appointment;
  updateLastWorkedAt: Provider;
  updateOperatorJoinStatus: Appointment;
  updatePatient: Patient;
  updatePatientJoinStatus: Appointment;
  updateProvider: Provider;
  updateSchedule: ProviderSchedule;
  updateTransaction: Transaction;
  verifyOtp: VerificationResponseDto;
  verifyProvider: Provider;
};


export type MutationActivateAdminUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddTagToClinicArgs = {
  clinicId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddTagToDoctorArgs = {
  doctorId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddTagToProviderArgs = {
  providerId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAdminCreateAddressArgs = {
  createAddressDto: CreateAddressDto;
};


export type MutationAdminDeleteAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminLoginArgs = {
  loginDto: AdminLoginDto;
};


export type MutationAdminRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationAdminSetDefaultAddressArgs = {
  addressId: Scalars['ID']['input'];
};


export type MutationAdminUpdateAddressArgs = {
  id: Scalars['ID']['input'];
  updateAddressDto: UpdateAddressDto;
};


export type MutationBatchCreateInsuranceCouponsArgs = {
  batchCreateInsuranceCouponsDto: BatchCreateInsuranceCouponsDto;
};


export type MutationBindInsurancePolicyArgs = {
  bindInsurancePolicyDto: BindInsurancePolicyDto;
};


export type MutationCancelAppointmentArgs = {
  cancelledBy: Scalars['String']['input'];
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationChangePasswordArgs = {
  changePasswordDto: ChangePasswordDto;
};


export type MutationCloudPrintJdExpressWaybillArgs = {
  input: JdExpressCloudPrintWaybillInput;
};


export type MutationCloudPrintSfExpressWaybillArgs = {
  input: SfExpressCloudPrintWaybillInput;
};


export type MutationCloudPrintSfExpressWaybillsBatchArgs = {
  inputs: Array<SfExpressCloudPrintWaybillInput>;
};


export type MutationCompleteAppointmentArgs = {
  completionData?: InputMaybe<UpdateAppointmentDto>;
  id: Scalars['String']['input'];
};


export type MutationConfirmAppointmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationCreateAddressArgs = {
  createAddressDto: CreateAddressDto;
};


export type MutationCreateAdminUserArgs = {
  createAdminUserDto: CreateAdminUserDto;
};


export type MutationCreateAdminUserRoleArgs = {
  createAdminUserRoleDto: CreateAdminUserRoleDto;
};


export type MutationCreateAppointmentArgs = {
  createAppointmentDto: CreateAppointmentDto;
};


export type MutationCreateAppointmentDocumentArgs = {
  input: CreateAppointmentDocumentDto;
};


export type MutationCreateBookingScheduleArgs = {
  input: CreateBookingScheduleInput;
};


export type MutationCreateClinicArgs = {
  createClinicDto: CreateClinicDto;
};


export type MutationCreateDoctorArgs = {
  createDoctorDto: CreateDoctorDto;
};


export type MutationCreateInsuranceClaimResultArgs = {
  createInsuranceClaimResultDto: CreateInsuranceClaimResultDto;
};


export type MutationCreateInsurancePlanArgs = {
  createInsurancePlanDto: CreateInsurancePlanDto;
};


export type MutationCreateInsurancePolicyArgs = {
  createInsurancePolicyDto: CreateInsurancePolicyDto;
};


export type MutationCreateInsuranceProviderContractArgs = {
  createInsuranceProviderContractDto: CreateInsuranceProviderContractDto;
};


export type MutationCreateJdExpressOrderFromAppointmentArgs = {
  input: CreateJdExpressOrderFromAppointmentDto;
};


export type MutationCreatePatientArgs = {
  createPatientDto: CreatePatientDto;
};


export type MutationCreateProviderArgs = {
  createProviderDto: CreateProviderDto;
};


export type MutationCreateScheduleArgs = {
  createScheduleDto: CreateScheduleDto;
  providerId: Scalars['ID']['input'];
};


export type MutationCreateSfExpressOrderArgs = {
  input: SfExpressCreateOrderInput;
};


export type MutationCreateSfExpressOrderFromAppointmentArgs = {
  input: CreateSfExpressOrderFromAppointmentDto;
};


export type MutationCreateSimpleSfExpressOrderArgs = {
  input: SfExpressSimpleOrderInput;
};


export type MutationCreateTransactionArgs = {
  createTransactionDto: CreateTransactionDto;
};


export type MutationCreateUserArgs = {
  createUserDto: CreateUserDto;
};


export type MutationCreateUserWithVerificationArgs = {
  createUserDto: CreateUserWithVerificationDto;
};


export type MutationDeactivateAdminUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeactivateAppointmentLinksArgs = {
  appointmentId: Scalars['String']['input'];
};


export type MutationDeactivateUserFcmTokensArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAdminUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAdminUserRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAppointmentDocumentArgs = {
  input: DeleteAppointmentDocumentDto;
};


export type MutationDeleteBookingScheduleArgs = {
  scheduleId: Scalars['String']['input'];
};


export type MutationDeleteClinicArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDoctorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentArgs = {
  input: DeleteDocumentDto;
};


export type MutationDeleteInsuranceClaimResultArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInsurancePlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInsurancePolicyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInsuranceProviderContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJdExpressOrderArgs = {
  input: DeleteJdExpressOrderDto;
};


export type MutationDeletePatientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProviderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSfExpressOrderArgs = {
  input: DeleteSfExpressOrderDto;
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateAgoraLinkArgs = {
  input: GenerateLinkInput;
};


export type MutationGenerateAgoraTokenArgs = {
  input: GenerateTokenInput;
};


export type MutationLoginArgs = {
  loginDto: LoginDto;
};


export type MutationLoginByPhoneArgs = {
  loginByPhoneDto: LoginByPhoneDto;
};


export type MutationLoginByPhonePasswordArgs = {
  loginByPhonePasswordDto: LoginByPhonePasswordDto;
};


export type MutationMarkAppointmentNoShowArgs = {
  id: Scalars['String']['input'];
};


export type MutationPrecheckJdExpressOrderFromAppointmentArgs = {
  input: CreateJdExpressOrderFromAppointmentDto;
};


export type MutationRefreshTokenArgs = {
  refreshTokenDto: RefreshTokenDto;
};


export type MutationRegisterFcmTokenArgs = {
  deviceInfo: DeviceInfoInput;
  token: Scalars['String']['input'];
};


export type MutationRemoveAppointmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveTagFromClinicArgs = {
  clinicId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationRemoveTagFromDoctorArgs = {
  doctorId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationRemoveTagFromProviderArgs = {
  providerId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationRemoveTransactionArgs = {
  id: Scalars['String']['input'];
};


export type MutationRequestPasswordResetArgs = {
  requestPasswordResetDto: RequestPasswordResetDto;
};


export type MutationRescheduleAppointmentArgs = {
  id: Scalars['String']['input'];
  newDate: Scalars['String']['input'];
  newTime: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetAdminUserPasswordArgs = {
  id: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  resetPasswordDto: ResetPasswordDto;
};


export type MutationRestoreUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendOtpArgs = {
  sendOtpDto: SendOtpDto;
};


export type MutationSendPushNotificationArgs = {
  input: NotificationTargetInput;
};


export type MutationSetAllowTeleconsultationArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetAppointmentEntryBufferMinutesArgs = {
  minutes: Scalars['Float']['input'];
};


export type MutationSetBookingDaysLimitArgs = {
  days: Scalars['Float']['input'];
};


export type MutationSetBookingOpenHoursArgs = {
  hours: Array<Scalars['String']['input']>;
};


export type MutationSetCloseBufferMinutesArgs = {
  minutes: Scalars['Float']['input'];
};


export type MutationSetDefaultAddressArgs = {
  addressId: Scalars['ID']['input'];
};


export type MutationSetDefaultDeliveryContactInfoArgs = {
  address: Scalars['String']['input'];
  contact: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
};


export type MutationSetDeliveryContactListArgs = {
  contacts: Array<DeliveryContactInput>;
};


export type MutationSetQueueNumberThresholdArgs = {
  number: Scalars['Float']['input'];
};


export type MutationSetRemoteAreaDeliveryExtraFeeArgs = {
  fee: Scalars['Float']['input'];
};


export type MutationSetTeleconsultationFeeArgs = {
  fee: Scalars['Float']['input'];
  tenant?: Scalars['String']['input'];
};


export type MutationSetTeleconsultationLeadTimeArgs = {
  hours: Scalars['Float']['input'];
};


export type MutationSoftDeleteUserArgs = {
  softDeleteUserDto: SoftDeleteUserDto;
};


export type MutationStartAppointmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationUnregisterFcmTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateAddressArgs = {
  id: Scalars['ID']['input'];
  updateAddressDto: UpdateAddressDto;
};


export type MutationUpdateAdminUserArgs = {
  id: Scalars['ID']['input'];
  updateAdminUserDto: UpdateAdminUserDto;
};


export type MutationUpdateAdminUserRoleArgs = {
  id: Scalars['ID']['input'];
  updateAdminUserRoleDto: UpdateAdminUserRoleDto;
};


export type MutationUpdateAppointmentArgs = {
  id: Scalars['String']['input'];
  updateAppointmentDto: UpdateAppointmentDto;
};


export type MutationUpdateAppointmentDocumentArgs = {
  id: Scalars['String']['input'];
  input: UpdateAppointmentDocumentDto;
};


export type MutationUpdateBookingScheduleArgs = {
  input: UpdateBookingScheduleInput;
};


export type MutationUpdateClinicArgs = {
  id: Scalars['ID']['input'];
  updateClinicDto: UpdateClinicDto;
};


export type MutationUpdateDoctorArgs = {
  id: Scalars['ID']['input'];
  updateDoctorDto: UpdateDoctorDto;
};


export type MutationUpdateDoctorJoinStatusArgs = {
  id: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdateDoctorRatingArgs = {
  doctorId: Scalars['ID']['input'];
  rating: Scalars['Float']['input'];
};


export type MutationUpdateInsuranceClaimResultArgs = {
  id: Scalars['ID']['input'];
  updateInsuranceClaimResultDto: UpdateInsuranceClaimResultDto;
};


export type MutationUpdateInsurancePlanArgs = {
  id: Scalars['ID']['input'];
  updateInsurancePlanDto: UpdateInsurancePlanDto;
};


export type MutationUpdateInsurancePolicyArgs = {
  id: Scalars['ID']['input'];
  updateInsurancePolicyDto: UpdateInsurancePolicyDto;
};


export type MutationUpdateInsuranceProviderContractArgs = {
  id: Scalars['ID']['input'];
  updateInsuranceProviderContractDto: UpdateInsuranceProviderContractDto;
};


export type MutationUpdateJoinStatusArgs = {
  id: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdateLastWorkedAtArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateOperatorJoinStatusArgs = {
  id: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdatePatientArgs = {
  id: Scalars['ID']['input'];
  updatePatientDto: UpdatePatientDto;
};


export type MutationUpdatePatientJoinStatusArgs = {
  id: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdateProviderArgs = {
  id: Scalars['ID']['input'];
  updateProviderDto: UpdateProviderDto;
};


export type MutationUpdateScheduleArgs = {
  id: Scalars['ID']['input'];
  updateScheduleDto: UpdateScheduleDto;
};


export type MutationUpdateTransactionArgs = {
  id: Scalars['String']['input'];
  updateTransactionDto: UpdateTransactionDto;
};


export type MutationVerifyOtpArgs = {
  verifyOtpDto: VerifyOtpDto;
};


export type MutationVerifyProviderArgs = {
  id: Scalars['ID']['input'];
};

export type NotificationInput = {
  body: Scalars['String']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type NotificationTargetInput = {
  notification: NotificationInput;
  userIds: Array<Scalars['String']['input']>;
};

export type OtpResponseDto = {
  __typename?: 'OtpResponseDto';
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  message: Scalars['String']['output'];
  remaining_attempts?: Maybe<Scalars['Float']['output']>;
  success: Scalars['Boolean']['output'];
  verification_id?: Maybe<Scalars['String']['output']>;
};

export type PaginatedInsurancePoliciesResponse = {
  __typename?: 'PaginatedInsurancePoliciesResponse';
  pagination: PaginationInfo;
  policies: Array<InsurancePolicy>;
};

export type PaginatedPatientsResponse = {
  __typename?: 'PaginatedPatientsResponse';
  pagination: PaginationInfo;
  patients: Array<Patient>;
};

export type PaginatedUsersResponse = {
  __typename?: 'PaginatedUsersResponse';
  pagination: PaginationInfo;
  users: Array<AppUser>;
};

export type PaginationDto = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  hasNext: Scalars['Boolean']['output'];
  hasPrev: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PasswordResetResponseDto = {
  __typename?: 'PasswordResetResponseDto';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Patient = {
  __typename?: 'Patient';
  allergies?: Maybe<Array<Scalars['String']['output']>>;
  app_user: AppUser;
  app_user_id: Scalars['String']['output'];
  avatar_url?: Maybe<Scalars['String']['output']>;
  birthdate?: Maybe<Scalars['Date']['output']>;
  blood_type?: Maybe<Scalars['String']['output']>;
  chronic_conditions?: Maybe<Array<Scalars['String']['output']>>;
  created_at: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emergency_contact_name?: Maybe<Scalars['String']['output']>;
  emergency_contact_phone?: Maybe<Scalars['String']['output']>;
  first_name_en: Scalars['String']['output'];
  first_name_zh_hk: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identity_document_number: Scalars['String']['output'];
  identity_document_type?: Maybe<Scalars['String']['output']>;
  language_preferences?: Maybe<Array<Scalars['String']['output']>>;
  last_name_en: Scalars['String']['output'];
  last_name_zh_hk: Scalars['String']['output'];
  medications?: Maybe<Array<Scalars['String']['output']>>;
  nationality?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  relationship_to_owner?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type Provider = {
  __typename?: 'Provider';
  clinic: Clinic;
  clinic_id: Scalars['String']['output'];
  consultation_fee?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['DateTime']['output'];
  department?: Maybe<Scalars['String']['output']>;
  doctor: Doctor;
  doctor_id: Scalars['String']['output'];
  employment_type: Scalars['String']['output'];
  end_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  last_worked_at?: Maybe<Scalars['DateTime']['output']>;
  providerTags: Array<ProviderTag>;
  role?: Maybe<Scalars['String']['output']>;
  schedules: Array<ProviderSchedule>;
  specialization_at_clinic?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
  tags: Array<Tag>;
  tenant: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  verified_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ProviderSchedule = {
  __typename?: 'ProviderSchedule';
  advance_booking_days?: Maybe<Scalars['Float']['output']>;
  auto_confirm_hours?: Maybe<Scalars['Float']['output']>;
  booking_window_end?: Maybe<Scalars['String']['output']>;
  booking_window_start?: Maybe<Scalars['String']['output']>;
  cancellation_hours?: Maybe<Scalars['Float']['output']>;
  confirmation_required?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  default_appointment_duration?: Maybe<Scalars['Float']['output']>;
  from_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  insurance_restrictions?: Maybe<Array<Scalars['String']['output']>>;
  is_available_for_telemedicine?: Maybe<Scalars['Boolean']['output']>;
  is_available_for_walk_in?: Maybe<Scalars['Boolean']['output']>;
  max_appointments_per_day?: Maybe<Scalars['Float']['output']>;
  max_notice_days?: Maybe<Scalars['Float']['output']>;
  min_notice_hours?: Maybe<Scalars['Float']['output']>;
  patient_type_restrictions?: Maybe<Array<Scalars['String']['output']>>;
  priority?: Maybe<Scalars['Float']['output']>;
  provider: Provider;
  provider_id: Scalars['String']['output'];
  reminder_hours?: Maybe<Array<Scalars['Float']['output']>>;
  requires_approval?: Maybe<Scalars['Boolean']['output']>;
  reschedule_hours?: Maybe<Scalars['Float']['output']>;
  same_day_booking?: Maybe<Scalars['Boolean']['output']>;
  schedule?: Maybe<WorkingHours>;
  send_reminders?: Maybe<Scalars['Boolean']['output']>;
  service_restrictions?: Maybe<Array<Scalars['String']['output']>>;
  status: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  to_date?: Maybe<Scalars['Date']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ProviderTag = {
  __typename?: 'ProviderTag';
  createdAt: Scalars['DateTime']['output'];
  provider: Provider;
  providerId: Scalars['String']['output'];
  tag: Tag;
  tagId: Scalars['String']['output'];
};

export type PushNotificationResult = {
  __typename?: 'PushNotificationResult';
  failed: Scalars['Int']['output'];
  success: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  activeBookingSchedules: Array<BookingSchedule>;
  address: AppUserAddress;
  adminMe: AdminUser;
  adminUser: AdminUser;
  adminUserRole: AdminUserRole;
  adminUserRolePermissions: Array<AdminUserRolePermission>;
  adminUserRoles: Array<AdminUserRole>;
  adminUsers: Array<AdminUser>;
  adminUsersByRole: Array<AdminUser>;
  allPatients: Array<Patient>;
  allTags: Array<Tag>;
  allowTeleconsultation: Scalars['Boolean']['output'];
  appointment: Appointment;
  appointmentDocument: AppointmentDocument;
  appointmentDocumentStats: Scalars['String']['output'];
  appointmentDocuments: Array<AppointmentDocument>;
  appointmentDocumentsByAppointment: Array<AppointmentDocument>;
  appointmentEntryBufferMinutes: Scalars['Float']['output'];
  appointmentStats: AppointmentStats;
  appointmentTransactions: Array<Transaction>;
  appointments: Array<Appointment>;
  appointmentsByDateRange: Array<Appointment>;
  availableAdminPermissions: Array<Scalars['String']['output']>;
  bookingDaysLimit: Scalars['Float']['output'];
  bookingOpenHours: Array<Scalars['String']['output']>;
  bookingSchedules: Array<BookingSchedule>;
  calculateTeleconsultationFees: TeleconsultationFees;
  canManageAppointments: Scalars['Boolean']['output'];
  canManageClinics: Scalars['Boolean']['output'];
  canManageDoctors: Scalars['Boolean']['output'];
  canManagePatients: Scalars['Boolean']['output'];
  canManageProviders: Scalars['Boolean']['output'];
  canManageUsers: Scalars['Boolean']['output'];
  checkPhoneNumber: CheckPhoneResponseDto;
  clinic: Clinic;
  clinics: Array<Clinic>;
  clinicsByDistrict: Array<Clinic>;
  clinicsByFacility: Array<Clinic>;
  clinicsByRegion: Array<Clinic>;
  clinicsByService: Array<Clinic>;
  clinicsByTag: Array<Clinic>;
  clinicsNearby: Array<Clinic>;
  closeBufferMinutes: Scalars['Float']['output'];
  currentSchedule: ProviderSchedule;
  defaultDeliveryContactInfo: DefaultDeliveryContactInfo;
  deliveryContactList: Array<DeliveryContact>;
  doctor: Doctor;
  doctorAppointments: Array<Appointment>;
  doctorSpecializations: Array<Scalars['String']['output']>;
  doctors: Array<Doctor>;
  doctorsByClinic: Array<Doctor>;
  doctorsByLanguage: Array<Doctor>;
  doctorsBySpecialization: Array<Doctor>;
  doctorsByTag: Array<Doctor>;
  document?: Maybe<Document>;
  documentsByAppointment: Array<Document>;
  emergencyClinics: Array<Clinic>;
  emergencyDoctors: Array<Doctor>;
  generateQfpayOutTradeNo: Scalars['String']['output'];
  generateTransactionReference: Scalars['String']['output'];
  getActiveAppointmentLinks: Array<AppointmentAgoraLinkResponse>;
  getAgoraAppId: Scalars['String']['output'];
  getAppointmentAgoraLink: AppointmentAgoraLinkResponse;
  getAppointmentSummaryByDate: Array<AppointmentSummaryReportItem>;
  getAppointmentSummaryByDateRange: Array<AppointmentSummaryReportItem>;
  getClaimsExportByDateRange: Array<ClaimsExportItem>;
  getExpressOrdersForAppointment: ExpressOrdersResponse;
  getFCMTokenStats: FcmTokenStats;
  getJdExpressOrdersForAppointment: Array<JdExpressOrder>;
  getQfpayTransaction: Transaction;
  getQfpayTransactionsByAppUserId: Array<Transaction>;
  getQfpayTransactionsByAppointmentId: Array<Transaction>;
  getSfExpressAccessToken: Scalars['String']['output'];
  getSfExpressOrdersForAppointment: Array<SfExpressOrder>;
  getTodaysAppointmentSummary: Array<AppointmentSummaryReportItem>;
  getUserFCMTokens: Array<FcmToken>;
  hkRegionsAndDistricts: HkRegionsAndDistrictsResponseDto;
  insuranceClaimResult: InsuranceClaim;
  insuranceClaimResults: Array<InsuranceClaim>;
  insuranceClaimResultsByAppointment: Array<InsuranceClaim>;
  insuranceClaimResultsByPolicy: Array<InsuranceClaim>;
  insuranceCouponsByPayor: Array<InsuranceCoupon>;
  insuranceCouponsByPlan: Array<InsuranceCoupon>;
  insuranceEligibilityCheckByCategory?: Maybe<InsuranceEligibilityCheckResult>;
  insuranceEligibilityCheckByCouponCode?: Maybe<InsuranceEligibilityCheckResult>;
  insuranceEligibilityCheckResult?: Maybe<InsuranceEligibilityCheckResult>;
  insurancePayors: Array<InsurancePayor>;
  insurancePlan: InsurancePlan;
  insurancePlanTypes: Array<InsurancePlanType>;
  insurancePlans: Array<InsurancePlan>;
  insurancePlansByPayor: Array<InsurancePlan>;
  insurancePlansByType: Array<InsurancePlan>;
  insurancePolicies: Array<InsurancePolicy>;
  insurancePoliciesByPayor: Array<InsurancePolicy>;
  insurancePoliciesByPayorPaginated: PaginatedInsurancePoliciesResponse;
  insurancePoliciesByPlan: Array<InsurancePolicy>;
  insurancePoliciesByUser: Array<InsurancePolicy>;
  insurancePolicy: InsurancePolicy;
  insuranceProviderContract: InsuranceProviderContract;
  insuranceProviderContracts: Array<InsuranceProviderContract>;
  insuranceProviderContractsByPlan: Array<InsuranceProviderContract>;
  isCouponPayor: Scalars['Boolean']['output'];
  me: AppUser;
  myAppointments: Array<Appointment>;
  myFamilyMembers: Array<Patient>;
  myPatient: Patient;
  myTransactions: Array<Transaction>;
  onlineConsultationClinics: Array<Clinic>;
  patient: Patient;
  patientsByUserId: Array<Patient>;
  patientsPaginated: PaginatedPatientsResponse;
  provider: Provider;
  providerAppointments: Array<Appointment>;
  providers: Array<Provider>;
  providersByClinic: Array<Provider>;
  providersByDoctor: Array<Provider>;
  providersByEmploymentType: Array<Provider>;
  providersByTag: Array<Provider>;
  queueNumberThreshold: Scalars['Float']['output'];
  remoteAreaDeliveryExtraFee: Scalars['Float']['output'];
  schedule: ProviderSchedule;
  scheduleOfDate?: Maybe<BookingSchedule>;
  schedulesByProvider: Array<ProviderSchedule>;
  searchClinics: Array<Clinic>;
  searchDoctors: Array<Doctor>;
  searchSfExpressRoutes: SfExpressRouteSearchResponseDto;
  searchSfExpressRoutesByAppointmentId: SfExpressRouteSearchResponseDto;
  teleconsultationFee: Scalars['Float']['output'];
  teleconsultationLeadTime: Scalars['Float']['output'];
  testSfExpressConnection: Scalars['Boolean']['output'];
  topRatedDoctors: Array<Doctor>;
  transaction: Transaction;
  transactionByReference: Transaction;
  transactionStats: TransactionStats;
  transactions: Array<Transaction>;
  user: AppUser;
  userAddresses: Array<AppUserAddress>;
  userAppointments: Array<Appointment>;
  userByEmail: AppUser;
  users: Array<AppUser>;
  usersPaginated: PaginatedUsersResponse;
  validateAgoraToken: ValidateTokenResponse;
};


export type QueryAddressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminUserRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminUsersByRoleArgs = {
  role: Scalars['String']['input'];
};


export type QueryAppointmentArgs = {
  id: Scalars['String']['input'];
};


export type QueryAppointmentDocumentArgs = {
  id: Scalars['String']['input'];
};


export type QueryAppointmentDocumentStatsArgs = {
  appointmentId: Scalars['String']['input'];
};


export type QueryAppointmentDocumentsArgs = {
  query: QueryAppointmentDocumentsDto;
};


export type QueryAppointmentDocumentsByAppointmentArgs = {
  appointmentId: Scalars['String']['input'];
};


export type QueryAppointmentStatsArgs = {
  providerId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAppointmentTransactionsArgs = {
  appointmentId: Scalars['String']['input'];
};


export type QueryAppointmentsArgs = {
  filter?: InputMaybe<AppointmentFilterDto>;
};


export type QueryAppointmentsByDateRangeArgs = {
  endDate: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryCalculateTeleconsultationFeesArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressId?: InputMaybe<Scalars['String']['input']>;
  tenant?: Scalars['String']['input'];
};


export type QueryCheckPhoneNumberArgs = {
  checkPhoneDto: CheckPhoneDto;
};


export type QueryClinicArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClinicsByDistrictArgs = {
  district: Scalars['String']['input'];
};


export type QueryClinicsByFacilityArgs = {
  facility: Scalars['String']['input'];
};


export type QueryClinicsByRegionArgs = {
  region: Scalars['String']['input'];
};


export type QueryClinicsByServiceArgs = {
  service: Scalars['String']['input'];
};


export type QueryClinicsByTagArgs = {
  tagSlug: Scalars['String']['input'];
};


export type QueryClinicsNearbyArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radiusInKm?: Scalars['Float']['input'];
};


export type QueryCurrentScheduleArgs = {
  providerId: Scalars['ID']['input'];
};


export type QueryDoctorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDoctorAppointmentsArgs = {
  doctorId: Scalars['String']['input'];
  filter?: InputMaybe<AppointmentFilterDto>;
};


export type QueryDoctorSpecializationsArgs = {
  locale?: Scalars['String']['input'];
  tenant?: Scalars['String']['input'];
};


export type QueryDoctorsByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryDoctorsByLanguageArgs = {
  language: Scalars['String']['input'];
};


export type QueryDoctorsBySpecializationArgs = {
  specialization: Scalars['String']['input'];
};


export type QueryDoctorsByTagArgs = {
  tagSlug: Scalars['String']['input'];
};


export type QueryDocumentArgs = {
  bucketPath: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};


export type QueryDocumentsByAppointmentArgs = {
  appointmentId: Scalars['String']['input'];
};


export type QueryGetActiveAppointmentLinksArgs = {
  appointmentId: Scalars['String']['input'];
};


export type QueryGetAppointmentAgoraLinkArgs = {
  input: GetAppointmentAgoraLinkInput;
};


export type QueryGetAppointmentSummaryByDateArgs = {
  date: Scalars['String']['input'];
};


export type QueryGetAppointmentSummaryByDateRangeArgs = {
  endDate: Scalars['String']['input'];
  reportType?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};


export type QueryGetClaimsExportByDateRangeArgs = {
  endDate: Scalars['String']['input'];
  payor: InsurancePayor;
  startDate: Scalars['String']['input'];
};


export type QueryGetExpressOrdersForAppointmentArgs = {
  appointmentId: Scalars['String']['input'];
};


export type QueryGetJdExpressOrdersForAppointmentArgs = {
  appointmentId: Scalars['String']['input'];
};


export type QueryGetQfpayTransactionArgs = {
  outTradeNo: Scalars['String']['input'];
};


export type QueryGetQfpayTransactionsByAppUserIdArgs = {
  appUserId: Scalars['String']['input'];
};


export type QueryGetQfpayTransactionsByAppointmentIdArgs = {
  appointmentId: Scalars['String']['input'];
};


export type QueryGetSfExpressOrdersForAppointmentArgs = {
  appointmentId: Scalars['String']['input'];
};


export type QueryInsuranceClaimResultArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInsuranceClaimResultsByAppointmentArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type QueryInsuranceClaimResultsByPolicyArgs = {
  policyId: Scalars['ID']['input'];
};


export type QueryInsuranceCouponsByPayorArgs = {
  payor: InsurancePayor;
};


export type QueryInsuranceCouponsByPlanArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryInsuranceEligibilityCheckByCategoryArgs = {
  category: CoverageType;
  policyId: Scalars['ID']['input'];
};


export type QueryInsuranceEligibilityCheckByCouponCodeArgs = {
  couponCode: Scalars['String']['input'];
};


export type QueryInsuranceEligibilityCheckResultArgs = {
  policyId: Scalars['ID']['input'];
};


export type QueryInsurancePlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInsurancePlansByPayorArgs = {
  payor: InsurancePayor;
};


export type QueryInsurancePlansByTypeArgs = {
  type: InsurancePlanType;
};


export type QueryInsurancePoliciesByPayorArgs = {
  payor: InsurancePayor;
};


export type QueryInsurancePoliciesByPayorPaginatedArgs = {
  paginationDto: PaginationDto;
  payor: InsurancePayor;
};


export type QueryInsurancePoliciesByPlanArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryInsurancePoliciesByUserArgs = {
  appUserId: Scalars['ID']['input'];
};


export type QueryInsurancePolicyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInsuranceProviderContractArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInsuranceProviderContractsByPlanArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryIsCouponPayorArgs = {
  payor: InsurancePayor;
};


export type QueryMyAppointmentsArgs = {
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPatientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPatientsByUserIdArgs = {
  appUserId: Scalars['ID']['input'];
};


export type QueryPatientsPaginatedArgs = {
  paginationDto: PaginationDto;
};


export type QueryProviderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProviderAppointmentsArgs = {
  providerId: Scalars['String']['input'];
};


export type QueryProvidersByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryProvidersByDoctorArgs = {
  doctorId: Scalars['ID']['input'];
};


export type QueryProvidersByEmploymentTypeArgs = {
  employmentType: Scalars['String']['input'];
};


export type QueryProvidersByTagArgs = {
  tagSlug: Scalars['String']['input'];
};


export type QueryScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScheduleOfDateArgs = {
  date: Scalars['String']['input'];
  tenant?: Scalars['String']['input'];
};


export type QuerySchedulesByProviderArgs = {
  providerId: Scalars['ID']['input'];
};


export type QuerySearchClinicsArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QuerySearchDoctorsArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QuerySearchSfExpressRoutesArgs = {
  input: SfExpressRouteSearchInput;
};


export type QuerySearchSfExpressRoutesByAppointmentIdArgs = {
  appointmentId: Scalars['String']['input'];
};


export type QueryTeleconsultationFeeArgs = {
  tenant?: Scalars['String']['input'];
};


export type QueryTopRatedDoctorsArgs = {
  limit?: Scalars['Float']['input'];
};


export type QueryTransactionArgs = {
  id: Scalars['String']['input'];
};


export type QueryTransactionByReferenceArgs = {
  transactionReference: Scalars['String']['input'];
};


export type QueryTransactionStatsArgs = {
  appUserId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserAppointmentsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersPaginatedArgs = {
  paginationDto: PaginationDto;
};


export type QueryValidateAgoraTokenArgs = {
  input: ValidateTokenInput;
};

export type QueryAppointmentDocumentsDto = {
  appointmentId: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  uploadedAfter?: InputMaybe<Scalars['String']['input']>;
  uploadedBefore?: InputMaybe<Scalars['String']['input']>;
  uploadedBy?: InputMaybe<Scalars['String']['input']>;
};

export type RefreshTokenDto = {
  refresh_token: Scalars['String']['input'];
};

export type RequestPasswordResetDto = {
  country_code: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordDto = {
  confirm_password: Scalars['String']['input'];
  country_code: Scalars['String']['input'];
  new_password: Scalars['String']['input'];
  otp_code: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordResponseDto = {
  __typename?: 'ResetPasswordResponseDto';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SendOtpDto = {
  country_code?: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  tenant?: Scalars['String']['input'];
};

export type SfExpressAddressInput = {
  address: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export type SfExpressAuthResponseDto = {
  __typename?: 'SfExpressAuthResponseDto';
  accessToken?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMsg?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Float']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SfExpressCargoDetailInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type SfExpressCloudPrintWaybillApiResponseDto = {
  __typename?: 'SfExpressCloudPrintWaybillApiResponseDto';
  data?: Maybe<SfExpressCloudPrintWaybillResponseDto>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMsg?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SfExpressCloudPrintWaybillInput = {
  fileType?: InputMaybe<Scalars['String']['input']>;
  sync?: InputMaybe<Scalars['Boolean']['input']>;
  templateCode?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  waybillNo: Scalars['String']['input'];
};

export type SfExpressCloudPrintWaybillResponseDto = {
  __typename?: 'SfExpressCloudPrintWaybillResponseDto';
  fileSize?: Maybe<Scalars['Float']['output']>;
  generateTime?: Maybe<Scalars['String']['output']>;
  pdfBase64?: Maybe<Scalars['String']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  templateCode?: Maybe<Scalars['String']['output']>;
  waybillNo?: Maybe<Scalars['String']['output']>;
};

export type SfExpressContactInfoInput = {
  address: Scalars['String']['input'];
  cargoHeight?: InputMaybe<Scalars['Float']['input']>;
  cargoLength?: InputMaybe<Scalars['Float']['input']>;
  cargoValue?: InputMaybe<Scalars['Float']['input']>;
  cargoWeight?: InputMaybe<Scalars['Float']['input']>;
  cargoWidth?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact: Scalars['String']['input'];
  contactType: Scalars['Float']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  mobile: Scalars['String']['input'];
  postCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  shipperCode?: InputMaybe<Scalars['String']['input']>;
};

export type SfExpressCreateOrderInput = {
  cargoDetails: Array<SfExpressCargoDetailInput>;
  contactInfoList: Array<SfExpressContactInfoInput>;
  custId?: InputMaybe<Scalars['String']['input']>;
  expressType?: InputMaybe<Scalars['Float']['input']>;
  expressTypeId?: InputMaybe<Scalars['Float']['input']>;
  isDocall?: InputMaybe<Scalars['Float']['input']>;
  isGenBarcode?: InputMaybe<Scalars['Float']['input']>;
  isGenEletricPic?: InputMaybe<Scalars['Float']['input']>;
  isReturnRoutelabel?: InputMaybe<Scalars['Float']['input']>;
  isReturnSignBack?: InputMaybe<Scalars['Float']['input']>;
  isReturnTemplate?: InputMaybe<Scalars['Float']['input']>;
  payMethod?: InputMaybe<Scalars['Float']['input']>;
};

export type SfExpressCreateOrderResponseDto = {
  __typename?: 'SfExpressCreateOrderResponseDto';
  destCode?: Maybe<Scalars['String']['output']>;
  estimatedDelivery?: Maybe<Scalars['String']['output']>;
  filterResult?: Maybe<Scalars['Float']['output']>;
  freight?: Maybe<Scalars['Float']['output']>;
  insuranceFee?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  originCode?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  totalFee?: Maybe<Scalars['Float']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  waybillNo?: Maybe<Scalars['String']['output']>;
};

export type SfExpressOrder = {
  __typename?: 'SfExpressOrder';
  api_error_msg?: Maybe<Scalars['String']['output']>;
  api_result_code?: Maybe<Scalars['String']['output']>;
  appointment?: Maybe<Appointment>;
  appointment_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Date']['output'];
  error_code?: Maybe<Scalars['String']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_retry_at?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  msg_digest: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  partner_id: Scalars['String']['output'];
  processed_at?: Maybe<Scalars['DateTime']['output']>;
  request_data: Scalars['JSON']['output'];
  request_id: Scalars['String']['output'];
  response_data?: Maybe<Scalars['JSON']['output']>;
  retry_count?: Maybe<Scalars['Float']['output']>;
  service_code: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timestamp: Scalars['Float']['output'];
  tracking_number?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Date']['output'];
  waybill_no?: Maybe<Scalars['String']['output']>;
};

export type SfExpressOrderApiResponseDto = {
  __typename?: 'SfExpressOrderApiResponseDto';
  data?: Maybe<SfExpressCreateOrderResponseDto>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMsg?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SfExpressOrderData = {
  __typename?: 'SfExpressOrderData';
  destCode?: Maybe<Scalars['String']['output']>;
  estimatedDelivery?: Maybe<Scalars['String']['output']>;
  freight?: Maybe<Scalars['Float']['output']>;
  insuranceFee?: Maybe<Scalars['Float']['output']>;
  orderId: Scalars['String']['output'];
  originCode?: Maybe<Scalars['String']['output']>;
  totalFee?: Maybe<Scalars['Float']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  waybillNo?: Maybe<Scalars['String']['output']>;
};

export type SfExpressOrderResponse = {
  __typename?: 'SfExpressOrderResponse';
  data?: Maybe<SfExpressOrderData>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMsg?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SfExpressPackageInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  weight: Scalars['Float']['input'];
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type SfExpressRouteInfoDto = {
  __typename?: 'SfExpressRouteInfoDto';
  currentLocation?: Maybe<Scalars['String']['output']>;
  currentStatus?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  estimatedDelivery?: Maybe<Scalars['String']['output']>;
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  routeInfo?: Maybe<Scalars['String']['output']>;
  senderAddress?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  waybillNo?: Maybe<Scalars['String']['output']>;
};

export type SfExpressRouteSearchInput = {
  appointmentId: Scalars['String']['input'];
  searchType?: InputMaybe<Scalars['Float']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
};

export type SfExpressRouteSearchResponseDto = {
  __typename?: 'SfExpressRouteSearchResponseDto';
  data?: Maybe<SfExpressRouteInfoDto>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMsg?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SfExpressSimpleOrderInput = {
  expressTypeId?: InputMaybe<Scalars['Float']['input']>;
  package: SfExpressPackageInput;
  payMethod?: InputMaybe<Scalars['Float']['input']>;
  receiver: SfExpressAddressInput;
  sender: SfExpressAddressInput;
};

export type SoftDeleteUserDto = {
  reason: Scalars['String']['input'];
};

export type SoftDeleteUserResponseDto = {
  __typename?: 'SoftDeleteUserResponseDto';
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  category: Scalars['String']['output'];
  color: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name: Scalars['String']['output'];
  entity_tags: Array<EntityTag>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insuranceProviderContractTags: Array<InsuranceProviderContractTag>;
  is_system_tag: Scalars['Boolean']['output'];
  last_used_at?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  providerTags: Array<ProviderTag>;
  slug: Scalars['String']['output'];
  sort_order?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  usage_count: Scalars['Float']['output'];
};

export type TeleconsultationFees = {
  __typename?: 'TeleconsultationFees';
  baseFee: Scalars['Float']['output'];
  claimBreakdown?: Maybe<Array<ClaimBreakdownItem>>;
  feeBreakdown: Array<FeeBreakdownItem>;
  insuranceCoverageAmount?: Maybe<Scalars['Float']['output']>;
  insurancePolicyId?: Maybe<Scalars['String']['output']>;
  isRemoteArea: Scalars['Boolean']['output'];
  patientPayAmount?: Maybe<Scalars['Float']['output']>;
  remoteAreaFee: Scalars['Float']['output'];
  totalFee: Scalars['Float']['output'];
};

export type TimeRange = {
  __typename?: 'TimeRange';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type TimeRangeInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type TimeSlot = {
  __typename?: 'TimeSlot';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type TimeSlotInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Scalars['Float']['output'];
  app_user: AppUser;
  app_user_id: Scalars['String']['output'];
  appointment: Appointment;
  appointment_id: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  final_amount?: Maybe<Scalars['Float']['output']>;
  gateway_response?: Maybe<Scalars['JSON']['output']>;
  gateway_transaction_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<TransactionItem>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  original_amount: Scalars['Float']['output'];
  original_transaction_id?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  processed_at?: Maybe<Scalars['DateTime']['output']>;
  processing_fee?: Maybe<Scalars['Float']['output']>;
  refund_reason?: Maybe<Scalars['String']['output']>;
  refunded_at?: Maybe<Scalars['DateTime']['output']>;
  refunded_by?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  subcategory?: Maybe<Scalars['String']['output']>;
  tax_amount?: Maybe<Scalars['Float']['output']>;
  tenant: Scalars['String']['output'];
  transaction_reference: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type TransactionItem = {
  __typename?: 'TransactionItem';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['JSON']['output']>;
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
};

export type TransactionItemInput = {
  category: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['JSON']['input']>;
  price: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
};

export type TransactionStats = {
  __typename?: 'TransactionStats';
  averageAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalRefunds: Scalars['Float']['output'];
  totalTransactions: Scalars['Int']['output'];
};

export type UpdateAddressDto = {
  block?: InputMaybe<Scalars['String']['input']>;
  building_name?: InputMaybe<Scalars['String']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  override_address?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdminUserDto = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  clinic_id?: InputMaybe<Scalars['String']['input']>;
  doctor_id?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdminUserRoleDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permission_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateAppointmentDocumentDto = {
  deletionReason?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppointmentDto = {
  app_user_id?: InputMaybe<Scalars['String']['input']>;
  appointment_notes?: InputMaybe<Scalars['String']['input']>;
  booking_source?: InputMaybe<Scalars['String']['input']>;
  cancelled_at?: InputMaybe<Scalars['String']['input']>;
  cancelled_by?: InputMaybe<Scalars['String']['input']>;
  cancelled_reason?: InputMaybe<Scalars['String']['input']>;
  claimBreakdown?: InputMaybe<Scalars['JSON']['input']>;
  completed_at?: InputMaybe<Scalars['String']['input']>;
  confirmed_at?: InputMaybe<Scalars['String']['input']>;
  consultation_type?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  delivery_address_id?: InputMaybe<Scalars['String']['input']>;
  delivery_note?: InputMaybe<Scalars['String']['input']>;
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  doctor_notes?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  emergency_contact?: InputMaybe<Scalars['String']['input']>;
  expected_time_range?: InputMaybe<Scalars['String']['input']>;
  follow_up_date?: InputMaybe<Scalars['String']['input']>;
  insurancePolicyId?: InputMaybe<Scalars['String']['input']>;
  insurance_claim_id?: InputMaybe<Scalars['String']['input']>;
  internal_remark?: InputMaybe<Scalars['String']['input']>;
  language_preference?: InputMaybe<Scalars['String']['input']>;
  medical_history_reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  medications_current?: InputMaybe<Array<Scalars['String']['input']>>;
  patient_email?: InputMaybe<Scalars['String']['input']>;
  patient_feedback?: InputMaybe<Scalars['String']['input']>;
  patient_id?: InputMaybe<Scalars['String']['input']>;
  patient_phone?: InputMaybe<Scalars['String']['input']>;
  patient_rating?: InputMaybe<Scalars['Float']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  prescription?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['String']['input']>;
  quality_score?: InputMaybe<Scalars['Float']['input']>;
  questionnaire?: InputMaybe<Scalars['JSON']['input']>;
  rescheduled_from?: InputMaybe<Scalars['String']['input']>;
  rescheduled_to?: InputMaybe<Scalars['String']['input']>;
  reservation_type?: InputMaybe<Scalars['String']['input']>;
  scheduled_at?: InputMaybe<Scalars['String']['input']>;
  special_instructions?: InputMaybe<Scalars['String']['input']>;
  started_at?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  transaction_items?: InputMaybe<Array<TransactionItemInput>>;
  treatment_plan?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vital_signs?: InputMaybe<VitalSignsInput>;
};

export type UpdateBookingScheduleInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<DayScheduleInput>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClinicDto = {
  address?: InputMaybe<Scalars['String']['input']>;
  appointment_booking_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  building_name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  district_id?: InputMaybe<Scalars['Float']['input']>;
  district_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergency_services?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  facilities?: InputMaybe<Array<Scalars['String']['input']>>;
  floor?: InputMaybe<Scalars['String']['input']>;
  iframe?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  internal_name?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_zh_cn?: InputMaybe<Scalars['String']['input']>;
  name_zh_hk?: InputMaybe<Scalars['String']['input']>;
  online_consultation_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  registration_number?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  walk_in_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDoctorDto = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  consultation_fee?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience_years?: InputMaybe<Scalars['Float']['input']>;
  first_name_en?: InputMaybe<Scalars['String']['input']>;
  first_name_zh_cn?: InputMaybe<Scalars['String']['input']>;
  first_name_zh_hk?: InputMaybe<Scalars['String']['input']>;
  is_available_for_emergency?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name_en?: InputMaybe<Scalars['String']['input']>;
  last_name_zh_cn?: InputMaybe<Scalars['String']['input']>;
  last_name_zh_hk?: InputMaybe<Scalars['String']['input']>;
  license_number?: InputMaybe<Scalars['String']['input']>;
  max_daily_appointments?: InputMaybe<Scalars['Float']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  qualification?: InputMaybe<Scalars['String']['input']>;
  specialization?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInsuranceClaimResultDto = {
  appointmentId?: InputMaybe<Scalars['String']['input']>;
  claimResultDetails?: InputMaybe<Scalars['JSON']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<CreateInsuranceClaimItemDto>>;
  name?: InputMaybe<Scalars['String']['input']>;
  policyId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInsurancePlanDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payor?: InputMaybe<Scalars['String']['input']>;
  planDetails?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInsurancePolicyDto = {
  appUserId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payor?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  policyDetails?: InputMaybe<Scalars['JSON']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInsuranceProviderContractDto = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePatientDto = {
  allergies?: InputMaybe<Array<Scalars['String']['input']>>;
  app_user_id?: InputMaybe<Scalars['String']['input']>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  birthdate?: InputMaybe<Scalars['DateTime']['input']>;
  blood_type?: InputMaybe<Scalars['String']['input']>;
  chronic_conditions?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_name?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_phone?: InputMaybe<Scalars['String']['input']>;
  first_name_en?: InputMaybe<Scalars['String']['input']>;
  first_name_zh_hk?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  identity_document_number?: InputMaybe<Scalars['String']['input']>;
  identity_document_type?: InputMaybe<Scalars['String']['input']>;
  language_preferences?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name_en?: InputMaybe<Scalars['String']['input']>;
  last_name_zh_hk?: InputMaybe<Scalars['String']['input']>;
  medications?: InputMaybe<Array<Scalars['String']['input']>>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  relationship_to_owner?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProviderDto = {
  clinic_id?: InputMaybe<Scalars['String']['input']>;
  consultation_fee?: InputMaybe<Scalars['Float']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  doctor_id?: InputMaybe<Scalars['String']['input']>;
  employment_type?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  specialization_at_clinic?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScheduleDto = {
  advance_booking_days?: InputMaybe<Scalars['Float']['input']>;
  auto_confirm_hours?: InputMaybe<Scalars['Float']['input']>;
  booking_window_end?: InputMaybe<Scalars['String']['input']>;
  booking_window_start?: InputMaybe<Scalars['String']['input']>;
  cancellation_hours?: InputMaybe<Scalars['Float']['input']>;
  confirmation_required?: InputMaybe<Scalars['Boolean']['input']>;
  default_appointment_duration?: InputMaybe<Scalars['Float']['input']>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  insurance_restrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  is_available_for_telemedicine?: InputMaybe<Scalars['Boolean']['input']>;
  is_available_for_walk_in?: InputMaybe<Scalars['Boolean']['input']>;
  max_appointments_per_day?: InputMaybe<Scalars['Float']['input']>;
  max_notice_days?: InputMaybe<Scalars['Float']['input']>;
  min_notice_hours?: InputMaybe<Scalars['Float']['input']>;
  patient_type_restrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  priority?: InputMaybe<Scalars['Float']['input']>;
  reminder_hours?: InputMaybe<Array<Scalars['Float']['input']>>;
  requires_approval?: InputMaybe<Scalars['Boolean']['input']>;
  reschedule_hours?: InputMaybe<Scalars['Float']['input']>;
  same_day_booking?: InputMaybe<Scalars['Boolean']['input']>;
  schedule?: InputMaybe<WorkingHoursInput>;
  send_reminders?: InputMaybe<Scalars['Boolean']['input']>;
  service_restrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateTransactionDto = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  appointment_id?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  completed_at?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount_amount?: InputMaybe<Scalars['Float']['input']>;
  final_amount?: InputMaybe<Scalars['Float']['input']>;
  gateway_response?: InputMaybe<Scalars['JSON']['input']>;
  gateway_transaction_id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  original_amount?: InputMaybe<Scalars['Float']['input']>;
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  processed_at?: InputMaybe<Scalars['DateTime']['input']>;
  processing_fee?: InputMaybe<Scalars['Float']['input']>;
  refund_reason?: InputMaybe<Scalars['String']['input']>;
  refunded_at?: InputMaybe<Scalars['DateTime']['input']>;
  refunded_by?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  tax_amount?: InputMaybe<Scalars['Float']['input']>;
  transaction_reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateTokenInput = {
  channelName: Scalars['String']['input'];
  token: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};

export type ValidateTokenResponse = {
  __typename?: 'ValidateTokenResponse';
  isValid: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type VerificationResponseDto = {
  __typename?: 'VerificationResponseDto';
  country_code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  verification_id?: Maybe<Scalars['String']['output']>;
};

export type VerifyOtpDto = {
  country_code?: Scalars['String']['input'];
  otp_code: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  tenant?: Scalars['String']['input'];
};

export type VitalSigns = {
  __typename?: 'VitalSigns';
  blood_glucose?: Maybe<Scalars['Float']['output']>;
  blood_pressure_diastolic?: Maybe<Scalars['Float']['output']>;
  blood_pressure_systolic?: Maybe<Scalars['Float']['output']>;
  bmi?: Maybe<Scalars['Float']['output']>;
  heart_rate?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  hip_circumference?: Maybe<Scalars['Float']['output']>;
  measured_at?: Maybe<Scalars['String']['output']>;
  measured_by?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  oxygen_saturation?: Maybe<Scalars['Float']['output']>;
  pain_level?: Maybe<Scalars['Float']['output']>;
  respiratory_rate?: Maybe<Scalars['Float']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  waist_circumference?: Maybe<Scalars['Float']['output']>;
  waist_to_hip_ratio?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type VitalSignsInput = {
  blood_glucose?: InputMaybe<Scalars['Float']['input']>;
  blood_pressure_diastolic?: InputMaybe<Scalars['Float']['input']>;
  blood_pressure_systolic?: InputMaybe<Scalars['Float']['input']>;
  bmi?: InputMaybe<Scalars['Float']['input']>;
  heart_rate?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  hip_circumference?: InputMaybe<Scalars['Float']['input']>;
  measured_at?: InputMaybe<Scalars['String']['input']>;
  measured_by?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  oxygen_saturation?: InputMaybe<Scalars['Float']['input']>;
  pain_level?: InputMaybe<Scalars['Float']['input']>;
  respiratory_rate?: InputMaybe<Scalars['Float']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  waist_circumference?: InputMaybe<Scalars['Float']['input']>;
  waist_to_hip_ratio?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkingHours = {
  __typename?: 'WorkingHours';
  friday?: Maybe<Array<TimeSlot>>;
  monday?: Maybe<Array<TimeSlot>>;
  saturday?: Maybe<Array<TimeSlot>>;
  sunday?: Maybe<Array<TimeSlot>>;
  thursday?: Maybe<Array<TimeSlot>>;
  tuesday?: Maybe<Array<TimeSlot>>;
  wednesday?: Maybe<Array<TimeSlot>>;
};

export type WorkingHoursInput = {
  friday?: InputMaybe<Array<TimeSlotInput>>;
  monday?: InputMaybe<Array<TimeSlotInput>>;
  saturday?: InputMaybe<Array<TimeSlotInput>>;
  sunday?: InputMaybe<Array<TimeSlotInput>>;
  thursday?: InputMaybe<Array<TimeSlotInput>>;
  tuesday?: InputMaybe<Array<TimeSlotInput>>;
  wednesday?: InputMaybe<Array<TimeSlotInput>>;
};

export type CreateClinicMutationVariables = Exact<{
  createClinicDto: CreateClinicDto;
}>;


export type CreateClinicMutation = { __typename?: 'Mutation', createClinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, internal_name: string, address: string, phone_number: string, email: string, status: string, region: string, district: string, description?: string | null, building_name?: string | null, floor?: string | null, unit?: string | null, postal_code: string, website_url?: string | null, emergency_services?: boolean | null, walk_in_enabled?: boolean | null, online_consultation_enabled?: boolean | null, appointment_booking_enabled?: boolean | null, facilities?: Array<string> | null, services?: Array<string> | null, images?: Array<string> | null, latitude?: number | null, longitude?: number | null, created_at: any, updated_at: any } };

export type UpdateClinicMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateClinicDto: UpdateClinicDto;
}>;


export type UpdateClinicMutation = { __typename?: 'Mutation', updateClinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, internal_name: string, address: string, phone_number: string, email: string, status: string, region: string, district: string, description?: string | null, building_name?: string | null, floor?: string | null, unit?: string | null, postal_code: string, website_url?: string | null, emergency_services?: boolean | null, walk_in_enabled?: boolean | null, online_consultation_enabled?: boolean | null, appointment_booking_enabled?: boolean | null, facilities?: Array<string> | null, services?: Array<string> | null, images?: Array<string> | null, latitude?: number | null, longitude?: number | null, created_at: any, updated_at: any } };

export type DeleteClinicMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClinicMutation = { __typename?: 'Mutation', deleteClinic: boolean };

export type CreateDoctorMutationVariables = Exact<{
  createDoctorDto: CreateDoctorDto;
}>;


export type CreateDoctorMutation = { __typename?: 'Mutation', createDoctor: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, license_number: string, specialization: string, status: string, rating?: number | null, experience_years?: number | null, consultation_fee?: number | null, avatar_url?: string | null, bio?: string | null, qualification?: string | null, title?: string | null, languages?: Array<string> | null, is_available_for_emergency?: boolean | null, max_daily_appointments?: number | null, total_reviews?: number | null, time_zone?: string | null, created_at: any, updated_at: any } };

export type UpdateDoctorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateDoctorDto: UpdateDoctorDto;
}>;


export type UpdateDoctorMutation = { __typename?: 'Mutation', updateDoctor: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, license_number: string, specialization: string, status: string, rating?: number | null, experience_years?: number | null, consultation_fee?: number | null, avatar_url?: string | null, bio?: string | null, qualification?: string | null, title?: string | null, languages?: Array<string> | null, is_available_for_emergency?: boolean | null, max_daily_appointments?: number | null, total_reviews?: number | null, time_zone?: string | null, created_at: any, updated_at: any } };

export type DeleteDoctorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDoctorMutation = { __typename?: 'Mutation', deleteDoctor: boolean };

export type CreatePatientMutationVariables = Exact<{
  createPatientDto: CreatePatientDto;
}>;


export type CreatePatientMutation = { __typename?: 'Mutation', createPatient: { __typename?: 'Patient', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, birthdate?: any | null, gender: string, status: string, emergency_contact_name?: string | null, emergency_contact_phone?: string | null, avatar_url?: string | null, blood_type?: string | null, nationality?: string | null, identity_document_type?: string | null, identity_document_number: string, language_preferences?: Array<string> | null, allergies?: Array<string> | null, chronic_conditions?: Array<string> | null, medications?: Array<string> | null, notes?: string | null, created_at: any, updated_at: any, app_user: { __typename?: 'AppUser', id: string, firstname?: string | null, lastname?: string | null, email: string, phone_number?: string | null } } };

export type UpdatePatientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updatePatientDto: UpdatePatientDto;
}>;


export type UpdatePatientMutation = { __typename?: 'Mutation', updatePatient: { __typename?: 'Patient', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, birthdate?: any | null, gender: string, status: string, emergency_contact_name?: string | null, emergency_contact_phone?: string | null, avatar_url?: string | null, blood_type?: string | null, nationality?: string | null, identity_document_type?: string | null, identity_document_number: string, language_preferences?: Array<string> | null, allergies?: Array<string> | null, chronic_conditions?: Array<string> | null, medications?: Array<string> | null, notes?: string | null, created_at: any, updated_at: any, app_user: { __typename?: 'AppUser', id: string, firstname?: string | null, lastname?: string | null, email: string, phone_number?: string | null } } };

export type DeletePatientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePatientMutation = { __typename?: 'Mutation', deletePatient: boolean };

export type CreateProviderMutationVariables = Exact<{
  createProviderDto: CreateProviderDto;
}>;


export type CreateProviderMutation = { __typename?: 'Mutation', createProvider: { __typename?: 'Provider', id: string, doctor_id: string, clinic_id: string, consultation_fee?: number | null, department?: string | null, employment_type: string, start_date?: any | null, end_date?: any | null, status: string, role?: string | null, specialization_at_clinic?: string | null, last_worked_at?: any | null, verified_at?: any | null, created_at: any, updated_at: any, doctor: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, license_number: string, specialization: string, status: string, rating?: number | null, experience_years?: number | null, email?: string | null, phone_number?: string | null }, clinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, address: string, region: string, district: string, phone_number: string, email: string, status: string } } };

export type UpdateProviderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateProviderDto: UpdateProviderDto;
}>;


export type UpdateProviderMutation = { __typename?: 'Mutation', updateProvider: { __typename?: 'Provider', id: string, doctor_id: string, clinic_id: string, consultation_fee?: number | null, department?: string | null, employment_type: string, start_date?: any | null, end_date?: any | null, status: string, role?: string | null, specialization_at_clinic?: string | null, last_worked_at?: any | null, verified_at?: any | null, created_at: any, updated_at: any, doctor: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, license_number: string, specialization: string, status: string, rating?: number | null, experience_years?: number | null, email?: string | null, phone_number?: string | null }, clinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, address: string, region: string, district: string, phone_number: string, email: string, status: string } } };

export type DeleteProviderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProviderMutation = { __typename?: 'Mutation', deleteProvider: boolean };

export type AddTagToProviderMutationVariables = Exact<{
  providerId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddTagToProviderMutation = { __typename?: 'Mutation', addTagToProvider: boolean };

export type RemoveTagFromProviderMutationVariables = Exact<{
  providerId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
}>;


export type RemoveTagFromProviderMutation = { __typename?: 'Mutation', removeTagFromProvider: boolean };

export type CreateScheduleMutationVariables = Exact<{
  createScheduleDto: CreateScheduleDto;
  providerId: Scalars['ID']['input'];
}>;


export type CreateScheduleMutation = { __typename?: 'Mutation', createSchedule: { __typename?: 'ProviderSchedule', id: string, provider_id: string, status: string, max_appointments_per_day?: number | null, default_appointment_duration?: number | null, is_available_for_telemedicine?: boolean | null, is_available_for_walk_in?: boolean | null, created_at: any, updated_at: any, schedule?: { __typename?: 'WorkingHours', monday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, tuesday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, wednesday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, thursday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, friday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, saturday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, sunday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null } | null } };

export type UpdateScheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateScheduleDto: UpdateScheduleDto;
}>;


export type UpdateScheduleMutation = { __typename?: 'Mutation', updateSchedule: { __typename?: 'ProviderSchedule', id: string, provider_id: string, status: string, max_appointments_per_day?: number | null, default_appointment_duration?: number | null, is_available_for_telemedicine?: boolean | null, is_available_for_walk_in?: boolean | null, created_at: any, updated_at: any, schedule?: { __typename?: 'WorkingHours', monday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, tuesday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, wednesday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, thursday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, friday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, saturday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, sunday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null } | null } };

export type DeleteScheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteScheduleMutation = { __typename?: 'Mutation', deleteSchedule: boolean };

export type CreateAppointmentMutationVariables = Exact<{
  createAppointmentDto: CreateAppointmentDto;
}>;


export type CreateAppointmentMutation = { __typename?: 'Mutation', createAppointment: { __typename?: 'CreateAppointmentResponse', appointment: { __typename?: 'Appointment', id: string, app_user_id: string, provider_id?: string | null, date: any, time: string, duration: number, status: string, type: string, reservation_type: string, questionnaire?: any | null, appointment_notes?: string | null, priority: string, consultation_type: string, language_preference?: string | null, booking_source: string, payment_method?: string | null, total_amount?: number | null, insurance_claim_id?: string | null, timezone?: string | null, medical_history_reviewed: boolean, patient_phone?: string | null, patient_email?: string | null, emergency_contact?: string | null, special_instructions?: string | null, tenant: string, created_at: any, updated_at: any }, transaction: { __typename?: 'Transaction', id: string, appointment_id: string, amount: number, currency: string, status: string, payment_method?: string | null, transaction_reference: string, gateway_transaction_id?: string | null, metadata?: any | null, created_at: any, updated_at: any } } };

export type UpdateAppointmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateAppointmentDto: UpdateAppointmentDto;
}>;


export type UpdateAppointmentMutation = { __typename?: 'Mutation', updateAppointment: { __typename?: 'Appointment', id: string, app_user_id: string, provider_id?: string | null, date: any, time: string, duration: number, status: string, type: string, reservation_type: string, questionnaire?: any | null, appointment_notes?: string | null, internal_remark?: string | null, doctor_notes?: string | null, priority: string, consultation_type: string, language_preference?: string | null, booking_source: string, payment_method?: string | null, total_amount?: number | null, insurance_claim_id?: string | null, timezone?: string | null, medical_history_reviewed: boolean, patient_phone?: string | null, patient_email?: string | null, emergency_contact?: string | null, special_instructions?: string | null, tenant: string, created_at: any, updated_at: any } };

export type DeleteAppointmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAppointmentMutation = { __typename?: 'Mutation', removeAppointment: { __typename?: 'Appointment', id: string, app_user_id: string, provider_id?: string | null, date: any, time: string, duration: number, status: string, type: string, reservation_type: string, questionnaire?: any | null, appointment_notes?: string | null, priority: string, consultation_type: string, language_preference?: string | null, booking_source: string, payment_method?: string | null, total_amount?: number | null, insurance_claim_id?: string | null, timezone?: string | null, medical_history_reviewed: boolean, patient_phone?: string | null, patient_email?: string | null, emergency_contact?: string | null, special_instructions?: string | null, tenant: string, created_at: any, updated_at: any } };

export type ConfirmAppointmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConfirmAppointmentMutation = { __typename?: 'Mutation', confirmAppointment: { __typename?: 'Appointment', id: string, status: string, confirmed_at?: any | null, updated_at: any } };

export type StartAppointmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type StartAppointmentMutation = { __typename?: 'Mutation', startAppointment: { __typename?: 'Appointment', id: string, status: string, started_at?: any | null, updated_at: any } };

export type DeleteSfExpressOrderMutationVariables = Exact<{
  input: DeleteSfExpressOrderDto;
}>;


export type DeleteSfExpressOrderMutation = { __typename?: 'Mutation', deleteSfExpressOrder: boolean };

export type DeleteJdExpressOrderMutationVariables = Exact<{
  input: DeleteJdExpressOrderDto;
}>;


export type DeleteJdExpressOrderMutation = { __typename?: 'Mutation', deleteJdExpressOrder: boolean };

export type CompleteAppointmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  completionData?: InputMaybe<UpdateAppointmentDto>;
}>;


export type CompleteAppointmentMutation = { __typename?: 'Mutation', completeAppointment: { __typename?: 'Appointment', id: string, status: string, completed_at?: any | null, updated_at: any } };

export type CancelAppointmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  cancelledBy: Scalars['String']['input'];
}>;


export type CancelAppointmentMutation = { __typename?: 'Mutation', cancelAppointment: { __typename?: 'Appointment', id: string, status: string, cancelled_at?: any | null, cancelled_reason?: string | null, cancelled_by?: string | null, updated_at: any } };

export type MarkAppointmentNoShowMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkAppointmentNoShowMutation = { __typename?: 'Mutation', markAppointmentNoShow: { __typename?: 'Appointment', id: string, status: string, updated_at: any } };

export type UpdateJoinStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateJoinStatusMutation = { __typename?: 'Mutation', updateJoinStatus: { __typename?: 'Appointment', id: string, otherStatuses?: any | null, updated_at: any } };

export type CreateAdminUserMutationVariables = Exact<{
  createAdminUserDto: CreateAdminUserDto;
}>;


export type CreateAdminUserMutation = { __typename?: 'Mutation', createAdminUser: { __typename?: 'AdminUser', id: string, email: string, firstname: string, lastname: string, role_id?: string | null, permissions: Array<AdminPermission>, is_super_admin: boolean, is_active: boolean, phone_number?: string | null, avatar_url?: string | null, last_login_at?: any | null, last_login_ip?: string | null, created_at: any, updated_at: any, doctor_id?: string | null, clinic_id?: string | null, doctor?: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, specialization: string, license_number: string } | null, clinic?: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, address: string, region: string, district: string, phone_number: string, email: string, status: string } | null, userRole?: { __typename?: 'AdminUserRole', id: string, name: string, description: string, is_system_role: boolean, is_active: boolean, permissions: Array<{ __typename?: 'AdminUserRolePermission', role_id: string, permission: AdminPermission }> } | null } };

export type UpdateAdminUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateAdminUserDto: UpdateAdminUserDto;
}>;


export type UpdateAdminUserMutation = { __typename?: 'Mutation', updateAdminUser: { __typename?: 'AdminUser', id: string, email: string, firstname: string, lastname: string, role_id?: string | null, permissions: Array<AdminPermission>, is_super_admin: boolean, is_active: boolean, phone_number?: string | null, avatar_url?: string | null, last_login_at?: any | null, last_login_ip?: string | null, created_at: any, updated_at: any, doctor_id?: string | null, clinic_id?: string | null, doctor?: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, specialization: string, license_number: string } | null, clinic?: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, address: string, region: string, district: string, phone_number: string, email: string, status: string } | null, userRole?: { __typename?: 'AdminUserRole', id: string, name: string, description: string, is_system_role: boolean, is_active: boolean, permissions: Array<{ __typename?: 'AdminUserRolePermission', role_id: string, permission: AdminPermission }> } | null } };

export type DeleteAdminUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAdminUserMutation = { __typename?: 'Mutation', deleteAdminUser: boolean };

export type ActivateAdminUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActivateAdminUserMutation = { __typename?: 'Mutation', activateAdminUser: { __typename?: 'AdminUser', id: string, is_active: boolean, updated_at: any } };

export type DeactivateAdminUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeactivateAdminUserMutation = { __typename?: 'Mutation', deactivateAdminUser: { __typename?: 'AdminUser', id: string, is_active: boolean, updated_at: any } };

export type ResetAdminUserPasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ResetAdminUserPasswordMutation = { __typename?: 'Mutation', resetAdminUserPassword: { __typename?: 'ResetPasswordResponseDto', success: boolean, message: string } };

export type AdminLoginMutationVariables = Exact<{
  loginDto: AdminLoginDto;
}>;


export type AdminLoginMutation = { __typename?: 'Mutation', adminLogin: { __typename?: 'AdminLoginResponse', accessToken: string, refreshToken: string, adminUser: { __typename?: 'AdminUser', id: string, email: string, firstname: string, lastname: string, role?: AdminRole | null, role_id?: string | null, permissions: Array<AdminPermission>, is_super_admin: boolean, is_active: boolean, doctor_id?: string | null, userRole?: { __typename?: 'AdminUserRole', id: string, name: string, description: string, is_system_role: boolean, is_active: boolean, permissions: Array<{ __typename?: 'AdminUserRolePermission', role_id: string, permission: AdminPermission }> } | null } } };

export type AdminMeQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminMeQuery = { __typename?: 'Query', adminMe: { __typename?: 'AdminUser', id: string, email: string, firstname: string, lastname: string, role_id?: string | null, permissions: Array<AdminPermission>, is_super_admin: boolean, is_active: boolean, last_login_at?: any | null, last_login_ip?: string | null, doctor_id?: string | null, userRole?: { __typename?: 'AdminUserRole', id: string, name: string, description: string, is_system_role: boolean, is_active: boolean, permissions: Array<{ __typename?: 'AdminUserRolePermission', role_id: string, permission: AdminPermission }> } | null } };

export type ChangePasswordMutationVariables = Exact<{
  changePasswordDto: ChangePasswordDto;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'ChangePasswordResponseDto', success: boolean, message: string } };

export type GetAdminUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminUsersQuery = { __typename?: 'Query', adminUsers: Array<{ __typename?: 'AdminUser', id: string, email: string, firstname: string, lastname: string, role_id?: string | null, permissions: Array<AdminPermission>, is_super_admin: boolean, is_active: boolean, phone_number?: string | null, avatar_url?: string | null, last_login_at?: any | null, last_login_ip?: string | null, created_at: any, updated_at: any, doctor_id?: string | null, clinic_id?: string | null, doctor?: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, specialization: string, license_number: string } | null, clinic?: { __typename?: 'Clinic', id: string, name_en: string, internal_name: string, name_zh_hk: string, address: string, region: string, district: string, phone_number: string, email: string, status: string } | null, userRole?: { __typename?: 'AdminUserRole', id: string, name: string, description: string, is_system_role: boolean, is_active: boolean, permissions: Array<{ __typename?: 'AdminUserRolePermission', role_id: string, permission: AdminPermission }> } | null }> };

export type AdminRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type AdminRefreshTokenMutation = { __typename?: 'Mutation', adminRefreshToken: { __typename?: 'AdminLoginResponse', accessToken: string, refreshToken: string, adminUser: { __typename?: 'AdminUser', id: string, email: string, firstname: string, lastname: string, role?: AdminRole | null, permissions: Array<AdminPermission>, is_super_admin: boolean, is_active: boolean, doctor_id?: string | null } } };

export type CreateAdminUserRoleMutationVariables = Exact<{
  createAdminUserRoleDto: CreateAdminUserRoleDto;
}>;


export type CreateAdminUserRoleMutation = { __typename?: 'Mutation', createAdminUserRole: { __typename?: 'AdminUserRole', id: string, name: string, description: string, is_system_role: boolean, is_active: boolean, created_at: any, updated_at: any, permissions: Array<{ __typename?: 'AdminUserRolePermission', role_id: string, permission: AdminPermission }> } };

export type UpdateAdminUserRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateAdminUserRoleDto: UpdateAdminUserRoleDto;
}>;


export type UpdateAdminUserRoleMutation = { __typename?: 'Mutation', updateAdminUserRole: { __typename?: 'AdminUserRole', id: string, name: string, description: string, is_system_role: boolean, is_active: boolean, created_at: any, updated_at: any, permissions: Array<{ __typename?: 'AdminUserRolePermission', role_id: string, permission: AdminPermission }> } };

export type DeleteAdminUserRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAdminUserRoleMutation = { __typename?: 'Mutation', deleteAdminUserRole: boolean };

export type GetAdminUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminUserRolesQuery = { __typename?: 'Query', adminUserRoles: Array<{ __typename?: 'AdminUserRole', id: string, name: string, description: string, is_system_role: boolean, is_active: boolean, created_at: any, updated_at: any, permissions: Array<{ __typename?: 'AdminUserRolePermission', role_id: string, permission: AdminPermission }> }> };

export type GetAdminUserRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAdminUserRoleQuery = { __typename?: 'Query', adminUserRole: { __typename?: 'AdminUserRole', id: string, name: string, description: string, is_system_role: boolean, is_active: boolean, created_at: any, updated_at: any, permissions: Array<{ __typename?: 'AdminUserRolePermission', role_id: string, permission: AdminPermission }> } };

export type GetAdminUserRolePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminUserRolePermissionsQuery = { __typename?: 'Query', adminUserRolePermissions: Array<{ __typename?: 'AdminUserRolePermission', role_id: string, permission: AdminPermission }> };

export type GetAvailableAdminPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableAdminPermissionsQuery = { __typename?: 'Query', availableAdminPermissions: Array<string> };

export type CreateTransactionMutationVariables = Exact<{
  createTransactionDto: CreateTransactionDto;
}>;


export type CreateTransactionMutation = { __typename?: 'Mutation', createTransaction: { __typename?: 'Transaction', id: string, app_user_id: string, appointment_id: string, transaction_reference: string, amount: number, currency: string, type: string, status: string, payment_method?: string | null, description?: string | null, category?: string | null, subcategory?: string | null, notes?: string | null, gateway_transaction_id?: string | null, gateway_response?: any | null, processing_fee?: number | null, tax_amount?: number | null, discount_amount?: number | null, final_amount?: number | null, metadata?: any | null, refund_reason?: string | null, refunded_by?: string | null, refunded_at?: any | null, original_transaction_id?: string | null, created_at: any, updated_at: any, processed_at?: any | null, completed_at?: any | null } };

export type UpdateTransactionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateTransactionDto: UpdateTransactionDto;
}>;


export type UpdateTransactionMutation = { __typename?: 'Mutation', updateTransaction: { __typename?: 'Transaction', id: string, app_user_id: string, appointment_id: string, transaction_reference: string, amount: number, currency: string, type: string, status: string, payment_method?: string | null, description?: string | null, category?: string | null, subcategory?: string | null, notes?: string | null, gateway_transaction_id?: string | null, gateway_response?: any | null, processing_fee?: number | null, tax_amount?: number | null, discount_amount?: number | null, final_amount?: number | null, metadata?: any | null, refund_reason?: string | null, refunded_by?: string | null, refunded_at?: any | null, original_transaction_id?: string | null, created_at: any, updated_at: any, processed_at?: any | null, completed_at?: any | null } };

export type DeleteTransactionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteTransactionMutation = { __typename?: 'Mutation', removeTransaction: { __typename?: 'Transaction', id: string, app_user_id: string, appointment_id: string, transaction_reference: string, amount: number, currency: string, type: string, status: string, payment_method?: string | null, description?: string | null, category?: string | null, subcategory?: string | null, notes?: string | null, gateway_transaction_id?: string | null, gateway_response?: any | null, processing_fee?: number | null, tax_amount?: number | null, discount_amount?: number | null, final_amount?: number | null, metadata?: any | null, refund_reason?: string | null, refunded_by?: string | null, refunded_at?: any | null, original_transaction_id?: string | null, created_at: any, updated_at: any, processed_at?: any | null, completed_at?: any | null } };

export type CreateAppUserMutationVariables = Exact<{
  createUserDto: CreateUserDto;
}>;


export type CreateAppUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'AppUser', id: string, email: string, firstname?: string | null, lastname?: string | null, phone_number?: string | null, tenant: string, language_preference: string, ic_type?: string | null, ic_number?: string | null, birthdate?: any | null, age?: number | null, gender?: string | null, created_at: any, updated_at: any, deleted_at?: any | null, deleted_reason?: string | null } };

export type DeleteAppUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAppUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type SoftDeleteAppUserMutationVariables = Exact<{
  softDeleteUserDto: SoftDeleteUserDto;
}>;


export type SoftDeleteAppUserMutation = { __typename?: 'Mutation', softDeleteUser: { __typename?: 'SoftDeleteUserResponseDto', success: boolean, message: string } };

export type RestoreAppUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreAppUserMutation = { __typename?: 'Mutation', restoreUser: { __typename?: 'SoftDeleteUserResponseDto', success: boolean, message: string } };

export type CloudPrintSfExpressWaybillMutationVariables = Exact<{
  input: SfExpressCloudPrintWaybillInput;
}>;


export type CloudPrintSfExpressWaybillMutation = { __typename?: 'Mutation', cloudPrintSfExpressWaybill: { __typename?: 'SfExpressCloudPrintWaybillApiResponseDto', success: boolean, errorCode?: string | null, errorMsg?: string | null, data?: { __typename?: 'SfExpressCloudPrintWaybillResponseDto', waybillNo?: string | null, pdfUrl?: string | null, pdfBase64?: string | null, templateCode?: string | null, fileSize?: number | null, generateTime?: string | null } | null } };

export type CloudPrintSfExpressWaybillsBatchMutationVariables = Exact<{
  inputs: Array<SfExpressCloudPrintWaybillInput> | SfExpressCloudPrintWaybillInput;
}>;


export type CloudPrintSfExpressWaybillsBatchMutation = { __typename?: 'Mutation', cloudPrintSfExpressWaybillsBatch: Array<{ __typename?: 'SfExpressCloudPrintWaybillApiResponseDto', success: boolean, errorCode?: string | null, errorMsg?: string | null, data?: { __typename?: 'SfExpressCloudPrintWaybillResponseDto', waybillNo?: string | null, pdfUrl?: string | null, pdfBase64?: string | null, templateCode?: string | null, fileSize?: number | null, generateTime?: string | null } | null }> };

export type PrecheckJdExpressOrderFromAppointmentMutationVariables = Exact<{
  input: CreateJdExpressOrderFromAppointmentDto;
}>;


export type PrecheckJdExpressOrderFromAppointmentMutation = { __typename?: 'Mutation', precheckJdExpressOrderFromAppointment: { __typename?: 'JdExpressPrecheckApiResponseDto', success: boolean, errorCode?: string | null, errorMsg?: string | null, data?: { __typename?: 'JdExpressPrecheckResponseDto', totalFreightPre?: number | null, currency?: string | null, calWeight?: number | null, totalAmount?: number | null, deliveryPromiseTime?: number | null, productCode?: string | null, productName?: string | null, freightPre?: number | null, startStationName?: string | null, endStationName?: string | null, startStationCode?: string | null, endStationCode?: string | null } | null } };

export type CloudPrintJdExpressWaybillMutationVariables = Exact<{
  input: JdExpressCloudPrintWaybillInput;
}>;


export type CloudPrintJdExpressWaybillMutation = { __typename?: 'Mutation', cloudPrintJdExpressWaybill: { __typename?: 'JdExpressCloudPrintWaybillApiResponseDto', success: boolean, errorCode?: string | null, errorMsg?: string | null, data?: { __typename?: 'JdExpressCloudPrintWaybillResponseDto', waybillNo?: string | null, pdfUrl?: string | null, pdfBase64?: string | null, templateCode?: string | null, fileSize?: number | null, generateTime?: string | null } | null } };

export type CreateAddressMutationVariables = Exact<{
  createAddressDto: CreateAddressDto;
}>;


export type CreateAddressMutation = { __typename?: 'Mutation', createAddress: { __typename?: 'AppUserAddress', id: string, type: string, display_name: string, region: string, district: string, street_address: string, building_name?: string | null, floor?: string | null, block?: string | null, unit?: string | null, postal_code: string, override_address?: string | null, is_default: boolean, phone_number: string, contact_name: string, created_at: any, updated_at: any } };

export type UpdateAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateAddressDto: UpdateAddressDto;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateAddress: { __typename?: 'AppUserAddress', id: string, type: string, display_name: string, region: string, district: string, street_address: string, building_name?: string | null, floor?: string | null, block?: string | null, unit?: string | null, postal_code: string, override_address?: string | null, is_default: boolean, phone_number: string, contact_name: string, created_at: any, updated_at: any } };

export type DeleteAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAddressMutation = { __typename?: 'Mutation', deleteAddress: boolean };

export type SetDefaultAddressMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
}>;


export type SetDefaultAddressMutation = { __typename?: 'Mutation', setDefaultAddress: { __typename?: 'AppUserAddress', id: string, type: string, display_name: string, region: string, district: string, street_address: string, building_name?: string | null, floor?: string | null, block?: string | null, unit?: string | null, postal_code: string, override_address?: string | null, is_default: boolean, phone_number: string, contact_name: string, created_at: any, updated_at: any } };

export type AdminCreateAddressMutationVariables = Exact<{
  createAddressDto: CreateAddressDto;
}>;


export type AdminCreateAddressMutation = { __typename?: 'Mutation', adminCreateAddress: { __typename?: 'AppUserAddress', id: string, type: string, display_name: string, region: string, district: string, street_address: string, building_name?: string | null, floor?: string | null, block?: string | null, unit?: string | null, postal_code: string, override_address?: string | null, is_default: boolean, phone_number: string, contact_name: string, created_at: any, updated_at: any } };

export type AdminUpdateAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateAddressDto: UpdateAddressDto;
}>;


export type AdminUpdateAddressMutation = { __typename?: 'Mutation', adminUpdateAddress: { __typename?: 'AppUserAddress', id: string, type: string, display_name: string, region: string, district: string, street_address: string, building_name?: string | null, floor?: string | null, block?: string | null, unit?: string | null, postal_code: string, override_address?: string | null, is_default: boolean, phone_number: string, contact_name: string, created_at: any, updated_at: any } };

export type AdminDeleteAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminDeleteAddressMutation = { __typename?: 'Mutation', adminDeleteAddress: boolean };

export type AdminSetDefaultAddressMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
}>;


export type AdminSetDefaultAddressMutation = { __typename?: 'Mutation', adminSetDefaultAddress: { __typename?: 'AppUserAddress', id: string, type: string, display_name: string, region: string, district: string, street_address: string, building_name?: string | null, floor?: string | null, block?: string | null, unit?: string | null, postal_code: string, override_address?: string | null, is_default: boolean, phone_number: string, contact_name: string, created_at: any, updated_at: any } };

export type CreateInsurancePolicyMutationVariables = Exact<{
  createInsurancePolicyDto: CreateInsurancePolicyDto;
}>;


export type CreateInsurancePolicyMutation = { __typename?: 'Mutation', createInsurancePolicy: { __typename?: 'InsurancePolicy', id: string, name: string, payor: string, planId: string, policyNumber?: string | null, startDate?: any | null, endDate?: any | null, appUserId?: string | null, description: string, isActive: boolean, createdAt: any, updatedAt: any, policyDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null }, plan?: { __typename?: 'InsurancePlan', id: string, name: string, payor: string, description: string, planDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null } } | null, appUser?: { __typename?: 'AppUser', id: string, firstname?: string | null, lastname?: string | null, email: string, phone_number?: string | null } | null } };

export type UpdateInsurancePolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInsurancePolicyDto: UpdateInsurancePolicyDto;
}>;


export type UpdateInsurancePolicyMutation = { __typename?: 'Mutation', updateInsurancePolicy: { __typename?: 'InsurancePolicy', id: string, name: string, payor: string, planId: string, policyNumber?: string | null, startDate?: any | null, endDate?: any | null, appUserId?: string | null, description: string, isActive: boolean, createdAt: any, updatedAt: any, policyDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null }, plan?: { __typename?: 'InsurancePlan', id: string, name: string, payor: string, description: string, planDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null } } | null, appUser?: { __typename?: 'AppUser', id: string, firstname?: string | null, lastname?: string | null, email: string, phone_number?: string | null } | null } };

export type CreateInsuranceClaimMutationVariables = Exact<{
  createInsuranceClaimResultDto: CreateInsuranceClaimResultDto;
}>;


export type CreateInsuranceClaimMutation = { __typename?: 'Mutation', createInsuranceClaimResult: { __typename?: 'InsuranceClaim', id: string, policyId: string, appointmentId: string, status: string, items: Array<{ __typename?: 'InsuranceClaimItem', id: string, name: string, category: string, amount: string, approvedAmount: string, transactionId?: string | null }> } };

export type BatchCreateInsuranceCouponsMutationVariables = Exact<{
  batchCreateInsuranceCouponsDto: BatchCreateInsuranceCouponsDto;
}>;


export type BatchCreateInsuranceCouponsMutation = { __typename?: 'Mutation', batchCreateInsuranceCoupons: Array<{ __typename?: 'InsuranceCoupon', id: string, payor: string, couponCode?: string | null, startDate?: any | null, endDate?: any | null, appUserId?: string | null, appointmentId?: string | null, isActive: boolean, createdAt: any, updatedAt: any, policyDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null }, plan?: { __typename?: 'InsurancePlan', id: string, name: string, payor: string, description: string } | null }> };

export type UpdateInsuranceClaimMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInsuranceClaimResultDto: UpdateInsuranceClaimResultDto;
}>;


export type UpdateInsuranceClaimMutation = { __typename?: 'Mutation', updateInsuranceClaimResult: { __typename?: 'InsuranceClaim', id: string, policyId: string, appointmentId: string, status: string, items: Array<{ __typename?: 'InsuranceClaimItem', id: string, name: string, category: string, amount: string, approvedAmount: string, transactionId?: string | null }> } };

export type AllowTeleconsultationQueryVariables = Exact<{ [key: string]: never; }>;


export type AllowTeleconsultationQuery = { __typename?: 'Query', allowTeleconsultation: boolean };

export type TeleconsultationFeeQueryVariables = Exact<{ [key: string]: never; }>;


export type TeleconsultationFeeQuery = { __typename?: 'Query', teleconsultationFee: number };

export type TeleconsultationFeeChinaLifeQueryVariables = Exact<{ [key: string]: never; }>;


export type TeleconsultationFeeChinaLifeQuery = { __typename?: 'Query', teleconsultationFee: number };

export type TeleconsultationLeadTimeQueryVariables = Exact<{ [key: string]: never; }>;


export type TeleconsultationLeadTimeQuery = { __typename?: 'Query', teleconsultationLeadTime: number };

export type RemoteAreaDeliveryExtraFeeQueryVariables = Exact<{ [key: string]: never; }>;


export type RemoteAreaDeliveryExtraFeeQuery = { __typename?: 'Query', remoteAreaDeliveryExtraFee: number };

export type BookingDaysLimitQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingDaysLimitQuery = { __typename?: 'Query', bookingDaysLimit: number };

export type BookingOpenHoursQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingOpenHoursQuery = { __typename?: 'Query', bookingOpenHours: Array<string> };

export type DoctorSpecializationsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorSpecializationsQuery = { __typename?: 'Query', doctorSpecializations: Array<string> };

export type BookingSchedulesQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingSchedulesQuery = { __typename?: 'Query', bookingSchedules: Array<{ __typename?: 'BookingSchedule', id: string, name: string, isDefault: boolean, fromDate?: string | null, toDate?: string | null, priority: number, isActive: boolean, createdAt: string, updatedAt: string, schedule: { __typename?: 'DaySchedule', monday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, tuesday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, wednesday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, thursday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, friday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, saturday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, sunday: Array<{ __typename?: 'TimeRange', from: string, to: string }> } }> };

export type ActiveBookingSchedulesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveBookingSchedulesQuery = { __typename?: 'Query', activeBookingSchedules: Array<{ __typename?: 'BookingSchedule', id: string, name: string, isDefault: boolean, fromDate?: string | null, toDate?: string | null, priority: number, isActive: boolean, createdAt: string, updatedAt: string, schedule: { __typename?: 'DaySchedule', monday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, tuesday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, wednesday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, thursday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, friday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, saturday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, sunday: Array<{ __typename?: 'TimeRange', from: string, to: string }> } }> };

export type GetScheduleOfDateQueryVariables = Exact<{
  date: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetScheduleOfDateQuery = { __typename?: 'Query', scheduleOfDate?: { __typename?: 'BookingSchedule', id: string, name: string, isDefault: boolean, fromDate?: string | null, toDate?: string | null, priority: number, isActive: boolean, createdAt: string, updatedAt: string, schedule: { __typename?: 'DaySchedule', monday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, tuesday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, wednesday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, thursday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, friday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, saturday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, sunday: Array<{ __typename?: 'TimeRange', from: string, to: string }> } } | null };

export type SetAllowTeleconsultationMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
}>;


export type SetAllowTeleconsultationMutation = { __typename?: 'Mutation', setAllowTeleconsultation: boolean };

export type SetTeleconsultationFeeMutationVariables = Exact<{
  fee: Scalars['Float']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetTeleconsultationFeeMutation = { __typename?: 'Mutation', setTeleconsultationFee: boolean };

export type SetTeleconsultationLeadTimeMutationVariables = Exact<{
  hours: Scalars['Float']['input'];
}>;


export type SetTeleconsultationLeadTimeMutation = { __typename?: 'Mutation', setTeleconsultationLeadTime: boolean };

export type SetRemoteAreaDeliveryExtraFeeMutationVariables = Exact<{
  fee: Scalars['Float']['input'];
}>;


export type SetRemoteAreaDeliveryExtraFeeMutation = { __typename?: 'Mutation', setRemoteAreaDeliveryExtraFee: boolean };

export type SetBookingDaysLimitMutationVariables = Exact<{
  days: Scalars['Float']['input'];
}>;


export type SetBookingDaysLimitMutation = { __typename?: 'Mutation', setBookingDaysLimit: boolean };

export type SetBookingOpenHoursMutationVariables = Exact<{
  hours: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SetBookingOpenHoursMutation = { __typename?: 'Mutation', setBookingOpenHours: boolean };

export type CreateBookingScheduleMutationVariables = Exact<{
  input: CreateBookingScheduleInput;
}>;


export type CreateBookingScheduleMutation = { __typename?: 'Mutation', createBookingSchedule: { __typename?: 'BookingSchedule', id: string, name: string, isDefault: boolean, fromDate?: string | null, toDate?: string | null, priority: number, isActive: boolean, createdAt: string, updatedAt: string, schedule: { __typename?: 'DaySchedule', monday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, tuesday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, wednesday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, thursday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, friday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, saturday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, sunday: Array<{ __typename?: 'TimeRange', from: string, to: string }> } } };

export type UpdateBookingScheduleMutationVariables = Exact<{
  input: UpdateBookingScheduleInput;
}>;


export type UpdateBookingScheduleMutation = { __typename?: 'Mutation', updateBookingSchedule: { __typename?: 'BookingSchedule', id: string, name: string, isDefault: boolean, fromDate?: string | null, toDate?: string | null, priority: number, isActive: boolean, createdAt: string, updatedAt: string, schedule: { __typename?: 'DaySchedule', monday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, tuesday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, wednesday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, thursday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, friday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, saturday: Array<{ __typename?: 'TimeRange', from: string, to: string }>, sunday: Array<{ __typename?: 'TimeRange', from: string, to: string }> } } };

export type DeleteBookingScheduleMutationVariables = Exact<{
  scheduleId: Scalars['String']['input'];
}>;


export type DeleteBookingScheduleMutation = { __typename?: 'Mutation', deleteBookingSchedule: boolean };

export type GetClinicsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClinicsQuery = { __typename?: 'Query', clinics: Array<{ __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, internal_name: string, address: string, phone_number: string, email: string, status: string, region: string, district: string, description?: string | null, building_name?: string | null, floor?: string | null, unit?: string | null, postal_code: string, website_url?: string | null, emergency_services?: boolean | null, walk_in_enabled?: boolean | null, online_consultation_enabled?: boolean | null, appointment_booking_enabled?: boolean | null, facilities?: Array<string> | null, services?: Array<string> | null, images?: Array<string> | null, latitude?: number | null, longitude?: number | null, created_at: any, updated_at: any }> };

export type GetClinicQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClinicQuery = { __typename?: 'Query', clinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, internal_name: string, address: string, phone_number: string, email: string, status: string, region: string, district: string, description?: string | null, building_name?: string | null, floor?: string | null, unit?: string | null, postal_code: string, website_url?: string | null, emergency_services?: boolean | null, walk_in_enabled?: boolean | null, online_consultation_enabled?: boolean | null, appointment_booking_enabled?: boolean | null, facilities?: Array<string> | null, services?: Array<string> | null, images?: Array<string> | null, latitude?: number | null, longitude?: number | null, created_at: any, updated_at: any, providers: Array<{ __typename?: 'Provider', id: string, doctor: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, specialization: string } }> } };

export type GetDoctorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDoctorsQuery = { __typename?: 'Query', doctors: Array<{ __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, license_number: string, specialization: string, status: string, rating?: number | null, experience_years?: number | null, consultation_fee?: number | null, avatar_url?: string | null, bio?: string | null, qualification?: string | null, title?: string | null, languages?: Array<string> | null, is_available_for_emergency?: boolean | null, max_daily_appointments?: number | null, total_reviews?: number | null, time_zone?: string | null, created_at: any, updated_at: any, providers: Array<{ __typename?: 'Provider', id: string, clinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, internal_name: string } }> }> };

export type GetDoctorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDoctorQuery = { __typename?: 'Query', doctor: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, license_number: string, specialization: string, status: string, rating?: number | null, experience_years?: number | null, consultation_fee?: number | null, avatar_url?: string | null, bio?: string | null, qualification?: string | null, title?: string | null, languages?: Array<string> | null, is_available_for_emergency?: boolean | null, max_daily_appointments?: number | null, total_reviews?: number | null, time_zone?: string | null, created_at: any, updated_at: any, providers: Array<{ __typename?: 'Provider', id: string, clinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, internal_name: string } }> } };

export type GetPatientsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientsQuery = { __typename?: 'Query', allPatients: Array<{ __typename?: 'Patient', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, birthdate?: any | null, gender: string, status: string, emergency_contact_name?: string | null, emergency_contact_phone?: string | null, avatar_url?: string | null, blood_type?: string | null, nationality?: string | null, identity_document_type?: string | null, identity_document_number: string, language_preferences?: Array<string> | null, allergies?: Array<string> | null, chronic_conditions?: Array<string> | null, medications?: Array<string> | null, notes?: string | null, created_at: any, updated_at: any, app_user: { __typename?: 'AppUser', id: string, firstname?: string | null, lastname?: string | null, email: string, phone_number?: string | null } }> };

export type GetPatientsPaginatedQueryVariables = Exact<{
  paginationDto: PaginationDto;
}>;


export type GetPatientsPaginatedQuery = { __typename?: 'Query', patientsPaginated: { __typename?: 'PaginatedPatientsResponse', patients: Array<{ __typename?: 'Patient', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, birthdate?: any | null, gender: string, status: string, emergency_contact_name?: string | null, emergency_contact_phone?: string | null, avatar_url?: string | null, blood_type?: string | null, nationality?: string | null, identity_document_type?: string | null, identity_document_number: string, language_preferences?: Array<string> | null, allergies?: Array<string> | null, chronic_conditions?: Array<string> | null, medications?: Array<string> | null, notes?: string | null, created_at: any, updated_at: any, app_user: { __typename?: 'AppUser', id: string, firstname?: string | null, lastname?: string | null, email: string, phone_number?: string | null } }>, pagination: { __typename?: 'PaginationInfo', page: number, limit: number, total: number, totalPages: number, hasNext: boolean, hasPrev: boolean } } };

export type GetPatientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPatientQuery = { __typename?: 'Query', patient: { __typename?: 'Patient', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, birthdate?: any | null, gender: string, status: string, emergency_contact_name?: string | null, emergency_contact_phone?: string | null, avatar_url?: string | null, blood_type?: string | null, nationality?: string | null, identity_document_type?: string | null, identity_document_number: string, language_preferences?: Array<string> | null, allergies?: Array<string> | null, chronic_conditions?: Array<string> | null, medications?: Array<string> | null, notes?: string | null, created_at: any, updated_at: any, app_user: { __typename?: 'AppUser', id: string, firstname?: string | null, lastname?: string | null, email: string, phone_number?: string | null } } };

export type GetProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProvidersQuery = { __typename?: 'Query', providers: Array<{ __typename?: 'Provider', id: string, doctor_id: string, clinic_id: string, consultation_fee?: number | null, department?: string | null, employment_type: string, start_date?: any | null, end_date?: any | null, status: string, role?: string | null, specialization_at_clinic?: string | null, last_worked_at?: any | null, verified_at?: any | null, created_at: any, updated_at: any, doctor: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, license_number: string, specialization: string, status: string, rating?: number | null, experience_years?: number | null, email?: string | null, phone_number?: string | null }, clinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, internal_name: string, address: string, region: string, district: string, phone_number: string, email: string, status: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string, category: string, status: string, display_name: string, description?: string | null, color: string, icon?: string | null, sort_order?: number | null, usage_count: number, last_used_at?: any | null, is_system_tag: boolean }>, schedules: Array<{ __typename?: 'ProviderSchedule', id: string, status: string, max_appointments_per_day?: number | null, default_appointment_duration?: number | null, is_available_for_telemedicine?: boolean | null, is_available_for_walk_in?: boolean | null, schedule?: { __typename?: 'WorkingHours', monday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, tuesday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, wednesday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, thursday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, friday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, saturday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, sunday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null } | null }> }> };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'Query', allTags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string, category: string, status: string, display_name: string, description?: string | null, color: string, icon?: string | null, sort_order?: number | null, usage_count: number, last_used_at?: any | null, is_system_tag: boolean }> };

export type GetProviderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProviderQuery = { __typename?: 'Query', provider: { __typename?: 'Provider', id: string, doctor_id: string, clinic_id: string, consultation_fee?: number | null, department?: string | null, employment_type: string, start_date?: any | null, end_date?: any | null, status: string, role?: string | null, specialization_at_clinic?: string | null, last_worked_at?: any | null, verified_at?: any | null, created_at: any, updated_at: any, doctor: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, license_number: string, specialization: string, status: string, rating?: number | null, experience_years?: number | null, email?: string | null, phone_number?: string | null }, clinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, internal_name: string, address: string, region: string, district: string, phone_number: string, email: string, status: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string, category: string, status: string, display_name: string, description?: string | null, color: string, icon?: string | null, sort_order?: number | null, usage_count: number, last_used_at?: any | null, is_system_tag: boolean }>, schedules: Array<{ __typename?: 'ProviderSchedule', id: string, status: string, max_appointments_per_day?: number | null, default_appointment_duration?: number | null, is_available_for_telemedicine?: boolean | null, is_available_for_walk_in?: boolean | null, schedule?: { __typename?: 'WorkingHours', monday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, tuesday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, wednesday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, thursday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, friday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, saturday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null, sunday?: Array<{ __typename?: 'TimeSlot', from: string, to: string }> | null } | null }> } };

export type GetHkRegionsAndDistrictsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHkRegionsAndDistrictsQuery = { __typename?: 'Query', hkRegionsAndDistricts: { __typename?: 'HKRegionsAndDistrictsResponseDto', regions: Array<{ __typename?: 'HKRegionDto', code: string, name_en: string, name_zh_hk: string, districts: Array<{ __typename?: 'HKDistrictDto', code: string, name_en: string, name_zh_hk: string }> }> } };

export type GetClinicsByRegionQueryVariables = Exact<{
  region: Scalars['String']['input'];
}>;


export type GetClinicsByRegionQuery = { __typename?: 'Query', clinicsByRegion: Array<{ __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, internal_name: string, address: string, phone_number: string, email: string, status: string, region: string, district: string }> };

export type GetDoctorsBySpecializationQueryVariables = Exact<{
  specialization: Scalars['String']['input'];
}>;


export type GetDoctorsBySpecializationQuery = { __typename?: 'Query', doctorsBySpecialization: Array<{ __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, license_number: string, specialization: string, status: string, rating?: number | null, experience_years?: number | null, consultation_fee?: number | null }> };

export type GetProvidersByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetProvidersByClinicQuery = { __typename?: 'Query', providersByClinic: Array<{ __typename?: 'Provider', id: string, doctor_id: string, clinic_id: string, consultation_fee?: number | null, status: string, doctor: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, specialization: string }, clinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, internal_name: string } }> };

export type GetAppointmentsQueryVariables = Exact<{
  filter?: InputMaybe<AppointmentFilterDto>;
}>;


export type GetAppointmentsQuery = { __typename?: 'Query', appointments: Array<{ __typename?: 'Appointment', id: string, app_user_id: string, patient_id?: string | null, provider_id?: string | null, date: any, time: string, expected_time_range?: string | null, duration: number, status: string, queue_number?: number | null, type: string, reservation_type: string, questionnaire?: any | null, appointment_notes?: string | null, internal_remark?: string | null, priority: string, consultation_type: string, language_preference?: string | null, booking_source: string, payment_status: string, payment_method?: string | null, total_amount?: number | null, insurance_claim_id?: string | null, timezone?: string | null, confirmation_sent: boolean, cancelled_reason?: string | null, cancelled_by?: string | null, medical_history_reviewed: boolean, diagnosis?: string | null, treatment_plan?: string | null, prescription?: string | null, follow_up_required: boolean, follow_up_date?: any | null, patient_phone?: string | null, patient_email?: string | null, emergency_contact?: string | null, special_instructions?: string | null, patient_rating?: number | null, patient_feedback?: string | null, doctor_notes?: string | null, quality_score?: number | null, created_at: any, updated_at: any, scheduled_at?: any | null, confirmed_at?: any | null, started_at?: any | null, completed_at?: any | null, cancelled_at?: any | null, otherStatuses?: any | null, app_user?: { __typename?: 'AppUser', id: string, firstname?: string | null, lastname?: string | null, email: string, phone_number?: string | null, tenant: string } | null, patient?: { __typename?: 'Patient', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, gender: string, birthdate?: any | null, email?: string | null, phone_number?: string | null, status: string, relationship_to_owner?: string | null } | null }> };

export type GetAppointmentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAppointmentQuery = { __typename?: 'Query', appointment: { __typename?: 'Appointment', id: string, app_user_id: string, patient_id?: string | null, provider_id?: string | null, date: any, time: string, expected_time_range?: string | null, duration: number, status: string, type: string, reservation_type: string, questionnaire?: any | null, appointment_notes?: string | null, internal_remark?: string | null, priority: string, consultation_type: string, language_preference?: string | null, booking_source: string, payment_status: string, payment_method?: string | null, total_amount?: number | null, insurance_claim_id?: string | null, timezone?: string | null, reminder_sent: boolean, confirmation_sent: boolean, rescheduled_from?: string | null, rescheduled_to?: string | null, cancelled_reason?: string | null, cancelled_by?: string | null, medical_history_reviewed: boolean, diagnosis?: string | null, treatment_plan?: string | null, prescription?: string | null, follow_up_required: boolean, follow_up_date?: any | null, patient_phone?: string | null, patient_email?: string | null, emergency_contact?: string | null, special_instructions?: string | null, delivery_address_id?: string | null, delivery_note?: string | null, patient_rating?: number | null, patient_feedback?: string | null, doctor_notes?: string | null, quality_score?: number | null, created_at: any, updated_at: any, scheduled_at?: any | null, confirmed_at?: any | null, started_at?: any | null, completed_at?: any | null, cancelled_at?: any | null, delivery_address?: { __typename?: 'AppUserAddress', id: string, type: string, display_name: string, region: string, district: string, street_address: string, building_name?: string | null, floor?: string | null, block?: string | null, unit?: string | null, postal_code: string, override_address?: string | null, is_default: boolean, phone_number: string, contact_name: string, created_at: any, updated_at: any } | null, sfExpressOrders?: Array<{ __typename?: 'SfExpressOrder', id: string, tenant: string, request_id: string, service_code: string, timestamp: number, partner_id: string, msg_digest: string, request_data: any, response_data?: any | null, status: string, order_id?: string | null, waybill_no?: string | null, tracking_number?: string | null, error_code?: string | null, error_message?: string | null, api_result_code?: string | null, api_error_msg?: string | null, notes?: string | null, created_at: any, updated_at: any, processed_at?: any | null, retry_count?: number | null, last_retry_at?: any | null, metadata?: any | null, appointment_id?: string | null }> | null, jdExpressOrders?: Array<{ __typename?: 'JdExpressOrder', id: string, tenant: string, request_id: string, service_code: string, timestamp: number, partner_id: string, msg_digest: string, request_data: any, response_data?: any | null, status: string, order_id?: string | null, waybill_no?: string | null, tracking_number?: string | null, error_code?: string | null, error_message?: string | null, api_result_code?: string | null, api_error_msg?: string | null, notes?: string | null, created_at: any, updated_at: any, processed_at?: any | null, retry_count?: number | null, last_retry_at?: any | null, metadata?: any | null, appointment_id?: string | null }> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, app_user_id: string, appointment_id: string, transaction_reference: string, original_amount: number, amount: number, currency: string, type: string, status: string, payment_method?: string | null, description?: string | null, category?: string | null, subcategory?: string | null, notes?: string | null, gateway_transaction_id?: string | null, gateway_response?: any | null, processing_fee?: number | null, tax_amount?: number | null, discount_amount?: number | null, final_amount?: number | null, metadata?: any | null, refund_reason?: string | null, refunded_by?: string | null, refunded_at?: any | null, original_transaction_id?: string | null, created_at: any, updated_at: any, processed_at?: any | null, completed_at?: any | null, items?: Array<{ __typename?: 'TransactionItem', id: string, name?: any | null, quantity: number, price: number }> | null }> | null, agoraLink?: { __typename?: 'AppointmentAgoraLinkResponse', id: string, appointmentId: string, channelName: string, uid: string, role: string, token: string, link: string, webLink: string, appId: string, expiresAt: any, isActive: boolean, createdAt: any, updatedAt: any } | null, insuranceClaims?: Array<{ __typename?: 'InsuranceClaim', id: string, policyId: string, appointmentId: string, status: string, isActive: boolean, createdAt: any, updatedAt: any, claimResultDetails: { __typename?: 'InsuranceClaimResultDetails', approved_amount?: string | null, rejected_amount?: string | null, rejected_reason?: string | null }, items: Array<{ __typename?: 'InsuranceClaimItem', id: string, insuranceClaimId: string, name: string, category: string, amount: string, approvedAmount: string, transactionId?: string | null, createdAt: any, updatedAt: any }> }> | null, app_user?: { __typename?: 'AppUser', id: string, firstname?: string | null, lastname?: string | null, email: string, phone_number?: string | null, tenant: string, addresses: Array<{ __typename?: 'AppUserAddress', id: string, type: string, street_address: string, unit?: string | null, floor?: string | null, building_name?: string | null, district: string, region: string, postal_code: string, is_default: boolean, created_at: any, updated_at: any }>, patients: Array<{ __typename?: 'Patient', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, birthdate?: any | null, gender: string, status: string, emergency_contact_name?: string | null, emergency_contact_phone?: string | null, avatar_url?: string | null, blood_type?: string | null, nationality?: string | null, identity_document_type?: string | null, identity_document_number: string, language_preferences?: Array<string> | null, allergies?: Array<string> | null, chronic_conditions?: Array<string> | null, medications?: Array<string> | null, notes?: string | null, relationship_to_owner?: string | null, created_at: any, updated_at: any }> } | null, patient?: { __typename?: 'Patient', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, gender: string, birthdate?: any | null, email?: string | null, phone_number?: string | null, status: string, relationship_to_owner?: string | null, emergency_contact_name?: string | null, emergency_contact_phone?: string | null, blood_type?: string | null, nationality?: string | null, identity_document_type?: string | null, identity_document_number: string, language_preferences?: Array<string> | null, allergies?: Array<string> | null, chronic_conditions?: Array<string> | null, medications?: Array<string> | null, notes?: string | null, avatar_url?: string | null, created_at: any, updated_at: any } | null, provider?: { __typename?: 'Provider', id: string, doctor_id: string, clinic_id: string, consultation_fee?: number | null, department?: string | null, employment_type: string, start_date?: any | null, end_date?: any | null, status: string, role?: string | null, specialization_at_clinic?: string | null, last_worked_at?: any | null, verified_at?: any | null, created_at: any, updated_at: any, doctor: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, license_number: string, specialization: string, status: string, rating?: number | null, experience_years?: number | null, email?: string | null, phone_number?: string | null, avatar_url?: string | null, bio?: string | null, qualification?: string | null, title?: string | null, languages?: Array<string> | null }, clinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, internal_name: string, address: string, region: string, district: string, phone_number: string, email: string, status: string, building_name?: string | null, floor?: string | null, unit?: string | null } } | null } };

export type GetAppointmentsByDateRangeQueryVariables = Exact<{
  providerId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetAppointmentsByDateRangeQuery = { __typename?: 'Query', appointmentsByDateRange: Array<{ __typename?: 'Appointment', id: string, app_user_id: string, provider_id?: string | null, date: any, time: string, duration: number, status: string, type: string, reservation_type: string, questionnaire?: any | null, appointment_notes?: string | null, priority: string, consultation_type: string, language_preference?: string | null, booking_source: string, payment_status: string, payment_method?: string | null, total_amount?: number | null, insurance_claim_id?: string | null, timezone?: string | null, reminder_sent: boolean, confirmation_sent: boolean, rescheduled_from?: string | null, rescheduled_to?: string | null, cancelled_reason?: string | null, cancelled_by?: string | null, medical_history_reviewed: boolean, diagnosis?: string | null, treatment_plan?: string | null, prescription?: string | null, follow_up_required: boolean, follow_up_date?: any | null, patient_phone?: string | null, patient_email?: string | null, emergency_contact?: string | null, special_instructions?: string | null, patient_rating?: number | null, patient_feedback?: string | null, doctor_notes?: string | null, quality_score?: number | null, tenant: string, created_at: any, updated_at: any, scheduled_at?: any | null, confirmed_at?: any | null, started_at?: any | null, completed_at?: any | null, cancelled_at?: any | null }> };

export type GetAppointmentStatsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAppointmentStatsQuery = { __typename?: 'Query', appointmentStats: { __typename?: 'AppointmentStats', scheduled?: number | null, confirmed?: number | null, in_progress?: number | null, completed?: number | null, cancelled?: number | null, no_show?: number | null } };

export type GetTodaysAppointmentSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTodaysAppointmentSummaryQuery = { __typename?: 'Query', getTodaysAppointmentSummary: Array<{ __typename?: 'AppointmentSummaryReportItem', appointmentDateTime?: string | null, status?: string | null, payment?: string | null, extraMed?: boolean | null, deliveryWaybill?: string | null, timestamp?: string | null, lastnameEn?: string | null, firstnameEn?: string | null, chineseName?: string | null, gender?: string | null, dob?: string | null, hkid?: string | null, appUserPhone?: string | null, deliveryAddress?: string | null, transactionId?: string | null, district?: string | null, transactionTotal?: number | null }> };

export type GetAppointmentSummaryByDateQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type GetAppointmentSummaryByDateQuery = { __typename?: 'Query', getAppointmentSummaryByDate: Array<{ __typename?: 'AppointmentSummaryReportItem', appointmentDateTime?: string | null, status?: string | null, payment?: string | null, extraMed?: boolean | null, deliveryWaybill?: string | null, timestamp?: string | null, lastnameEn?: string | null, firstnameEn?: string | null, chineseName?: string | null, gender?: string | null, dob?: string | null, hkid?: string | null, appUserPhone?: string | null, deliveryAddress?: string | null, transactionId?: string | null, district?: string | null, transactionTotal?: number | null }> };

export type GetAppointmentSummaryByDateRangeQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  reportType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAppointmentSummaryByDateRangeQuery = { __typename?: 'Query', getAppointmentSummaryByDateRange: Array<{ __typename?: 'AppointmentSummaryReportItem', appointmentDateTime?: string | null, status?: string | null, payment?: string | null, extraMed?: boolean | null, deliveryWaybill?: string | null, timestamp?: string | null, lastnameEn?: string | null, firstnameEn?: string | null, chineseName?: string | null, gender?: string | null, dob?: string | null, hkid?: string | null, appUserPhone?: string | null, deliveryAddress?: string | null, transactionId?: string | null, district?: string | null, transactionTotal?: number | null, appointmentId?: string | null, date?: string | null, englishName?: string | null, waybillNo?: string | null, address?: string | null, mobile?: string | null, doctorName?: string | null }> };

export type GetClaimsExportByDateRangeQueryVariables = Exact<{
  payor: InsurancePayor;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetClaimsExportByDateRangeQuery = { __typename?: 'Query', getClaimsExportByDateRange: Array<{ __typename?: 'ClaimsExportItem', claimId: string, policyNumber?: string | null, policyName?: string | null, planName?: string | null, appointmentId: string, appointmentDate?: string | null, approvedAmount?: string | null, patientName?: string | null, doctorName?: string | null, clinicName?: string | null }> };

export type GetAppointmentAgoraLinkQueryVariables = Exact<{
  input: GetAppointmentAgoraLinkInput;
}>;


export type GetAppointmentAgoraLinkQuery = { __typename?: 'Query', getAppointmentAgoraLink: { __typename?: 'AppointmentAgoraLinkResponse', id: string, appointmentId: string, channelName: string, uid: string, role: string, token: string, link: string, webLink: string, appId: string, expiresAt: any, isActive: boolean, createdAt: any, updatedAt: any } };

export type GenerateAgoraTokenMutationVariables = Exact<{
  input: GenerateTokenInput;
}>;


export type GenerateAgoraTokenMutation = { __typename?: 'Mutation', generateAgoraToken: { __typename?: 'AgoraTokenResponse', token: string, appId: string, channelName: string, uid: string, role: string, expiresAt: number } };

export type ValidateAgoraTokenQueryVariables = Exact<{
  input: ValidateTokenInput;
}>;


export type ValidateAgoraTokenQuery = { __typename?: 'Query', validateAgoraToken: { __typename?: 'ValidateTokenResponse', isValid: boolean, message?: string | null } };

export type GetAgoraAppIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgoraAppIdQuery = { __typename?: 'Query', getAgoraAppId: string };

export type GetUserAppointmentsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserAppointmentsQuery = { __typename?: 'Query', userAppointments: Array<{ __typename?: 'Appointment', id: string, app_user_id: string, provider_id?: string | null, date: any, time: string, duration: number, status: string, type: string, reservation_type: string, questionnaire?: any | null, appointment_notes?: string | null, priority: string, consultation_type: string, language_preference?: string | null, booking_source: string, payment_status: string, payment_method?: string | null, total_amount?: number | null, insurance_claim_id?: string | null, timezone?: string | null, reminder_sent: boolean, confirmation_sent: boolean, rescheduled_from?: string | null, rescheduled_to?: string | null, cancelled_reason?: string | null, cancelled_by?: string | null, medical_history_reviewed: boolean, diagnosis?: string | null, treatment_plan?: string | null, prescription?: string | null, follow_up_required: boolean, follow_up_date?: any | null, patient_phone?: string | null, patient_email?: string | null, emergency_contact?: string | null, special_instructions?: string | null, patient_rating?: number | null, patient_feedback?: string | null, doctor_notes?: string | null, quality_score?: number | null, tenant: string, created_at: any, updated_at: any, scheduled_at?: any | null, confirmed_at?: any | null, started_at?: any | null, completed_at?: any | null, cancelled_at?: any | null, provider?: { __typename?: 'Provider', id: string, doctor_id: string, clinic_id: string, consultation_fee?: number | null, doctor: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, first_name_zh_cn: string, last_name_zh_cn: string, specialization: string, title?: string | null }, clinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, name_zh_cn: string, internal_name: string } } | null }> };

export type GetProviderAppointmentsQueryVariables = Exact<{
  providerId: Scalars['String']['input'];
}>;


export type GetProviderAppointmentsQuery = { __typename?: 'Query', providerAppointments: Array<{ __typename?: 'Appointment', id: string, app_user_id: string, provider_id?: string | null, date: any, time: string, duration: number, status: string, type: string, reservation_type: string, questionnaire?: any | null, appointment_notes?: string | null, priority: string, consultation_type: string, language_preference?: string | null, booking_source: string, payment_status: string, payment_method?: string | null, total_amount?: number | null, insurance_claim_id?: string | null, timezone?: string | null, reminder_sent: boolean, confirmation_sent: boolean, rescheduled_from?: string | null, rescheduled_to?: string | null, cancelled_reason?: string | null, cancelled_by?: string | null, medical_history_reviewed: boolean, diagnosis?: string | null, treatment_plan?: string | null, prescription?: string | null, follow_up_required: boolean, follow_up_date?: any | null, patient_phone?: string | null, patient_email?: string | null, emergency_contact?: string | null, special_instructions?: string | null, patient_rating?: number | null, patient_feedback?: string | null, doctor_notes?: string | null, quality_score?: number | null, tenant: string, created_at: any, updated_at: any, scheduled_at?: any | null, confirmed_at?: any | null, started_at?: any | null, completed_at?: any | null, cancelled_at?: any | null, provider?: { __typename?: 'Provider', id: string, doctor_id: string, clinic_id: string, consultation_fee?: number | null, doctor: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, first_name_zh_cn: string, last_name_zh_cn: string, specialization: string, title?: string | null }, clinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, name_zh_cn: string, internal_name: string } } | null }> };

export type GetDoctorAppointmentsQueryVariables = Exact<{
  doctorId: Scalars['String']['input'];
  filter?: InputMaybe<AppointmentFilterDto>;
}>;


export type GetDoctorAppointmentsQuery = { __typename?: 'Query', doctorAppointments: Array<{ __typename?: 'Appointment', id: string, app_user_id: string, patient_id?: string | null, provider_id?: string | null, date: any, time: string, duration: number, status: string, queue_number?: number | null, type: string, reservation_type: string, questionnaire?: any | null, appointment_notes?: string | null, priority: string, consultation_type: string, language_preference?: string | null, booking_source: string, payment_status: string, payment_method?: string | null, total_amount?: number | null, insurance_claim_id?: string | null, timezone?: string | null, reminder_sent: boolean, confirmation_sent: boolean, rescheduled_from?: string | null, rescheduled_to?: string | null, cancelled_reason?: string | null, cancelled_by?: string | null, medical_history_reviewed: boolean, diagnosis?: string | null, treatment_plan?: string | null, prescription?: string | null, follow_up_required: boolean, follow_up_date?: any | null, patient_phone?: string | null, patient_email?: string | null, emergency_contact?: string | null, special_instructions?: string | null, patient_rating?: number | null, patient_feedback?: string | null, doctor_notes?: string | null, quality_score?: number | null, created_at: any, updated_at: any, scheduled_at?: any | null, confirmed_at?: any | null, started_at?: any | null, completed_at?: any | null, cancelled_at?: any | null, otherStatuses?: any | null, app_user?: { __typename?: 'AppUser', id: string, firstname?: string | null, lastname?: string | null, email: string, phone_number?: string | null, tenant: string } | null, patient?: { __typename?: 'Patient', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, gender: string, birthdate?: any | null, email?: string | null, phone_number?: string | null, status: string, relationship_to_owner?: string | null } | null, provider?: { __typename?: 'Provider', id: string, doctor_id: string, clinic_id: string, consultation_fee?: number | null, doctor: { __typename?: 'Doctor', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, specialization: string, title?: string | null }, clinic: { __typename?: 'Clinic', id: string, name_en: string, name_zh_hk: string, internal_name: string, address: string, region: string, district: string } } | null }> };

export type GetTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransactionsQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'Transaction', id: string, app_user_id: string, appointment_id: string, transaction_reference: string, amount: number, currency: string, type: string, status: string, payment_method?: string | null, description?: string | null, category?: string | null, subcategory?: string | null, notes?: string | null, gateway_transaction_id?: string | null, gateway_response?: any | null, processing_fee?: number | null, tax_amount?: number | null, discount_amount?: number | null, final_amount?: number | null, metadata?: any | null, refund_reason?: string | null, refunded_by?: string | null, refunded_at?: any | null, original_transaction_id?: string | null, created_at: any, updated_at: any, processed_at?: any | null, completed_at?: any | null }> };

export type GetMyTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyTransactionsQuery = { __typename?: 'Query', myTransactions: Array<{ __typename?: 'Transaction', id: string, app_user_id: string, appointment_id: string, transaction_reference: string, amount: number, currency: string, type: string, status: string, payment_method?: string | null, description?: string | null, category?: string | null, subcategory?: string | null, notes?: string | null, gateway_transaction_id?: string | null, gateway_response?: any | null, processing_fee?: number | null, tax_amount?: number | null, discount_amount?: number | null, final_amount?: number | null, metadata?: any | null, refund_reason?: string | null, refunded_by?: string | null, refunded_at?: any | null, original_transaction_id?: string | null, created_at: any, updated_at: any, processed_at?: any | null, completed_at?: any | null }> };

export type GetAppointmentTransactionsQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type GetAppointmentTransactionsQuery = { __typename?: 'Query', appointmentTransactions: Array<{ __typename?: 'Transaction', id: string, app_user_id: string, appointment_id: string, transaction_reference: string, original_amount: number, amount: number, currency: string, type: string, status: string, payment_method?: string | null, description?: string | null, category?: string | null, subcategory?: string | null, notes?: string | null, gateway_transaction_id?: string | null, gateway_response?: any | null, processing_fee?: number | null, tax_amount?: number | null, discount_amount?: number | null, final_amount?: number | null, metadata?: any | null, refund_reason?: string | null, refunded_by?: string | null, refunded_at?: any | null, original_transaction_id?: string | null, created_at: any, updated_at: any, processed_at?: any | null, completed_at?: any | null }> };

export type GetTransactionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTransactionQuery = { __typename?: 'Query', transaction: { __typename?: 'Transaction', id: string, app_user_id: string, appointment_id: string, transaction_reference: string, amount: number, currency: string, type: string, status: string, payment_method?: string | null, description?: string | null, category?: string | null, subcategory?: string | null, notes?: string | null, gateway_transaction_id?: string | null, gateway_response?: any | null, processing_fee?: number | null, tax_amount?: number | null, discount_amount?: number | null, final_amount?: number | null, metadata?: any | null, refund_reason?: string | null, refunded_by?: string | null, refunded_at?: any | null, original_transaction_id?: string | null, created_at: any, updated_at: any, processed_at?: any | null, completed_at?: any | null } };

export type GetTransactionByReferenceQueryVariables = Exact<{
  transactionReference: Scalars['String']['input'];
}>;


export type GetTransactionByReferenceQuery = { __typename?: 'Query', transactionByReference: { __typename?: 'Transaction', id: string, app_user_id: string, appointment_id: string, transaction_reference: string, amount: number, currency: string, type: string, status: string, payment_method?: string | null, description?: string | null, category?: string | null, subcategory?: string | null, notes?: string | null, gateway_transaction_id?: string | null, gateway_response?: any | null, processing_fee?: number | null, tax_amount?: number | null, discount_amount?: number | null, final_amount?: number | null, metadata?: any | null, refund_reason?: string | null, refunded_by?: string | null, refunded_at?: any | null, original_transaction_id?: string | null, created_at: any, updated_at: any, processed_at?: any | null, completed_at?: any | null } };

export type GetTransactionStatsQueryVariables = Exact<{
  appUserId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTransactionStatsQuery = { __typename?: 'Query', transactionStats: { __typename?: 'TransactionStats', totalTransactions: number, totalAmount: number, totalPayments: number, totalRefunds: number, averageAmount: number } };

export type GenerateTransactionReferenceQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateTransactionReferenceQuery = { __typename?: 'Query', generateTransactionReference: string };

export type GetCloseBufferMinutesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCloseBufferMinutesQuery = { __typename?: 'Query', closeBufferMinutes: number };

export type SetCloseBufferMinutesMutationVariables = Exact<{
  minutes: Scalars['Float']['input'];
}>;


export type SetCloseBufferMinutesMutation = { __typename?: 'Mutation', setCloseBufferMinutes: boolean };

export type GetQueueNumberThresholdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQueueNumberThresholdQuery = { __typename?: 'Query', queueNumberThreshold: number };

export type SetQueueNumberThresholdMutationVariables = Exact<{
  number: Scalars['Float']['input'];
}>;


export type SetQueueNumberThresholdMutation = { __typename?: 'Mutation', setQueueNumberThreshold: boolean };

export type GetAppointmentEntryBufferMinutesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppointmentEntryBufferMinutesQuery = { __typename?: 'Query', appointmentEntryBufferMinutes: number };

export type SetAppointmentEntryBufferMinutesMutationVariables = Exact<{
  minutes: Scalars['Float']['input'];
}>;


export type SetAppointmentEntryBufferMinutesMutation = { __typename?: 'Mutation', setAppointmentEntryBufferMinutes: boolean };

export type GetDefaultDeliveryContactInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultDeliveryContactInfoQuery = { __typename?: 'Query', defaultDeliveryContactInfo: { __typename?: 'DefaultDeliveryContactInfo', contact: string, mobile: string, address: string } };

export type SetDefaultDeliveryContactInfoMutationVariables = Exact<{
  contact: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  address: Scalars['String']['input'];
}>;


export type SetDefaultDeliveryContactInfoMutation = { __typename?: 'Mutation', setDefaultDeliveryContactInfo: boolean };

export type GetDeliveryContactListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDeliveryContactListQuery = { __typename?: 'Query', deliveryContactList: Array<{ __typename?: 'DeliveryContact', id: string, contact: string, mobile: string, address: string }> };

export type SetDeliveryContactListMutationVariables = Exact<{
  contacts: Array<DeliveryContactInput> | DeliveryContactInput;
}>;


export type SetDeliveryContactListMutation = { __typename?: 'Mutation', setDeliveryContactList: boolean };

export type GetAppUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'AppUser', id: string, email: string, firstname?: string | null, lastname?: string | null, phone_number?: string | null, tenant: string, language_preference: string, ic_type?: string | null, ic_number?: string | null, birthdate?: any | null, age?: number | null, gender?: string | null, created_at: any, updated_at: any, deleted_at?: any | null, deleted_reason?: string | null, addresses: Array<{ __typename?: 'AppUserAddress', id: string, type: string, display_name: string, region: string, district: string, street_address: string, building_name?: string | null, floor?: string | null, block?: string | null, unit?: string | null, postal_code: string, is_default: boolean, phone_number: string, contact_name: string, created_at: any, updated_at: any }>, patients: Array<{ __typename?: 'Patient', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, birthdate?: any | null, gender: string, status: string, relationship_to_owner?: string | null, created_at: any, updated_at: any }> }> };

export type GetAppUsersPaginatedQueryVariables = Exact<{
  paginationDto: PaginationDto;
}>;


export type GetAppUsersPaginatedQuery = { __typename?: 'Query', usersPaginated: { __typename?: 'PaginatedUsersResponse', users: Array<{ __typename?: 'AppUser', id: string, email: string, firstname?: string | null, lastname?: string | null, phone_number?: string | null, tenant: string, language_preference: string, ic_type?: string | null, ic_number?: string | null, birthdate?: any | null, age?: number | null, gender?: string | null, created_at: any, updated_at: any, deleted_at?: any | null, deleted_reason?: string | null, addresses: Array<{ __typename?: 'AppUserAddress', id: string, type: string, display_name: string, region: string, district: string, street_address: string, building_name?: string | null, floor?: string | null, block?: string | null, unit?: string | null, postal_code: string, is_default: boolean, phone_number: string, contact_name: string, created_at: any, updated_at: any }>, patients: Array<{ __typename?: 'Patient', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, birthdate?: any | null, gender: string, status: string, relationship_to_owner?: string | null, created_at: any, updated_at: any }> }>, pagination: { __typename?: 'PaginationInfo', page: number, limit: number, total: number, totalPages: number, hasNext: boolean, hasPrev: boolean } } };

export type GetAppUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAppUserQuery = { __typename?: 'Query', user: { __typename?: 'AppUser', id: string, email: string, firstname?: string | null, lastname?: string | null, phone_number?: string | null, tenant: string, language_preference: string, ic_type?: string | null, ic_number?: string | null, birthdate?: any | null, age?: number | null, gender?: string | null, created_at: any, updated_at: any, deleted_at?: any | null, deleted_reason?: string | null, addresses: Array<{ __typename?: 'AppUserAddress', id: string, type: string, display_name: string, region: string, district: string, street_address: string, building_name?: string | null, floor?: string | null, block?: string | null, unit?: string | null, postal_code: string, is_default: boolean, phone_number: string, contact_name: string, created_at: any, updated_at: any }>, patients: Array<{ __typename?: 'Patient', id: string, first_name_en: string, last_name_en: string, first_name_zh_hk: string, last_name_zh_hk: string, email?: string | null, phone_number?: string | null, birthdate?: any | null, gender: string, status: string, relationship_to_owner?: string | null, created_at: any, updated_at: any }> } };

export type GetSfExpressOrdersForAppointmentQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type GetSfExpressOrdersForAppointmentQuery = { __typename?: 'Query', getSfExpressOrdersForAppointment: Array<{ __typename?: 'SfExpressOrder', id: string, tenant: string, request_id: string, service_code: string, timestamp: number, partner_id: string, msg_digest: string, request_data: any, response_data?: any | null, status: string, order_id?: string | null, waybill_no?: string | null, tracking_number?: string | null, error_code?: string | null, error_message?: string | null, api_result_code?: string | null, api_error_msg?: string | null, notes?: string | null, created_at: any, updated_at: any, processed_at?: any | null, retry_count?: number | null, last_retry_at?: any | null, metadata?: any | null, appointment_id?: string | null }> };

export type SearchSfExpressRoutesQueryVariables = Exact<{
  input: SfExpressRouteSearchInput;
}>;


export type SearchSfExpressRoutesQuery = { __typename?: 'Query', searchSfExpressRoutes: { __typename?: 'SfExpressRouteSearchResponseDto', success: boolean, errorCode?: string | null, errorMsg?: string | null, data?: { __typename?: 'SfExpressRouteInfoDto', waybillNo?: string | null, orderId?: string | null, trackingNumber?: string | null, routeInfo?: string | null, estimatedDelivery?: string | null, currentStatus?: string | null, currentLocation?: string | null, lastUpdateTime?: string | null, deliveryAddress?: string | null, senderAddress?: string | null } | null } };

export type SearchSfExpressRoutesByAppointmentIdQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type SearchSfExpressRoutesByAppointmentIdQuery = { __typename?: 'Query', searchSfExpressRoutesByAppointmentId: { __typename?: 'SfExpressRouteSearchResponseDto', success: boolean, errorCode?: string | null, errorMsg?: string | null, data?: { __typename?: 'SfExpressRouteInfoDto', waybillNo?: string | null, orderId?: string | null, trackingNumber?: string | null, routeInfo?: string | null, estimatedDelivery?: string | null, currentStatus?: string | null, currentLocation?: string | null, lastUpdateTime?: string | null, deliveryAddress?: string | null, senderAddress?: string | null } | null } };

export type GetJdExpressOrdersForAppointmentQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type GetJdExpressOrdersForAppointmentQuery = { __typename?: 'Query', getJdExpressOrdersForAppointment: Array<{ __typename?: 'JdExpressOrder', id: string, tenant: string, request_id: string, service_code: string, timestamp: number, partner_id: string, msg_digest: string, request_data: any, response_data?: any | null, status: string, order_id?: string | null, waybill_no?: string | null, tracking_number?: string | null, error_code?: string | null, error_message?: string | null, api_result_code?: string | null, api_error_msg?: string | null, notes?: string | null, created_at: any, updated_at: any, processed_at?: any | null, retry_count?: number | null, last_retry_at?: any | null, metadata?: any | null, appointment_id?: string | null }> };

export type GetExpressOrdersForAppointmentQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type GetExpressOrdersForAppointmentQuery = { __typename?: 'Query', getExpressOrdersForAppointment: { __typename?: 'ExpressOrdersResponse', sfExpressOrders: Array<{ __typename?: 'SfExpressOrder', id: string, tenant: string, request_id: string, service_code: string, timestamp: number, partner_id: string, msg_digest: string, request_data: any, response_data?: any | null, status: string, order_id?: string | null, waybill_no?: string | null, tracking_number?: string | null, error_code?: string | null, error_message?: string | null, api_result_code?: string | null, api_error_msg?: string | null, notes?: string | null, created_at: any, updated_at: any, processed_at?: any | null, retry_count?: number | null, last_retry_at?: any | null, metadata?: any | null, appointment_id?: string | null }>, jdExpressOrders: Array<{ __typename?: 'JdExpressOrder', id: string, tenant: string, request_id: string, service_code: string, timestamp: number, partner_id: string, msg_digest: string, request_data: any, response_data?: any | null, status: string, order_id?: string | null, waybill_no?: string | null, tracking_number?: string | null, error_code?: string | null, error_message?: string | null, api_result_code?: string | null, api_error_msg?: string | null, notes?: string | null, created_at: any, updated_at: any, processed_at?: any | null, retry_count?: number | null, last_retry_at?: any | null, metadata?: any | null, appointment_id?: string | null }> } };

export type GetInsurancePayorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsurancePayorsQuery = { __typename?: 'Query', insurancePayors: Array<InsurancePayor> };

export type GetInsurancePoliciesByPayorQueryVariables = Exact<{
  payor: InsurancePayor;
}>;


export type GetInsurancePoliciesByPayorQuery = { __typename?: 'Query', insurancePoliciesByPayor: Array<{ __typename?: 'InsurancePolicy', id: string, name: string, payor: string, planId: string, policyNumber?: string | null, startDate?: any | null, endDate?: any | null, appUserId?: string | null, description: string, isActive: boolean, createdAt: any, updatedAt: any, policyDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null }, plan?: { __typename?: 'InsurancePlan', id: string, name: string, payor: string, description: string, planDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null } } | null, appUser?: { __typename?: 'AppUser', id: string, firstname?: string | null, lastname?: string | null, email: string, phone_number?: string | null } | null }> };

export type GetInsurancePoliciesByPayorPaginatedQueryVariables = Exact<{
  payor: InsurancePayor;
  paginationDto: PaginationDto;
}>;


export type GetInsurancePoliciesByPayorPaginatedQuery = { __typename?: 'Query', insurancePoliciesByPayorPaginated: { __typename?: 'PaginatedInsurancePoliciesResponse', policies: Array<{ __typename?: 'InsurancePolicy', id: string, name: string, payor: string, planId: string, policyNumber?: string | null, startDate?: any | null, endDate?: any | null, appUserId?: string | null, description: string, isActive: boolean, createdAt: any, updatedAt: any, policyDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null }, plan?: { __typename?: 'InsurancePlan', id: string, name: string, payor: string, description: string, planDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null, copayment_amount?: number | null, coverage?: Array<{ __typename?: 'CoverageItem', name: string, description?: string | null, type: CoverageType, coverage_amount?: number | null, copayment_amount?: number | null, coverage_times_per_month?: number | null }> | null } } | null, appUser?: { __typename?: 'AppUser', id: string, firstname?: string | null, lastname?: string | null, email: string, phone_number?: string | null } | null }>, pagination: { __typename?: 'PaginationInfo', page: number, limit: number, total: number, totalPages: number, hasNext: boolean, hasPrev: boolean } } };

export type GetInsurancePlansByPayorQueryVariables = Exact<{
  payor: InsurancePayor;
}>;


export type GetInsurancePlansByPayorQuery = { __typename?: 'Query', insurancePlansByPayor: Array<{ __typename?: 'InsurancePlan', id: string, name: string, payor: string, description: string, createdAt: any, updatedAt: any, planDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null, copayment_amount?: number | null, coverage?: Array<{ __typename?: 'CoverageItem', name: string, description?: string | null, type: CoverageType, coverage_amount?: number | null, copayment_amount?: number | null, coverage_times_per_month?: number | null }> | null } }> };

export type IsCouponPayorQueryVariables = Exact<{
  payor: InsurancePayor;
}>;


export type IsCouponPayorQuery = { __typename?: 'Query', isCouponPayor: boolean };

export type GetInsuranceCouponsByPayorQueryVariables = Exact<{
  payor: InsurancePayor;
}>;


export type GetInsuranceCouponsByPayorQuery = { __typename?: 'Query', insuranceCouponsByPayor: Array<{ __typename?: 'InsuranceCoupon', id: string, payor: string, couponCode?: string | null, startDate?: any | null, endDate?: any | null, appUserId?: string | null, appointmentId?: string | null, isActive: boolean, createdAt: any, updatedAt: any, policyDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null }, plan?: { __typename?: 'InsurancePlan', id: string, name: string, payor: string, description: string, planDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null } } | null, appointment?: { __typename?: 'Appointment', id: string, date: any, time: string, status: string, type: string } | null }> };

export type GetInsuranceCouponsByPlanQueryVariables = Exact<{
  planId: Scalars['ID']['input'];
}>;


export type GetInsuranceCouponsByPlanQuery = { __typename?: 'Query', insuranceCouponsByPlan: Array<{ __typename?: 'InsuranceCoupon', id: string, payor: string, couponCode?: string | null, startDate?: any | null, endDate?: any | null, appUserId?: string | null, appointmentId?: string | null, isActive: boolean, createdAt: any, updatedAt: any, policyDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null }, plan?: { __typename?: 'InsurancePlan', id: string, name: string, payor: string, description: string } | null, appUser?: { __typename?: 'AppUser', id: string, firstname?: string | null, lastname?: string | null, email: string, phone_number?: string | null } | null }> };

export type GetPolicyConsumptionDetailsQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
}>;


export type GetPolicyConsumptionDetailsQuery = { __typename?: 'Query', insuranceEligibilityCheckResult?: { __typename?: 'InsuranceEligibilityCheckResult', insurancePolicyId: string, copaymentAmount?: number | null, coverageDetails: { __typename?: 'CoverageDetails', freeConsultations?: number | null, freeConsultationsPerYear?: number | null, freeConsultationsPerMonth?: number | null, freeConsultationsPerWeek?: number | null, remainingCoverageAmount?: any | null } } | null };

export type InsuranceEligibilityCheckByCategoryQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
  category: CoverageType;
}>;


export type InsuranceEligibilityCheckByCategoryQuery = { __typename?: 'Query', insuranceEligibilityCheckByCategory?: { __typename?: 'InsuranceEligibilityCheckResult', insurancePolicyId: string, copaymentAmount?: number | null, coverageDetails: { __typename?: 'CoverageDetails', freeConsultations?: number | null, freeConsultationsPerYear?: number | null, freeConsultationsPerMonth?: number | null, freeConsultationsPerWeek?: number | null, remainingCoverageAmount?: any | null } } | null };

export type GetInsurancePoliciesByUserQueryVariables = Exact<{
  appUserId: Scalars['ID']['input'];
}>;


export type GetInsurancePoliciesByUserQuery = { __typename?: 'Query', insurancePoliciesByUser: Array<{ __typename?: 'InsurancePolicy', id: string, name: string, payor: string, planId: string, policyNumber?: string | null, startDate?: any | null, endDate?: any | null, appUserId?: string | null, description: string, isActive: boolean, createdAt: any, updatedAt: any, policyDetails: { __typename?: 'InsurancePolicyDetails', free_consultations?: number | null, free_consultations_per_year?: number | null, free_consultations_per_month?: number | null, free_consultations_per_week?: number | null } }> };

export type GetInsuranceClaimsByAppointmentQueryVariables = Exact<{
  appointmentId: Scalars['ID']['input'];
}>;


export type GetInsuranceClaimsByAppointmentQuery = { __typename?: 'Query', insuranceClaimResultsByAppointment: Array<{ __typename?: 'InsuranceClaim', id: string, policyId: string, appointmentId: string, status: string, isActive: boolean, createdAt: any, updatedAt: any, claimResultDetails: { __typename?: 'InsuranceClaimResultDetails', approved_amount?: string | null, rejected_amount?: string | null, rejected_reason?: string | null }, items: Array<{ __typename?: 'InsuranceClaimItem', id: string, insuranceClaimId: string, name: string, category: string, amount: string, approvedAmount: string, transactionId?: string | null, createdAt: any, updatedAt: any }> }> };

export type GetInsuranceClaimsByPolicyQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
}>;


export type GetInsuranceClaimsByPolicyQuery = { __typename?: 'Query', insuranceClaimResultsByPolicy: Array<{ __typename?: 'InsuranceClaim', id: string, policyId: string, appointmentId: string, status: string, isActive: boolean, createdAt: any, updatedAt: any, claimResultDetails: { __typename?: 'InsuranceClaimResultDetails', approved_amount?: string | null, rejected_amount?: string | null, rejected_reason?: string | null }, items: Array<{ __typename?: 'InsuranceClaimItem', id: string, insuranceClaimId: string, name: string, category: string, amount: string, approvedAmount: string, transactionId?: string | null, createdAt: any, updatedAt: any }> }> };

export type GetInsuranceClaimByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInsuranceClaimByIdQuery = { __typename?: 'Query', insuranceClaimResult: { __typename?: 'InsuranceClaim', id: string, policyId: string, appointmentId: string, status: string, isActive: boolean, createdAt: any, updatedAt: any, claimResultDetails: { __typename?: 'InsuranceClaimResultDetails', approved_amount?: string | null, rejected_amount?: string | null, rejected_reason?: string | null }, items: Array<{ __typename?: 'InsuranceClaimItem', id: string, insuranceClaimId: string, name: string, category: string, amount: string, approvedAmount: string, transactionId?: string | null, createdAt: any, updatedAt: any }> } };

export type CreateSfExpressOrderFromAppointmentMutationVariables = Exact<{
  input: CreateSfExpressOrderFromAppointmentDto;
}>;


export type CreateSfExpressOrderFromAppointmentMutation = { __typename?: 'Mutation', createSfExpressOrderFromAppointment: { __typename?: 'SfExpressOrderResponse', success: boolean, errorCode?: string | null, errorMsg?: string | null, data?: { __typename?: 'SfExpressOrderData', orderId: string, trackingNumber?: string | null, waybillNo?: string | null } | null } };

export type CreateJdExpressOrderFromAppointmentMutationVariables = Exact<{
  input: CreateJdExpressOrderFromAppointmentDto;
}>;


export type CreateJdExpressOrderFromAppointmentMutation = { __typename?: 'Mutation', createJdExpressOrderFromAppointment: { __typename?: 'JdExpressAppointmentOrderApiResponseDto', success: boolean, errorCode?: string | null, errorMsg?: string | null, data?: { __typename?: 'JdExpressOrderResponseDto', orderId?: string | null, trackingNumber?: string | null, waybillNo?: string | null, estimatedDelivery?: string | null, freight?: number | null, insuranceFee?: number | null, totalFee?: number | null, originCode?: string | null, destCode?: string | null, remark?: string | null } | null } };


export const CreateClinicDocument = gql`
    mutation CreateClinic($createClinicDto: CreateClinicDto!) {
  createClinic(createClinicDto: $createClinicDto) {
    id
    name_en
    name_zh_hk
    internal_name
    address
    phone_number
    email
    status
    region
    district
    description
    building_name
    floor
    unit
    postal_code
    website_url
    emergency_services
    walk_in_enabled
    online_consultation_enabled
    appointment_booking_enabled
    facilities
    services
    images
    latitude
    longitude
    created_at
    updated_at
  }
}
    `;
export type CreateClinicMutationFn = Apollo.MutationFunction<CreateClinicMutation, CreateClinicMutationVariables>;

/**
 * __useCreateClinicMutation__
 *
 * To run a mutation, you first call `useCreateClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicMutation, { data, loading, error }] = useCreateClinicMutation({
 *   variables: {
 *      createClinicDto: // value for 'createClinicDto'
 *   },
 * });
 */
export function useCreateClinicMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicMutation, CreateClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicMutation, CreateClinicMutationVariables>(CreateClinicDocument, options);
      }
export type CreateClinicMutationHookResult = ReturnType<typeof useCreateClinicMutation>;
export type CreateClinicMutationResult = Apollo.MutationResult<CreateClinicMutation>;
export type CreateClinicMutationOptions = Apollo.BaseMutationOptions<CreateClinicMutation, CreateClinicMutationVariables>;
export const UpdateClinicDocument = gql`
    mutation UpdateClinic($id: ID!, $updateClinicDto: UpdateClinicDto!) {
  updateClinic(id: $id, updateClinicDto: $updateClinicDto) {
    id
    name_en
    name_zh_hk
    internal_name
    address
    phone_number
    email
    status
    region
    district
    description
    building_name
    floor
    unit
    postal_code
    website_url
    emergency_services
    walk_in_enabled
    online_consultation_enabled
    appointment_booking_enabled
    facilities
    services
    images
    latitude
    longitude
    created_at
    updated_at
  }
}
    `;
export type UpdateClinicMutationFn = Apollo.MutationFunction<UpdateClinicMutation, UpdateClinicMutationVariables>;

/**
 * __useUpdateClinicMutation__
 *
 * To run a mutation, you first call `useUpdateClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicMutation, { data, loading, error }] = useUpdateClinicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateClinicDto: // value for 'updateClinicDto'
 *   },
 * });
 */
export function useUpdateClinicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicMutation, UpdateClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicMutation, UpdateClinicMutationVariables>(UpdateClinicDocument, options);
      }
export type UpdateClinicMutationHookResult = ReturnType<typeof useUpdateClinicMutation>;
export type UpdateClinicMutationResult = Apollo.MutationResult<UpdateClinicMutation>;
export type UpdateClinicMutationOptions = Apollo.BaseMutationOptions<UpdateClinicMutation, UpdateClinicMutationVariables>;
export const DeleteClinicDocument = gql`
    mutation DeleteClinic($id: ID!) {
  deleteClinic(id: $id)
}
    `;
export type DeleteClinicMutationFn = Apollo.MutationFunction<DeleteClinicMutation, DeleteClinicMutationVariables>;

/**
 * __useDeleteClinicMutation__
 *
 * To run a mutation, you first call `useDeleteClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicMutation, { data, loading, error }] = useDeleteClinicMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClinicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicMutation, DeleteClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicMutation, DeleteClinicMutationVariables>(DeleteClinicDocument, options);
      }
export type DeleteClinicMutationHookResult = ReturnType<typeof useDeleteClinicMutation>;
export type DeleteClinicMutationResult = Apollo.MutationResult<DeleteClinicMutation>;
export type DeleteClinicMutationOptions = Apollo.BaseMutationOptions<DeleteClinicMutation, DeleteClinicMutationVariables>;
export const CreateDoctorDocument = gql`
    mutation CreateDoctor($createDoctorDto: CreateDoctorDto!) {
  createDoctor(createDoctorDto: $createDoctorDto) {
    id
    first_name_en
    last_name_en
    first_name_zh_hk
    last_name_zh_hk
    email
    phone_number
    license_number
    specialization
    status
    rating
    experience_years
    consultation_fee
    avatar_url
    bio
    qualification
    title
    languages
    is_available_for_emergency
    max_daily_appointments
    total_reviews
    time_zone
    created_at
    updated_at
  }
}
    `;
export type CreateDoctorMutationFn = Apollo.MutationFunction<CreateDoctorMutation, CreateDoctorMutationVariables>;

/**
 * __useCreateDoctorMutation__
 *
 * To run a mutation, you first call `useCreateDoctorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDoctorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDoctorMutation, { data, loading, error }] = useCreateDoctorMutation({
 *   variables: {
 *      createDoctorDto: // value for 'createDoctorDto'
 *   },
 * });
 */
export function useCreateDoctorMutation(baseOptions?: Apollo.MutationHookOptions<CreateDoctorMutation, CreateDoctorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDoctorMutation, CreateDoctorMutationVariables>(CreateDoctorDocument, options);
      }
export type CreateDoctorMutationHookResult = ReturnType<typeof useCreateDoctorMutation>;
export type CreateDoctorMutationResult = Apollo.MutationResult<CreateDoctorMutation>;
export type CreateDoctorMutationOptions = Apollo.BaseMutationOptions<CreateDoctorMutation, CreateDoctorMutationVariables>;
export const UpdateDoctorDocument = gql`
    mutation UpdateDoctor($id: ID!, $updateDoctorDto: UpdateDoctorDto!) {
  updateDoctor(id: $id, updateDoctorDto: $updateDoctorDto) {
    id
    first_name_en
    last_name_en
    first_name_zh_hk
    last_name_zh_hk
    email
    phone_number
    license_number
    specialization
    status
    rating
    experience_years
    consultation_fee
    avatar_url
    bio
    qualification
    title
    languages
    is_available_for_emergency
    max_daily_appointments
    total_reviews
    time_zone
    created_at
    updated_at
  }
}
    `;
export type UpdateDoctorMutationFn = Apollo.MutationFunction<UpdateDoctorMutation, UpdateDoctorMutationVariables>;

/**
 * __useUpdateDoctorMutation__
 *
 * To run a mutation, you first call `useUpdateDoctorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDoctorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDoctorMutation, { data, loading, error }] = useUpdateDoctorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateDoctorDto: // value for 'updateDoctorDto'
 *   },
 * });
 */
export function useUpdateDoctorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDoctorMutation, UpdateDoctorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDoctorMutation, UpdateDoctorMutationVariables>(UpdateDoctorDocument, options);
      }
export type UpdateDoctorMutationHookResult = ReturnType<typeof useUpdateDoctorMutation>;
export type UpdateDoctorMutationResult = Apollo.MutationResult<UpdateDoctorMutation>;
export type UpdateDoctorMutationOptions = Apollo.BaseMutationOptions<UpdateDoctorMutation, UpdateDoctorMutationVariables>;
export const DeleteDoctorDocument = gql`
    mutation DeleteDoctor($id: ID!) {
  deleteDoctor(id: $id)
}
    `;
export type DeleteDoctorMutationFn = Apollo.MutationFunction<DeleteDoctorMutation, DeleteDoctorMutationVariables>;

/**
 * __useDeleteDoctorMutation__
 *
 * To run a mutation, you first call `useDeleteDoctorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDoctorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDoctorMutation, { data, loading, error }] = useDeleteDoctorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDoctorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDoctorMutation, DeleteDoctorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDoctorMutation, DeleteDoctorMutationVariables>(DeleteDoctorDocument, options);
      }
export type DeleteDoctorMutationHookResult = ReturnType<typeof useDeleteDoctorMutation>;
export type DeleteDoctorMutationResult = Apollo.MutationResult<DeleteDoctorMutation>;
export type DeleteDoctorMutationOptions = Apollo.BaseMutationOptions<DeleteDoctorMutation, DeleteDoctorMutationVariables>;
export const CreatePatientDocument = gql`
    mutation CreatePatient($createPatientDto: CreatePatientDto!) {
  createPatient(createPatientDto: $createPatientDto) {
    id
    first_name_en
    last_name_en
    first_name_zh_hk
    last_name_zh_hk
    email
    phone_number
    birthdate
    gender
    status
    emergency_contact_name
    emergency_contact_phone
    avatar_url
    blood_type
    nationality
    identity_document_type
    identity_document_number
    language_preferences
    allergies
    chronic_conditions
    medications
    notes
    created_at
    updated_at
    app_user {
      id
      firstname
      lastname
      email
      phone_number
    }
  }
}
    `;
export type CreatePatientMutationFn = Apollo.MutationFunction<CreatePatientMutation, CreatePatientMutationVariables>;

/**
 * __useCreatePatientMutation__
 *
 * To run a mutation, you first call `useCreatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientMutation, { data, loading, error }] = useCreatePatientMutation({
 *   variables: {
 *      createPatientDto: // value for 'createPatientDto'
 *   },
 * });
 */
export function useCreatePatientMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientMutation, CreatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatientMutation, CreatePatientMutationVariables>(CreatePatientDocument, options);
      }
export type CreatePatientMutationHookResult = ReturnType<typeof useCreatePatientMutation>;
export type CreatePatientMutationResult = Apollo.MutationResult<CreatePatientMutation>;
export type CreatePatientMutationOptions = Apollo.BaseMutationOptions<CreatePatientMutation, CreatePatientMutationVariables>;
export const UpdatePatientDocument = gql`
    mutation UpdatePatient($id: ID!, $updatePatientDto: UpdatePatientDto!) {
  updatePatient(id: $id, updatePatientDto: $updatePatientDto) {
    id
    first_name_en
    last_name_en
    first_name_zh_hk
    last_name_zh_hk
    email
    phone_number
    birthdate
    gender
    status
    emergency_contact_name
    emergency_contact_phone
    avatar_url
    blood_type
    nationality
    identity_document_type
    identity_document_number
    language_preferences
    allergies
    chronic_conditions
    medications
    notes
    created_at
    updated_at
    app_user {
      id
      firstname
      lastname
      email
      phone_number
    }
  }
}
    `;
export type UpdatePatientMutationFn = Apollo.MutationFunction<UpdatePatientMutation, UpdatePatientMutationVariables>;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatePatientDto: // value for 'updatePatientDto'
 *   },
 * });
 */
export function useUpdatePatientMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientMutation, UpdatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientMutation, UpdatePatientMutationVariables>(UpdatePatientDocument, options);
      }
export type UpdatePatientMutationHookResult = ReturnType<typeof useUpdatePatientMutation>;
export type UpdatePatientMutationResult = Apollo.MutationResult<UpdatePatientMutation>;
export type UpdatePatientMutationOptions = Apollo.BaseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>;
export const DeletePatientDocument = gql`
    mutation DeletePatient($id: ID!) {
  deletePatient(id: $id)
}
    `;
export type DeletePatientMutationFn = Apollo.MutationFunction<DeletePatientMutation, DeletePatientMutationVariables>;

/**
 * __useDeletePatientMutation__
 *
 * To run a mutation, you first call `useDeletePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePatientMutation, { data, loading, error }] = useDeletePatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePatientMutation(baseOptions?: Apollo.MutationHookOptions<DeletePatientMutation, DeletePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePatientMutation, DeletePatientMutationVariables>(DeletePatientDocument, options);
      }
export type DeletePatientMutationHookResult = ReturnType<typeof useDeletePatientMutation>;
export type DeletePatientMutationResult = Apollo.MutationResult<DeletePatientMutation>;
export type DeletePatientMutationOptions = Apollo.BaseMutationOptions<DeletePatientMutation, DeletePatientMutationVariables>;
export const CreateProviderDocument = gql`
    mutation CreateProvider($createProviderDto: CreateProviderDto!) {
  createProvider(createProviderDto: $createProviderDto) {
    id
    doctor_id
    clinic_id
    consultation_fee
    department
    employment_type
    start_date
    end_date
    status
    role
    specialization_at_clinic
    last_worked_at
    verified_at
    created_at
    updated_at
    doctor {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      license_number
      specialization
      status
      rating
      experience_years
      email
      phone_number
    }
    clinic {
      id
      name_en
      name_zh_hk
      address
      region
      district
      phone_number
      email
      status
    }
  }
}
    `;
export type CreateProviderMutationFn = Apollo.MutationFunction<CreateProviderMutation, CreateProviderMutationVariables>;

/**
 * __useCreateProviderMutation__
 *
 * To run a mutation, you first call `useCreateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderMutation, { data, loading, error }] = useCreateProviderMutation({
 *   variables: {
 *      createProviderDto: // value for 'createProviderDto'
 *   },
 * });
 */
export function useCreateProviderMutation(baseOptions?: Apollo.MutationHookOptions<CreateProviderMutation, CreateProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProviderMutation, CreateProviderMutationVariables>(CreateProviderDocument, options);
      }
export type CreateProviderMutationHookResult = ReturnType<typeof useCreateProviderMutation>;
export type CreateProviderMutationResult = Apollo.MutationResult<CreateProviderMutation>;
export type CreateProviderMutationOptions = Apollo.BaseMutationOptions<CreateProviderMutation, CreateProviderMutationVariables>;
export const UpdateProviderDocument = gql`
    mutation UpdateProvider($id: ID!, $updateProviderDto: UpdateProviderDto!) {
  updateProvider(id: $id, updateProviderDto: $updateProviderDto) {
    id
    doctor_id
    clinic_id
    consultation_fee
    department
    employment_type
    start_date
    end_date
    status
    role
    specialization_at_clinic
    last_worked_at
    verified_at
    created_at
    updated_at
    doctor {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      license_number
      specialization
      status
      rating
      experience_years
      email
      phone_number
    }
    clinic {
      id
      name_en
      name_zh_hk
      address
      region
      district
      phone_number
      email
      status
    }
  }
}
    `;
export type UpdateProviderMutationFn = Apollo.MutationFunction<UpdateProviderMutation, UpdateProviderMutationVariables>;

/**
 * __useUpdateProviderMutation__
 *
 * To run a mutation, you first call `useUpdateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderMutation, { data, loading, error }] = useUpdateProviderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateProviderDto: // value for 'updateProviderDto'
 *   },
 * });
 */
export function useUpdateProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderMutation, UpdateProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderMutation, UpdateProviderMutationVariables>(UpdateProviderDocument, options);
      }
export type UpdateProviderMutationHookResult = ReturnType<typeof useUpdateProviderMutation>;
export type UpdateProviderMutationResult = Apollo.MutationResult<UpdateProviderMutation>;
export type UpdateProviderMutationOptions = Apollo.BaseMutationOptions<UpdateProviderMutation, UpdateProviderMutationVariables>;
export const DeleteProviderDocument = gql`
    mutation DeleteProvider($id: ID!) {
  deleteProvider(id: $id)
}
    `;
export type DeleteProviderMutationFn = Apollo.MutationFunction<DeleteProviderMutation, DeleteProviderMutationVariables>;

/**
 * __useDeleteProviderMutation__
 *
 * To run a mutation, you first call `useDeleteProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderMutation, { data, loading, error }] = useDeleteProviderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProviderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderMutation, DeleteProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderMutation, DeleteProviderMutationVariables>(DeleteProviderDocument, options);
      }
export type DeleteProviderMutationHookResult = ReturnType<typeof useDeleteProviderMutation>;
export type DeleteProviderMutationResult = Apollo.MutationResult<DeleteProviderMutation>;
export type DeleteProviderMutationOptions = Apollo.BaseMutationOptions<DeleteProviderMutation, DeleteProviderMutationVariables>;
export const AddTagToProviderDocument = gql`
    mutation AddTagToProvider($providerId: ID!, $tagId: ID!, $userId: ID) {
  addTagToProvider(providerId: $providerId, tagId: $tagId, userId: $userId)
}
    `;
export type AddTagToProviderMutationFn = Apollo.MutationFunction<AddTagToProviderMutation, AddTagToProviderMutationVariables>;

/**
 * __useAddTagToProviderMutation__
 *
 * To run a mutation, you first call `useAddTagToProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagToProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagToProviderMutation, { data, loading, error }] = useAddTagToProviderMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      tagId: // value for 'tagId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddTagToProviderMutation(baseOptions?: Apollo.MutationHookOptions<AddTagToProviderMutation, AddTagToProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagToProviderMutation, AddTagToProviderMutationVariables>(AddTagToProviderDocument, options);
      }
export type AddTagToProviderMutationHookResult = ReturnType<typeof useAddTagToProviderMutation>;
export type AddTagToProviderMutationResult = Apollo.MutationResult<AddTagToProviderMutation>;
export type AddTagToProviderMutationOptions = Apollo.BaseMutationOptions<AddTagToProviderMutation, AddTagToProviderMutationVariables>;
export const RemoveTagFromProviderDocument = gql`
    mutation RemoveTagFromProvider($providerId: ID!, $tagId: ID!) {
  removeTagFromProvider(providerId: $providerId, tagId: $tagId)
}
    `;
export type RemoveTagFromProviderMutationFn = Apollo.MutationFunction<RemoveTagFromProviderMutation, RemoveTagFromProviderMutationVariables>;

/**
 * __useRemoveTagFromProviderMutation__
 *
 * To run a mutation, you first call `useRemoveTagFromProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagFromProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagFromProviderMutation, { data, loading, error }] = useRemoveTagFromProviderMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useRemoveTagFromProviderMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTagFromProviderMutation, RemoveTagFromProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTagFromProviderMutation, RemoveTagFromProviderMutationVariables>(RemoveTagFromProviderDocument, options);
      }
export type RemoveTagFromProviderMutationHookResult = ReturnType<typeof useRemoveTagFromProviderMutation>;
export type RemoveTagFromProviderMutationResult = Apollo.MutationResult<RemoveTagFromProviderMutation>;
export type RemoveTagFromProviderMutationOptions = Apollo.BaseMutationOptions<RemoveTagFromProviderMutation, RemoveTagFromProviderMutationVariables>;
export const CreateScheduleDocument = gql`
    mutation CreateSchedule($createScheduleDto: CreateScheduleDto!, $providerId: ID!) {
  createSchedule(createScheduleDto: $createScheduleDto, providerId: $providerId) {
    id
    provider_id
    status
    max_appointments_per_day
    default_appointment_duration
    is_available_for_telemedicine
    is_available_for_walk_in
    schedule {
      monday {
        from
        to
      }
      tuesday {
        from
        to
      }
      wednesday {
        from
        to
      }
      thursday {
        from
        to
      }
      friday {
        from
        to
      }
      saturday {
        from
        to
      }
      sunday {
        from
        to
      }
    }
    created_at
    updated_at
  }
}
    `;
export type CreateScheduleMutationFn = Apollo.MutationFunction<CreateScheduleMutation, CreateScheduleMutationVariables>;

/**
 * __useCreateScheduleMutation__
 *
 * To run a mutation, you first call `useCreateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleMutation, { data, loading, error }] = useCreateScheduleMutation({
 *   variables: {
 *      createScheduleDto: // value for 'createScheduleDto'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useCreateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleMutation, CreateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleMutation, CreateScheduleMutationVariables>(CreateScheduleDocument, options);
      }
export type CreateScheduleMutationHookResult = ReturnType<typeof useCreateScheduleMutation>;
export type CreateScheduleMutationResult = Apollo.MutationResult<CreateScheduleMutation>;
export type CreateScheduleMutationOptions = Apollo.BaseMutationOptions<CreateScheduleMutation, CreateScheduleMutationVariables>;
export const UpdateScheduleDocument = gql`
    mutation UpdateSchedule($id: ID!, $updateScheduleDto: UpdateScheduleDto!) {
  updateSchedule(id: $id, updateScheduleDto: $updateScheduleDto) {
    id
    provider_id
    status
    max_appointments_per_day
    default_appointment_duration
    is_available_for_telemedicine
    is_available_for_walk_in
    schedule {
      monday {
        from
        to
      }
      tuesday {
        from
        to
      }
      wednesday {
        from
        to
      }
      thursday {
        from
        to
      }
      friday {
        from
        to
      }
      saturday {
        from
        to
      }
      sunday {
        from
        to
      }
    }
    created_at
    updated_at
  }
}
    `;
export type UpdateScheduleMutationFn = Apollo.MutationFunction<UpdateScheduleMutation, UpdateScheduleMutationVariables>;

/**
 * __useUpdateScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleMutation, { data, loading, error }] = useUpdateScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateScheduleDto: // value for 'updateScheduleDto'
 *   },
 * });
 */
export function useUpdateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleMutation, UpdateScheduleMutationVariables>(UpdateScheduleDocument, options);
      }
export type UpdateScheduleMutationHookResult = ReturnType<typeof useUpdateScheduleMutation>;
export type UpdateScheduleMutationResult = Apollo.MutationResult<UpdateScheduleMutation>;
export type UpdateScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>;
export const DeleteScheduleDocument = gql`
    mutation DeleteSchedule($id: ID!) {
  deleteSchedule(id: $id)
}
    `;
export type DeleteScheduleMutationFn = Apollo.MutationFunction<DeleteScheduleMutation, DeleteScheduleMutationVariables>;

/**
 * __useDeleteScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduleMutation, { data, loading, error }] = useDeleteScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduleMutation, DeleteScheduleMutationVariables>(DeleteScheduleDocument, options);
      }
export type DeleteScheduleMutationHookResult = ReturnType<typeof useDeleteScheduleMutation>;
export type DeleteScheduleMutationResult = Apollo.MutationResult<DeleteScheduleMutation>;
export type DeleteScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>;
export const CreateAppointmentDocument = gql`
    mutation CreateAppointment($createAppointmentDto: CreateAppointmentDto!) {
  createAppointment(createAppointmentDto: $createAppointmentDto) {
    appointment {
      id
      app_user_id
      provider_id
      date
      time
      duration
      status
      type
      reservation_type
      questionnaire
      appointment_notes
      priority
      consultation_type
      language_preference
      booking_source
      payment_method
      total_amount
      insurance_claim_id
      timezone
      medical_history_reviewed
      patient_phone
      patient_email
      emergency_contact
      special_instructions
      tenant
      created_at
      updated_at
    }
    transaction {
      id
      appointment_id
      amount
      currency
      status
      payment_method
      transaction_reference
      gateway_transaction_id
      metadata
      created_at
      updated_at
    }
  }
}
    `;
export type CreateAppointmentMutationFn = Apollo.MutationFunction<CreateAppointmentMutation, CreateAppointmentMutationVariables>;

/**
 * __useCreateAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentMutation, { data, loading, error }] = useCreateAppointmentMutation({
 *   variables: {
 *      createAppointmentDto: // value for 'createAppointmentDto'
 *   },
 * });
 */
export function useCreateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentMutation, CreateAppointmentMutationVariables>(CreateAppointmentDocument, options);
      }
export type CreateAppointmentMutationHookResult = ReturnType<typeof useCreateAppointmentMutation>;
export type CreateAppointmentMutationResult = Apollo.MutationResult<CreateAppointmentMutation>;
export type CreateAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>;
export const UpdateAppointmentDocument = gql`
    mutation UpdateAppointment($id: String!, $updateAppointmentDto: UpdateAppointmentDto!) {
  updateAppointment(id: $id, updateAppointmentDto: $updateAppointmentDto) {
    id
    app_user_id
    provider_id
    date
    time
    duration
    status
    type
    reservation_type
    questionnaire
    appointment_notes
    internal_remark
    doctor_notes
    priority
    consultation_type
    language_preference
    booking_source
    payment_method
    total_amount
    insurance_claim_id
    timezone
    medical_history_reviewed
    patient_phone
    patient_email
    emergency_contact
    special_instructions
    tenant
    created_at
    updated_at
  }
}
    `;
export type UpdateAppointmentMutationFn = Apollo.MutationFunction<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;

/**
 * __useUpdateAppointmentMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentMutation, { data, loading, error }] = useUpdateAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateAppointmentDto: // value for 'updateAppointmentDto'
 *   },
 * });
 */
export function useUpdateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>(UpdateAppointmentDocument, options);
      }
export type UpdateAppointmentMutationHookResult = ReturnType<typeof useUpdateAppointmentMutation>;
export type UpdateAppointmentMutationResult = Apollo.MutationResult<UpdateAppointmentMutation>;
export type UpdateAppointmentMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;
export const DeleteAppointmentDocument = gql`
    mutation DeleteAppointment($id: String!) {
  removeAppointment(id: $id) {
    id
    app_user_id
    provider_id
    date
    time
    duration
    status
    type
    reservation_type
    questionnaire
    appointment_notes
    priority
    consultation_type
    language_preference
    booking_source
    payment_method
    total_amount
    insurance_claim_id
    timezone
    medical_history_reviewed
    patient_phone
    patient_email
    emergency_contact
    special_instructions
    tenant
    created_at
    updated_at
  }
}
    `;
export type DeleteAppointmentMutationFn = Apollo.MutationFunction<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>;

/**
 * __useDeleteAppointmentMutation__
 *
 * To run a mutation, you first call `useDeleteAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppointmentMutation, { data, loading, error }] = useDeleteAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>(DeleteAppointmentDocument, options);
      }
export type DeleteAppointmentMutationHookResult = ReturnType<typeof useDeleteAppointmentMutation>;
export type DeleteAppointmentMutationResult = Apollo.MutationResult<DeleteAppointmentMutation>;
export type DeleteAppointmentMutationOptions = Apollo.BaseMutationOptions<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>;
export const ConfirmAppointmentDocument = gql`
    mutation ConfirmAppointment($id: String!) {
  confirmAppointment(id: $id) {
    id
    status
    confirmed_at
    updated_at
  }
}
    `;
export type ConfirmAppointmentMutationFn = Apollo.MutationFunction<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>;

/**
 * __useConfirmAppointmentMutation__
 *
 * To run a mutation, you first call `useConfirmAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAppointmentMutation, { data, loading, error }] = useConfirmAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>(ConfirmAppointmentDocument, options);
      }
export type ConfirmAppointmentMutationHookResult = ReturnType<typeof useConfirmAppointmentMutation>;
export type ConfirmAppointmentMutationResult = Apollo.MutationResult<ConfirmAppointmentMutation>;
export type ConfirmAppointmentMutationOptions = Apollo.BaseMutationOptions<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>;
export const StartAppointmentDocument = gql`
    mutation StartAppointment($id: String!) {
  startAppointment(id: $id) {
    id
    status
    started_at
    updated_at
  }
}
    `;
export type StartAppointmentMutationFn = Apollo.MutationFunction<StartAppointmentMutation, StartAppointmentMutationVariables>;

/**
 * __useStartAppointmentMutation__
 *
 * To run a mutation, you first call `useStartAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAppointmentMutation, { data, loading, error }] = useStartAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<StartAppointmentMutation, StartAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAppointmentMutation, StartAppointmentMutationVariables>(StartAppointmentDocument, options);
      }
export type StartAppointmentMutationHookResult = ReturnType<typeof useStartAppointmentMutation>;
export type StartAppointmentMutationResult = Apollo.MutationResult<StartAppointmentMutation>;
export type StartAppointmentMutationOptions = Apollo.BaseMutationOptions<StartAppointmentMutation, StartAppointmentMutationVariables>;
export const DeleteSfExpressOrderDocument = gql`
    mutation DeleteSfExpressOrder($input: DeleteSfExpressOrderDto!) {
  deleteSfExpressOrder(input: $input)
}
    `;
export type DeleteSfExpressOrderMutationFn = Apollo.MutationFunction<DeleteSfExpressOrderMutation, DeleteSfExpressOrderMutationVariables>;

/**
 * __useDeleteSfExpressOrderMutation__
 *
 * To run a mutation, you first call `useDeleteSfExpressOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSfExpressOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSfExpressOrderMutation, { data, loading, error }] = useDeleteSfExpressOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSfExpressOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSfExpressOrderMutation, DeleteSfExpressOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSfExpressOrderMutation, DeleteSfExpressOrderMutationVariables>(DeleteSfExpressOrderDocument, options);
      }
export type DeleteSfExpressOrderMutationHookResult = ReturnType<typeof useDeleteSfExpressOrderMutation>;
export type DeleteSfExpressOrderMutationResult = Apollo.MutationResult<DeleteSfExpressOrderMutation>;
export type DeleteSfExpressOrderMutationOptions = Apollo.BaseMutationOptions<DeleteSfExpressOrderMutation, DeleteSfExpressOrderMutationVariables>;
export const DeleteJdExpressOrderDocument = gql`
    mutation DeleteJdExpressOrder($input: DeleteJdExpressOrderDto!) {
  deleteJdExpressOrder(input: $input)
}
    `;
export type DeleteJdExpressOrderMutationFn = Apollo.MutationFunction<DeleteJdExpressOrderMutation, DeleteJdExpressOrderMutationVariables>;

/**
 * __useDeleteJdExpressOrderMutation__
 *
 * To run a mutation, you first call `useDeleteJdExpressOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJdExpressOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJdExpressOrderMutation, { data, loading, error }] = useDeleteJdExpressOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteJdExpressOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJdExpressOrderMutation, DeleteJdExpressOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJdExpressOrderMutation, DeleteJdExpressOrderMutationVariables>(DeleteJdExpressOrderDocument, options);
      }
export type DeleteJdExpressOrderMutationHookResult = ReturnType<typeof useDeleteJdExpressOrderMutation>;
export type DeleteJdExpressOrderMutationResult = Apollo.MutationResult<DeleteJdExpressOrderMutation>;
export type DeleteJdExpressOrderMutationOptions = Apollo.BaseMutationOptions<DeleteJdExpressOrderMutation, DeleteJdExpressOrderMutationVariables>;
export const CompleteAppointmentDocument = gql`
    mutation CompleteAppointment($id: String!, $completionData: UpdateAppointmentDto) {
  completeAppointment(id: $id, completionData: $completionData) {
    id
    status
    completed_at
    updated_at
  }
}
    `;
export type CompleteAppointmentMutationFn = Apollo.MutationFunction<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>;

/**
 * __useCompleteAppointmentMutation__
 *
 * To run a mutation, you first call `useCompleteAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAppointmentMutation, { data, loading, error }] = useCompleteAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      completionData: // value for 'completionData'
 *   },
 * });
 */
export function useCompleteAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>(CompleteAppointmentDocument, options);
      }
export type CompleteAppointmentMutationHookResult = ReturnType<typeof useCompleteAppointmentMutation>;
export type CompleteAppointmentMutationResult = Apollo.MutationResult<CompleteAppointmentMutation>;
export type CompleteAppointmentMutationOptions = Apollo.BaseMutationOptions<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>;
export const CancelAppointmentDocument = gql`
    mutation CancelAppointment($id: String!, $reason: String!, $cancelledBy: String!) {
  cancelAppointment(id: $id, reason: $reason, cancelledBy: $cancelledBy) {
    id
    status
    cancelled_at
    cancelled_reason
    cancelled_by
    updated_at
  }
}
    `;
export type CancelAppointmentMutationFn = Apollo.MutationFunction<CancelAppointmentMutation, CancelAppointmentMutationVariables>;

/**
 * __useCancelAppointmentMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentMutation, { data, loading, error }] = useCancelAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      cancelledBy: // value for 'cancelledBy'
 *   },
 * });
 */
export function useCancelAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentMutation, CancelAppointmentMutationVariables>(CancelAppointmentDocument, options);
      }
export type CancelAppointmentMutationHookResult = ReturnType<typeof useCancelAppointmentMutation>;
export type CancelAppointmentMutationResult = Apollo.MutationResult<CancelAppointmentMutation>;
export type CancelAppointmentMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>;
export const MarkAppointmentNoShowDocument = gql`
    mutation MarkAppointmentNoShow($id: String!) {
  markAppointmentNoShow(id: $id) {
    id
    status
    updated_at
  }
}
    `;
export type MarkAppointmentNoShowMutationFn = Apollo.MutationFunction<MarkAppointmentNoShowMutation, MarkAppointmentNoShowMutationVariables>;

/**
 * __useMarkAppointmentNoShowMutation__
 *
 * To run a mutation, you first call `useMarkAppointmentNoShowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAppointmentNoShowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAppointmentNoShowMutation, { data, loading, error }] = useMarkAppointmentNoShowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkAppointmentNoShowMutation(baseOptions?: Apollo.MutationHookOptions<MarkAppointmentNoShowMutation, MarkAppointmentNoShowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAppointmentNoShowMutation, MarkAppointmentNoShowMutationVariables>(MarkAppointmentNoShowDocument, options);
      }
export type MarkAppointmentNoShowMutationHookResult = ReturnType<typeof useMarkAppointmentNoShowMutation>;
export type MarkAppointmentNoShowMutationResult = Apollo.MutationResult<MarkAppointmentNoShowMutation>;
export type MarkAppointmentNoShowMutationOptions = Apollo.BaseMutationOptions<MarkAppointmentNoShowMutation, MarkAppointmentNoShowMutationVariables>;
export const UpdateJoinStatusDocument = gql`
    mutation UpdateJoinStatus($id: String!, $status: String!) {
  updateJoinStatus(id: $id, status: $status) {
    id
    otherStatuses
    updated_at
  }
}
    `;
export type UpdateJoinStatusMutationFn = Apollo.MutationFunction<UpdateJoinStatusMutation, UpdateJoinStatusMutationVariables>;

/**
 * __useUpdateJoinStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJoinStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJoinStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJoinStatusMutation, { data, loading, error }] = useUpdateJoinStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateJoinStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJoinStatusMutation, UpdateJoinStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJoinStatusMutation, UpdateJoinStatusMutationVariables>(UpdateJoinStatusDocument, options);
      }
export type UpdateJoinStatusMutationHookResult = ReturnType<typeof useUpdateJoinStatusMutation>;
export type UpdateJoinStatusMutationResult = Apollo.MutationResult<UpdateJoinStatusMutation>;
export type UpdateJoinStatusMutationOptions = Apollo.BaseMutationOptions<UpdateJoinStatusMutation, UpdateJoinStatusMutationVariables>;
export const CreateAdminUserDocument = gql`
    mutation CreateAdminUser($createAdminUserDto: CreateAdminUserDto!) {
  createAdminUser(createAdminUserDto: $createAdminUserDto) {
    id
    email
    firstname
    lastname
    role_id
    permissions
    is_super_admin
    is_active
    phone_number
    avatar_url
    last_login_at
    last_login_ip
    created_at
    updated_at
    doctor_id
    doctor {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      specialization
      license_number
    }
    clinic_id
    clinic {
      id
      name_en
      name_zh_hk
      address
      region
      district
      phone_number
      email
      status
    }
    userRole {
      id
      name
      description
      is_system_role
      is_active
      permissions {
        role_id
        permission
      }
    }
  }
}
    `;
export type CreateAdminUserMutationFn = Apollo.MutationFunction<CreateAdminUserMutation, CreateAdminUserMutationVariables>;

/**
 * __useCreateAdminUserMutation__
 *
 * To run a mutation, you first call `useCreateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminUserMutation, { data, loading, error }] = useCreateAdminUserMutation({
 *   variables: {
 *      createAdminUserDto: // value for 'createAdminUserDto'
 *   },
 * });
 */
export function useCreateAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminUserMutation, CreateAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminUserMutation, CreateAdminUserMutationVariables>(CreateAdminUserDocument, options);
      }
export type CreateAdminUserMutationHookResult = ReturnType<typeof useCreateAdminUserMutation>;
export type CreateAdminUserMutationResult = Apollo.MutationResult<CreateAdminUserMutation>;
export type CreateAdminUserMutationOptions = Apollo.BaseMutationOptions<CreateAdminUserMutation, CreateAdminUserMutationVariables>;
export const UpdateAdminUserDocument = gql`
    mutation UpdateAdminUser($id: ID!, $updateAdminUserDto: UpdateAdminUserDto!) {
  updateAdminUser(id: $id, updateAdminUserDto: $updateAdminUserDto) {
    id
    email
    firstname
    lastname
    role_id
    permissions
    is_super_admin
    is_active
    phone_number
    avatar_url
    last_login_at
    last_login_ip
    created_at
    updated_at
    doctor_id
    doctor {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      specialization
      license_number
    }
    clinic_id
    clinic {
      id
      name_en
      name_zh_hk
      address
      region
      district
      phone_number
      email
      status
    }
    userRole {
      id
      name
      description
      is_system_role
      is_active
      permissions {
        role_id
        permission
      }
    }
  }
}
    `;
export type UpdateAdminUserMutationFn = Apollo.MutationFunction<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>;

/**
 * __useUpdateAdminUserMutation__
 *
 * To run a mutation, you first call `useUpdateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminUserMutation, { data, loading, error }] = useUpdateAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateAdminUserDto: // value for 'updateAdminUserDto'
 *   },
 * });
 */
export function useUpdateAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>(UpdateAdminUserDocument, options);
      }
export type UpdateAdminUserMutationHookResult = ReturnType<typeof useUpdateAdminUserMutation>;
export type UpdateAdminUserMutationResult = Apollo.MutationResult<UpdateAdminUserMutation>;
export type UpdateAdminUserMutationOptions = Apollo.BaseMutationOptions<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>;
export const DeleteAdminUserDocument = gql`
    mutation DeleteAdminUser($id: ID!) {
  deleteAdminUser(id: $id)
}
    `;
export type DeleteAdminUserMutationFn = Apollo.MutationFunction<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>;

/**
 * __useDeleteAdminUserMutation__
 *
 * To run a mutation, you first call `useDeleteAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminUserMutation, { data, loading, error }] = useDeleteAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>(DeleteAdminUserDocument, options);
      }
export type DeleteAdminUserMutationHookResult = ReturnType<typeof useDeleteAdminUserMutation>;
export type DeleteAdminUserMutationResult = Apollo.MutationResult<DeleteAdminUserMutation>;
export type DeleteAdminUserMutationOptions = Apollo.BaseMutationOptions<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>;
export const ActivateAdminUserDocument = gql`
    mutation ActivateAdminUser($id: ID!) {
  activateAdminUser(id: $id) {
    id
    is_active
    updated_at
  }
}
    `;
export type ActivateAdminUserMutationFn = Apollo.MutationFunction<ActivateAdminUserMutation, ActivateAdminUserMutationVariables>;

/**
 * __useActivateAdminUserMutation__
 *
 * To run a mutation, you first call `useActivateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateAdminUserMutation, { data, loading, error }] = useActivateAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<ActivateAdminUserMutation, ActivateAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateAdminUserMutation, ActivateAdminUserMutationVariables>(ActivateAdminUserDocument, options);
      }
export type ActivateAdminUserMutationHookResult = ReturnType<typeof useActivateAdminUserMutation>;
export type ActivateAdminUserMutationResult = Apollo.MutationResult<ActivateAdminUserMutation>;
export type ActivateAdminUserMutationOptions = Apollo.BaseMutationOptions<ActivateAdminUserMutation, ActivateAdminUserMutationVariables>;
export const DeactivateAdminUserDocument = gql`
    mutation DeactivateAdminUser($id: ID!) {
  deactivateAdminUser(id: $id) {
    id
    is_active
    updated_at
  }
}
    `;
export type DeactivateAdminUserMutationFn = Apollo.MutationFunction<DeactivateAdminUserMutation, DeactivateAdminUserMutationVariables>;

/**
 * __useDeactivateAdminUserMutation__
 *
 * To run a mutation, you first call `useDeactivateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAdminUserMutation, { data, loading, error }] = useDeactivateAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateAdminUserMutation, DeactivateAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateAdminUserMutation, DeactivateAdminUserMutationVariables>(DeactivateAdminUserDocument, options);
      }
export type DeactivateAdminUserMutationHookResult = ReturnType<typeof useDeactivateAdminUserMutation>;
export type DeactivateAdminUserMutationResult = Apollo.MutationResult<DeactivateAdminUserMutation>;
export type DeactivateAdminUserMutationOptions = Apollo.BaseMutationOptions<DeactivateAdminUserMutation, DeactivateAdminUserMutationVariables>;
export const ResetAdminUserPasswordDocument = gql`
    mutation ResetAdminUserPassword($id: ID!, $newPassword: String!) {
  resetAdminUserPassword(id: $id, newPassword: $newPassword) {
    success
    message
  }
}
    `;
export type ResetAdminUserPasswordMutationFn = Apollo.MutationFunction<ResetAdminUserPasswordMutation, ResetAdminUserPasswordMutationVariables>;

/**
 * __useResetAdminUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetAdminUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAdminUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAdminUserPasswordMutation, { data, loading, error }] = useResetAdminUserPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetAdminUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetAdminUserPasswordMutation, ResetAdminUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAdminUserPasswordMutation, ResetAdminUserPasswordMutationVariables>(ResetAdminUserPasswordDocument, options);
      }
export type ResetAdminUserPasswordMutationHookResult = ReturnType<typeof useResetAdminUserPasswordMutation>;
export type ResetAdminUserPasswordMutationResult = Apollo.MutationResult<ResetAdminUserPasswordMutation>;
export type ResetAdminUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetAdminUserPasswordMutation, ResetAdminUserPasswordMutationVariables>;
export const AdminLoginDocument = gql`
    mutation AdminLogin($loginDto: AdminLoginDto!) {
  adminLogin(loginDto: $loginDto) {
    adminUser {
      id
      email
      firstname
      lastname
      role
      role_id
      permissions
      is_super_admin
      is_active
      doctor_id
      userRole {
        id
        name
        description
        is_system_role
        is_active
        permissions {
          role_id
          permission
        }
      }
    }
    accessToken
    refreshToken
  }
}
    `;
export type AdminLoginMutationFn = Apollo.MutationFunction<AdminLoginMutation, AdminLoginMutationVariables>;

/**
 * __useAdminLoginMutation__
 *
 * To run a mutation, you first call `useAdminLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminLoginMutation, { data, loading, error }] = useAdminLoginMutation({
 *   variables: {
 *      loginDto: // value for 'loginDto'
 *   },
 * });
 */
export function useAdminLoginMutation(baseOptions?: Apollo.MutationHookOptions<AdminLoginMutation, AdminLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminLoginMutation, AdminLoginMutationVariables>(AdminLoginDocument, options);
      }
export type AdminLoginMutationHookResult = ReturnType<typeof useAdminLoginMutation>;
export type AdminLoginMutationResult = Apollo.MutationResult<AdminLoginMutation>;
export type AdminLoginMutationOptions = Apollo.BaseMutationOptions<AdminLoginMutation, AdminLoginMutationVariables>;
export const AdminMeDocument = gql`
    query AdminMe {
  adminMe {
    id
    email
    firstname
    lastname
    role_id
    permissions
    is_super_admin
    is_active
    last_login_at
    last_login_ip
    doctor_id
    userRole {
      id
      name
      description
      is_system_role
      is_active
      permissions {
        role_id
        permission
      }
    }
  }
}
    `;

/**
 * __useAdminMeQuery__
 *
 * To run a query within a React component, call `useAdminMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminMeQuery(baseOptions?: Apollo.QueryHookOptions<AdminMeQuery, AdminMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMeQuery, AdminMeQueryVariables>(AdminMeDocument, options);
      }
export function useAdminMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMeQuery, AdminMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMeQuery, AdminMeQueryVariables>(AdminMeDocument, options);
        }
export function useAdminMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminMeQuery, AdminMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminMeQuery, AdminMeQueryVariables>(AdminMeDocument, options);
        }
export type AdminMeQueryHookResult = ReturnType<typeof useAdminMeQuery>;
export type AdminMeLazyQueryHookResult = ReturnType<typeof useAdminMeLazyQuery>;
export type AdminMeSuspenseQueryHookResult = ReturnType<typeof useAdminMeSuspenseQuery>;
export type AdminMeQueryResult = Apollo.QueryResult<AdminMeQuery, AdminMeQueryVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($changePasswordDto: ChangePasswordDto!) {
  changePassword(changePasswordDto: $changePasswordDto) {
    success
    message
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      changePasswordDto: // value for 'changePasswordDto'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const GetAdminUsersDocument = gql`
    query GetAdminUsers {
  adminUsers {
    id
    email
    firstname
    lastname
    role_id
    permissions
    is_super_admin
    is_active
    phone_number
    avatar_url
    last_login_at
    last_login_ip
    created_at
    updated_at
    doctor_id
    doctor {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      specialization
      license_number
    }
    clinic_id
    clinic {
      id
      name_en
      internal_name
      name_zh_hk
      address
      region
      district
      phone_number
      email
      status
    }
    userRole {
      id
      name
      description
      is_system_role
      is_active
      permissions {
        role_id
        permission
      }
    }
  }
}
    `;

/**
 * __useGetAdminUsersQuery__
 *
 * To run a query within a React component, call `useGetAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
      }
export function useGetAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
        }
export function useGetAdminUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
        }
export type GetAdminUsersQueryHookResult = ReturnType<typeof useGetAdminUsersQuery>;
export type GetAdminUsersLazyQueryHookResult = ReturnType<typeof useGetAdminUsersLazyQuery>;
export type GetAdminUsersSuspenseQueryHookResult = ReturnType<typeof useGetAdminUsersSuspenseQuery>;
export type GetAdminUsersQueryResult = Apollo.QueryResult<GetAdminUsersQuery, GetAdminUsersQueryVariables>;
export const AdminRefreshTokenDocument = gql`
    mutation AdminRefreshToken($refreshToken: String!) {
  adminRefreshToken(refreshToken: $refreshToken) {
    adminUser {
      id
      email
      firstname
      lastname
      role
      permissions
      is_super_admin
      is_active
      doctor_id
    }
    accessToken
    refreshToken
  }
}
    `;
export type AdminRefreshTokenMutationFn = Apollo.MutationFunction<AdminRefreshTokenMutation, AdminRefreshTokenMutationVariables>;

/**
 * __useAdminRefreshTokenMutation__
 *
 * To run a mutation, you first call `useAdminRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRefreshTokenMutation, { data, loading, error }] = useAdminRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useAdminRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<AdminRefreshTokenMutation, AdminRefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRefreshTokenMutation, AdminRefreshTokenMutationVariables>(AdminRefreshTokenDocument, options);
      }
export type AdminRefreshTokenMutationHookResult = ReturnType<typeof useAdminRefreshTokenMutation>;
export type AdminRefreshTokenMutationResult = Apollo.MutationResult<AdminRefreshTokenMutation>;
export type AdminRefreshTokenMutationOptions = Apollo.BaseMutationOptions<AdminRefreshTokenMutation, AdminRefreshTokenMutationVariables>;
export const CreateAdminUserRoleDocument = gql`
    mutation CreateAdminUserRole($createAdminUserRoleDto: CreateAdminUserRoleDto!) {
  createAdminUserRole(createAdminUserRoleDto: $createAdminUserRoleDto) {
    id
    name
    description
    is_system_role
    is_active
    created_at
    updated_at
    permissions {
      role_id
      permission
    }
  }
}
    `;
export type CreateAdminUserRoleMutationFn = Apollo.MutationFunction<CreateAdminUserRoleMutation, CreateAdminUserRoleMutationVariables>;

/**
 * __useCreateAdminUserRoleMutation__
 *
 * To run a mutation, you first call `useCreateAdminUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminUserRoleMutation, { data, loading, error }] = useCreateAdminUserRoleMutation({
 *   variables: {
 *      createAdminUserRoleDto: // value for 'createAdminUserRoleDto'
 *   },
 * });
 */
export function useCreateAdminUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminUserRoleMutation, CreateAdminUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminUserRoleMutation, CreateAdminUserRoleMutationVariables>(CreateAdminUserRoleDocument, options);
      }
export type CreateAdminUserRoleMutationHookResult = ReturnType<typeof useCreateAdminUserRoleMutation>;
export type CreateAdminUserRoleMutationResult = Apollo.MutationResult<CreateAdminUserRoleMutation>;
export type CreateAdminUserRoleMutationOptions = Apollo.BaseMutationOptions<CreateAdminUserRoleMutation, CreateAdminUserRoleMutationVariables>;
export const UpdateAdminUserRoleDocument = gql`
    mutation UpdateAdminUserRole($id: ID!, $updateAdminUserRoleDto: UpdateAdminUserRoleDto!) {
  updateAdminUserRole(id: $id, updateAdminUserRoleDto: $updateAdminUserRoleDto) {
    id
    name
    description
    is_system_role
    is_active
    created_at
    updated_at
    permissions {
      role_id
      permission
    }
  }
}
    `;
export type UpdateAdminUserRoleMutationFn = Apollo.MutationFunction<UpdateAdminUserRoleMutation, UpdateAdminUserRoleMutationVariables>;

/**
 * __useUpdateAdminUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateAdminUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminUserRoleMutation, { data, loading, error }] = useUpdateAdminUserRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateAdminUserRoleDto: // value for 'updateAdminUserRoleDto'
 *   },
 * });
 */
export function useUpdateAdminUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminUserRoleMutation, UpdateAdminUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminUserRoleMutation, UpdateAdminUserRoleMutationVariables>(UpdateAdminUserRoleDocument, options);
      }
export type UpdateAdminUserRoleMutationHookResult = ReturnType<typeof useUpdateAdminUserRoleMutation>;
export type UpdateAdminUserRoleMutationResult = Apollo.MutationResult<UpdateAdminUserRoleMutation>;
export type UpdateAdminUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateAdminUserRoleMutation, UpdateAdminUserRoleMutationVariables>;
export const DeleteAdminUserRoleDocument = gql`
    mutation DeleteAdminUserRole($id: ID!) {
  deleteAdminUserRole(id: $id)
}
    `;
export type DeleteAdminUserRoleMutationFn = Apollo.MutationFunction<DeleteAdminUserRoleMutation, DeleteAdminUserRoleMutationVariables>;

/**
 * __useDeleteAdminUserRoleMutation__
 *
 * To run a mutation, you first call `useDeleteAdminUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminUserRoleMutation, { data, loading, error }] = useDeleteAdminUserRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdminUserRoleMutation, DeleteAdminUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdminUserRoleMutation, DeleteAdminUserRoleMutationVariables>(DeleteAdminUserRoleDocument, options);
      }
export type DeleteAdminUserRoleMutationHookResult = ReturnType<typeof useDeleteAdminUserRoleMutation>;
export type DeleteAdminUserRoleMutationResult = Apollo.MutationResult<DeleteAdminUserRoleMutation>;
export type DeleteAdminUserRoleMutationOptions = Apollo.BaseMutationOptions<DeleteAdminUserRoleMutation, DeleteAdminUserRoleMutationVariables>;
export const GetAdminUserRolesDocument = gql`
    query GetAdminUserRoles {
  adminUserRoles {
    id
    name
    description
    is_system_role
    is_active
    created_at
    updated_at
    permissions {
      role_id
      permission
    }
  }
}
    `;

/**
 * __useGetAdminUserRolesQuery__
 *
 * To run a query within a React component, call `useGetAdminUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminUserRolesQuery, GetAdminUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUserRolesQuery, GetAdminUserRolesQueryVariables>(GetAdminUserRolesDocument, options);
      }
export function useGetAdminUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUserRolesQuery, GetAdminUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUserRolesQuery, GetAdminUserRolesQueryVariables>(GetAdminUserRolesDocument, options);
        }
export function useGetAdminUserRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminUserRolesQuery, GetAdminUserRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminUserRolesQuery, GetAdminUserRolesQueryVariables>(GetAdminUserRolesDocument, options);
        }
export type GetAdminUserRolesQueryHookResult = ReturnType<typeof useGetAdminUserRolesQuery>;
export type GetAdminUserRolesLazyQueryHookResult = ReturnType<typeof useGetAdminUserRolesLazyQuery>;
export type GetAdminUserRolesSuspenseQueryHookResult = ReturnType<typeof useGetAdminUserRolesSuspenseQuery>;
export type GetAdminUserRolesQueryResult = Apollo.QueryResult<GetAdminUserRolesQuery, GetAdminUserRolesQueryVariables>;
export const GetAdminUserRoleDocument = gql`
    query GetAdminUserRole($id: ID!) {
  adminUserRole(id: $id) {
    id
    name
    description
    is_system_role
    is_active
    created_at
    updated_at
    permissions {
      role_id
      permission
    }
  }
}
    `;

/**
 * __useGetAdminUserRoleQuery__
 *
 * To run a query within a React component, call `useGetAdminUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUserRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminUserRoleQuery(baseOptions: Apollo.QueryHookOptions<GetAdminUserRoleQuery, GetAdminUserRoleQueryVariables> & ({ variables: GetAdminUserRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUserRoleQuery, GetAdminUserRoleQueryVariables>(GetAdminUserRoleDocument, options);
      }
export function useGetAdminUserRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUserRoleQuery, GetAdminUserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUserRoleQuery, GetAdminUserRoleQueryVariables>(GetAdminUserRoleDocument, options);
        }
export function useGetAdminUserRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminUserRoleQuery, GetAdminUserRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminUserRoleQuery, GetAdminUserRoleQueryVariables>(GetAdminUserRoleDocument, options);
        }
export type GetAdminUserRoleQueryHookResult = ReturnType<typeof useGetAdminUserRoleQuery>;
export type GetAdminUserRoleLazyQueryHookResult = ReturnType<typeof useGetAdminUserRoleLazyQuery>;
export type GetAdminUserRoleSuspenseQueryHookResult = ReturnType<typeof useGetAdminUserRoleSuspenseQuery>;
export type GetAdminUserRoleQueryResult = Apollo.QueryResult<GetAdminUserRoleQuery, GetAdminUserRoleQueryVariables>;
export const GetAdminUserRolePermissionsDocument = gql`
    query GetAdminUserRolePermissions {
  adminUserRolePermissions {
    role_id
    permission
  }
}
    `;

/**
 * __useGetAdminUserRolePermissionsQuery__
 *
 * To run a query within a React component, call `useGetAdminUserRolePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUserRolePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUserRolePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminUserRolePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminUserRolePermissionsQuery, GetAdminUserRolePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUserRolePermissionsQuery, GetAdminUserRolePermissionsQueryVariables>(GetAdminUserRolePermissionsDocument, options);
      }
export function useGetAdminUserRolePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUserRolePermissionsQuery, GetAdminUserRolePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUserRolePermissionsQuery, GetAdminUserRolePermissionsQueryVariables>(GetAdminUserRolePermissionsDocument, options);
        }
export function useGetAdminUserRolePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminUserRolePermissionsQuery, GetAdminUserRolePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminUserRolePermissionsQuery, GetAdminUserRolePermissionsQueryVariables>(GetAdminUserRolePermissionsDocument, options);
        }
export type GetAdminUserRolePermissionsQueryHookResult = ReturnType<typeof useGetAdminUserRolePermissionsQuery>;
export type GetAdminUserRolePermissionsLazyQueryHookResult = ReturnType<typeof useGetAdminUserRolePermissionsLazyQuery>;
export type GetAdminUserRolePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetAdminUserRolePermissionsSuspenseQuery>;
export type GetAdminUserRolePermissionsQueryResult = Apollo.QueryResult<GetAdminUserRolePermissionsQuery, GetAdminUserRolePermissionsQueryVariables>;
export const GetAvailableAdminPermissionsDocument = gql`
    query GetAvailableAdminPermissions {
  availableAdminPermissions
}
    `;

/**
 * __useGetAvailableAdminPermissionsQuery__
 *
 * To run a query within a React component, call `useGetAvailableAdminPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableAdminPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableAdminPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableAdminPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableAdminPermissionsQuery, GetAvailableAdminPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableAdminPermissionsQuery, GetAvailableAdminPermissionsQueryVariables>(GetAvailableAdminPermissionsDocument, options);
      }
export function useGetAvailableAdminPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableAdminPermissionsQuery, GetAvailableAdminPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableAdminPermissionsQuery, GetAvailableAdminPermissionsQueryVariables>(GetAvailableAdminPermissionsDocument, options);
        }
export function useGetAvailableAdminPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableAdminPermissionsQuery, GetAvailableAdminPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableAdminPermissionsQuery, GetAvailableAdminPermissionsQueryVariables>(GetAvailableAdminPermissionsDocument, options);
        }
export type GetAvailableAdminPermissionsQueryHookResult = ReturnType<typeof useGetAvailableAdminPermissionsQuery>;
export type GetAvailableAdminPermissionsLazyQueryHookResult = ReturnType<typeof useGetAvailableAdminPermissionsLazyQuery>;
export type GetAvailableAdminPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetAvailableAdminPermissionsSuspenseQuery>;
export type GetAvailableAdminPermissionsQueryResult = Apollo.QueryResult<GetAvailableAdminPermissionsQuery, GetAvailableAdminPermissionsQueryVariables>;
export const CreateTransactionDocument = gql`
    mutation CreateTransaction($createTransactionDto: CreateTransactionDto!) {
  createTransaction(createTransactionDto: $createTransactionDto) {
    id
    app_user_id
    appointment_id
    transaction_reference
    amount
    currency
    type
    status
    payment_method
    description
    category
    subcategory
    notes
    gateway_transaction_id
    gateway_response
    processing_fee
    tax_amount
    discount_amount
    final_amount
    metadata
    refund_reason
    refunded_by
    refunded_at
    original_transaction_id
    created_at
    updated_at
    processed_at
    completed_at
  }
}
    `;
export type CreateTransactionMutationFn = Apollo.MutationFunction<CreateTransactionMutation, CreateTransactionMutationVariables>;

/**
 * __useCreateTransactionMutation__
 *
 * To run a mutation, you first call `useCreateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionMutation, { data, loading, error }] = useCreateTransactionMutation({
 *   variables: {
 *      createTransactionDto: // value for 'createTransactionDto'
 *   },
 * });
 */
export function useCreateTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionMutation, CreateTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionMutation, CreateTransactionMutationVariables>(CreateTransactionDocument, options);
      }
export type CreateTransactionMutationHookResult = ReturnType<typeof useCreateTransactionMutation>;
export type CreateTransactionMutationResult = Apollo.MutationResult<CreateTransactionMutation>;
export type CreateTransactionMutationOptions = Apollo.BaseMutationOptions<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const UpdateTransactionDocument = gql`
    mutation UpdateTransaction($id: String!, $updateTransactionDto: UpdateTransactionDto!) {
  updateTransaction(id: $id, updateTransactionDto: $updateTransactionDto) {
    id
    app_user_id
    appointment_id
    transaction_reference
    amount
    currency
    type
    status
    payment_method
    description
    category
    subcategory
    notes
    gateway_transaction_id
    gateway_response
    processing_fee
    tax_amount
    discount_amount
    final_amount
    metadata
    refund_reason
    refunded_by
    refunded_at
    original_transaction_id
    created_at
    updated_at
    processed_at
    completed_at
  }
}
    `;
export type UpdateTransactionMutationFn = Apollo.MutationFunction<UpdateTransactionMutation, UpdateTransactionMutationVariables>;

/**
 * __useUpdateTransactionMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionMutation, { data, loading, error }] = useUpdateTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateTransactionDto: // value for 'updateTransactionDto'
 *   },
 * });
 */
export function useUpdateTransactionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionMutation, UpdateTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionMutation, UpdateTransactionMutationVariables>(UpdateTransactionDocument, options);
      }
export type UpdateTransactionMutationHookResult = ReturnType<typeof useUpdateTransactionMutation>;
export type UpdateTransactionMutationResult = Apollo.MutationResult<UpdateTransactionMutation>;
export type UpdateTransactionMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionMutation, UpdateTransactionMutationVariables>;
export const DeleteTransactionDocument = gql`
    mutation DeleteTransaction($id: String!) {
  removeTransaction(id: $id) {
    id
    app_user_id
    appointment_id
    transaction_reference
    amount
    currency
    type
    status
    payment_method
    description
    category
    subcategory
    notes
    gateway_transaction_id
    gateway_response
    processing_fee
    tax_amount
    discount_amount
    final_amount
    metadata
    refund_reason
    refunded_by
    refunded_at
    original_transaction_id
    created_at
    updated_at
    processed_at
    completed_at
  }
}
    `;
export type DeleteTransactionMutationFn = Apollo.MutationFunction<DeleteTransactionMutation, DeleteTransactionMutationVariables>;

/**
 * __useDeleteTransactionMutation__
 *
 * To run a mutation, you first call `useDeleteTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransactionMutation, { data, loading, error }] = useDeleteTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTransactionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransactionMutation, DeleteTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransactionMutation, DeleteTransactionMutationVariables>(DeleteTransactionDocument, options);
      }
export type DeleteTransactionMutationHookResult = ReturnType<typeof useDeleteTransactionMutation>;
export type DeleteTransactionMutationResult = Apollo.MutationResult<DeleteTransactionMutation>;
export type DeleteTransactionMutationOptions = Apollo.BaseMutationOptions<DeleteTransactionMutation, DeleteTransactionMutationVariables>;
export const CreateAppUserDocument = gql`
    mutation CreateAppUser($createUserDto: CreateUserDto!) {
  createUser(createUserDto: $createUserDto) {
    id
    email
    firstname
    lastname
    phone_number
    tenant
    language_preference
    ic_type
    ic_number
    birthdate
    age
    gender
    created_at
    updated_at
    deleted_at
    deleted_reason
  }
}
    `;
export type CreateAppUserMutationFn = Apollo.MutationFunction<CreateAppUserMutation, CreateAppUserMutationVariables>;

/**
 * __useCreateAppUserMutation__
 *
 * To run a mutation, you first call `useCreateAppUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppUserMutation, { data, loading, error }] = useCreateAppUserMutation({
 *   variables: {
 *      createUserDto: // value for 'createUserDto'
 *   },
 * });
 */
export function useCreateAppUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppUserMutation, CreateAppUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppUserMutation, CreateAppUserMutationVariables>(CreateAppUserDocument, options);
      }
export type CreateAppUserMutationHookResult = ReturnType<typeof useCreateAppUserMutation>;
export type CreateAppUserMutationResult = Apollo.MutationResult<CreateAppUserMutation>;
export type CreateAppUserMutationOptions = Apollo.BaseMutationOptions<CreateAppUserMutation, CreateAppUserMutationVariables>;
export const DeleteAppUserDocument = gql`
    mutation DeleteAppUser($id: ID!) {
  deleteUser(id: $id)
}
    `;
export type DeleteAppUserMutationFn = Apollo.MutationFunction<DeleteAppUserMutation, DeleteAppUserMutationVariables>;

/**
 * __useDeleteAppUserMutation__
 *
 * To run a mutation, you first call `useDeleteAppUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppUserMutation, { data, loading, error }] = useDeleteAppUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAppUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAppUserMutation, DeleteAppUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAppUserMutation, DeleteAppUserMutationVariables>(DeleteAppUserDocument, options);
      }
export type DeleteAppUserMutationHookResult = ReturnType<typeof useDeleteAppUserMutation>;
export type DeleteAppUserMutationResult = Apollo.MutationResult<DeleteAppUserMutation>;
export type DeleteAppUserMutationOptions = Apollo.BaseMutationOptions<DeleteAppUserMutation, DeleteAppUserMutationVariables>;
export const SoftDeleteAppUserDocument = gql`
    mutation SoftDeleteAppUser($softDeleteUserDto: SoftDeleteUserDto!) {
  softDeleteUser(softDeleteUserDto: $softDeleteUserDto) {
    success
    message
  }
}
    `;
export type SoftDeleteAppUserMutationFn = Apollo.MutationFunction<SoftDeleteAppUserMutation, SoftDeleteAppUserMutationVariables>;

/**
 * __useSoftDeleteAppUserMutation__
 *
 * To run a mutation, you first call `useSoftDeleteAppUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteAppUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteAppUserMutation, { data, loading, error }] = useSoftDeleteAppUserMutation({
 *   variables: {
 *      softDeleteUserDto: // value for 'softDeleteUserDto'
 *   },
 * });
 */
export function useSoftDeleteAppUserMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteAppUserMutation, SoftDeleteAppUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteAppUserMutation, SoftDeleteAppUserMutationVariables>(SoftDeleteAppUserDocument, options);
      }
export type SoftDeleteAppUserMutationHookResult = ReturnType<typeof useSoftDeleteAppUserMutation>;
export type SoftDeleteAppUserMutationResult = Apollo.MutationResult<SoftDeleteAppUserMutation>;
export type SoftDeleteAppUserMutationOptions = Apollo.BaseMutationOptions<SoftDeleteAppUserMutation, SoftDeleteAppUserMutationVariables>;
export const RestoreAppUserDocument = gql`
    mutation RestoreAppUser($id: ID!) {
  restoreUser(id: $id) {
    success
    message
  }
}
    `;
export type RestoreAppUserMutationFn = Apollo.MutationFunction<RestoreAppUserMutation, RestoreAppUserMutationVariables>;

/**
 * __useRestoreAppUserMutation__
 *
 * To run a mutation, you first call `useRestoreAppUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreAppUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreAppUserMutation, { data, loading, error }] = useRestoreAppUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreAppUserMutation(baseOptions?: Apollo.MutationHookOptions<RestoreAppUserMutation, RestoreAppUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreAppUserMutation, RestoreAppUserMutationVariables>(RestoreAppUserDocument, options);
      }
export type RestoreAppUserMutationHookResult = ReturnType<typeof useRestoreAppUserMutation>;
export type RestoreAppUserMutationResult = Apollo.MutationResult<RestoreAppUserMutation>;
export type RestoreAppUserMutationOptions = Apollo.BaseMutationOptions<RestoreAppUserMutation, RestoreAppUserMutationVariables>;
export const CloudPrintSfExpressWaybillDocument = gql`
    mutation CloudPrintSfExpressWaybill($input: SfExpressCloudPrintWaybillInput!) {
  cloudPrintSfExpressWaybill(input: $input) {
    success
    errorCode
    errorMsg
    data {
      waybillNo
      pdfUrl
      pdfBase64
      templateCode
      fileSize
      generateTime
    }
  }
}
    `;
export type CloudPrintSfExpressWaybillMutationFn = Apollo.MutationFunction<CloudPrintSfExpressWaybillMutation, CloudPrintSfExpressWaybillMutationVariables>;

/**
 * __useCloudPrintSfExpressWaybillMutation__
 *
 * To run a mutation, you first call `useCloudPrintSfExpressWaybillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloudPrintSfExpressWaybillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloudPrintSfExpressWaybillMutation, { data, loading, error }] = useCloudPrintSfExpressWaybillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloudPrintSfExpressWaybillMutation(baseOptions?: Apollo.MutationHookOptions<CloudPrintSfExpressWaybillMutation, CloudPrintSfExpressWaybillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloudPrintSfExpressWaybillMutation, CloudPrintSfExpressWaybillMutationVariables>(CloudPrintSfExpressWaybillDocument, options);
      }
export type CloudPrintSfExpressWaybillMutationHookResult = ReturnType<typeof useCloudPrintSfExpressWaybillMutation>;
export type CloudPrintSfExpressWaybillMutationResult = Apollo.MutationResult<CloudPrintSfExpressWaybillMutation>;
export type CloudPrintSfExpressWaybillMutationOptions = Apollo.BaseMutationOptions<CloudPrintSfExpressWaybillMutation, CloudPrintSfExpressWaybillMutationVariables>;
export const CloudPrintSfExpressWaybillsBatchDocument = gql`
    mutation CloudPrintSfExpressWaybillsBatch($inputs: [SfExpressCloudPrintWaybillInput!]!) {
  cloudPrintSfExpressWaybillsBatch(inputs: $inputs) {
    success
    errorCode
    errorMsg
    data {
      waybillNo
      pdfUrl
      pdfBase64
      templateCode
      fileSize
      generateTime
    }
  }
}
    `;
export type CloudPrintSfExpressWaybillsBatchMutationFn = Apollo.MutationFunction<CloudPrintSfExpressWaybillsBatchMutation, CloudPrintSfExpressWaybillsBatchMutationVariables>;

/**
 * __useCloudPrintSfExpressWaybillsBatchMutation__
 *
 * To run a mutation, you first call `useCloudPrintSfExpressWaybillsBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloudPrintSfExpressWaybillsBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloudPrintSfExpressWaybillsBatchMutation, { data, loading, error }] = useCloudPrintSfExpressWaybillsBatchMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCloudPrintSfExpressWaybillsBatchMutation(baseOptions?: Apollo.MutationHookOptions<CloudPrintSfExpressWaybillsBatchMutation, CloudPrintSfExpressWaybillsBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloudPrintSfExpressWaybillsBatchMutation, CloudPrintSfExpressWaybillsBatchMutationVariables>(CloudPrintSfExpressWaybillsBatchDocument, options);
      }
export type CloudPrintSfExpressWaybillsBatchMutationHookResult = ReturnType<typeof useCloudPrintSfExpressWaybillsBatchMutation>;
export type CloudPrintSfExpressWaybillsBatchMutationResult = Apollo.MutationResult<CloudPrintSfExpressWaybillsBatchMutation>;
export type CloudPrintSfExpressWaybillsBatchMutationOptions = Apollo.BaseMutationOptions<CloudPrintSfExpressWaybillsBatchMutation, CloudPrintSfExpressWaybillsBatchMutationVariables>;
export const PrecheckJdExpressOrderFromAppointmentDocument = gql`
    mutation PrecheckJdExpressOrderFromAppointment($input: CreateJdExpressOrderFromAppointmentDto!) {
  precheckJdExpressOrderFromAppointment(input: $input) {
    success
    errorCode
    errorMsg
    data {
      totalFreightPre
      currency
      calWeight
      totalAmount
      deliveryPromiseTime
      productCode
      productName
      freightPre
      startStationName
      endStationName
      startStationCode
      endStationCode
    }
  }
}
    `;
export type PrecheckJdExpressOrderFromAppointmentMutationFn = Apollo.MutationFunction<PrecheckJdExpressOrderFromAppointmentMutation, PrecheckJdExpressOrderFromAppointmentMutationVariables>;

/**
 * __usePrecheckJdExpressOrderFromAppointmentMutation__
 *
 * To run a mutation, you first call `usePrecheckJdExpressOrderFromAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrecheckJdExpressOrderFromAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [precheckJdExpressOrderFromAppointmentMutation, { data, loading, error }] = usePrecheckJdExpressOrderFromAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrecheckJdExpressOrderFromAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<PrecheckJdExpressOrderFromAppointmentMutation, PrecheckJdExpressOrderFromAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrecheckJdExpressOrderFromAppointmentMutation, PrecheckJdExpressOrderFromAppointmentMutationVariables>(PrecheckJdExpressOrderFromAppointmentDocument, options);
      }
export type PrecheckJdExpressOrderFromAppointmentMutationHookResult = ReturnType<typeof usePrecheckJdExpressOrderFromAppointmentMutation>;
export type PrecheckJdExpressOrderFromAppointmentMutationResult = Apollo.MutationResult<PrecheckJdExpressOrderFromAppointmentMutation>;
export type PrecheckJdExpressOrderFromAppointmentMutationOptions = Apollo.BaseMutationOptions<PrecheckJdExpressOrderFromAppointmentMutation, PrecheckJdExpressOrderFromAppointmentMutationVariables>;
export const CloudPrintJdExpressWaybillDocument = gql`
    mutation CloudPrintJdExpressWaybill($input: JdExpressCloudPrintWaybillInput!) {
  cloudPrintJdExpressWaybill(input: $input) {
    success
    errorCode
    errorMsg
    data {
      waybillNo
      pdfUrl
      pdfBase64
      templateCode
      fileSize
      generateTime
    }
  }
}
    `;
export type CloudPrintJdExpressWaybillMutationFn = Apollo.MutationFunction<CloudPrintJdExpressWaybillMutation, CloudPrintJdExpressWaybillMutationVariables>;

/**
 * __useCloudPrintJdExpressWaybillMutation__
 *
 * To run a mutation, you first call `useCloudPrintJdExpressWaybillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloudPrintJdExpressWaybillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloudPrintJdExpressWaybillMutation, { data, loading, error }] = useCloudPrintJdExpressWaybillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloudPrintJdExpressWaybillMutation(baseOptions?: Apollo.MutationHookOptions<CloudPrintJdExpressWaybillMutation, CloudPrintJdExpressWaybillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloudPrintJdExpressWaybillMutation, CloudPrintJdExpressWaybillMutationVariables>(CloudPrintJdExpressWaybillDocument, options);
      }
export type CloudPrintJdExpressWaybillMutationHookResult = ReturnType<typeof useCloudPrintJdExpressWaybillMutation>;
export type CloudPrintJdExpressWaybillMutationResult = Apollo.MutationResult<CloudPrintJdExpressWaybillMutation>;
export type CloudPrintJdExpressWaybillMutationOptions = Apollo.BaseMutationOptions<CloudPrintJdExpressWaybillMutation, CloudPrintJdExpressWaybillMutationVariables>;
export const CreateAddressDocument = gql`
    mutation CreateAddress($createAddressDto: CreateAddressDto!) {
  createAddress(createAddressDto: $createAddressDto) {
    id
    type
    display_name
    region
    district
    street_address
    building_name
    floor
    block
    unit
    postal_code
    override_address
    is_default
    phone_number
    contact_name
    created_at
    updated_at
  }
}
    `;
export type CreateAddressMutationFn = Apollo.MutationFunction<CreateAddressMutation, CreateAddressMutationVariables>;

/**
 * __useCreateAddressMutation__
 *
 * To run a mutation, you first call `useCreateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddressMutation, { data, loading, error }] = useCreateAddressMutation({
 *   variables: {
 *      createAddressDto: // value for 'createAddressDto'
 *   },
 * });
 */
export function useCreateAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateAddressMutation, CreateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAddressMutation, CreateAddressMutationVariables>(CreateAddressDocument, options);
      }
export type CreateAddressMutationHookResult = ReturnType<typeof useCreateAddressMutation>;
export type CreateAddressMutationResult = Apollo.MutationResult<CreateAddressMutation>;
export type CreateAddressMutationOptions = Apollo.BaseMutationOptions<CreateAddressMutation, CreateAddressMutationVariables>;
export const UpdateAddressDocument = gql`
    mutation UpdateAddress($id: ID!, $updateAddressDto: UpdateAddressDto!) {
  updateAddress(id: $id, updateAddressDto: $updateAddressDto) {
    id
    type
    display_name
    region
    district
    street_address
    building_name
    floor
    block
    unit
    postal_code
    override_address
    is_default
    phone_number
    contact_name
    created_at
    updated_at
  }
}
    `;
export type UpdateAddressMutationFn = Apollo.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateAddressDto: // value for 'updateAddressDto'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const DeleteAddressDocument = gql`
    mutation DeleteAddress($id: ID!) {
  deleteAddress(id: $id)
}
    `;
export type DeleteAddressMutationFn = Apollo.MutationFunction<DeleteAddressMutation, DeleteAddressMutationVariables>;

/**
 * __useDeleteAddressMutation__
 *
 * To run a mutation, you first call `useDeleteAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddressMutation, { data, loading, error }] = useDeleteAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAddressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAddressMutation, DeleteAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAddressMutation, DeleteAddressMutationVariables>(DeleteAddressDocument, options);
      }
export type DeleteAddressMutationHookResult = ReturnType<typeof useDeleteAddressMutation>;
export type DeleteAddressMutationResult = Apollo.MutationResult<DeleteAddressMutation>;
export type DeleteAddressMutationOptions = Apollo.BaseMutationOptions<DeleteAddressMutation, DeleteAddressMutationVariables>;
export const SetDefaultAddressDocument = gql`
    mutation SetDefaultAddress($addressId: ID!) {
  setDefaultAddress(addressId: $addressId) {
    id
    type
    display_name
    region
    district
    street_address
    building_name
    floor
    block
    unit
    postal_code
    override_address
    is_default
    phone_number
    contact_name
    created_at
    updated_at
  }
}
    `;
export type SetDefaultAddressMutationFn = Apollo.MutationFunction<SetDefaultAddressMutation, SetDefaultAddressMutationVariables>;

/**
 * __useSetDefaultAddressMutation__
 *
 * To run a mutation, you first call `useSetDefaultAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultAddressMutation, { data, loading, error }] = useSetDefaultAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useSetDefaultAddressMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultAddressMutation, SetDefaultAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultAddressMutation, SetDefaultAddressMutationVariables>(SetDefaultAddressDocument, options);
      }
export type SetDefaultAddressMutationHookResult = ReturnType<typeof useSetDefaultAddressMutation>;
export type SetDefaultAddressMutationResult = Apollo.MutationResult<SetDefaultAddressMutation>;
export type SetDefaultAddressMutationOptions = Apollo.BaseMutationOptions<SetDefaultAddressMutation, SetDefaultAddressMutationVariables>;
export const AdminCreateAddressDocument = gql`
    mutation AdminCreateAddress($createAddressDto: CreateAddressDto!) {
  adminCreateAddress(createAddressDto: $createAddressDto) {
    id
    type
    display_name
    region
    district
    street_address
    building_name
    floor
    block
    unit
    postal_code
    override_address
    is_default
    phone_number
    contact_name
    created_at
    updated_at
  }
}
    `;
export type AdminCreateAddressMutationFn = Apollo.MutationFunction<AdminCreateAddressMutation, AdminCreateAddressMutationVariables>;

/**
 * __useAdminCreateAddressMutation__
 *
 * To run a mutation, you first call `useAdminCreateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateAddressMutation, { data, loading, error }] = useAdminCreateAddressMutation({
 *   variables: {
 *      createAddressDto: // value for 'createAddressDto'
 *   },
 * });
 */
export function useAdminCreateAddressMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateAddressMutation, AdminCreateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateAddressMutation, AdminCreateAddressMutationVariables>(AdminCreateAddressDocument, options);
      }
export type AdminCreateAddressMutationHookResult = ReturnType<typeof useAdminCreateAddressMutation>;
export type AdminCreateAddressMutationResult = Apollo.MutationResult<AdminCreateAddressMutation>;
export type AdminCreateAddressMutationOptions = Apollo.BaseMutationOptions<AdminCreateAddressMutation, AdminCreateAddressMutationVariables>;
export const AdminUpdateAddressDocument = gql`
    mutation AdminUpdateAddress($id: ID!, $updateAddressDto: UpdateAddressDto!) {
  adminUpdateAddress(id: $id, updateAddressDto: $updateAddressDto) {
    id
    type
    display_name
    region
    district
    street_address
    building_name
    floor
    block
    unit
    postal_code
    override_address
    is_default
    phone_number
    contact_name
    created_at
    updated_at
  }
}
    `;
export type AdminUpdateAddressMutationFn = Apollo.MutationFunction<AdminUpdateAddressMutation, AdminUpdateAddressMutationVariables>;

/**
 * __useAdminUpdateAddressMutation__
 *
 * To run a mutation, you first call `useAdminUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateAddressMutation, { data, loading, error }] = useAdminUpdateAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateAddressDto: // value for 'updateAddressDto'
 *   },
 * });
 */
export function useAdminUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateAddressMutation, AdminUpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateAddressMutation, AdminUpdateAddressMutationVariables>(AdminUpdateAddressDocument, options);
      }
export type AdminUpdateAddressMutationHookResult = ReturnType<typeof useAdminUpdateAddressMutation>;
export type AdminUpdateAddressMutationResult = Apollo.MutationResult<AdminUpdateAddressMutation>;
export type AdminUpdateAddressMutationOptions = Apollo.BaseMutationOptions<AdminUpdateAddressMutation, AdminUpdateAddressMutationVariables>;
export const AdminDeleteAddressDocument = gql`
    mutation AdminDeleteAddress($id: ID!) {
  adminDeleteAddress(id: $id)
}
    `;
export type AdminDeleteAddressMutationFn = Apollo.MutationFunction<AdminDeleteAddressMutation, AdminDeleteAddressMutationVariables>;

/**
 * __useAdminDeleteAddressMutation__
 *
 * To run a mutation, you first call `useAdminDeleteAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteAddressMutation, { data, loading, error }] = useAdminDeleteAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteAddressMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteAddressMutation, AdminDeleteAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteAddressMutation, AdminDeleteAddressMutationVariables>(AdminDeleteAddressDocument, options);
      }
export type AdminDeleteAddressMutationHookResult = ReturnType<typeof useAdminDeleteAddressMutation>;
export type AdminDeleteAddressMutationResult = Apollo.MutationResult<AdminDeleteAddressMutation>;
export type AdminDeleteAddressMutationOptions = Apollo.BaseMutationOptions<AdminDeleteAddressMutation, AdminDeleteAddressMutationVariables>;
export const AdminSetDefaultAddressDocument = gql`
    mutation AdminSetDefaultAddress($addressId: ID!) {
  adminSetDefaultAddress(addressId: $addressId) {
    id
    type
    display_name
    region
    district
    street_address
    building_name
    floor
    block
    unit
    postal_code
    override_address
    is_default
    phone_number
    contact_name
    created_at
    updated_at
  }
}
    `;
export type AdminSetDefaultAddressMutationFn = Apollo.MutationFunction<AdminSetDefaultAddressMutation, AdminSetDefaultAddressMutationVariables>;

/**
 * __useAdminSetDefaultAddressMutation__
 *
 * To run a mutation, you first call `useAdminSetDefaultAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetDefaultAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetDefaultAddressMutation, { data, loading, error }] = useAdminSetDefaultAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useAdminSetDefaultAddressMutation(baseOptions?: Apollo.MutationHookOptions<AdminSetDefaultAddressMutation, AdminSetDefaultAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSetDefaultAddressMutation, AdminSetDefaultAddressMutationVariables>(AdminSetDefaultAddressDocument, options);
      }
export type AdminSetDefaultAddressMutationHookResult = ReturnType<typeof useAdminSetDefaultAddressMutation>;
export type AdminSetDefaultAddressMutationResult = Apollo.MutationResult<AdminSetDefaultAddressMutation>;
export type AdminSetDefaultAddressMutationOptions = Apollo.BaseMutationOptions<AdminSetDefaultAddressMutation, AdminSetDefaultAddressMutationVariables>;
export const CreateInsurancePolicyDocument = gql`
    mutation CreateInsurancePolicy($createInsurancePolicyDto: CreateInsurancePolicyDto!) {
  createInsurancePolicy(createInsurancePolicyDto: $createInsurancePolicyDto) {
    id
    name
    payor
    planId
    policyNumber
    startDate
    endDate
    appUserId
    description
    policyDetails {
      free_consultations
      free_consultations_per_year
      free_consultations_per_month
      free_consultations_per_week
    }
    isActive
    createdAt
    updatedAt
    plan {
      id
      name
      payor
      description
      planDetails {
        free_consultations
        free_consultations_per_year
        free_consultations_per_month
        free_consultations_per_week
      }
    }
    appUser {
      id
      firstname
      lastname
      email
      phone_number
    }
  }
}
    `;
export type CreateInsurancePolicyMutationFn = Apollo.MutationFunction<CreateInsurancePolicyMutation, CreateInsurancePolicyMutationVariables>;

/**
 * __useCreateInsurancePolicyMutation__
 *
 * To run a mutation, you first call `useCreateInsurancePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsurancePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsurancePolicyMutation, { data, loading, error }] = useCreateInsurancePolicyMutation({
 *   variables: {
 *      createInsurancePolicyDto: // value for 'createInsurancePolicyDto'
 *   },
 * });
 */
export function useCreateInsurancePolicyMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsurancePolicyMutation, CreateInsurancePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsurancePolicyMutation, CreateInsurancePolicyMutationVariables>(CreateInsurancePolicyDocument, options);
      }
export type CreateInsurancePolicyMutationHookResult = ReturnType<typeof useCreateInsurancePolicyMutation>;
export type CreateInsurancePolicyMutationResult = Apollo.MutationResult<CreateInsurancePolicyMutation>;
export type CreateInsurancePolicyMutationOptions = Apollo.BaseMutationOptions<CreateInsurancePolicyMutation, CreateInsurancePolicyMutationVariables>;
export const UpdateInsurancePolicyDocument = gql`
    mutation UpdateInsurancePolicy($id: ID!, $updateInsurancePolicyDto: UpdateInsurancePolicyDto!) {
  updateInsurancePolicy(
    id: $id
    updateInsurancePolicyDto: $updateInsurancePolicyDto
  ) {
    id
    name
    payor
    planId
    policyNumber
    startDate
    endDate
    appUserId
    description
    policyDetails {
      free_consultations
      free_consultations_per_year
      free_consultations_per_month
      free_consultations_per_week
    }
    isActive
    createdAt
    updatedAt
    plan {
      id
      name
      payor
      description
      planDetails {
        free_consultations
        free_consultations_per_year
        free_consultations_per_month
        free_consultations_per_week
      }
    }
    appUser {
      id
      firstname
      lastname
      email
      phone_number
    }
  }
}
    `;
export type UpdateInsurancePolicyMutationFn = Apollo.MutationFunction<UpdateInsurancePolicyMutation, UpdateInsurancePolicyMutationVariables>;

/**
 * __useUpdateInsurancePolicyMutation__
 *
 * To run a mutation, you first call `useUpdateInsurancePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsurancePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsurancePolicyMutation, { data, loading, error }] = useUpdateInsurancePolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateInsurancePolicyDto: // value for 'updateInsurancePolicyDto'
 *   },
 * });
 */
export function useUpdateInsurancePolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsurancePolicyMutation, UpdateInsurancePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsurancePolicyMutation, UpdateInsurancePolicyMutationVariables>(UpdateInsurancePolicyDocument, options);
      }
export type UpdateInsurancePolicyMutationHookResult = ReturnType<typeof useUpdateInsurancePolicyMutation>;
export type UpdateInsurancePolicyMutationResult = Apollo.MutationResult<UpdateInsurancePolicyMutation>;
export type UpdateInsurancePolicyMutationOptions = Apollo.BaseMutationOptions<UpdateInsurancePolicyMutation, UpdateInsurancePolicyMutationVariables>;
export const CreateInsuranceClaimDocument = gql`
    mutation CreateInsuranceClaim($createInsuranceClaimResultDto: CreateInsuranceClaimResultDto!) {
  createInsuranceClaimResult(
    createInsuranceClaimResultDto: $createInsuranceClaimResultDto
  ) {
    id
    policyId
    appointmentId
    status
    items {
      id
      name
      category
      amount
      approvedAmount
      transactionId
    }
  }
}
    `;
export type CreateInsuranceClaimMutationFn = Apollo.MutationFunction<CreateInsuranceClaimMutation, CreateInsuranceClaimMutationVariables>;

/**
 * __useCreateInsuranceClaimMutation__
 *
 * To run a mutation, you first call `useCreateInsuranceClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsuranceClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsuranceClaimMutation, { data, loading, error }] = useCreateInsuranceClaimMutation({
 *   variables: {
 *      createInsuranceClaimResultDto: // value for 'createInsuranceClaimResultDto'
 *   },
 * });
 */
export function useCreateInsuranceClaimMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsuranceClaimMutation, CreateInsuranceClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsuranceClaimMutation, CreateInsuranceClaimMutationVariables>(CreateInsuranceClaimDocument, options);
      }
export type CreateInsuranceClaimMutationHookResult = ReturnType<typeof useCreateInsuranceClaimMutation>;
export type CreateInsuranceClaimMutationResult = Apollo.MutationResult<CreateInsuranceClaimMutation>;
export type CreateInsuranceClaimMutationOptions = Apollo.BaseMutationOptions<CreateInsuranceClaimMutation, CreateInsuranceClaimMutationVariables>;
export const BatchCreateInsuranceCouponsDocument = gql`
    mutation BatchCreateInsuranceCoupons($batchCreateInsuranceCouponsDto: BatchCreateInsuranceCouponsDto!) {
  batchCreateInsuranceCoupons(
    batchCreateInsuranceCouponsDto: $batchCreateInsuranceCouponsDto
  ) {
    id
    payor
    couponCode
    startDate
    endDate
    appUserId
    appointmentId
    policyDetails {
      free_consultations
      free_consultations_per_year
      free_consultations_per_month
      free_consultations_per_week
    }
    isActive
    createdAt
    updatedAt
    plan {
      id
      name
      payor
      description
    }
  }
}
    `;
export type BatchCreateInsuranceCouponsMutationFn = Apollo.MutationFunction<BatchCreateInsuranceCouponsMutation, BatchCreateInsuranceCouponsMutationVariables>;

/**
 * __useBatchCreateInsuranceCouponsMutation__
 *
 * To run a mutation, you first call `useBatchCreateInsuranceCouponsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateInsuranceCouponsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateInsuranceCouponsMutation, { data, loading, error }] = useBatchCreateInsuranceCouponsMutation({
 *   variables: {
 *      batchCreateInsuranceCouponsDto: // value for 'batchCreateInsuranceCouponsDto'
 *   },
 * });
 */
export function useBatchCreateInsuranceCouponsMutation(baseOptions?: Apollo.MutationHookOptions<BatchCreateInsuranceCouponsMutation, BatchCreateInsuranceCouponsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchCreateInsuranceCouponsMutation, BatchCreateInsuranceCouponsMutationVariables>(BatchCreateInsuranceCouponsDocument, options);
      }
export type BatchCreateInsuranceCouponsMutationHookResult = ReturnType<typeof useBatchCreateInsuranceCouponsMutation>;
export type BatchCreateInsuranceCouponsMutationResult = Apollo.MutationResult<BatchCreateInsuranceCouponsMutation>;
export type BatchCreateInsuranceCouponsMutationOptions = Apollo.BaseMutationOptions<BatchCreateInsuranceCouponsMutation, BatchCreateInsuranceCouponsMutationVariables>;
export const UpdateInsuranceClaimDocument = gql`
    mutation UpdateInsuranceClaim($id: ID!, $updateInsuranceClaimResultDto: UpdateInsuranceClaimResultDto!) {
  updateInsuranceClaimResult(
    id: $id
    updateInsuranceClaimResultDto: $updateInsuranceClaimResultDto
  ) {
    id
    policyId
    appointmentId
    status
    items {
      id
      name
      category
      amount
      approvedAmount
      transactionId
    }
  }
}
    `;
export type UpdateInsuranceClaimMutationFn = Apollo.MutationFunction<UpdateInsuranceClaimMutation, UpdateInsuranceClaimMutationVariables>;

/**
 * __useUpdateInsuranceClaimMutation__
 *
 * To run a mutation, you first call `useUpdateInsuranceClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsuranceClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsuranceClaimMutation, { data, loading, error }] = useUpdateInsuranceClaimMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateInsuranceClaimResultDto: // value for 'updateInsuranceClaimResultDto'
 *   },
 * });
 */
export function useUpdateInsuranceClaimMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsuranceClaimMutation, UpdateInsuranceClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsuranceClaimMutation, UpdateInsuranceClaimMutationVariables>(UpdateInsuranceClaimDocument, options);
      }
export type UpdateInsuranceClaimMutationHookResult = ReturnType<typeof useUpdateInsuranceClaimMutation>;
export type UpdateInsuranceClaimMutationResult = Apollo.MutationResult<UpdateInsuranceClaimMutation>;
export type UpdateInsuranceClaimMutationOptions = Apollo.BaseMutationOptions<UpdateInsuranceClaimMutation, UpdateInsuranceClaimMutationVariables>;
export const AllowTeleconsultationDocument = gql`
    query AllowTeleconsultation {
  allowTeleconsultation
}
    `;

/**
 * __useAllowTeleconsultationQuery__
 *
 * To run a query within a React component, call `useAllowTeleconsultationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowTeleconsultationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowTeleconsultationQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllowTeleconsultationQuery(baseOptions?: Apollo.QueryHookOptions<AllowTeleconsultationQuery, AllowTeleconsultationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllowTeleconsultationQuery, AllowTeleconsultationQueryVariables>(AllowTeleconsultationDocument, options);
      }
export function useAllowTeleconsultationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllowTeleconsultationQuery, AllowTeleconsultationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllowTeleconsultationQuery, AllowTeleconsultationQueryVariables>(AllowTeleconsultationDocument, options);
        }
export function useAllowTeleconsultationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllowTeleconsultationQuery, AllowTeleconsultationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllowTeleconsultationQuery, AllowTeleconsultationQueryVariables>(AllowTeleconsultationDocument, options);
        }
export type AllowTeleconsultationQueryHookResult = ReturnType<typeof useAllowTeleconsultationQuery>;
export type AllowTeleconsultationLazyQueryHookResult = ReturnType<typeof useAllowTeleconsultationLazyQuery>;
export type AllowTeleconsultationSuspenseQueryHookResult = ReturnType<typeof useAllowTeleconsultationSuspenseQuery>;
export type AllowTeleconsultationQueryResult = Apollo.QueryResult<AllowTeleconsultationQuery, AllowTeleconsultationQueryVariables>;
export const TeleconsultationFeeDocument = gql`
    query TeleconsultationFee {
  teleconsultationFee(tenant: "default")
}
    `;

/**
 * __useTeleconsultationFeeQuery__
 *
 * To run a query within a React component, call `useTeleconsultationFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeleconsultationFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeleconsultationFeeQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeleconsultationFeeQuery(baseOptions?: Apollo.QueryHookOptions<TeleconsultationFeeQuery, TeleconsultationFeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeleconsultationFeeQuery, TeleconsultationFeeQueryVariables>(TeleconsultationFeeDocument, options);
      }
export function useTeleconsultationFeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeleconsultationFeeQuery, TeleconsultationFeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeleconsultationFeeQuery, TeleconsultationFeeQueryVariables>(TeleconsultationFeeDocument, options);
        }
export function useTeleconsultationFeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeleconsultationFeeQuery, TeleconsultationFeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeleconsultationFeeQuery, TeleconsultationFeeQueryVariables>(TeleconsultationFeeDocument, options);
        }
export type TeleconsultationFeeQueryHookResult = ReturnType<typeof useTeleconsultationFeeQuery>;
export type TeleconsultationFeeLazyQueryHookResult = ReturnType<typeof useTeleconsultationFeeLazyQuery>;
export type TeleconsultationFeeSuspenseQueryHookResult = ReturnType<typeof useTeleconsultationFeeSuspenseQuery>;
export type TeleconsultationFeeQueryResult = Apollo.QueryResult<TeleconsultationFeeQuery, TeleconsultationFeeQueryVariables>;
export const TeleconsultationFeeChinaLifeDocument = gql`
    query TeleconsultationFeeChinaLife {
  teleconsultationFee(tenant: "china-life")
}
    `;

/**
 * __useTeleconsultationFeeChinaLifeQuery__
 *
 * To run a query within a React component, call `useTeleconsultationFeeChinaLifeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeleconsultationFeeChinaLifeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeleconsultationFeeChinaLifeQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeleconsultationFeeChinaLifeQuery(baseOptions?: Apollo.QueryHookOptions<TeleconsultationFeeChinaLifeQuery, TeleconsultationFeeChinaLifeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeleconsultationFeeChinaLifeQuery, TeleconsultationFeeChinaLifeQueryVariables>(TeleconsultationFeeChinaLifeDocument, options);
      }
export function useTeleconsultationFeeChinaLifeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeleconsultationFeeChinaLifeQuery, TeleconsultationFeeChinaLifeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeleconsultationFeeChinaLifeQuery, TeleconsultationFeeChinaLifeQueryVariables>(TeleconsultationFeeChinaLifeDocument, options);
        }
export function useTeleconsultationFeeChinaLifeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeleconsultationFeeChinaLifeQuery, TeleconsultationFeeChinaLifeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeleconsultationFeeChinaLifeQuery, TeleconsultationFeeChinaLifeQueryVariables>(TeleconsultationFeeChinaLifeDocument, options);
        }
export type TeleconsultationFeeChinaLifeQueryHookResult = ReturnType<typeof useTeleconsultationFeeChinaLifeQuery>;
export type TeleconsultationFeeChinaLifeLazyQueryHookResult = ReturnType<typeof useTeleconsultationFeeChinaLifeLazyQuery>;
export type TeleconsultationFeeChinaLifeSuspenseQueryHookResult = ReturnType<typeof useTeleconsultationFeeChinaLifeSuspenseQuery>;
export type TeleconsultationFeeChinaLifeQueryResult = Apollo.QueryResult<TeleconsultationFeeChinaLifeQuery, TeleconsultationFeeChinaLifeQueryVariables>;
export const TeleconsultationLeadTimeDocument = gql`
    query TeleconsultationLeadTime {
  teleconsultationLeadTime
}
    `;

/**
 * __useTeleconsultationLeadTimeQuery__
 *
 * To run a query within a React component, call `useTeleconsultationLeadTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeleconsultationLeadTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeleconsultationLeadTimeQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeleconsultationLeadTimeQuery(baseOptions?: Apollo.QueryHookOptions<TeleconsultationLeadTimeQuery, TeleconsultationLeadTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeleconsultationLeadTimeQuery, TeleconsultationLeadTimeQueryVariables>(TeleconsultationLeadTimeDocument, options);
      }
export function useTeleconsultationLeadTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeleconsultationLeadTimeQuery, TeleconsultationLeadTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeleconsultationLeadTimeQuery, TeleconsultationLeadTimeQueryVariables>(TeleconsultationLeadTimeDocument, options);
        }
export function useTeleconsultationLeadTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeleconsultationLeadTimeQuery, TeleconsultationLeadTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeleconsultationLeadTimeQuery, TeleconsultationLeadTimeQueryVariables>(TeleconsultationLeadTimeDocument, options);
        }
export type TeleconsultationLeadTimeQueryHookResult = ReturnType<typeof useTeleconsultationLeadTimeQuery>;
export type TeleconsultationLeadTimeLazyQueryHookResult = ReturnType<typeof useTeleconsultationLeadTimeLazyQuery>;
export type TeleconsultationLeadTimeSuspenseQueryHookResult = ReturnType<typeof useTeleconsultationLeadTimeSuspenseQuery>;
export type TeleconsultationLeadTimeQueryResult = Apollo.QueryResult<TeleconsultationLeadTimeQuery, TeleconsultationLeadTimeQueryVariables>;
export const RemoteAreaDeliveryExtraFeeDocument = gql`
    query RemoteAreaDeliveryExtraFee {
  remoteAreaDeliveryExtraFee
}
    `;

/**
 * __useRemoteAreaDeliveryExtraFeeQuery__
 *
 * To run a query within a React component, call `useRemoteAreaDeliveryExtraFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemoteAreaDeliveryExtraFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemoteAreaDeliveryExtraFeeQuery({
 *   variables: {
 *   },
 * });
 */
export function useRemoteAreaDeliveryExtraFeeQuery(baseOptions?: Apollo.QueryHookOptions<RemoteAreaDeliveryExtraFeeQuery, RemoteAreaDeliveryExtraFeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemoteAreaDeliveryExtraFeeQuery, RemoteAreaDeliveryExtraFeeQueryVariables>(RemoteAreaDeliveryExtraFeeDocument, options);
      }
export function useRemoteAreaDeliveryExtraFeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemoteAreaDeliveryExtraFeeQuery, RemoteAreaDeliveryExtraFeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemoteAreaDeliveryExtraFeeQuery, RemoteAreaDeliveryExtraFeeQueryVariables>(RemoteAreaDeliveryExtraFeeDocument, options);
        }
export function useRemoteAreaDeliveryExtraFeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RemoteAreaDeliveryExtraFeeQuery, RemoteAreaDeliveryExtraFeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RemoteAreaDeliveryExtraFeeQuery, RemoteAreaDeliveryExtraFeeQueryVariables>(RemoteAreaDeliveryExtraFeeDocument, options);
        }
export type RemoteAreaDeliveryExtraFeeQueryHookResult = ReturnType<typeof useRemoteAreaDeliveryExtraFeeQuery>;
export type RemoteAreaDeliveryExtraFeeLazyQueryHookResult = ReturnType<typeof useRemoteAreaDeliveryExtraFeeLazyQuery>;
export type RemoteAreaDeliveryExtraFeeSuspenseQueryHookResult = ReturnType<typeof useRemoteAreaDeliveryExtraFeeSuspenseQuery>;
export type RemoteAreaDeliveryExtraFeeQueryResult = Apollo.QueryResult<RemoteAreaDeliveryExtraFeeQuery, RemoteAreaDeliveryExtraFeeQueryVariables>;
export const BookingDaysLimitDocument = gql`
    query BookingDaysLimit {
  bookingDaysLimit
}
    `;

/**
 * __useBookingDaysLimitQuery__
 *
 * To run a query within a React component, call `useBookingDaysLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingDaysLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingDaysLimitQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingDaysLimitQuery(baseOptions?: Apollo.QueryHookOptions<BookingDaysLimitQuery, BookingDaysLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingDaysLimitQuery, BookingDaysLimitQueryVariables>(BookingDaysLimitDocument, options);
      }
export function useBookingDaysLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingDaysLimitQuery, BookingDaysLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingDaysLimitQuery, BookingDaysLimitQueryVariables>(BookingDaysLimitDocument, options);
        }
export function useBookingDaysLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingDaysLimitQuery, BookingDaysLimitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingDaysLimitQuery, BookingDaysLimitQueryVariables>(BookingDaysLimitDocument, options);
        }
export type BookingDaysLimitQueryHookResult = ReturnType<typeof useBookingDaysLimitQuery>;
export type BookingDaysLimitLazyQueryHookResult = ReturnType<typeof useBookingDaysLimitLazyQuery>;
export type BookingDaysLimitSuspenseQueryHookResult = ReturnType<typeof useBookingDaysLimitSuspenseQuery>;
export type BookingDaysLimitQueryResult = Apollo.QueryResult<BookingDaysLimitQuery, BookingDaysLimitQueryVariables>;
export const BookingOpenHoursDocument = gql`
    query BookingOpenHours {
  bookingOpenHours
}
    `;

/**
 * __useBookingOpenHoursQuery__
 *
 * To run a query within a React component, call `useBookingOpenHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingOpenHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingOpenHoursQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingOpenHoursQuery(baseOptions?: Apollo.QueryHookOptions<BookingOpenHoursQuery, BookingOpenHoursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingOpenHoursQuery, BookingOpenHoursQueryVariables>(BookingOpenHoursDocument, options);
      }
export function useBookingOpenHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingOpenHoursQuery, BookingOpenHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingOpenHoursQuery, BookingOpenHoursQueryVariables>(BookingOpenHoursDocument, options);
        }
export function useBookingOpenHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingOpenHoursQuery, BookingOpenHoursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingOpenHoursQuery, BookingOpenHoursQueryVariables>(BookingOpenHoursDocument, options);
        }
export type BookingOpenHoursQueryHookResult = ReturnType<typeof useBookingOpenHoursQuery>;
export type BookingOpenHoursLazyQueryHookResult = ReturnType<typeof useBookingOpenHoursLazyQuery>;
export type BookingOpenHoursSuspenseQueryHookResult = ReturnType<typeof useBookingOpenHoursSuspenseQuery>;
export type BookingOpenHoursQueryResult = Apollo.QueryResult<BookingOpenHoursQuery, BookingOpenHoursQueryVariables>;
export const DoctorSpecializationsDocument = gql`
    query DoctorSpecializations($locale: String) {
  doctorSpecializations(locale: $locale)
}
    `;

/**
 * __useDoctorSpecializationsQuery__
 *
 * To run a query within a React component, call `useDoctorSpecializationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorSpecializationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorSpecializationsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useDoctorSpecializationsQuery(baseOptions?: Apollo.QueryHookOptions<DoctorSpecializationsQuery, DoctorSpecializationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorSpecializationsQuery, DoctorSpecializationsQueryVariables>(DoctorSpecializationsDocument, options);
      }
export function useDoctorSpecializationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorSpecializationsQuery, DoctorSpecializationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorSpecializationsQuery, DoctorSpecializationsQueryVariables>(DoctorSpecializationsDocument, options);
        }
export function useDoctorSpecializationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorSpecializationsQuery, DoctorSpecializationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorSpecializationsQuery, DoctorSpecializationsQueryVariables>(DoctorSpecializationsDocument, options);
        }
export type DoctorSpecializationsQueryHookResult = ReturnType<typeof useDoctorSpecializationsQuery>;
export type DoctorSpecializationsLazyQueryHookResult = ReturnType<typeof useDoctorSpecializationsLazyQuery>;
export type DoctorSpecializationsSuspenseQueryHookResult = ReturnType<typeof useDoctorSpecializationsSuspenseQuery>;
export type DoctorSpecializationsQueryResult = Apollo.QueryResult<DoctorSpecializationsQuery, DoctorSpecializationsQueryVariables>;
export const BookingSchedulesDocument = gql`
    query BookingSchedules {
  bookingSchedules {
    id
    name
    isDefault
    fromDate
    toDate
    priority
    isActive
    createdAt
    updatedAt
    schedule {
      monday {
        from
        to
      }
      tuesday {
        from
        to
      }
      wednesday {
        from
        to
      }
      thursday {
        from
        to
      }
      friday {
        from
        to
      }
      saturday {
        from
        to
      }
      sunday {
        from
        to
      }
    }
  }
}
    `;

/**
 * __useBookingSchedulesQuery__
 *
 * To run a query within a React component, call `useBookingSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingSchedulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<BookingSchedulesQuery, BookingSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingSchedulesQuery, BookingSchedulesQueryVariables>(BookingSchedulesDocument, options);
      }
export function useBookingSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingSchedulesQuery, BookingSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingSchedulesQuery, BookingSchedulesQueryVariables>(BookingSchedulesDocument, options);
        }
export function useBookingSchedulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingSchedulesQuery, BookingSchedulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingSchedulesQuery, BookingSchedulesQueryVariables>(BookingSchedulesDocument, options);
        }
export type BookingSchedulesQueryHookResult = ReturnType<typeof useBookingSchedulesQuery>;
export type BookingSchedulesLazyQueryHookResult = ReturnType<typeof useBookingSchedulesLazyQuery>;
export type BookingSchedulesSuspenseQueryHookResult = ReturnType<typeof useBookingSchedulesSuspenseQuery>;
export type BookingSchedulesQueryResult = Apollo.QueryResult<BookingSchedulesQuery, BookingSchedulesQueryVariables>;
export const ActiveBookingSchedulesDocument = gql`
    query ActiveBookingSchedules {
  activeBookingSchedules {
    id
    name
    isDefault
    fromDate
    toDate
    priority
    isActive
    createdAt
    updatedAt
    schedule {
      monday {
        from
        to
      }
      tuesday {
        from
        to
      }
      wednesday {
        from
        to
      }
      thursday {
        from
        to
      }
      friday {
        from
        to
      }
      saturday {
        from
        to
      }
      sunday {
        from
        to
      }
    }
  }
}
    `;

/**
 * __useActiveBookingSchedulesQuery__
 *
 * To run a query within a React component, call `useActiveBookingSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveBookingSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveBookingSchedulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveBookingSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<ActiveBookingSchedulesQuery, ActiveBookingSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveBookingSchedulesQuery, ActiveBookingSchedulesQueryVariables>(ActiveBookingSchedulesDocument, options);
      }
export function useActiveBookingSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveBookingSchedulesQuery, ActiveBookingSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveBookingSchedulesQuery, ActiveBookingSchedulesQueryVariables>(ActiveBookingSchedulesDocument, options);
        }
export function useActiveBookingSchedulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveBookingSchedulesQuery, ActiveBookingSchedulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveBookingSchedulesQuery, ActiveBookingSchedulesQueryVariables>(ActiveBookingSchedulesDocument, options);
        }
export type ActiveBookingSchedulesQueryHookResult = ReturnType<typeof useActiveBookingSchedulesQuery>;
export type ActiveBookingSchedulesLazyQueryHookResult = ReturnType<typeof useActiveBookingSchedulesLazyQuery>;
export type ActiveBookingSchedulesSuspenseQueryHookResult = ReturnType<typeof useActiveBookingSchedulesSuspenseQuery>;
export type ActiveBookingSchedulesQueryResult = Apollo.QueryResult<ActiveBookingSchedulesQuery, ActiveBookingSchedulesQueryVariables>;
export const GetScheduleOfDateDocument = gql`
    query GetScheduleOfDate($date: String!, $tenant: String) {
  scheduleOfDate(date: $date, tenant: $tenant) {
    id
    name
    isDefault
    fromDate
    toDate
    priority
    isActive
    createdAt
    updatedAt
    schedule {
      monday {
        from
        to
      }
      tuesday {
        from
        to
      }
      wednesday {
        from
        to
      }
      thursday {
        from
        to
      }
      friday {
        from
        to
      }
      saturday {
        from
        to
      }
      sunday {
        from
        to
      }
    }
  }
}
    `;

/**
 * __useGetScheduleOfDateQuery__
 *
 * To run a query within a React component, call `useGetScheduleOfDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleOfDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleOfDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useGetScheduleOfDateQuery(baseOptions: Apollo.QueryHookOptions<GetScheduleOfDateQuery, GetScheduleOfDateQueryVariables> & ({ variables: GetScheduleOfDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleOfDateQuery, GetScheduleOfDateQueryVariables>(GetScheduleOfDateDocument, options);
      }
export function useGetScheduleOfDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleOfDateQuery, GetScheduleOfDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleOfDateQuery, GetScheduleOfDateQueryVariables>(GetScheduleOfDateDocument, options);
        }
export function useGetScheduleOfDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScheduleOfDateQuery, GetScheduleOfDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScheduleOfDateQuery, GetScheduleOfDateQueryVariables>(GetScheduleOfDateDocument, options);
        }
export type GetScheduleOfDateQueryHookResult = ReturnType<typeof useGetScheduleOfDateQuery>;
export type GetScheduleOfDateLazyQueryHookResult = ReturnType<typeof useGetScheduleOfDateLazyQuery>;
export type GetScheduleOfDateSuspenseQueryHookResult = ReturnType<typeof useGetScheduleOfDateSuspenseQuery>;
export type GetScheduleOfDateQueryResult = Apollo.QueryResult<GetScheduleOfDateQuery, GetScheduleOfDateQueryVariables>;
export const SetAllowTeleconsultationDocument = gql`
    mutation SetAllowTeleconsultation($enabled: Boolean!) {
  setAllowTeleconsultation(enabled: $enabled)
}
    `;
export type SetAllowTeleconsultationMutationFn = Apollo.MutationFunction<SetAllowTeleconsultationMutation, SetAllowTeleconsultationMutationVariables>;

/**
 * __useSetAllowTeleconsultationMutation__
 *
 * To run a mutation, you first call `useSetAllowTeleconsultationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAllowTeleconsultationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAllowTeleconsultationMutation, { data, loading, error }] = useSetAllowTeleconsultationMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetAllowTeleconsultationMutation(baseOptions?: Apollo.MutationHookOptions<SetAllowTeleconsultationMutation, SetAllowTeleconsultationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAllowTeleconsultationMutation, SetAllowTeleconsultationMutationVariables>(SetAllowTeleconsultationDocument, options);
      }
export type SetAllowTeleconsultationMutationHookResult = ReturnType<typeof useSetAllowTeleconsultationMutation>;
export type SetAllowTeleconsultationMutationResult = Apollo.MutationResult<SetAllowTeleconsultationMutation>;
export type SetAllowTeleconsultationMutationOptions = Apollo.BaseMutationOptions<SetAllowTeleconsultationMutation, SetAllowTeleconsultationMutationVariables>;
export const SetTeleconsultationFeeDocument = gql`
    mutation SetTeleconsultationFee($fee: Float!, $tenant: String) {
  setTeleconsultationFee(fee: $fee, tenant: $tenant)
}
    `;
export type SetTeleconsultationFeeMutationFn = Apollo.MutationFunction<SetTeleconsultationFeeMutation, SetTeleconsultationFeeMutationVariables>;

/**
 * __useSetTeleconsultationFeeMutation__
 *
 * To run a mutation, you first call `useSetTeleconsultationFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTeleconsultationFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTeleconsultationFeeMutation, { data, loading, error }] = useSetTeleconsultationFeeMutation({
 *   variables: {
 *      fee: // value for 'fee'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useSetTeleconsultationFeeMutation(baseOptions?: Apollo.MutationHookOptions<SetTeleconsultationFeeMutation, SetTeleconsultationFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTeleconsultationFeeMutation, SetTeleconsultationFeeMutationVariables>(SetTeleconsultationFeeDocument, options);
      }
export type SetTeleconsultationFeeMutationHookResult = ReturnType<typeof useSetTeleconsultationFeeMutation>;
export type SetTeleconsultationFeeMutationResult = Apollo.MutationResult<SetTeleconsultationFeeMutation>;
export type SetTeleconsultationFeeMutationOptions = Apollo.BaseMutationOptions<SetTeleconsultationFeeMutation, SetTeleconsultationFeeMutationVariables>;
export const SetTeleconsultationLeadTimeDocument = gql`
    mutation SetTeleconsultationLeadTime($hours: Float!) {
  setTeleconsultationLeadTime(hours: $hours)
}
    `;
export type SetTeleconsultationLeadTimeMutationFn = Apollo.MutationFunction<SetTeleconsultationLeadTimeMutation, SetTeleconsultationLeadTimeMutationVariables>;

/**
 * __useSetTeleconsultationLeadTimeMutation__
 *
 * To run a mutation, you first call `useSetTeleconsultationLeadTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTeleconsultationLeadTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTeleconsultationLeadTimeMutation, { data, loading, error }] = useSetTeleconsultationLeadTimeMutation({
 *   variables: {
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useSetTeleconsultationLeadTimeMutation(baseOptions?: Apollo.MutationHookOptions<SetTeleconsultationLeadTimeMutation, SetTeleconsultationLeadTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTeleconsultationLeadTimeMutation, SetTeleconsultationLeadTimeMutationVariables>(SetTeleconsultationLeadTimeDocument, options);
      }
export type SetTeleconsultationLeadTimeMutationHookResult = ReturnType<typeof useSetTeleconsultationLeadTimeMutation>;
export type SetTeleconsultationLeadTimeMutationResult = Apollo.MutationResult<SetTeleconsultationLeadTimeMutation>;
export type SetTeleconsultationLeadTimeMutationOptions = Apollo.BaseMutationOptions<SetTeleconsultationLeadTimeMutation, SetTeleconsultationLeadTimeMutationVariables>;
export const SetRemoteAreaDeliveryExtraFeeDocument = gql`
    mutation SetRemoteAreaDeliveryExtraFee($fee: Float!) {
  setRemoteAreaDeliveryExtraFee(fee: $fee)
}
    `;
export type SetRemoteAreaDeliveryExtraFeeMutationFn = Apollo.MutationFunction<SetRemoteAreaDeliveryExtraFeeMutation, SetRemoteAreaDeliveryExtraFeeMutationVariables>;

/**
 * __useSetRemoteAreaDeliveryExtraFeeMutation__
 *
 * To run a mutation, you first call `useSetRemoteAreaDeliveryExtraFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRemoteAreaDeliveryExtraFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRemoteAreaDeliveryExtraFeeMutation, { data, loading, error }] = useSetRemoteAreaDeliveryExtraFeeMutation({
 *   variables: {
 *      fee: // value for 'fee'
 *   },
 * });
 */
export function useSetRemoteAreaDeliveryExtraFeeMutation(baseOptions?: Apollo.MutationHookOptions<SetRemoteAreaDeliveryExtraFeeMutation, SetRemoteAreaDeliveryExtraFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRemoteAreaDeliveryExtraFeeMutation, SetRemoteAreaDeliveryExtraFeeMutationVariables>(SetRemoteAreaDeliveryExtraFeeDocument, options);
      }
export type SetRemoteAreaDeliveryExtraFeeMutationHookResult = ReturnType<typeof useSetRemoteAreaDeliveryExtraFeeMutation>;
export type SetRemoteAreaDeliveryExtraFeeMutationResult = Apollo.MutationResult<SetRemoteAreaDeliveryExtraFeeMutation>;
export type SetRemoteAreaDeliveryExtraFeeMutationOptions = Apollo.BaseMutationOptions<SetRemoteAreaDeliveryExtraFeeMutation, SetRemoteAreaDeliveryExtraFeeMutationVariables>;
export const SetBookingDaysLimitDocument = gql`
    mutation SetBookingDaysLimit($days: Float!) {
  setBookingDaysLimit(days: $days)
}
    `;
export type SetBookingDaysLimitMutationFn = Apollo.MutationFunction<SetBookingDaysLimitMutation, SetBookingDaysLimitMutationVariables>;

/**
 * __useSetBookingDaysLimitMutation__
 *
 * To run a mutation, you first call `useSetBookingDaysLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBookingDaysLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBookingDaysLimitMutation, { data, loading, error }] = useSetBookingDaysLimitMutation({
 *   variables: {
 *      days: // value for 'days'
 *   },
 * });
 */
export function useSetBookingDaysLimitMutation(baseOptions?: Apollo.MutationHookOptions<SetBookingDaysLimitMutation, SetBookingDaysLimitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBookingDaysLimitMutation, SetBookingDaysLimitMutationVariables>(SetBookingDaysLimitDocument, options);
      }
export type SetBookingDaysLimitMutationHookResult = ReturnType<typeof useSetBookingDaysLimitMutation>;
export type SetBookingDaysLimitMutationResult = Apollo.MutationResult<SetBookingDaysLimitMutation>;
export type SetBookingDaysLimitMutationOptions = Apollo.BaseMutationOptions<SetBookingDaysLimitMutation, SetBookingDaysLimitMutationVariables>;
export const SetBookingOpenHoursDocument = gql`
    mutation SetBookingOpenHours($hours: [String!]!) {
  setBookingOpenHours(hours: $hours)
}
    `;
export type SetBookingOpenHoursMutationFn = Apollo.MutationFunction<SetBookingOpenHoursMutation, SetBookingOpenHoursMutationVariables>;

/**
 * __useSetBookingOpenHoursMutation__
 *
 * To run a mutation, you first call `useSetBookingOpenHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBookingOpenHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBookingOpenHoursMutation, { data, loading, error }] = useSetBookingOpenHoursMutation({
 *   variables: {
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useSetBookingOpenHoursMutation(baseOptions?: Apollo.MutationHookOptions<SetBookingOpenHoursMutation, SetBookingOpenHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBookingOpenHoursMutation, SetBookingOpenHoursMutationVariables>(SetBookingOpenHoursDocument, options);
      }
export type SetBookingOpenHoursMutationHookResult = ReturnType<typeof useSetBookingOpenHoursMutation>;
export type SetBookingOpenHoursMutationResult = Apollo.MutationResult<SetBookingOpenHoursMutation>;
export type SetBookingOpenHoursMutationOptions = Apollo.BaseMutationOptions<SetBookingOpenHoursMutation, SetBookingOpenHoursMutationVariables>;
export const CreateBookingScheduleDocument = gql`
    mutation CreateBookingSchedule($input: CreateBookingScheduleInput!) {
  createBookingSchedule(input: $input) {
    id
    name
    isDefault
    fromDate
    toDate
    priority
    isActive
    createdAt
    updatedAt
    schedule {
      monday {
        from
        to
      }
      tuesday {
        from
        to
      }
      wednesday {
        from
        to
      }
      thursday {
        from
        to
      }
      friday {
        from
        to
      }
      saturday {
        from
        to
      }
      sunday {
        from
        to
      }
    }
  }
}
    `;
export type CreateBookingScheduleMutationFn = Apollo.MutationFunction<CreateBookingScheduleMutation, CreateBookingScheduleMutationVariables>;

/**
 * __useCreateBookingScheduleMutation__
 *
 * To run a mutation, you first call `useCreateBookingScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingScheduleMutation, { data, loading, error }] = useCreateBookingScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookingScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingScheduleMutation, CreateBookingScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingScheduleMutation, CreateBookingScheduleMutationVariables>(CreateBookingScheduleDocument, options);
      }
export type CreateBookingScheduleMutationHookResult = ReturnType<typeof useCreateBookingScheduleMutation>;
export type CreateBookingScheduleMutationResult = Apollo.MutationResult<CreateBookingScheduleMutation>;
export type CreateBookingScheduleMutationOptions = Apollo.BaseMutationOptions<CreateBookingScheduleMutation, CreateBookingScheduleMutationVariables>;
export const UpdateBookingScheduleDocument = gql`
    mutation UpdateBookingSchedule($input: UpdateBookingScheduleInput!) {
  updateBookingSchedule(input: $input) {
    id
    name
    isDefault
    fromDate
    toDate
    priority
    isActive
    createdAt
    updatedAt
    schedule {
      monday {
        from
        to
      }
      tuesday {
        from
        to
      }
      wednesday {
        from
        to
      }
      thursday {
        from
        to
      }
      friday {
        from
        to
      }
      saturday {
        from
        to
      }
      sunday {
        from
        to
      }
    }
  }
}
    `;
export type UpdateBookingScheduleMutationFn = Apollo.MutationFunction<UpdateBookingScheduleMutation, UpdateBookingScheduleMutationVariables>;

/**
 * __useUpdateBookingScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateBookingScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingScheduleMutation, { data, loading, error }] = useUpdateBookingScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBookingScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingScheduleMutation, UpdateBookingScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingScheduleMutation, UpdateBookingScheduleMutationVariables>(UpdateBookingScheduleDocument, options);
      }
export type UpdateBookingScheduleMutationHookResult = ReturnType<typeof useUpdateBookingScheduleMutation>;
export type UpdateBookingScheduleMutationResult = Apollo.MutationResult<UpdateBookingScheduleMutation>;
export type UpdateBookingScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateBookingScheduleMutation, UpdateBookingScheduleMutationVariables>;
export const DeleteBookingScheduleDocument = gql`
    mutation DeleteBookingSchedule($scheduleId: String!) {
  deleteBookingSchedule(scheduleId: $scheduleId)
}
    `;
export type DeleteBookingScheduleMutationFn = Apollo.MutationFunction<DeleteBookingScheduleMutation, DeleteBookingScheduleMutationVariables>;

/**
 * __useDeleteBookingScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteBookingScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookingScheduleMutation, { data, loading, error }] = useDeleteBookingScheduleMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useDeleteBookingScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookingScheduleMutation, DeleteBookingScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookingScheduleMutation, DeleteBookingScheduleMutationVariables>(DeleteBookingScheduleDocument, options);
      }
export type DeleteBookingScheduleMutationHookResult = ReturnType<typeof useDeleteBookingScheduleMutation>;
export type DeleteBookingScheduleMutationResult = Apollo.MutationResult<DeleteBookingScheduleMutation>;
export type DeleteBookingScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteBookingScheduleMutation, DeleteBookingScheduleMutationVariables>;
export const GetClinicsDocument = gql`
    query GetClinics {
  clinics {
    id
    name_en
    name_zh_hk
    internal_name
    address
    phone_number
    email
    status
    region
    district
    description
    building_name
    floor
    unit
    postal_code
    website_url
    emergency_services
    walk_in_enabled
    online_consultation_enabled
    appointment_booking_enabled
    facilities
    services
    images
    latitude
    longitude
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetClinicsQuery__
 *
 * To run a query within a React component, call `useGetClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClinicsQuery(baseOptions?: Apollo.QueryHookOptions<GetClinicsQuery, GetClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicsQuery, GetClinicsQueryVariables>(GetClinicsDocument, options);
      }
export function useGetClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicsQuery, GetClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicsQuery, GetClinicsQueryVariables>(GetClinicsDocument, options);
        }
export function useGetClinicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClinicsQuery, GetClinicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicsQuery, GetClinicsQueryVariables>(GetClinicsDocument, options);
        }
export type GetClinicsQueryHookResult = ReturnType<typeof useGetClinicsQuery>;
export type GetClinicsLazyQueryHookResult = ReturnType<typeof useGetClinicsLazyQuery>;
export type GetClinicsSuspenseQueryHookResult = ReturnType<typeof useGetClinicsSuspenseQuery>;
export type GetClinicsQueryResult = Apollo.QueryResult<GetClinicsQuery, GetClinicsQueryVariables>;
export const GetClinicDocument = gql`
    query GetClinic($id: ID!) {
  clinic(id: $id) {
    id
    name_en
    name_zh_hk
    internal_name
    address
    phone_number
    email
    status
    region
    district
    description
    building_name
    floor
    unit
    postal_code
    website_url
    emergency_services
    walk_in_enabled
    online_consultation_enabled
    appointment_booking_enabled
    facilities
    services
    images
    latitude
    longitude
    created_at
    updated_at
    providers {
      id
      doctor {
        id
        first_name_en
        last_name_en
        specialization
      }
    }
  }
}
    `;

/**
 * __useGetClinicQuery__
 *
 * To run a query within a React component, call `useGetClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClinicQuery, GetClinicQueryVariables> & ({ variables: GetClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicQuery, GetClinicQueryVariables>(GetClinicDocument, options);
      }
export function useGetClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicQuery, GetClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicQuery, GetClinicQueryVariables>(GetClinicDocument, options);
        }
export function useGetClinicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClinicQuery, GetClinicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicQuery, GetClinicQueryVariables>(GetClinicDocument, options);
        }
export type GetClinicQueryHookResult = ReturnType<typeof useGetClinicQuery>;
export type GetClinicLazyQueryHookResult = ReturnType<typeof useGetClinicLazyQuery>;
export type GetClinicSuspenseQueryHookResult = ReturnType<typeof useGetClinicSuspenseQuery>;
export type GetClinicQueryResult = Apollo.QueryResult<GetClinicQuery, GetClinicQueryVariables>;
export const GetDoctorsDocument = gql`
    query GetDoctors {
  doctors {
    id
    first_name_en
    last_name_en
    first_name_zh_hk
    last_name_zh_hk
    email
    phone_number
    license_number
    specialization
    status
    rating
    experience_years
    consultation_fee
    avatar_url
    bio
    qualification
    title
    languages
    is_available_for_emergency
    max_daily_appointments
    total_reviews
    time_zone
    created_at
    updated_at
    providers {
      id
      clinic {
        id
        name_en
        name_zh_hk
        internal_name
      }
    }
  }
}
    `;

/**
 * __useGetDoctorsQuery__
 *
 * To run a query within a React component, call `useGetDoctorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDoctorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDoctorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDoctorsQuery(baseOptions?: Apollo.QueryHookOptions<GetDoctorsQuery, GetDoctorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDoctorsQuery, GetDoctorsQueryVariables>(GetDoctorsDocument, options);
      }
export function useGetDoctorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDoctorsQuery, GetDoctorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDoctorsQuery, GetDoctorsQueryVariables>(GetDoctorsDocument, options);
        }
export function useGetDoctorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDoctorsQuery, GetDoctorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDoctorsQuery, GetDoctorsQueryVariables>(GetDoctorsDocument, options);
        }
export type GetDoctorsQueryHookResult = ReturnType<typeof useGetDoctorsQuery>;
export type GetDoctorsLazyQueryHookResult = ReturnType<typeof useGetDoctorsLazyQuery>;
export type GetDoctorsSuspenseQueryHookResult = ReturnType<typeof useGetDoctorsSuspenseQuery>;
export type GetDoctorsQueryResult = Apollo.QueryResult<GetDoctorsQuery, GetDoctorsQueryVariables>;
export const GetDoctorDocument = gql`
    query GetDoctor($id: ID!) {
  doctor(id: $id) {
    id
    first_name_en
    last_name_en
    first_name_zh_hk
    last_name_zh_hk
    email
    phone_number
    license_number
    specialization
    status
    rating
    experience_years
    consultation_fee
    avatar_url
    bio
    qualification
    title
    languages
    is_available_for_emergency
    max_daily_appointments
    total_reviews
    time_zone
    created_at
    updated_at
    providers {
      id
      clinic {
        id
        name_en
        name_zh_hk
        internal_name
      }
    }
  }
}
    `;

/**
 * __useGetDoctorQuery__
 *
 * To run a query within a React component, call `useGetDoctorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDoctorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDoctorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDoctorQuery(baseOptions: Apollo.QueryHookOptions<GetDoctorQuery, GetDoctorQueryVariables> & ({ variables: GetDoctorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDoctorQuery, GetDoctorQueryVariables>(GetDoctorDocument, options);
      }
export function useGetDoctorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDoctorQuery, GetDoctorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDoctorQuery, GetDoctorQueryVariables>(GetDoctorDocument, options);
        }
export function useGetDoctorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDoctorQuery, GetDoctorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDoctorQuery, GetDoctorQueryVariables>(GetDoctorDocument, options);
        }
export type GetDoctorQueryHookResult = ReturnType<typeof useGetDoctorQuery>;
export type GetDoctorLazyQueryHookResult = ReturnType<typeof useGetDoctorLazyQuery>;
export type GetDoctorSuspenseQueryHookResult = ReturnType<typeof useGetDoctorSuspenseQuery>;
export type GetDoctorQueryResult = Apollo.QueryResult<GetDoctorQuery, GetDoctorQueryVariables>;
export const GetPatientsDocument = gql`
    query GetPatients {
  allPatients {
    id
    first_name_en
    last_name_en
    first_name_zh_hk
    last_name_zh_hk
    email
    phone_number
    birthdate
    gender
    status
    emergency_contact_name
    emergency_contact_phone
    avatar_url
    blood_type
    nationality
    identity_document_type
    identity_document_number
    language_preferences
    allergies
    chronic_conditions
    medications
    notes
    created_at
    updated_at
    app_user {
      id
      firstname
      lastname
      email
      phone_number
    }
  }
}
    `;

/**
 * __useGetPatientsQuery__
 *
 * To run a query within a React component, call `useGetPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPatientsQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientsQuery, GetPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientsQuery, GetPatientsQueryVariables>(GetPatientsDocument, options);
      }
export function useGetPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientsQuery, GetPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientsQuery, GetPatientsQueryVariables>(GetPatientsDocument, options);
        }
export function useGetPatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientsQuery, GetPatientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientsQuery, GetPatientsQueryVariables>(GetPatientsDocument, options);
        }
export type GetPatientsQueryHookResult = ReturnType<typeof useGetPatientsQuery>;
export type GetPatientsLazyQueryHookResult = ReturnType<typeof useGetPatientsLazyQuery>;
export type GetPatientsSuspenseQueryHookResult = ReturnType<typeof useGetPatientsSuspenseQuery>;
export type GetPatientsQueryResult = Apollo.QueryResult<GetPatientsQuery, GetPatientsQueryVariables>;
export const GetPatientsPaginatedDocument = gql`
    query GetPatientsPaginated($paginationDto: PaginationDto!) {
  patientsPaginated(paginationDto: $paginationDto) {
    patients {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      email
      phone_number
      birthdate
      gender
      status
      emergency_contact_name
      emergency_contact_phone
      avatar_url
      blood_type
      nationality
      identity_document_type
      identity_document_number
      language_preferences
      allergies
      chronic_conditions
      medications
      notes
      created_at
      updated_at
      app_user {
        id
        firstname
        lastname
        email
        phone_number
      }
    }
    pagination {
      page
      limit
      total
      totalPages
      hasNext
      hasPrev
    }
  }
}
    `;

/**
 * __useGetPatientsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetPatientsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientsPaginatedQuery({
 *   variables: {
 *      paginationDto: // value for 'paginationDto'
 *   },
 * });
 */
export function useGetPatientsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetPatientsPaginatedQuery, GetPatientsPaginatedQueryVariables> & ({ variables: GetPatientsPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientsPaginatedQuery, GetPatientsPaginatedQueryVariables>(GetPatientsPaginatedDocument, options);
      }
export function useGetPatientsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientsPaginatedQuery, GetPatientsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientsPaginatedQuery, GetPatientsPaginatedQueryVariables>(GetPatientsPaginatedDocument, options);
        }
export function useGetPatientsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientsPaginatedQuery, GetPatientsPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientsPaginatedQuery, GetPatientsPaginatedQueryVariables>(GetPatientsPaginatedDocument, options);
        }
export type GetPatientsPaginatedQueryHookResult = ReturnType<typeof useGetPatientsPaginatedQuery>;
export type GetPatientsPaginatedLazyQueryHookResult = ReturnType<typeof useGetPatientsPaginatedLazyQuery>;
export type GetPatientsPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetPatientsPaginatedSuspenseQuery>;
export type GetPatientsPaginatedQueryResult = Apollo.QueryResult<GetPatientsPaginatedQuery, GetPatientsPaginatedQueryVariables>;
export const GetPatientDocument = gql`
    query GetPatient($id: ID!) {
  patient(id: $id) {
    id
    first_name_en
    last_name_en
    first_name_zh_hk
    last_name_zh_hk
    email
    phone_number
    birthdate
    gender
    status
    emergency_contact_name
    emergency_contact_phone
    avatar_url
    blood_type
    nationality
    identity_document_type
    identity_document_number
    language_preferences
    allergies
    chronic_conditions
    medications
    notes
    created_at
    updated_at
    app_user {
      id
      firstname
      lastname
      email
      phone_number
    }
  }
}
    `;

/**
 * __useGetPatientQuery__
 *
 * To run a query within a React component, call `useGetPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientQuery(baseOptions: Apollo.QueryHookOptions<GetPatientQuery, GetPatientQueryVariables> & ({ variables: GetPatientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
      }
export function useGetPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
        }
export function useGetPatientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
        }
export type GetPatientQueryHookResult = ReturnType<typeof useGetPatientQuery>;
export type GetPatientLazyQueryHookResult = ReturnType<typeof useGetPatientLazyQuery>;
export type GetPatientSuspenseQueryHookResult = ReturnType<typeof useGetPatientSuspenseQuery>;
export type GetPatientQueryResult = Apollo.QueryResult<GetPatientQuery, GetPatientQueryVariables>;
export const GetProvidersDocument = gql`
    query GetProviders {
  providers {
    id
    doctor_id
    clinic_id
    consultation_fee
    department
    employment_type
    start_date
    end_date
    status
    role
    specialization_at_clinic
    last_worked_at
    verified_at
    created_at
    updated_at
    doctor {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      license_number
      specialization
      status
      rating
      experience_years
      email
      phone_number
    }
    clinic {
      id
      name_en
      name_zh_hk
      internal_name
      address
      region
      district
      phone_number
      email
      status
    }
    tags {
      id
      name
      slug
      category
      status
      display_name
      description
      color
      icon
      sort_order
      usage_count
      last_used_at
      is_system_tag
    }
    schedules {
      id
      status
      max_appointments_per_day
      default_appointment_duration
      is_available_for_telemedicine
      is_available_for_walk_in
      schedule {
        monday {
          from
          to
        }
        tuesday {
          from
          to
        }
        wednesday {
          from
          to
        }
        thursday {
          from
          to
        }
        friday {
          from
          to
        }
        saturday {
          from
          to
        }
        sunday {
          from
          to
        }
      }
    }
  }
}
    `;

/**
 * __useGetProvidersQuery__
 *
 * To run a query within a React component, call `useGetProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProvidersQuery(baseOptions?: Apollo.QueryHookOptions<GetProvidersQuery, GetProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProvidersQuery, GetProvidersQueryVariables>(GetProvidersDocument, options);
      }
export function useGetProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProvidersQuery, GetProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProvidersQuery, GetProvidersQueryVariables>(GetProvidersDocument, options);
        }
export function useGetProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProvidersQuery, GetProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProvidersQuery, GetProvidersQueryVariables>(GetProvidersDocument, options);
        }
export type GetProvidersQueryHookResult = ReturnType<typeof useGetProvidersQuery>;
export type GetProvidersLazyQueryHookResult = ReturnType<typeof useGetProvidersLazyQuery>;
export type GetProvidersSuspenseQueryHookResult = ReturnType<typeof useGetProvidersSuspenseQuery>;
export type GetProvidersQueryResult = Apollo.QueryResult<GetProvidersQuery, GetProvidersQueryVariables>;
export const GetTagsDocument = gql`
    query GetTags {
  allTags {
    id
    name
    slug
    category
    status
    display_name
    description
    color
    icon
    sort_order
    usage_count
    last_used_at
    is_system_tag
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const GetProviderDocument = gql`
    query GetProvider($id: ID!) {
  provider(id: $id) {
    id
    doctor_id
    clinic_id
    consultation_fee
    department
    employment_type
    start_date
    end_date
    status
    role
    specialization_at_clinic
    last_worked_at
    verified_at
    created_at
    updated_at
    doctor {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      license_number
      specialization
      status
      rating
      experience_years
      email
      phone_number
    }
    clinic {
      id
      name_en
      name_zh_hk
      internal_name
      address
      region
      district
      phone_number
      email
      status
    }
    tags {
      id
      name
      slug
      category
      status
      display_name
      description
      color
      icon
      sort_order
      usage_count
      last_used_at
      is_system_tag
    }
    schedules {
      id
      status
      max_appointments_per_day
      default_appointment_duration
      is_available_for_telemedicine
      is_available_for_walk_in
      schedule {
        monday {
          from
          to
        }
        tuesday {
          from
          to
        }
        wednesday {
          from
          to
        }
        thursday {
          from
          to
        }
        friday {
          from
          to
        }
        saturday {
          from
          to
        }
        sunday {
          from
          to
        }
      }
    }
  }
}
    `;

/**
 * __useGetProviderQuery__
 *
 * To run a query within a React component, call `useGetProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProviderQuery(baseOptions: Apollo.QueryHookOptions<GetProviderQuery, GetProviderQueryVariables> & ({ variables: GetProviderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderQuery, GetProviderQueryVariables>(GetProviderDocument, options);
      }
export function useGetProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderQuery, GetProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderQuery, GetProviderQueryVariables>(GetProviderDocument, options);
        }
export function useGetProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderQuery, GetProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProviderQuery, GetProviderQueryVariables>(GetProviderDocument, options);
        }
export type GetProviderQueryHookResult = ReturnType<typeof useGetProviderQuery>;
export type GetProviderLazyQueryHookResult = ReturnType<typeof useGetProviderLazyQuery>;
export type GetProviderSuspenseQueryHookResult = ReturnType<typeof useGetProviderSuspenseQuery>;
export type GetProviderQueryResult = Apollo.QueryResult<GetProviderQuery, GetProviderQueryVariables>;
export const GetHkRegionsAndDistrictsDocument = gql`
    query GetHKRegionsAndDistricts {
  hkRegionsAndDistricts {
    regions {
      code
      name_en
      name_zh_hk
      districts {
        code
        name_en
        name_zh_hk
      }
    }
  }
}
    `;

/**
 * __useGetHkRegionsAndDistrictsQuery__
 *
 * To run a query within a React component, call `useGetHkRegionsAndDistrictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHkRegionsAndDistrictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHkRegionsAndDistrictsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHkRegionsAndDistrictsQuery(baseOptions?: Apollo.QueryHookOptions<GetHkRegionsAndDistrictsQuery, GetHkRegionsAndDistrictsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHkRegionsAndDistrictsQuery, GetHkRegionsAndDistrictsQueryVariables>(GetHkRegionsAndDistrictsDocument, options);
      }
export function useGetHkRegionsAndDistrictsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHkRegionsAndDistrictsQuery, GetHkRegionsAndDistrictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHkRegionsAndDistrictsQuery, GetHkRegionsAndDistrictsQueryVariables>(GetHkRegionsAndDistrictsDocument, options);
        }
export function useGetHkRegionsAndDistrictsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHkRegionsAndDistrictsQuery, GetHkRegionsAndDistrictsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHkRegionsAndDistrictsQuery, GetHkRegionsAndDistrictsQueryVariables>(GetHkRegionsAndDistrictsDocument, options);
        }
export type GetHkRegionsAndDistrictsQueryHookResult = ReturnType<typeof useGetHkRegionsAndDistrictsQuery>;
export type GetHkRegionsAndDistrictsLazyQueryHookResult = ReturnType<typeof useGetHkRegionsAndDistrictsLazyQuery>;
export type GetHkRegionsAndDistrictsSuspenseQueryHookResult = ReturnType<typeof useGetHkRegionsAndDistrictsSuspenseQuery>;
export type GetHkRegionsAndDistrictsQueryResult = Apollo.QueryResult<GetHkRegionsAndDistrictsQuery, GetHkRegionsAndDistrictsQueryVariables>;
export const GetClinicsByRegionDocument = gql`
    query GetClinicsByRegion($region: String!) {
  clinicsByRegion(region: $region) {
    id
    name_en
    name_zh_hk
    internal_name
    address
    phone_number
    email
    status
    region
    district
  }
}
    `;

/**
 * __useGetClinicsByRegionQuery__
 *
 * To run a query within a React component, call `useGetClinicsByRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicsByRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicsByRegionQuery({
 *   variables: {
 *      region: // value for 'region'
 *   },
 * });
 */
export function useGetClinicsByRegionQuery(baseOptions: Apollo.QueryHookOptions<GetClinicsByRegionQuery, GetClinicsByRegionQueryVariables> & ({ variables: GetClinicsByRegionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicsByRegionQuery, GetClinicsByRegionQueryVariables>(GetClinicsByRegionDocument, options);
      }
export function useGetClinicsByRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicsByRegionQuery, GetClinicsByRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicsByRegionQuery, GetClinicsByRegionQueryVariables>(GetClinicsByRegionDocument, options);
        }
export function useGetClinicsByRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClinicsByRegionQuery, GetClinicsByRegionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicsByRegionQuery, GetClinicsByRegionQueryVariables>(GetClinicsByRegionDocument, options);
        }
export type GetClinicsByRegionQueryHookResult = ReturnType<typeof useGetClinicsByRegionQuery>;
export type GetClinicsByRegionLazyQueryHookResult = ReturnType<typeof useGetClinicsByRegionLazyQuery>;
export type GetClinicsByRegionSuspenseQueryHookResult = ReturnType<typeof useGetClinicsByRegionSuspenseQuery>;
export type GetClinicsByRegionQueryResult = Apollo.QueryResult<GetClinicsByRegionQuery, GetClinicsByRegionQueryVariables>;
export const GetDoctorsBySpecializationDocument = gql`
    query GetDoctorsBySpecialization($specialization: String!) {
  doctorsBySpecialization(specialization: $specialization) {
    id
    first_name_en
    last_name_en
    first_name_zh_hk
    last_name_zh_hk
    email
    phone_number
    license_number
    specialization
    status
    rating
    experience_years
    consultation_fee
  }
}
    `;

/**
 * __useGetDoctorsBySpecializationQuery__
 *
 * To run a query within a React component, call `useGetDoctorsBySpecializationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDoctorsBySpecializationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDoctorsBySpecializationQuery({
 *   variables: {
 *      specialization: // value for 'specialization'
 *   },
 * });
 */
export function useGetDoctorsBySpecializationQuery(baseOptions: Apollo.QueryHookOptions<GetDoctorsBySpecializationQuery, GetDoctorsBySpecializationQueryVariables> & ({ variables: GetDoctorsBySpecializationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDoctorsBySpecializationQuery, GetDoctorsBySpecializationQueryVariables>(GetDoctorsBySpecializationDocument, options);
      }
export function useGetDoctorsBySpecializationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDoctorsBySpecializationQuery, GetDoctorsBySpecializationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDoctorsBySpecializationQuery, GetDoctorsBySpecializationQueryVariables>(GetDoctorsBySpecializationDocument, options);
        }
export function useGetDoctorsBySpecializationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDoctorsBySpecializationQuery, GetDoctorsBySpecializationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDoctorsBySpecializationQuery, GetDoctorsBySpecializationQueryVariables>(GetDoctorsBySpecializationDocument, options);
        }
export type GetDoctorsBySpecializationQueryHookResult = ReturnType<typeof useGetDoctorsBySpecializationQuery>;
export type GetDoctorsBySpecializationLazyQueryHookResult = ReturnType<typeof useGetDoctorsBySpecializationLazyQuery>;
export type GetDoctorsBySpecializationSuspenseQueryHookResult = ReturnType<typeof useGetDoctorsBySpecializationSuspenseQuery>;
export type GetDoctorsBySpecializationQueryResult = Apollo.QueryResult<GetDoctorsBySpecializationQuery, GetDoctorsBySpecializationQueryVariables>;
export const GetProvidersByClinicDocument = gql`
    query GetProvidersByClinic($clinicId: ID!) {
  providersByClinic(clinicId: $clinicId) {
    id
    doctor_id
    clinic_id
    consultation_fee
    status
    doctor {
      id
      first_name_en
      last_name_en
      specialization
    }
    clinic {
      id
      name_en
      name_zh_hk
      internal_name
    }
  }
}
    `;

/**
 * __useGetProvidersByClinicQuery__
 *
 * To run a query within a React component, call `useGetProvidersByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetProvidersByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetProvidersByClinicQuery, GetProvidersByClinicQueryVariables> & ({ variables: GetProvidersByClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProvidersByClinicQuery, GetProvidersByClinicQueryVariables>(GetProvidersByClinicDocument, options);
      }
export function useGetProvidersByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProvidersByClinicQuery, GetProvidersByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProvidersByClinicQuery, GetProvidersByClinicQueryVariables>(GetProvidersByClinicDocument, options);
        }
export function useGetProvidersByClinicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProvidersByClinicQuery, GetProvidersByClinicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProvidersByClinicQuery, GetProvidersByClinicQueryVariables>(GetProvidersByClinicDocument, options);
        }
export type GetProvidersByClinicQueryHookResult = ReturnType<typeof useGetProvidersByClinicQuery>;
export type GetProvidersByClinicLazyQueryHookResult = ReturnType<typeof useGetProvidersByClinicLazyQuery>;
export type GetProvidersByClinicSuspenseQueryHookResult = ReturnType<typeof useGetProvidersByClinicSuspenseQuery>;
export type GetProvidersByClinicQueryResult = Apollo.QueryResult<GetProvidersByClinicQuery, GetProvidersByClinicQueryVariables>;
export const GetAppointmentsDocument = gql`
    query GetAppointments($filter: AppointmentFilterDto) {
  appointments(filter: $filter) {
    id
    app_user_id
    patient_id
    provider_id
    date
    time
    expected_time_range
    duration
    status
    queue_number
    type
    reservation_type
    questionnaire
    appointment_notes
    internal_remark
    priority
    consultation_type
    language_preference
    booking_source
    payment_status
    payment_method
    total_amount
    insurance_claim_id
    timezone
    confirmation_sent
    cancelled_reason
    cancelled_by
    medical_history_reviewed
    diagnosis
    treatment_plan
    prescription
    follow_up_required
    follow_up_date
    patient_phone
    patient_email
    emergency_contact
    special_instructions
    patient_rating
    patient_feedback
    doctor_notes
    quality_score
    created_at
    updated_at
    scheduled_at
    confirmed_at
    started_at
    completed_at
    cancelled_at
    otherStatuses
    app_user {
      id
      firstname
      lastname
      email
      phone_number
      tenant
    }
    patient {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      gender
      birthdate
      email
      phone_number
      status
      relationship_to_owner
    }
  }
}
    `;

/**
 * __useGetAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
      }
export function useGetAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
        }
export function useGetAppointmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
        }
export type GetAppointmentsQueryHookResult = ReturnType<typeof useGetAppointmentsQuery>;
export type GetAppointmentsLazyQueryHookResult = ReturnType<typeof useGetAppointmentsLazyQuery>;
export type GetAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsSuspenseQuery>;
export type GetAppointmentsQueryResult = Apollo.QueryResult<GetAppointmentsQuery, GetAppointmentsQueryVariables>;
export const GetAppointmentDocument = gql`
    query GetAppointment($id: String!) {
  appointment(id: $id) {
    id
    app_user_id
    patient_id
    provider_id
    date
    time
    expected_time_range
    duration
    status
    type
    reservation_type
    questionnaire
    appointment_notes
    internal_remark
    priority
    consultation_type
    language_preference
    booking_source
    payment_status
    payment_method
    total_amount
    insurance_claim_id
    timezone
    reminder_sent
    confirmation_sent
    rescheduled_from
    rescheduled_to
    cancelled_reason
    cancelled_by
    medical_history_reviewed
    diagnosis
    treatment_plan
    prescription
    follow_up_required
    follow_up_date
    patient_phone
    patient_email
    emergency_contact
    special_instructions
    delivery_address_id
    delivery_note
    delivery_address {
      id
      type
      display_name
      region
      district
      street_address
      building_name
      floor
      block
      unit
      postal_code
      override_address
      is_default
      phone_number
      contact_name
      created_at
      updated_at
    }
    sfExpressOrders {
      id
      tenant
      request_id
      service_code
      timestamp
      partner_id
      msg_digest
      request_data
      response_data
      status
      order_id
      waybill_no
      tracking_number
      error_code
      error_message
      api_result_code
      api_error_msg
      notes
      created_at
      updated_at
      processed_at
      retry_count
      last_retry_at
      metadata
      appointment_id
    }
    jdExpressOrders {
      id
      tenant
      request_id
      service_code
      timestamp
      partner_id
      msg_digest
      request_data
      response_data
      status
      order_id
      waybill_no
      tracking_number
      error_code
      error_message
      api_result_code
      api_error_msg
      notes
      created_at
      updated_at
      processed_at
      retry_count
      last_retry_at
      metadata
      appointment_id
    }
    transactions {
      id
      app_user_id
      appointment_id
      transaction_reference
      original_amount
      amount
      currency
      type
      status
      payment_method
      description
      category
      subcategory
      notes
      gateway_transaction_id
      gateway_response
      processing_fee
      tax_amount
      discount_amount
      final_amount
      metadata
      refund_reason
      refunded_by
      refunded_at
      original_transaction_id
      created_at
      updated_at
      processed_at
      completed_at
      items {
        id
        name
        quantity
        price
      }
    }
    agoraLink {
      id
      appointmentId
      channelName
      uid
      role
      token
      link
      webLink
      appId
      expiresAt
      isActive
      createdAt
      updatedAt
    }
    insuranceClaims {
      id
      policyId
      appointmentId
      status
      claimResultDetails {
        approved_amount
        rejected_amount
        rejected_reason
      }
      isActive
      createdAt
      updatedAt
      items {
        id
        insuranceClaimId
        name
        category
        amount
        approvedAmount
        transactionId
        createdAt
        updatedAt
      }
    }
    patient_rating
    patient_feedback
    doctor_notes
    quality_score
    created_at
    updated_at
    scheduled_at
    confirmed_at
    started_at
    completed_at
    cancelled_at
    app_user {
      id
      firstname
      lastname
      email
      phone_number
      tenant
      addresses {
        id
        type
        street_address
        unit
        floor
        building_name
        district
        region
        postal_code
        is_default
        created_at
        updated_at
      }
      patients {
        id
        first_name_en
        last_name_en
        first_name_zh_hk
        last_name_zh_hk
        email
        phone_number
        birthdate
        gender
        status
        emergency_contact_name
        emergency_contact_phone
        avatar_url
        blood_type
        nationality
        identity_document_type
        identity_document_number
        language_preferences
        allergies
        chronic_conditions
        medications
        notes
        relationship_to_owner
        created_at
        updated_at
      }
    }
    patient {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      gender
      birthdate
      email
      phone_number
      status
      relationship_to_owner
      emergency_contact_name
      emergency_contact_phone
      blood_type
      nationality
      identity_document_type
      identity_document_number
      language_preferences
      allergies
      chronic_conditions
      medications
      notes
      avatar_url
      created_at
      updated_at
    }
    provider {
      id
      doctor_id
      clinic_id
      consultation_fee
      department
      employment_type
      start_date
      end_date
      status
      role
      specialization_at_clinic
      last_worked_at
      verified_at
      created_at
      updated_at
      doctor {
        id
        first_name_en
        last_name_en
        first_name_zh_hk
        last_name_zh_hk
        license_number
        specialization
        status
        rating
        experience_years
        email
        phone_number
        avatar_url
        bio
        qualification
        title
        languages
      }
      clinic {
        id
        name_en
        name_zh_hk
        internal_name
        address
        region
        district
        phone_number
        email
        status
        building_name
        floor
        unit
      }
    }
  }
}
    `;

/**
 * __useGetAppointmentQuery__
 *
 * To run a query within a React component, call `useGetAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables> & ({ variables: GetAppointmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
      }
export function useGetAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
        }
export function useGetAppointmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
        }
export type GetAppointmentQueryHookResult = ReturnType<typeof useGetAppointmentQuery>;
export type GetAppointmentLazyQueryHookResult = ReturnType<typeof useGetAppointmentLazyQuery>;
export type GetAppointmentSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentSuspenseQuery>;
export type GetAppointmentQueryResult = Apollo.QueryResult<GetAppointmentQuery, GetAppointmentQueryVariables>;
export const GetAppointmentsByDateRangeDocument = gql`
    query GetAppointmentsByDateRange($providerId: String!, $startDate: String!, $endDate: String!) {
  appointmentsByDateRange(
    providerId: $providerId
    startDate: $startDate
    endDate: $endDate
  ) {
    id
    app_user_id
    provider_id
    date
    time
    duration
    status
    type
    reservation_type
    questionnaire
    appointment_notes
    priority
    consultation_type
    language_preference
    booking_source
    payment_status
    payment_method
    total_amount
    insurance_claim_id
    timezone
    reminder_sent
    confirmation_sent
    rescheduled_from
    rescheduled_to
    cancelled_reason
    cancelled_by
    medical_history_reviewed
    diagnosis
    treatment_plan
    prescription
    follow_up_required
    follow_up_date
    patient_phone
    patient_email
    emergency_contact
    special_instructions
    patient_rating
    patient_feedback
    doctor_notes
    quality_score
    tenant
    created_at
    updated_at
    scheduled_at
    confirmed_at
    started_at
    completed_at
    cancelled_at
  }
}
    `;

/**
 * __useGetAppointmentsByDateRangeQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsByDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsByDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsByDateRangeQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetAppointmentsByDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsByDateRangeQuery, GetAppointmentsByDateRangeQueryVariables> & ({ variables: GetAppointmentsByDateRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsByDateRangeQuery, GetAppointmentsByDateRangeQueryVariables>(GetAppointmentsByDateRangeDocument, options);
      }
export function useGetAppointmentsByDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsByDateRangeQuery, GetAppointmentsByDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsByDateRangeQuery, GetAppointmentsByDateRangeQueryVariables>(GetAppointmentsByDateRangeDocument, options);
        }
export function useGetAppointmentsByDateRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentsByDateRangeQuery, GetAppointmentsByDateRangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsByDateRangeQuery, GetAppointmentsByDateRangeQueryVariables>(GetAppointmentsByDateRangeDocument, options);
        }
export type GetAppointmentsByDateRangeQueryHookResult = ReturnType<typeof useGetAppointmentsByDateRangeQuery>;
export type GetAppointmentsByDateRangeLazyQueryHookResult = ReturnType<typeof useGetAppointmentsByDateRangeLazyQuery>;
export type GetAppointmentsByDateRangeSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsByDateRangeSuspenseQuery>;
export type GetAppointmentsByDateRangeQueryResult = Apollo.QueryResult<GetAppointmentsByDateRangeQuery, GetAppointmentsByDateRangeQueryVariables>;
export const GetAppointmentStatsDocument = gql`
    query GetAppointmentStats($userId: String, $providerId: String) {
  appointmentStats(userId: $userId, providerId: $providerId) {
    scheduled
    confirmed
    in_progress
    completed
    cancelled
    no_show
  }
}
    `;

/**
 * __useGetAppointmentStatsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentStatsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetAppointmentStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentStatsQuery, GetAppointmentStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentStatsQuery, GetAppointmentStatsQueryVariables>(GetAppointmentStatsDocument, options);
      }
export function useGetAppointmentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentStatsQuery, GetAppointmentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentStatsQuery, GetAppointmentStatsQueryVariables>(GetAppointmentStatsDocument, options);
        }
export function useGetAppointmentStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentStatsQuery, GetAppointmentStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentStatsQuery, GetAppointmentStatsQueryVariables>(GetAppointmentStatsDocument, options);
        }
export type GetAppointmentStatsQueryHookResult = ReturnType<typeof useGetAppointmentStatsQuery>;
export type GetAppointmentStatsLazyQueryHookResult = ReturnType<typeof useGetAppointmentStatsLazyQuery>;
export type GetAppointmentStatsSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentStatsSuspenseQuery>;
export type GetAppointmentStatsQueryResult = Apollo.QueryResult<GetAppointmentStatsQuery, GetAppointmentStatsQueryVariables>;
export const GetTodaysAppointmentSummaryDocument = gql`
    query GetTodaysAppointmentSummary {
  getTodaysAppointmentSummary {
    appointmentDateTime
    status
    payment
    extraMed
    deliveryWaybill
    timestamp
    lastnameEn
    firstnameEn
    chineseName
    gender
    dob
    hkid
    appUserPhone
    deliveryAddress
    transactionId
    district
    transactionTotal
  }
}
    `;

/**
 * __useGetTodaysAppointmentSummaryQuery__
 *
 * To run a query within a React component, call `useGetTodaysAppointmentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTodaysAppointmentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTodaysAppointmentSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTodaysAppointmentSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetTodaysAppointmentSummaryQuery, GetTodaysAppointmentSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTodaysAppointmentSummaryQuery, GetTodaysAppointmentSummaryQueryVariables>(GetTodaysAppointmentSummaryDocument, options);
      }
export function useGetTodaysAppointmentSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTodaysAppointmentSummaryQuery, GetTodaysAppointmentSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTodaysAppointmentSummaryQuery, GetTodaysAppointmentSummaryQueryVariables>(GetTodaysAppointmentSummaryDocument, options);
        }
export function useGetTodaysAppointmentSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTodaysAppointmentSummaryQuery, GetTodaysAppointmentSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTodaysAppointmentSummaryQuery, GetTodaysAppointmentSummaryQueryVariables>(GetTodaysAppointmentSummaryDocument, options);
        }
export type GetTodaysAppointmentSummaryQueryHookResult = ReturnType<typeof useGetTodaysAppointmentSummaryQuery>;
export type GetTodaysAppointmentSummaryLazyQueryHookResult = ReturnType<typeof useGetTodaysAppointmentSummaryLazyQuery>;
export type GetTodaysAppointmentSummarySuspenseQueryHookResult = ReturnType<typeof useGetTodaysAppointmentSummarySuspenseQuery>;
export type GetTodaysAppointmentSummaryQueryResult = Apollo.QueryResult<GetTodaysAppointmentSummaryQuery, GetTodaysAppointmentSummaryQueryVariables>;
export const GetAppointmentSummaryByDateDocument = gql`
    query GetAppointmentSummaryByDate($date: String!) {
  getAppointmentSummaryByDate(date: $date) {
    appointmentDateTime
    status
    payment
    extraMed
    deliveryWaybill
    timestamp
    lastnameEn
    firstnameEn
    chineseName
    gender
    dob
    hkid
    appUserPhone
    deliveryAddress
    transactionId
    district
    transactionTotal
  }
}
    `;

/**
 * __useGetAppointmentSummaryByDateQuery__
 *
 * To run a query within a React component, call `useGetAppointmentSummaryByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentSummaryByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentSummaryByDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetAppointmentSummaryByDateQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentSummaryByDateQuery, GetAppointmentSummaryByDateQueryVariables> & ({ variables: GetAppointmentSummaryByDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentSummaryByDateQuery, GetAppointmentSummaryByDateQueryVariables>(GetAppointmentSummaryByDateDocument, options);
      }
export function useGetAppointmentSummaryByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentSummaryByDateQuery, GetAppointmentSummaryByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentSummaryByDateQuery, GetAppointmentSummaryByDateQueryVariables>(GetAppointmentSummaryByDateDocument, options);
        }
export function useGetAppointmentSummaryByDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentSummaryByDateQuery, GetAppointmentSummaryByDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentSummaryByDateQuery, GetAppointmentSummaryByDateQueryVariables>(GetAppointmentSummaryByDateDocument, options);
        }
export type GetAppointmentSummaryByDateQueryHookResult = ReturnType<typeof useGetAppointmentSummaryByDateQuery>;
export type GetAppointmentSummaryByDateLazyQueryHookResult = ReturnType<typeof useGetAppointmentSummaryByDateLazyQuery>;
export type GetAppointmentSummaryByDateSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentSummaryByDateSuspenseQuery>;
export type GetAppointmentSummaryByDateQueryResult = Apollo.QueryResult<GetAppointmentSummaryByDateQuery, GetAppointmentSummaryByDateQueryVariables>;
export const GetAppointmentSummaryByDateRangeDocument = gql`
    query GetAppointmentSummaryByDateRange($startDate: String!, $endDate: String!, $reportType: String) {
  getAppointmentSummaryByDateRange(
    startDate: $startDate
    endDate: $endDate
    reportType: $reportType
  ) {
    appointmentDateTime
    status
    payment
    extraMed
    deliveryWaybill
    timestamp
    lastnameEn
    firstnameEn
    chineseName
    gender
    dob
    hkid
    appUserPhone
    deliveryAddress
    transactionId
    district
    transactionTotal
    appointmentId
    date
    englishName
    waybillNo
    address
    mobile
    doctorName
  }
}
    `;

/**
 * __useGetAppointmentSummaryByDateRangeQuery__
 *
 * To run a query within a React component, call `useGetAppointmentSummaryByDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentSummaryByDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentSummaryByDateRangeQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      reportType: // value for 'reportType'
 *   },
 * });
 */
export function useGetAppointmentSummaryByDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentSummaryByDateRangeQuery, GetAppointmentSummaryByDateRangeQueryVariables> & ({ variables: GetAppointmentSummaryByDateRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentSummaryByDateRangeQuery, GetAppointmentSummaryByDateRangeQueryVariables>(GetAppointmentSummaryByDateRangeDocument, options);
      }
export function useGetAppointmentSummaryByDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentSummaryByDateRangeQuery, GetAppointmentSummaryByDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentSummaryByDateRangeQuery, GetAppointmentSummaryByDateRangeQueryVariables>(GetAppointmentSummaryByDateRangeDocument, options);
        }
export function useGetAppointmentSummaryByDateRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentSummaryByDateRangeQuery, GetAppointmentSummaryByDateRangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentSummaryByDateRangeQuery, GetAppointmentSummaryByDateRangeQueryVariables>(GetAppointmentSummaryByDateRangeDocument, options);
        }
export type GetAppointmentSummaryByDateRangeQueryHookResult = ReturnType<typeof useGetAppointmentSummaryByDateRangeQuery>;
export type GetAppointmentSummaryByDateRangeLazyQueryHookResult = ReturnType<typeof useGetAppointmentSummaryByDateRangeLazyQuery>;
export type GetAppointmentSummaryByDateRangeSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentSummaryByDateRangeSuspenseQuery>;
export type GetAppointmentSummaryByDateRangeQueryResult = Apollo.QueryResult<GetAppointmentSummaryByDateRangeQuery, GetAppointmentSummaryByDateRangeQueryVariables>;
export const GetClaimsExportByDateRangeDocument = gql`
    query GetClaimsExportByDateRange($payor: InsurancePayor!, $startDate: String!, $endDate: String!) {
  getClaimsExportByDateRange(
    payor: $payor
    startDate: $startDate
    endDate: $endDate
  ) {
    claimId
    policyNumber
    policyName
    planName
    appointmentId
    appointmentDate
    approvedAmount
    patientName
    doctorName
    clinicName
  }
}
    `;

/**
 * __useGetClaimsExportByDateRangeQuery__
 *
 * To run a query within a React component, call `useGetClaimsExportByDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClaimsExportByDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClaimsExportByDateRangeQuery({
 *   variables: {
 *      payor: // value for 'payor'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetClaimsExportByDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetClaimsExportByDateRangeQuery, GetClaimsExportByDateRangeQueryVariables> & ({ variables: GetClaimsExportByDateRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClaimsExportByDateRangeQuery, GetClaimsExportByDateRangeQueryVariables>(GetClaimsExportByDateRangeDocument, options);
      }
export function useGetClaimsExportByDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClaimsExportByDateRangeQuery, GetClaimsExportByDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClaimsExportByDateRangeQuery, GetClaimsExportByDateRangeQueryVariables>(GetClaimsExportByDateRangeDocument, options);
        }
export function useGetClaimsExportByDateRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClaimsExportByDateRangeQuery, GetClaimsExportByDateRangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClaimsExportByDateRangeQuery, GetClaimsExportByDateRangeQueryVariables>(GetClaimsExportByDateRangeDocument, options);
        }
export type GetClaimsExportByDateRangeQueryHookResult = ReturnType<typeof useGetClaimsExportByDateRangeQuery>;
export type GetClaimsExportByDateRangeLazyQueryHookResult = ReturnType<typeof useGetClaimsExportByDateRangeLazyQuery>;
export type GetClaimsExportByDateRangeSuspenseQueryHookResult = ReturnType<typeof useGetClaimsExportByDateRangeSuspenseQuery>;
export type GetClaimsExportByDateRangeQueryResult = Apollo.QueryResult<GetClaimsExportByDateRangeQuery, GetClaimsExportByDateRangeQueryVariables>;
export const GetAppointmentAgoraLinkDocument = gql`
    query GetAppointmentAgoraLink($input: GetAppointmentAgoraLinkInput!) {
  getAppointmentAgoraLink(input: $input) {
    id
    appointmentId
    channelName
    uid
    role
    token
    link
    webLink
    appId
    expiresAt
    isActive
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAppointmentAgoraLinkQuery__
 *
 * To run a query within a React component, call `useGetAppointmentAgoraLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentAgoraLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentAgoraLinkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAppointmentAgoraLinkQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentAgoraLinkQuery, GetAppointmentAgoraLinkQueryVariables> & ({ variables: GetAppointmentAgoraLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentAgoraLinkQuery, GetAppointmentAgoraLinkQueryVariables>(GetAppointmentAgoraLinkDocument, options);
      }
export function useGetAppointmentAgoraLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentAgoraLinkQuery, GetAppointmentAgoraLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentAgoraLinkQuery, GetAppointmentAgoraLinkQueryVariables>(GetAppointmentAgoraLinkDocument, options);
        }
export function useGetAppointmentAgoraLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentAgoraLinkQuery, GetAppointmentAgoraLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentAgoraLinkQuery, GetAppointmentAgoraLinkQueryVariables>(GetAppointmentAgoraLinkDocument, options);
        }
export type GetAppointmentAgoraLinkQueryHookResult = ReturnType<typeof useGetAppointmentAgoraLinkQuery>;
export type GetAppointmentAgoraLinkLazyQueryHookResult = ReturnType<typeof useGetAppointmentAgoraLinkLazyQuery>;
export type GetAppointmentAgoraLinkSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentAgoraLinkSuspenseQuery>;
export type GetAppointmentAgoraLinkQueryResult = Apollo.QueryResult<GetAppointmentAgoraLinkQuery, GetAppointmentAgoraLinkQueryVariables>;
export const GenerateAgoraTokenDocument = gql`
    mutation GenerateAgoraToken($input: GenerateTokenInput!) {
  generateAgoraToken(input: $input) {
    token
    appId
    channelName
    uid
    role
    expiresAt
  }
}
    `;
export type GenerateAgoraTokenMutationFn = Apollo.MutationFunction<GenerateAgoraTokenMutation, GenerateAgoraTokenMutationVariables>;

/**
 * __useGenerateAgoraTokenMutation__
 *
 * To run a mutation, you first call `useGenerateAgoraTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAgoraTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAgoraTokenMutation, { data, loading, error }] = useGenerateAgoraTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAgoraTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAgoraTokenMutation, GenerateAgoraTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAgoraTokenMutation, GenerateAgoraTokenMutationVariables>(GenerateAgoraTokenDocument, options);
      }
export type GenerateAgoraTokenMutationHookResult = ReturnType<typeof useGenerateAgoraTokenMutation>;
export type GenerateAgoraTokenMutationResult = Apollo.MutationResult<GenerateAgoraTokenMutation>;
export type GenerateAgoraTokenMutationOptions = Apollo.BaseMutationOptions<GenerateAgoraTokenMutation, GenerateAgoraTokenMutationVariables>;
export const ValidateAgoraTokenDocument = gql`
    query ValidateAgoraToken($input: ValidateTokenInput!) {
  validateAgoraToken(input: $input) {
    isValid
    message
  }
}
    `;

/**
 * __useValidateAgoraTokenQuery__
 *
 * To run a query within a React component, call `useValidateAgoraTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateAgoraTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateAgoraTokenQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateAgoraTokenQuery(baseOptions: Apollo.QueryHookOptions<ValidateAgoraTokenQuery, ValidateAgoraTokenQueryVariables> & ({ variables: ValidateAgoraTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateAgoraTokenQuery, ValidateAgoraTokenQueryVariables>(ValidateAgoraTokenDocument, options);
      }
export function useValidateAgoraTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateAgoraTokenQuery, ValidateAgoraTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateAgoraTokenQuery, ValidateAgoraTokenQueryVariables>(ValidateAgoraTokenDocument, options);
        }
export function useValidateAgoraTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateAgoraTokenQuery, ValidateAgoraTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateAgoraTokenQuery, ValidateAgoraTokenQueryVariables>(ValidateAgoraTokenDocument, options);
        }
export type ValidateAgoraTokenQueryHookResult = ReturnType<typeof useValidateAgoraTokenQuery>;
export type ValidateAgoraTokenLazyQueryHookResult = ReturnType<typeof useValidateAgoraTokenLazyQuery>;
export type ValidateAgoraTokenSuspenseQueryHookResult = ReturnType<typeof useValidateAgoraTokenSuspenseQuery>;
export type ValidateAgoraTokenQueryResult = Apollo.QueryResult<ValidateAgoraTokenQuery, ValidateAgoraTokenQueryVariables>;
export const GetAgoraAppIdDocument = gql`
    query GetAgoraAppId {
  getAgoraAppId
}
    `;

/**
 * __useGetAgoraAppIdQuery__
 *
 * To run a query within a React component, call `useGetAgoraAppIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgoraAppIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgoraAppIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgoraAppIdQuery(baseOptions?: Apollo.QueryHookOptions<GetAgoraAppIdQuery, GetAgoraAppIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgoraAppIdQuery, GetAgoraAppIdQueryVariables>(GetAgoraAppIdDocument, options);
      }
export function useGetAgoraAppIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgoraAppIdQuery, GetAgoraAppIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgoraAppIdQuery, GetAgoraAppIdQueryVariables>(GetAgoraAppIdDocument, options);
        }
export function useGetAgoraAppIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgoraAppIdQuery, GetAgoraAppIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgoraAppIdQuery, GetAgoraAppIdQueryVariables>(GetAgoraAppIdDocument, options);
        }
export type GetAgoraAppIdQueryHookResult = ReturnType<typeof useGetAgoraAppIdQuery>;
export type GetAgoraAppIdLazyQueryHookResult = ReturnType<typeof useGetAgoraAppIdLazyQuery>;
export type GetAgoraAppIdSuspenseQueryHookResult = ReturnType<typeof useGetAgoraAppIdSuspenseQuery>;
export type GetAgoraAppIdQueryResult = Apollo.QueryResult<GetAgoraAppIdQuery, GetAgoraAppIdQueryVariables>;
export const GetUserAppointmentsDocument = gql`
    query GetUserAppointments($userId: String!) {
  userAppointments(userId: $userId) {
    id
    app_user_id
    provider_id
    date
    time
    duration
    status
    type
    reservation_type
    questionnaire
    appointment_notes
    priority
    consultation_type
    language_preference
    booking_source
    payment_status
    payment_method
    total_amount
    insurance_claim_id
    timezone
    reminder_sent
    confirmation_sent
    rescheduled_from
    rescheduled_to
    cancelled_reason
    cancelled_by
    medical_history_reviewed
    diagnosis
    treatment_plan
    prescription
    follow_up_required
    follow_up_date
    patient_phone
    patient_email
    emergency_contact
    special_instructions
    patient_rating
    patient_feedback
    doctor_notes
    quality_score
    tenant
    created_at
    updated_at
    scheduled_at
    confirmed_at
    started_at
    completed_at
    cancelled_at
    provider {
      id
      doctor_id
      clinic_id
      consultation_fee
      doctor {
        id
        first_name_en
        last_name_en
        first_name_zh_hk
        last_name_zh_hk
        first_name_zh_cn
        last_name_zh_cn
        specialization
        title
      }
      clinic {
        id
        name_en
        name_zh_hk
        name_zh_cn
        internal_name
      }
    }
  }
}
    `;

/**
 * __useGetUserAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetUserAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAppointmentsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetUserAppointmentsQuery, GetUserAppointmentsQueryVariables> & ({ variables: GetUserAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAppointmentsQuery, GetUserAppointmentsQueryVariables>(GetUserAppointmentsDocument, options);
      }
export function useGetUserAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAppointmentsQuery, GetUserAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAppointmentsQuery, GetUserAppointmentsQueryVariables>(GetUserAppointmentsDocument, options);
        }
export function useGetUserAppointmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAppointmentsQuery, GetUserAppointmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAppointmentsQuery, GetUserAppointmentsQueryVariables>(GetUserAppointmentsDocument, options);
        }
export type GetUserAppointmentsQueryHookResult = ReturnType<typeof useGetUserAppointmentsQuery>;
export type GetUserAppointmentsLazyQueryHookResult = ReturnType<typeof useGetUserAppointmentsLazyQuery>;
export type GetUserAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetUserAppointmentsSuspenseQuery>;
export type GetUserAppointmentsQueryResult = Apollo.QueryResult<GetUserAppointmentsQuery, GetUserAppointmentsQueryVariables>;
export const GetProviderAppointmentsDocument = gql`
    query GetProviderAppointments($providerId: String!) {
  providerAppointments(providerId: $providerId) {
    id
    app_user_id
    provider_id
    date
    time
    duration
    status
    type
    reservation_type
    questionnaire
    appointment_notes
    priority
    consultation_type
    language_preference
    booking_source
    payment_status
    payment_method
    total_amount
    insurance_claim_id
    timezone
    reminder_sent
    confirmation_sent
    rescheduled_from
    rescheduled_to
    cancelled_reason
    cancelled_by
    medical_history_reviewed
    diagnosis
    treatment_plan
    prescription
    follow_up_required
    follow_up_date
    patient_phone
    patient_email
    emergency_contact
    special_instructions
    patient_rating
    patient_feedback
    doctor_notes
    quality_score
    tenant
    created_at
    updated_at
    scheduled_at
    confirmed_at
    started_at
    completed_at
    cancelled_at
    provider {
      id
      doctor_id
      clinic_id
      consultation_fee
      doctor {
        id
        first_name_en
        last_name_en
        first_name_zh_hk
        last_name_zh_hk
        first_name_zh_cn
        last_name_zh_cn
        specialization
        title
      }
      clinic {
        id
        name_en
        name_zh_hk
        name_zh_cn
        internal_name
      }
    }
  }
}
    `;

/**
 * __useGetProviderAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetProviderAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderAppointmentsQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetProviderAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetProviderAppointmentsQuery, GetProviderAppointmentsQueryVariables> & ({ variables: GetProviderAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderAppointmentsQuery, GetProviderAppointmentsQueryVariables>(GetProviderAppointmentsDocument, options);
      }
export function useGetProviderAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderAppointmentsQuery, GetProviderAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderAppointmentsQuery, GetProviderAppointmentsQueryVariables>(GetProviderAppointmentsDocument, options);
        }
export function useGetProviderAppointmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderAppointmentsQuery, GetProviderAppointmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProviderAppointmentsQuery, GetProviderAppointmentsQueryVariables>(GetProviderAppointmentsDocument, options);
        }
export type GetProviderAppointmentsQueryHookResult = ReturnType<typeof useGetProviderAppointmentsQuery>;
export type GetProviderAppointmentsLazyQueryHookResult = ReturnType<typeof useGetProviderAppointmentsLazyQuery>;
export type GetProviderAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetProviderAppointmentsSuspenseQuery>;
export type GetProviderAppointmentsQueryResult = Apollo.QueryResult<GetProviderAppointmentsQuery, GetProviderAppointmentsQueryVariables>;
export const GetDoctorAppointmentsDocument = gql`
    query GetDoctorAppointments($doctorId: String!, $filter: AppointmentFilterDto) {
  doctorAppointments(doctorId: $doctorId, filter: $filter) {
    id
    app_user_id
    patient_id
    provider_id
    date
    time
    duration
    status
    queue_number
    type
    reservation_type
    questionnaire
    appointment_notes
    priority
    consultation_type
    language_preference
    booking_source
    payment_status
    payment_method
    total_amount
    insurance_claim_id
    timezone
    reminder_sent
    confirmation_sent
    rescheduled_from
    rescheduled_to
    cancelled_reason
    cancelled_by
    medical_history_reviewed
    diagnosis
    treatment_plan
    prescription
    follow_up_required
    follow_up_date
    patient_phone
    patient_email
    emergency_contact
    special_instructions
    patient_rating
    patient_feedback
    doctor_notes
    quality_score
    created_at
    updated_at
    scheduled_at
    confirmed_at
    started_at
    completed_at
    cancelled_at
    otherStatuses
    app_user {
      id
      firstname
      lastname
      email
      phone_number
      tenant
    }
    patient {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      gender
      birthdate
      email
      phone_number
      status
      relationship_to_owner
    }
    provider {
      id
      doctor_id
      clinic_id
      consultation_fee
      doctor {
        id
        first_name_en
        last_name_en
        first_name_zh_hk
        last_name_zh_hk
        specialization
        title
      }
      clinic {
        id
        name_en
        name_zh_hk
        internal_name
        address
        region
        district
      }
    }
  }
}
    `;

/**
 * __useGetDoctorAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetDoctorAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDoctorAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDoctorAppointmentsQuery({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDoctorAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetDoctorAppointmentsQuery, GetDoctorAppointmentsQueryVariables> & ({ variables: GetDoctorAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDoctorAppointmentsQuery, GetDoctorAppointmentsQueryVariables>(GetDoctorAppointmentsDocument, options);
      }
export function useGetDoctorAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDoctorAppointmentsQuery, GetDoctorAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDoctorAppointmentsQuery, GetDoctorAppointmentsQueryVariables>(GetDoctorAppointmentsDocument, options);
        }
export function useGetDoctorAppointmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDoctorAppointmentsQuery, GetDoctorAppointmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDoctorAppointmentsQuery, GetDoctorAppointmentsQueryVariables>(GetDoctorAppointmentsDocument, options);
        }
export type GetDoctorAppointmentsQueryHookResult = ReturnType<typeof useGetDoctorAppointmentsQuery>;
export type GetDoctorAppointmentsLazyQueryHookResult = ReturnType<typeof useGetDoctorAppointmentsLazyQuery>;
export type GetDoctorAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetDoctorAppointmentsSuspenseQuery>;
export type GetDoctorAppointmentsQueryResult = Apollo.QueryResult<GetDoctorAppointmentsQuery, GetDoctorAppointmentsQueryVariables>;
export const GetTransactionsDocument = gql`
    query GetTransactions {
  transactions {
    id
    app_user_id
    appointment_id
    transaction_reference
    amount
    currency
    type
    status
    payment_method
    description
    category
    subcategory
    notes
    gateway_transaction_id
    gateway_response
    processing_fee
    tax_amount
    discount_amount
    final_amount
    metadata
    refund_reason
    refunded_by
    refunded_at
    original_transaction_id
    created_at
    updated_at
    processed_at
    completed_at
  }
}
    `;

/**
 * __useGetTransactionsQuery__
 *
 * To run a query within a React component, call `useGetTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
      }
export function useGetTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
export function useGetTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
export type GetTransactionsQueryHookResult = ReturnType<typeof useGetTransactionsQuery>;
export type GetTransactionsLazyQueryHookResult = ReturnType<typeof useGetTransactionsLazyQuery>;
export type GetTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetTransactionsSuspenseQuery>;
export type GetTransactionsQueryResult = Apollo.QueryResult<GetTransactionsQuery, GetTransactionsQueryVariables>;
export const GetMyTransactionsDocument = gql`
    query GetMyTransactions {
  myTransactions {
    id
    app_user_id
    appointment_id
    transaction_reference
    amount
    currency
    type
    status
    payment_method
    description
    category
    subcategory
    notes
    gateway_transaction_id
    gateway_response
    processing_fee
    tax_amount
    discount_amount
    final_amount
    metadata
    refund_reason
    refunded_by
    refunded_at
    original_transaction_id
    created_at
    updated_at
    processed_at
    completed_at
  }
}
    `;

/**
 * __useGetMyTransactionsQuery__
 *
 * To run a query within a React component, call `useGetMyTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTransactionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>(GetMyTransactionsDocument, options);
      }
export function useGetMyTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>(GetMyTransactionsDocument, options);
        }
export function useGetMyTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>(GetMyTransactionsDocument, options);
        }
export type GetMyTransactionsQueryHookResult = ReturnType<typeof useGetMyTransactionsQuery>;
export type GetMyTransactionsLazyQueryHookResult = ReturnType<typeof useGetMyTransactionsLazyQuery>;
export type GetMyTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetMyTransactionsSuspenseQuery>;
export type GetMyTransactionsQueryResult = Apollo.QueryResult<GetMyTransactionsQuery, GetMyTransactionsQueryVariables>;
export const GetAppointmentTransactionsDocument = gql`
    query GetAppointmentTransactions($appointmentId: String!) {
  appointmentTransactions(appointmentId: $appointmentId) {
    id
    app_user_id
    appointment_id
    transaction_reference
    original_amount
    amount
    currency
    type
    status
    payment_method
    description
    category
    subcategory
    notes
    gateway_transaction_id
    gateway_response
    processing_fee
    tax_amount
    discount_amount
    final_amount
    metadata
    refund_reason
    refunded_by
    refunded_at
    original_transaction_id
    created_at
    updated_at
    processed_at
    completed_at
  }
}
    `;

/**
 * __useGetAppointmentTransactionsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentTransactionsQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentTransactionsQuery, GetAppointmentTransactionsQueryVariables> & ({ variables: GetAppointmentTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentTransactionsQuery, GetAppointmentTransactionsQueryVariables>(GetAppointmentTransactionsDocument, options);
      }
export function useGetAppointmentTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentTransactionsQuery, GetAppointmentTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentTransactionsQuery, GetAppointmentTransactionsQueryVariables>(GetAppointmentTransactionsDocument, options);
        }
export function useGetAppointmentTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentTransactionsQuery, GetAppointmentTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentTransactionsQuery, GetAppointmentTransactionsQueryVariables>(GetAppointmentTransactionsDocument, options);
        }
export type GetAppointmentTransactionsQueryHookResult = ReturnType<typeof useGetAppointmentTransactionsQuery>;
export type GetAppointmentTransactionsLazyQueryHookResult = ReturnType<typeof useGetAppointmentTransactionsLazyQuery>;
export type GetAppointmentTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentTransactionsSuspenseQuery>;
export type GetAppointmentTransactionsQueryResult = Apollo.QueryResult<GetAppointmentTransactionsQuery, GetAppointmentTransactionsQueryVariables>;
export const GetTransactionDocument = gql`
    query GetTransaction($id: String!) {
  transaction(id: $id) {
    id
    app_user_id
    appointment_id
    transaction_reference
    amount
    currency
    type
    status
    payment_method
    description
    category
    subcategory
    notes
    gateway_transaction_id
    gateway_response
    processing_fee
    tax_amount
    discount_amount
    final_amount
    metadata
    refund_reason
    refunded_by
    refunded_at
    original_transaction_id
    created_at
    updated_at
    processed_at
    completed_at
  }
}
    `;

/**
 * __useGetTransactionQuery__
 *
 * To run a query within a React component, call `useGetTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTransactionQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables> & ({ variables: GetTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
      }
export function useGetTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
        }
export function useGetTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
        }
export type GetTransactionQueryHookResult = ReturnType<typeof useGetTransactionQuery>;
export type GetTransactionLazyQueryHookResult = ReturnType<typeof useGetTransactionLazyQuery>;
export type GetTransactionSuspenseQueryHookResult = ReturnType<typeof useGetTransactionSuspenseQuery>;
export type GetTransactionQueryResult = Apollo.QueryResult<GetTransactionQuery, GetTransactionQueryVariables>;
export const GetTransactionByReferenceDocument = gql`
    query GetTransactionByReference($transactionReference: String!) {
  transactionByReference(transactionReference: $transactionReference) {
    id
    app_user_id
    appointment_id
    transaction_reference
    amount
    currency
    type
    status
    payment_method
    description
    category
    subcategory
    notes
    gateway_transaction_id
    gateway_response
    processing_fee
    tax_amount
    discount_amount
    final_amount
    metadata
    refund_reason
    refunded_by
    refunded_at
    original_transaction_id
    created_at
    updated_at
    processed_at
    completed_at
  }
}
    `;

/**
 * __useGetTransactionByReferenceQuery__
 *
 * To run a query within a React component, call `useGetTransactionByReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionByReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionByReferenceQuery({
 *   variables: {
 *      transactionReference: // value for 'transactionReference'
 *   },
 * });
 */
export function useGetTransactionByReferenceQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionByReferenceQuery, GetTransactionByReferenceQueryVariables> & ({ variables: GetTransactionByReferenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionByReferenceQuery, GetTransactionByReferenceQueryVariables>(GetTransactionByReferenceDocument, options);
      }
export function useGetTransactionByReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionByReferenceQuery, GetTransactionByReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionByReferenceQuery, GetTransactionByReferenceQueryVariables>(GetTransactionByReferenceDocument, options);
        }
export function useGetTransactionByReferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionByReferenceQuery, GetTransactionByReferenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionByReferenceQuery, GetTransactionByReferenceQueryVariables>(GetTransactionByReferenceDocument, options);
        }
export type GetTransactionByReferenceQueryHookResult = ReturnType<typeof useGetTransactionByReferenceQuery>;
export type GetTransactionByReferenceLazyQueryHookResult = ReturnType<typeof useGetTransactionByReferenceLazyQuery>;
export type GetTransactionByReferenceSuspenseQueryHookResult = ReturnType<typeof useGetTransactionByReferenceSuspenseQuery>;
export type GetTransactionByReferenceQueryResult = Apollo.QueryResult<GetTransactionByReferenceQuery, GetTransactionByReferenceQueryVariables>;
export const GetTransactionStatsDocument = gql`
    query GetTransactionStats($appUserId: String) {
  transactionStats(appUserId: $appUserId) {
    totalTransactions
    totalAmount
    totalPayments
    totalRefunds
    averageAmount
  }
}
    `;

/**
 * __useGetTransactionStatsQuery__
 *
 * To run a query within a React component, call `useGetTransactionStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionStatsQuery({
 *   variables: {
 *      appUserId: // value for 'appUserId'
 *   },
 * });
 */
export function useGetTransactionStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionStatsQuery, GetTransactionStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionStatsQuery, GetTransactionStatsQueryVariables>(GetTransactionStatsDocument, options);
      }
export function useGetTransactionStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionStatsQuery, GetTransactionStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionStatsQuery, GetTransactionStatsQueryVariables>(GetTransactionStatsDocument, options);
        }
export function useGetTransactionStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionStatsQuery, GetTransactionStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionStatsQuery, GetTransactionStatsQueryVariables>(GetTransactionStatsDocument, options);
        }
export type GetTransactionStatsQueryHookResult = ReturnType<typeof useGetTransactionStatsQuery>;
export type GetTransactionStatsLazyQueryHookResult = ReturnType<typeof useGetTransactionStatsLazyQuery>;
export type GetTransactionStatsSuspenseQueryHookResult = ReturnType<typeof useGetTransactionStatsSuspenseQuery>;
export type GetTransactionStatsQueryResult = Apollo.QueryResult<GetTransactionStatsQuery, GetTransactionStatsQueryVariables>;
export const GenerateTransactionReferenceDocument = gql`
    query GenerateTransactionReference {
  generateTransactionReference
}
    `;

/**
 * __useGenerateTransactionReferenceQuery__
 *
 * To run a query within a React component, call `useGenerateTransactionReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateTransactionReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateTransactionReferenceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateTransactionReferenceQuery(baseOptions?: Apollo.QueryHookOptions<GenerateTransactionReferenceQuery, GenerateTransactionReferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateTransactionReferenceQuery, GenerateTransactionReferenceQueryVariables>(GenerateTransactionReferenceDocument, options);
      }
export function useGenerateTransactionReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateTransactionReferenceQuery, GenerateTransactionReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateTransactionReferenceQuery, GenerateTransactionReferenceQueryVariables>(GenerateTransactionReferenceDocument, options);
        }
export function useGenerateTransactionReferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateTransactionReferenceQuery, GenerateTransactionReferenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateTransactionReferenceQuery, GenerateTransactionReferenceQueryVariables>(GenerateTransactionReferenceDocument, options);
        }
export type GenerateTransactionReferenceQueryHookResult = ReturnType<typeof useGenerateTransactionReferenceQuery>;
export type GenerateTransactionReferenceLazyQueryHookResult = ReturnType<typeof useGenerateTransactionReferenceLazyQuery>;
export type GenerateTransactionReferenceSuspenseQueryHookResult = ReturnType<typeof useGenerateTransactionReferenceSuspenseQuery>;
export type GenerateTransactionReferenceQueryResult = Apollo.QueryResult<GenerateTransactionReferenceQuery, GenerateTransactionReferenceQueryVariables>;
export const GetCloseBufferMinutesDocument = gql`
    query GetCloseBufferMinutes {
  closeBufferMinutes
}
    `;

/**
 * __useGetCloseBufferMinutesQuery__
 *
 * To run a query within a React component, call `useGetCloseBufferMinutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCloseBufferMinutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCloseBufferMinutesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCloseBufferMinutesQuery(baseOptions?: Apollo.QueryHookOptions<GetCloseBufferMinutesQuery, GetCloseBufferMinutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCloseBufferMinutesQuery, GetCloseBufferMinutesQueryVariables>(GetCloseBufferMinutesDocument, options);
      }
export function useGetCloseBufferMinutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCloseBufferMinutesQuery, GetCloseBufferMinutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCloseBufferMinutesQuery, GetCloseBufferMinutesQueryVariables>(GetCloseBufferMinutesDocument, options);
        }
export function useGetCloseBufferMinutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCloseBufferMinutesQuery, GetCloseBufferMinutesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCloseBufferMinutesQuery, GetCloseBufferMinutesQueryVariables>(GetCloseBufferMinutesDocument, options);
        }
export type GetCloseBufferMinutesQueryHookResult = ReturnType<typeof useGetCloseBufferMinutesQuery>;
export type GetCloseBufferMinutesLazyQueryHookResult = ReturnType<typeof useGetCloseBufferMinutesLazyQuery>;
export type GetCloseBufferMinutesSuspenseQueryHookResult = ReturnType<typeof useGetCloseBufferMinutesSuspenseQuery>;
export type GetCloseBufferMinutesQueryResult = Apollo.QueryResult<GetCloseBufferMinutesQuery, GetCloseBufferMinutesQueryVariables>;
export const SetCloseBufferMinutesDocument = gql`
    mutation SetCloseBufferMinutes($minutes: Float!) {
  setCloseBufferMinutes(minutes: $minutes)
}
    `;
export type SetCloseBufferMinutesMutationFn = Apollo.MutationFunction<SetCloseBufferMinutesMutation, SetCloseBufferMinutesMutationVariables>;

/**
 * __useSetCloseBufferMinutesMutation__
 *
 * To run a mutation, you first call `useSetCloseBufferMinutesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCloseBufferMinutesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCloseBufferMinutesMutation, { data, loading, error }] = useSetCloseBufferMinutesMutation({
 *   variables: {
 *      minutes: // value for 'minutes'
 *   },
 * });
 */
export function useSetCloseBufferMinutesMutation(baseOptions?: Apollo.MutationHookOptions<SetCloseBufferMinutesMutation, SetCloseBufferMinutesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCloseBufferMinutesMutation, SetCloseBufferMinutesMutationVariables>(SetCloseBufferMinutesDocument, options);
      }
export type SetCloseBufferMinutesMutationHookResult = ReturnType<typeof useSetCloseBufferMinutesMutation>;
export type SetCloseBufferMinutesMutationResult = Apollo.MutationResult<SetCloseBufferMinutesMutation>;
export type SetCloseBufferMinutesMutationOptions = Apollo.BaseMutationOptions<SetCloseBufferMinutesMutation, SetCloseBufferMinutesMutationVariables>;
export const GetQueueNumberThresholdDocument = gql`
    query GetQueueNumberThreshold {
  queueNumberThreshold
}
    `;

/**
 * __useGetQueueNumberThresholdQuery__
 *
 * To run a query within a React component, call `useGetQueueNumberThresholdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueNumberThresholdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueNumberThresholdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQueueNumberThresholdQuery(baseOptions?: Apollo.QueryHookOptions<GetQueueNumberThresholdQuery, GetQueueNumberThresholdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueueNumberThresholdQuery, GetQueueNumberThresholdQueryVariables>(GetQueueNumberThresholdDocument, options);
      }
export function useGetQueueNumberThresholdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueueNumberThresholdQuery, GetQueueNumberThresholdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueueNumberThresholdQuery, GetQueueNumberThresholdQueryVariables>(GetQueueNumberThresholdDocument, options);
        }
export function useGetQueueNumberThresholdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQueueNumberThresholdQuery, GetQueueNumberThresholdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQueueNumberThresholdQuery, GetQueueNumberThresholdQueryVariables>(GetQueueNumberThresholdDocument, options);
        }
export type GetQueueNumberThresholdQueryHookResult = ReturnType<typeof useGetQueueNumberThresholdQuery>;
export type GetQueueNumberThresholdLazyQueryHookResult = ReturnType<typeof useGetQueueNumberThresholdLazyQuery>;
export type GetQueueNumberThresholdSuspenseQueryHookResult = ReturnType<typeof useGetQueueNumberThresholdSuspenseQuery>;
export type GetQueueNumberThresholdQueryResult = Apollo.QueryResult<GetQueueNumberThresholdQuery, GetQueueNumberThresholdQueryVariables>;
export const SetQueueNumberThresholdDocument = gql`
    mutation SetQueueNumberThreshold($number: Float!) {
  setQueueNumberThreshold(number: $number)
}
    `;
export type SetQueueNumberThresholdMutationFn = Apollo.MutationFunction<SetQueueNumberThresholdMutation, SetQueueNumberThresholdMutationVariables>;

/**
 * __useSetQueueNumberThresholdMutation__
 *
 * To run a mutation, you first call `useSetQueueNumberThresholdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQueueNumberThresholdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQueueNumberThresholdMutation, { data, loading, error }] = useSetQueueNumberThresholdMutation({
 *   variables: {
 *      number: // value for 'number'
 *   },
 * });
 */
export function useSetQueueNumberThresholdMutation(baseOptions?: Apollo.MutationHookOptions<SetQueueNumberThresholdMutation, SetQueueNumberThresholdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetQueueNumberThresholdMutation, SetQueueNumberThresholdMutationVariables>(SetQueueNumberThresholdDocument, options);
      }
export type SetQueueNumberThresholdMutationHookResult = ReturnType<typeof useSetQueueNumberThresholdMutation>;
export type SetQueueNumberThresholdMutationResult = Apollo.MutationResult<SetQueueNumberThresholdMutation>;
export type SetQueueNumberThresholdMutationOptions = Apollo.BaseMutationOptions<SetQueueNumberThresholdMutation, SetQueueNumberThresholdMutationVariables>;
export const GetAppointmentEntryBufferMinutesDocument = gql`
    query GetAppointmentEntryBufferMinutes {
  appointmentEntryBufferMinutes
}
    `;

/**
 * __useGetAppointmentEntryBufferMinutesQuery__
 *
 * To run a query within a React component, call `useGetAppointmentEntryBufferMinutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentEntryBufferMinutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentEntryBufferMinutesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppointmentEntryBufferMinutesQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentEntryBufferMinutesQuery, GetAppointmentEntryBufferMinutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentEntryBufferMinutesQuery, GetAppointmentEntryBufferMinutesQueryVariables>(GetAppointmentEntryBufferMinutesDocument, options);
      }
export function useGetAppointmentEntryBufferMinutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentEntryBufferMinutesQuery, GetAppointmentEntryBufferMinutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentEntryBufferMinutesQuery, GetAppointmentEntryBufferMinutesQueryVariables>(GetAppointmentEntryBufferMinutesDocument, options);
        }
export function useGetAppointmentEntryBufferMinutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentEntryBufferMinutesQuery, GetAppointmentEntryBufferMinutesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentEntryBufferMinutesQuery, GetAppointmentEntryBufferMinutesQueryVariables>(GetAppointmentEntryBufferMinutesDocument, options);
        }
export type GetAppointmentEntryBufferMinutesQueryHookResult = ReturnType<typeof useGetAppointmentEntryBufferMinutesQuery>;
export type GetAppointmentEntryBufferMinutesLazyQueryHookResult = ReturnType<typeof useGetAppointmentEntryBufferMinutesLazyQuery>;
export type GetAppointmentEntryBufferMinutesSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentEntryBufferMinutesSuspenseQuery>;
export type GetAppointmentEntryBufferMinutesQueryResult = Apollo.QueryResult<GetAppointmentEntryBufferMinutesQuery, GetAppointmentEntryBufferMinutesQueryVariables>;
export const SetAppointmentEntryBufferMinutesDocument = gql`
    mutation SetAppointmentEntryBufferMinutes($minutes: Float!) {
  setAppointmentEntryBufferMinutes(minutes: $minutes)
}
    `;
export type SetAppointmentEntryBufferMinutesMutationFn = Apollo.MutationFunction<SetAppointmentEntryBufferMinutesMutation, SetAppointmentEntryBufferMinutesMutationVariables>;

/**
 * __useSetAppointmentEntryBufferMinutesMutation__
 *
 * To run a mutation, you first call `useSetAppointmentEntryBufferMinutesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAppointmentEntryBufferMinutesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAppointmentEntryBufferMinutesMutation, { data, loading, error }] = useSetAppointmentEntryBufferMinutesMutation({
 *   variables: {
 *      minutes: // value for 'minutes'
 *   },
 * });
 */
export function useSetAppointmentEntryBufferMinutesMutation(baseOptions?: Apollo.MutationHookOptions<SetAppointmentEntryBufferMinutesMutation, SetAppointmentEntryBufferMinutesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAppointmentEntryBufferMinutesMutation, SetAppointmentEntryBufferMinutesMutationVariables>(SetAppointmentEntryBufferMinutesDocument, options);
      }
export type SetAppointmentEntryBufferMinutesMutationHookResult = ReturnType<typeof useSetAppointmentEntryBufferMinutesMutation>;
export type SetAppointmentEntryBufferMinutesMutationResult = Apollo.MutationResult<SetAppointmentEntryBufferMinutesMutation>;
export type SetAppointmentEntryBufferMinutesMutationOptions = Apollo.BaseMutationOptions<SetAppointmentEntryBufferMinutesMutation, SetAppointmentEntryBufferMinutesMutationVariables>;
export const GetDefaultDeliveryContactInfoDocument = gql`
    query GetDefaultDeliveryContactInfo {
  defaultDeliveryContactInfo {
    contact
    mobile
    address
  }
}
    `;

/**
 * __useGetDefaultDeliveryContactInfoQuery__
 *
 * To run a query within a React component, call `useGetDefaultDeliveryContactInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultDeliveryContactInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultDeliveryContactInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultDeliveryContactInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultDeliveryContactInfoQuery, GetDefaultDeliveryContactInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultDeliveryContactInfoQuery, GetDefaultDeliveryContactInfoQueryVariables>(GetDefaultDeliveryContactInfoDocument, options);
      }
export function useGetDefaultDeliveryContactInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultDeliveryContactInfoQuery, GetDefaultDeliveryContactInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultDeliveryContactInfoQuery, GetDefaultDeliveryContactInfoQueryVariables>(GetDefaultDeliveryContactInfoDocument, options);
        }
export function useGetDefaultDeliveryContactInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDefaultDeliveryContactInfoQuery, GetDefaultDeliveryContactInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDefaultDeliveryContactInfoQuery, GetDefaultDeliveryContactInfoQueryVariables>(GetDefaultDeliveryContactInfoDocument, options);
        }
export type GetDefaultDeliveryContactInfoQueryHookResult = ReturnType<typeof useGetDefaultDeliveryContactInfoQuery>;
export type GetDefaultDeliveryContactInfoLazyQueryHookResult = ReturnType<typeof useGetDefaultDeliveryContactInfoLazyQuery>;
export type GetDefaultDeliveryContactInfoSuspenseQueryHookResult = ReturnType<typeof useGetDefaultDeliveryContactInfoSuspenseQuery>;
export type GetDefaultDeliveryContactInfoQueryResult = Apollo.QueryResult<GetDefaultDeliveryContactInfoQuery, GetDefaultDeliveryContactInfoQueryVariables>;
export const SetDefaultDeliveryContactInfoDocument = gql`
    mutation SetDefaultDeliveryContactInfo($contact: String!, $mobile: String!, $address: String!) {
  setDefaultDeliveryContactInfo(
    contact: $contact
    mobile: $mobile
    address: $address
  )
}
    `;
export type SetDefaultDeliveryContactInfoMutationFn = Apollo.MutationFunction<SetDefaultDeliveryContactInfoMutation, SetDefaultDeliveryContactInfoMutationVariables>;

/**
 * __useSetDefaultDeliveryContactInfoMutation__
 *
 * To run a mutation, you first call `useSetDefaultDeliveryContactInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultDeliveryContactInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultDeliveryContactInfoMutation, { data, loading, error }] = useSetDefaultDeliveryContactInfoMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *      mobile: // value for 'mobile'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useSetDefaultDeliveryContactInfoMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultDeliveryContactInfoMutation, SetDefaultDeliveryContactInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultDeliveryContactInfoMutation, SetDefaultDeliveryContactInfoMutationVariables>(SetDefaultDeliveryContactInfoDocument, options);
      }
export type SetDefaultDeliveryContactInfoMutationHookResult = ReturnType<typeof useSetDefaultDeliveryContactInfoMutation>;
export type SetDefaultDeliveryContactInfoMutationResult = Apollo.MutationResult<SetDefaultDeliveryContactInfoMutation>;
export type SetDefaultDeliveryContactInfoMutationOptions = Apollo.BaseMutationOptions<SetDefaultDeliveryContactInfoMutation, SetDefaultDeliveryContactInfoMutationVariables>;
export const GetDeliveryContactListDocument = gql`
    query GetDeliveryContactList {
  deliveryContactList {
    id
    contact
    mobile
    address
  }
}
    `;

/**
 * __useGetDeliveryContactListQuery__
 *
 * To run a query within a React component, call `useGetDeliveryContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryContactListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDeliveryContactListQuery(baseOptions?: Apollo.QueryHookOptions<GetDeliveryContactListQuery, GetDeliveryContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryContactListQuery, GetDeliveryContactListQueryVariables>(GetDeliveryContactListDocument, options);
      }
export function useGetDeliveryContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryContactListQuery, GetDeliveryContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryContactListQuery, GetDeliveryContactListQueryVariables>(GetDeliveryContactListDocument, options);
        }
export function useGetDeliveryContactListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryContactListQuery, GetDeliveryContactListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeliveryContactListQuery, GetDeliveryContactListQueryVariables>(GetDeliveryContactListDocument, options);
        }
export type GetDeliveryContactListQueryHookResult = ReturnType<typeof useGetDeliveryContactListQuery>;
export type GetDeliveryContactListLazyQueryHookResult = ReturnType<typeof useGetDeliveryContactListLazyQuery>;
export type GetDeliveryContactListSuspenseQueryHookResult = ReturnType<typeof useGetDeliveryContactListSuspenseQuery>;
export type GetDeliveryContactListQueryResult = Apollo.QueryResult<GetDeliveryContactListQuery, GetDeliveryContactListQueryVariables>;
export const SetDeliveryContactListDocument = gql`
    mutation SetDeliveryContactList($contacts: [DeliveryContactInput!]!) {
  setDeliveryContactList(contacts: $contacts)
}
    `;
export type SetDeliveryContactListMutationFn = Apollo.MutationFunction<SetDeliveryContactListMutation, SetDeliveryContactListMutationVariables>;

/**
 * __useSetDeliveryContactListMutation__
 *
 * To run a mutation, you first call `useSetDeliveryContactListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeliveryContactListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeliveryContactListMutation, { data, loading, error }] = useSetDeliveryContactListMutation({
 *   variables: {
 *      contacts: // value for 'contacts'
 *   },
 * });
 */
export function useSetDeliveryContactListMutation(baseOptions?: Apollo.MutationHookOptions<SetDeliveryContactListMutation, SetDeliveryContactListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDeliveryContactListMutation, SetDeliveryContactListMutationVariables>(SetDeliveryContactListDocument, options);
      }
export type SetDeliveryContactListMutationHookResult = ReturnType<typeof useSetDeliveryContactListMutation>;
export type SetDeliveryContactListMutationResult = Apollo.MutationResult<SetDeliveryContactListMutation>;
export type SetDeliveryContactListMutationOptions = Apollo.BaseMutationOptions<SetDeliveryContactListMutation, SetDeliveryContactListMutationVariables>;
export const GetAppUsersDocument = gql`
    query GetAppUsers {
  users {
    id
    email
    firstname
    lastname
    phone_number
    tenant
    language_preference
    ic_type
    ic_number
    birthdate
    age
    gender
    created_at
    updated_at
    deleted_at
    deleted_reason
    addresses {
      id
      type
      display_name
      region
      district
      street_address
      building_name
      floor
      block
      unit
      postal_code
      is_default
      phone_number
      contact_name
      created_at
      updated_at
    }
    patients {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      email
      phone_number
      birthdate
      gender
      status
      relationship_to_owner
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useGetAppUsersQuery__
 *
 * To run a query within a React component, call `useGetAppUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAppUsersQuery, GetAppUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppUsersQuery, GetAppUsersQueryVariables>(GetAppUsersDocument, options);
      }
export function useGetAppUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppUsersQuery, GetAppUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppUsersQuery, GetAppUsersQueryVariables>(GetAppUsersDocument, options);
        }
export function useGetAppUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppUsersQuery, GetAppUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppUsersQuery, GetAppUsersQueryVariables>(GetAppUsersDocument, options);
        }
export type GetAppUsersQueryHookResult = ReturnType<typeof useGetAppUsersQuery>;
export type GetAppUsersLazyQueryHookResult = ReturnType<typeof useGetAppUsersLazyQuery>;
export type GetAppUsersSuspenseQueryHookResult = ReturnType<typeof useGetAppUsersSuspenseQuery>;
export type GetAppUsersQueryResult = Apollo.QueryResult<GetAppUsersQuery, GetAppUsersQueryVariables>;
export const GetAppUsersPaginatedDocument = gql`
    query GetAppUsersPaginated($paginationDto: PaginationDto!) {
  usersPaginated(paginationDto: $paginationDto) {
    users {
      id
      email
      firstname
      lastname
      phone_number
      tenant
      language_preference
      ic_type
      ic_number
      birthdate
      age
      gender
      created_at
      updated_at
      deleted_at
      deleted_reason
      addresses {
        id
        type
        display_name
        region
        district
        street_address
        building_name
        floor
        block
        unit
        postal_code
        is_default
        phone_number
        contact_name
        created_at
        updated_at
      }
      patients {
        id
        first_name_en
        last_name_en
        first_name_zh_hk
        last_name_zh_hk
        email
        phone_number
        birthdate
        gender
        status
        relationship_to_owner
        created_at
        updated_at
      }
    }
    pagination {
      page
      limit
      total
      totalPages
      hasNext
      hasPrev
    }
  }
}
    `;

/**
 * __useGetAppUsersPaginatedQuery__
 *
 * To run a query within a React component, call `useGetAppUsersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppUsersPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppUsersPaginatedQuery({
 *   variables: {
 *      paginationDto: // value for 'paginationDto'
 *   },
 * });
 */
export function useGetAppUsersPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetAppUsersPaginatedQuery, GetAppUsersPaginatedQueryVariables> & ({ variables: GetAppUsersPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppUsersPaginatedQuery, GetAppUsersPaginatedQueryVariables>(GetAppUsersPaginatedDocument, options);
      }
export function useGetAppUsersPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppUsersPaginatedQuery, GetAppUsersPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppUsersPaginatedQuery, GetAppUsersPaginatedQueryVariables>(GetAppUsersPaginatedDocument, options);
        }
export function useGetAppUsersPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppUsersPaginatedQuery, GetAppUsersPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppUsersPaginatedQuery, GetAppUsersPaginatedQueryVariables>(GetAppUsersPaginatedDocument, options);
        }
export type GetAppUsersPaginatedQueryHookResult = ReturnType<typeof useGetAppUsersPaginatedQuery>;
export type GetAppUsersPaginatedLazyQueryHookResult = ReturnType<typeof useGetAppUsersPaginatedLazyQuery>;
export type GetAppUsersPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetAppUsersPaginatedSuspenseQuery>;
export type GetAppUsersPaginatedQueryResult = Apollo.QueryResult<GetAppUsersPaginatedQuery, GetAppUsersPaginatedQueryVariables>;
export const GetAppUserDocument = gql`
    query GetAppUser($id: ID!) {
  user(id: $id) {
    id
    email
    firstname
    lastname
    phone_number
    tenant
    language_preference
    ic_type
    ic_number
    birthdate
    age
    gender
    created_at
    updated_at
    deleted_at
    deleted_reason
    addresses {
      id
      type
      display_name
      region
      district
      street_address
      building_name
      floor
      block
      unit
      postal_code
      is_default
      phone_number
      contact_name
      created_at
      updated_at
    }
    patients {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      email
      phone_number
      birthdate
      gender
      status
      relationship_to_owner
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useGetAppUserQuery__
 *
 * To run a query within a React component, call `useGetAppUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAppUserQuery(baseOptions: Apollo.QueryHookOptions<GetAppUserQuery, GetAppUserQueryVariables> & ({ variables: GetAppUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppUserQuery, GetAppUserQueryVariables>(GetAppUserDocument, options);
      }
export function useGetAppUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppUserQuery, GetAppUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppUserQuery, GetAppUserQueryVariables>(GetAppUserDocument, options);
        }
export function useGetAppUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppUserQuery, GetAppUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppUserQuery, GetAppUserQueryVariables>(GetAppUserDocument, options);
        }
export type GetAppUserQueryHookResult = ReturnType<typeof useGetAppUserQuery>;
export type GetAppUserLazyQueryHookResult = ReturnType<typeof useGetAppUserLazyQuery>;
export type GetAppUserSuspenseQueryHookResult = ReturnType<typeof useGetAppUserSuspenseQuery>;
export type GetAppUserQueryResult = Apollo.QueryResult<GetAppUserQuery, GetAppUserQueryVariables>;
export const GetSfExpressOrdersForAppointmentDocument = gql`
    query GetSfExpressOrdersForAppointment($appointmentId: String!) {
  getSfExpressOrdersForAppointment(appointmentId: $appointmentId) {
    id
    tenant
    request_id
    service_code
    timestamp
    partner_id
    msg_digest
    request_data
    response_data
    status
    order_id
    waybill_no
    tracking_number
    error_code
    error_message
    api_result_code
    api_error_msg
    notes
    created_at
    updated_at
    processed_at
    retry_count
    last_retry_at
    metadata
    appointment_id
  }
}
    `;

/**
 * __useGetSfExpressOrdersForAppointmentQuery__
 *
 * To run a query within a React component, call `useGetSfExpressOrdersForAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSfExpressOrdersForAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSfExpressOrdersForAppointmentQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetSfExpressOrdersForAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetSfExpressOrdersForAppointmentQuery, GetSfExpressOrdersForAppointmentQueryVariables> & ({ variables: GetSfExpressOrdersForAppointmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSfExpressOrdersForAppointmentQuery, GetSfExpressOrdersForAppointmentQueryVariables>(GetSfExpressOrdersForAppointmentDocument, options);
      }
export function useGetSfExpressOrdersForAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSfExpressOrdersForAppointmentQuery, GetSfExpressOrdersForAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSfExpressOrdersForAppointmentQuery, GetSfExpressOrdersForAppointmentQueryVariables>(GetSfExpressOrdersForAppointmentDocument, options);
        }
export function useGetSfExpressOrdersForAppointmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSfExpressOrdersForAppointmentQuery, GetSfExpressOrdersForAppointmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSfExpressOrdersForAppointmentQuery, GetSfExpressOrdersForAppointmentQueryVariables>(GetSfExpressOrdersForAppointmentDocument, options);
        }
export type GetSfExpressOrdersForAppointmentQueryHookResult = ReturnType<typeof useGetSfExpressOrdersForAppointmentQuery>;
export type GetSfExpressOrdersForAppointmentLazyQueryHookResult = ReturnType<typeof useGetSfExpressOrdersForAppointmentLazyQuery>;
export type GetSfExpressOrdersForAppointmentSuspenseQueryHookResult = ReturnType<typeof useGetSfExpressOrdersForAppointmentSuspenseQuery>;
export type GetSfExpressOrdersForAppointmentQueryResult = Apollo.QueryResult<GetSfExpressOrdersForAppointmentQuery, GetSfExpressOrdersForAppointmentQueryVariables>;
export const SearchSfExpressRoutesDocument = gql`
    query SearchSfExpressRoutes($input: SfExpressRouteSearchInput!) {
  searchSfExpressRoutes(input: $input) {
    success
    errorCode
    errorMsg
    data {
      waybillNo
      orderId
      trackingNumber
      routeInfo
      estimatedDelivery
      currentStatus
      currentLocation
      lastUpdateTime
      deliveryAddress
      senderAddress
    }
  }
}
    `;

/**
 * __useSearchSfExpressRoutesQuery__
 *
 * To run a query within a React component, call `useSearchSfExpressRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSfExpressRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSfExpressRoutesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchSfExpressRoutesQuery(baseOptions: Apollo.QueryHookOptions<SearchSfExpressRoutesQuery, SearchSfExpressRoutesQueryVariables> & ({ variables: SearchSfExpressRoutesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSfExpressRoutesQuery, SearchSfExpressRoutesQueryVariables>(SearchSfExpressRoutesDocument, options);
      }
export function useSearchSfExpressRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSfExpressRoutesQuery, SearchSfExpressRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSfExpressRoutesQuery, SearchSfExpressRoutesQueryVariables>(SearchSfExpressRoutesDocument, options);
        }
export function useSearchSfExpressRoutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSfExpressRoutesQuery, SearchSfExpressRoutesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSfExpressRoutesQuery, SearchSfExpressRoutesQueryVariables>(SearchSfExpressRoutesDocument, options);
        }
export type SearchSfExpressRoutesQueryHookResult = ReturnType<typeof useSearchSfExpressRoutesQuery>;
export type SearchSfExpressRoutesLazyQueryHookResult = ReturnType<typeof useSearchSfExpressRoutesLazyQuery>;
export type SearchSfExpressRoutesSuspenseQueryHookResult = ReturnType<typeof useSearchSfExpressRoutesSuspenseQuery>;
export type SearchSfExpressRoutesQueryResult = Apollo.QueryResult<SearchSfExpressRoutesQuery, SearchSfExpressRoutesQueryVariables>;
export const SearchSfExpressRoutesByAppointmentIdDocument = gql`
    query SearchSfExpressRoutesByAppointmentId($appointmentId: String!) {
  searchSfExpressRoutesByAppointmentId(appointmentId: $appointmentId) {
    success
    errorCode
    errorMsg
    data {
      waybillNo
      orderId
      trackingNumber
      routeInfo
      estimatedDelivery
      currentStatus
      currentLocation
      lastUpdateTime
      deliveryAddress
      senderAddress
    }
  }
}
    `;

/**
 * __useSearchSfExpressRoutesByAppointmentIdQuery__
 *
 * To run a query within a React component, call `useSearchSfExpressRoutesByAppointmentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSfExpressRoutesByAppointmentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSfExpressRoutesByAppointmentIdQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useSearchSfExpressRoutesByAppointmentIdQuery(baseOptions: Apollo.QueryHookOptions<SearchSfExpressRoutesByAppointmentIdQuery, SearchSfExpressRoutesByAppointmentIdQueryVariables> & ({ variables: SearchSfExpressRoutesByAppointmentIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSfExpressRoutesByAppointmentIdQuery, SearchSfExpressRoutesByAppointmentIdQueryVariables>(SearchSfExpressRoutesByAppointmentIdDocument, options);
      }
export function useSearchSfExpressRoutesByAppointmentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSfExpressRoutesByAppointmentIdQuery, SearchSfExpressRoutesByAppointmentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSfExpressRoutesByAppointmentIdQuery, SearchSfExpressRoutesByAppointmentIdQueryVariables>(SearchSfExpressRoutesByAppointmentIdDocument, options);
        }
export function useSearchSfExpressRoutesByAppointmentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSfExpressRoutesByAppointmentIdQuery, SearchSfExpressRoutesByAppointmentIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSfExpressRoutesByAppointmentIdQuery, SearchSfExpressRoutesByAppointmentIdQueryVariables>(SearchSfExpressRoutesByAppointmentIdDocument, options);
        }
export type SearchSfExpressRoutesByAppointmentIdQueryHookResult = ReturnType<typeof useSearchSfExpressRoutesByAppointmentIdQuery>;
export type SearchSfExpressRoutesByAppointmentIdLazyQueryHookResult = ReturnType<typeof useSearchSfExpressRoutesByAppointmentIdLazyQuery>;
export type SearchSfExpressRoutesByAppointmentIdSuspenseQueryHookResult = ReturnType<typeof useSearchSfExpressRoutesByAppointmentIdSuspenseQuery>;
export type SearchSfExpressRoutesByAppointmentIdQueryResult = Apollo.QueryResult<SearchSfExpressRoutesByAppointmentIdQuery, SearchSfExpressRoutesByAppointmentIdQueryVariables>;
export const GetJdExpressOrdersForAppointmentDocument = gql`
    query GetJdExpressOrdersForAppointment($appointmentId: String!) {
  getJdExpressOrdersForAppointment(appointmentId: $appointmentId) {
    id
    tenant
    request_id
    service_code
    timestamp
    partner_id
    msg_digest
    request_data
    response_data
    status
    order_id
    waybill_no
    tracking_number
    error_code
    error_message
    api_result_code
    api_error_msg
    notes
    created_at
    updated_at
    processed_at
    retry_count
    last_retry_at
    metadata
    appointment_id
  }
}
    `;

/**
 * __useGetJdExpressOrdersForAppointmentQuery__
 *
 * To run a query within a React component, call `useGetJdExpressOrdersForAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJdExpressOrdersForAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJdExpressOrdersForAppointmentQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetJdExpressOrdersForAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetJdExpressOrdersForAppointmentQuery, GetJdExpressOrdersForAppointmentQueryVariables> & ({ variables: GetJdExpressOrdersForAppointmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJdExpressOrdersForAppointmentQuery, GetJdExpressOrdersForAppointmentQueryVariables>(GetJdExpressOrdersForAppointmentDocument, options);
      }
export function useGetJdExpressOrdersForAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJdExpressOrdersForAppointmentQuery, GetJdExpressOrdersForAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJdExpressOrdersForAppointmentQuery, GetJdExpressOrdersForAppointmentQueryVariables>(GetJdExpressOrdersForAppointmentDocument, options);
        }
export function useGetJdExpressOrdersForAppointmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJdExpressOrdersForAppointmentQuery, GetJdExpressOrdersForAppointmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJdExpressOrdersForAppointmentQuery, GetJdExpressOrdersForAppointmentQueryVariables>(GetJdExpressOrdersForAppointmentDocument, options);
        }
export type GetJdExpressOrdersForAppointmentQueryHookResult = ReturnType<typeof useGetJdExpressOrdersForAppointmentQuery>;
export type GetJdExpressOrdersForAppointmentLazyQueryHookResult = ReturnType<typeof useGetJdExpressOrdersForAppointmentLazyQuery>;
export type GetJdExpressOrdersForAppointmentSuspenseQueryHookResult = ReturnType<typeof useGetJdExpressOrdersForAppointmentSuspenseQuery>;
export type GetJdExpressOrdersForAppointmentQueryResult = Apollo.QueryResult<GetJdExpressOrdersForAppointmentQuery, GetJdExpressOrdersForAppointmentQueryVariables>;
export const GetExpressOrdersForAppointmentDocument = gql`
    query GetExpressOrdersForAppointment($appointmentId: String!) {
  getExpressOrdersForAppointment(appointmentId: $appointmentId) {
    sfExpressOrders {
      id
      tenant
      request_id
      service_code
      timestamp
      partner_id
      msg_digest
      request_data
      response_data
      status
      order_id
      waybill_no
      tracking_number
      error_code
      error_message
      api_result_code
      api_error_msg
      notes
      created_at
      updated_at
      processed_at
      retry_count
      last_retry_at
      metadata
      appointment_id
    }
    jdExpressOrders {
      id
      tenant
      request_id
      service_code
      timestamp
      partner_id
      msg_digest
      request_data
      response_data
      status
      order_id
      waybill_no
      tracking_number
      error_code
      error_message
      api_result_code
      api_error_msg
      notes
      created_at
      updated_at
      processed_at
      retry_count
      last_retry_at
      metadata
      appointment_id
    }
  }
}
    `;

/**
 * __useGetExpressOrdersForAppointmentQuery__
 *
 * To run a query within a React component, call `useGetExpressOrdersForAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpressOrdersForAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpressOrdersForAppointmentQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetExpressOrdersForAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetExpressOrdersForAppointmentQuery, GetExpressOrdersForAppointmentQueryVariables> & ({ variables: GetExpressOrdersForAppointmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpressOrdersForAppointmentQuery, GetExpressOrdersForAppointmentQueryVariables>(GetExpressOrdersForAppointmentDocument, options);
      }
export function useGetExpressOrdersForAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpressOrdersForAppointmentQuery, GetExpressOrdersForAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpressOrdersForAppointmentQuery, GetExpressOrdersForAppointmentQueryVariables>(GetExpressOrdersForAppointmentDocument, options);
        }
export function useGetExpressOrdersForAppointmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExpressOrdersForAppointmentQuery, GetExpressOrdersForAppointmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExpressOrdersForAppointmentQuery, GetExpressOrdersForAppointmentQueryVariables>(GetExpressOrdersForAppointmentDocument, options);
        }
export type GetExpressOrdersForAppointmentQueryHookResult = ReturnType<typeof useGetExpressOrdersForAppointmentQuery>;
export type GetExpressOrdersForAppointmentLazyQueryHookResult = ReturnType<typeof useGetExpressOrdersForAppointmentLazyQuery>;
export type GetExpressOrdersForAppointmentSuspenseQueryHookResult = ReturnType<typeof useGetExpressOrdersForAppointmentSuspenseQuery>;
export type GetExpressOrdersForAppointmentQueryResult = Apollo.QueryResult<GetExpressOrdersForAppointmentQuery, GetExpressOrdersForAppointmentQueryVariables>;
export const GetInsurancePayorsDocument = gql`
    query GetInsurancePayors {
  insurancePayors
}
    `;

/**
 * __useGetInsurancePayorsQuery__
 *
 * To run a query within a React component, call `useGetInsurancePayorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancePayorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancePayorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInsurancePayorsQuery(baseOptions?: Apollo.QueryHookOptions<GetInsurancePayorsQuery, GetInsurancePayorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsurancePayorsQuery, GetInsurancePayorsQueryVariables>(GetInsurancePayorsDocument, options);
      }
export function useGetInsurancePayorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsurancePayorsQuery, GetInsurancePayorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsurancePayorsQuery, GetInsurancePayorsQueryVariables>(GetInsurancePayorsDocument, options);
        }
export function useGetInsurancePayorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsurancePayorsQuery, GetInsurancePayorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsurancePayorsQuery, GetInsurancePayorsQueryVariables>(GetInsurancePayorsDocument, options);
        }
export type GetInsurancePayorsQueryHookResult = ReturnType<typeof useGetInsurancePayorsQuery>;
export type GetInsurancePayorsLazyQueryHookResult = ReturnType<typeof useGetInsurancePayorsLazyQuery>;
export type GetInsurancePayorsSuspenseQueryHookResult = ReturnType<typeof useGetInsurancePayorsSuspenseQuery>;
export type GetInsurancePayorsQueryResult = Apollo.QueryResult<GetInsurancePayorsQuery, GetInsurancePayorsQueryVariables>;
export const GetInsurancePoliciesByPayorDocument = gql`
    query GetInsurancePoliciesByPayor($payor: InsurancePayor!) {
  insurancePoliciesByPayor(payor: $payor) {
    id
    name
    payor
    planId
    policyNumber
    startDate
    endDate
    appUserId
    description
    policyDetails {
      free_consultations
      free_consultations_per_year
      free_consultations_per_month
      free_consultations_per_week
    }
    isActive
    createdAt
    updatedAt
    plan {
      id
      name
      payor
      description
      planDetails {
        free_consultations
        free_consultations_per_year
        free_consultations_per_month
        free_consultations_per_week
      }
    }
    appUser {
      id
      firstname
      lastname
      email
      phone_number
    }
  }
}
    `;

/**
 * __useGetInsurancePoliciesByPayorQuery__
 *
 * To run a query within a React component, call `useGetInsurancePoliciesByPayorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancePoliciesByPayorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancePoliciesByPayorQuery({
 *   variables: {
 *      payor: // value for 'payor'
 *   },
 * });
 */
export function useGetInsurancePoliciesByPayorQuery(baseOptions: Apollo.QueryHookOptions<GetInsurancePoliciesByPayorQuery, GetInsurancePoliciesByPayorQueryVariables> & ({ variables: GetInsurancePoliciesByPayorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsurancePoliciesByPayorQuery, GetInsurancePoliciesByPayorQueryVariables>(GetInsurancePoliciesByPayorDocument, options);
      }
export function useGetInsurancePoliciesByPayorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsurancePoliciesByPayorQuery, GetInsurancePoliciesByPayorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsurancePoliciesByPayorQuery, GetInsurancePoliciesByPayorQueryVariables>(GetInsurancePoliciesByPayorDocument, options);
        }
export function useGetInsurancePoliciesByPayorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsurancePoliciesByPayorQuery, GetInsurancePoliciesByPayorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsurancePoliciesByPayorQuery, GetInsurancePoliciesByPayorQueryVariables>(GetInsurancePoliciesByPayorDocument, options);
        }
export type GetInsurancePoliciesByPayorQueryHookResult = ReturnType<typeof useGetInsurancePoliciesByPayorQuery>;
export type GetInsurancePoliciesByPayorLazyQueryHookResult = ReturnType<typeof useGetInsurancePoliciesByPayorLazyQuery>;
export type GetInsurancePoliciesByPayorSuspenseQueryHookResult = ReturnType<typeof useGetInsurancePoliciesByPayorSuspenseQuery>;
export type GetInsurancePoliciesByPayorQueryResult = Apollo.QueryResult<GetInsurancePoliciesByPayorQuery, GetInsurancePoliciesByPayorQueryVariables>;
export const GetInsurancePoliciesByPayorPaginatedDocument = gql`
    query GetInsurancePoliciesByPayorPaginated($payor: InsurancePayor!, $paginationDto: PaginationDto!) {
  insurancePoliciesByPayorPaginated(payor: $payor, paginationDto: $paginationDto) {
    policies {
      id
      name
      payor
      planId
      policyNumber
      startDate
      endDate
      appUserId
      description
      policyDetails {
        free_consultations
        free_consultations_per_year
        free_consultations_per_month
        free_consultations_per_week
      }
      isActive
      createdAt
      updatedAt
      plan {
        id
        name
        payor
        description
        planDetails {
          free_consultations
          free_consultations_per_year
          free_consultations_per_month
          free_consultations_per_week
          copayment_amount
          coverage {
            name
            description
            type
            coverage_amount
            copayment_amount
            coverage_times_per_month
          }
        }
      }
      appUser {
        id
        firstname
        lastname
        email
        phone_number
      }
    }
    pagination {
      page
      limit
      total
      totalPages
      hasNext
      hasPrev
    }
  }
}
    `;

/**
 * __useGetInsurancePoliciesByPayorPaginatedQuery__
 *
 * To run a query within a React component, call `useGetInsurancePoliciesByPayorPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancePoliciesByPayorPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancePoliciesByPayorPaginatedQuery({
 *   variables: {
 *      payor: // value for 'payor'
 *      paginationDto: // value for 'paginationDto'
 *   },
 * });
 */
export function useGetInsurancePoliciesByPayorPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetInsurancePoliciesByPayorPaginatedQuery, GetInsurancePoliciesByPayorPaginatedQueryVariables> & ({ variables: GetInsurancePoliciesByPayorPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsurancePoliciesByPayorPaginatedQuery, GetInsurancePoliciesByPayorPaginatedQueryVariables>(GetInsurancePoliciesByPayorPaginatedDocument, options);
      }
export function useGetInsurancePoliciesByPayorPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsurancePoliciesByPayorPaginatedQuery, GetInsurancePoliciesByPayorPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsurancePoliciesByPayorPaginatedQuery, GetInsurancePoliciesByPayorPaginatedQueryVariables>(GetInsurancePoliciesByPayorPaginatedDocument, options);
        }
export function useGetInsurancePoliciesByPayorPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsurancePoliciesByPayorPaginatedQuery, GetInsurancePoliciesByPayorPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsurancePoliciesByPayorPaginatedQuery, GetInsurancePoliciesByPayorPaginatedQueryVariables>(GetInsurancePoliciesByPayorPaginatedDocument, options);
        }
export type GetInsurancePoliciesByPayorPaginatedQueryHookResult = ReturnType<typeof useGetInsurancePoliciesByPayorPaginatedQuery>;
export type GetInsurancePoliciesByPayorPaginatedLazyQueryHookResult = ReturnType<typeof useGetInsurancePoliciesByPayorPaginatedLazyQuery>;
export type GetInsurancePoliciesByPayorPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetInsurancePoliciesByPayorPaginatedSuspenseQuery>;
export type GetInsurancePoliciesByPayorPaginatedQueryResult = Apollo.QueryResult<GetInsurancePoliciesByPayorPaginatedQuery, GetInsurancePoliciesByPayorPaginatedQueryVariables>;
export const GetInsurancePlansByPayorDocument = gql`
    query GetInsurancePlansByPayor($payor: InsurancePayor!) {
  insurancePlansByPayor(payor: $payor) {
    id
    name
    payor
    description
    planDetails {
      free_consultations
      free_consultations_per_year
      free_consultations_per_month
      free_consultations_per_week
      copayment_amount
      coverage {
        name
        description
        type
        coverage_amount
        copayment_amount
        coverage_times_per_month
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetInsurancePlansByPayorQuery__
 *
 * To run a query within a React component, call `useGetInsurancePlansByPayorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancePlansByPayorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancePlansByPayorQuery({
 *   variables: {
 *      payor: // value for 'payor'
 *   },
 * });
 */
export function useGetInsurancePlansByPayorQuery(baseOptions: Apollo.QueryHookOptions<GetInsurancePlansByPayorQuery, GetInsurancePlansByPayorQueryVariables> & ({ variables: GetInsurancePlansByPayorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsurancePlansByPayorQuery, GetInsurancePlansByPayorQueryVariables>(GetInsurancePlansByPayorDocument, options);
      }
export function useGetInsurancePlansByPayorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsurancePlansByPayorQuery, GetInsurancePlansByPayorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsurancePlansByPayorQuery, GetInsurancePlansByPayorQueryVariables>(GetInsurancePlansByPayorDocument, options);
        }
export function useGetInsurancePlansByPayorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsurancePlansByPayorQuery, GetInsurancePlansByPayorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsurancePlansByPayorQuery, GetInsurancePlansByPayorQueryVariables>(GetInsurancePlansByPayorDocument, options);
        }
export type GetInsurancePlansByPayorQueryHookResult = ReturnType<typeof useGetInsurancePlansByPayorQuery>;
export type GetInsurancePlansByPayorLazyQueryHookResult = ReturnType<typeof useGetInsurancePlansByPayorLazyQuery>;
export type GetInsurancePlansByPayorSuspenseQueryHookResult = ReturnType<typeof useGetInsurancePlansByPayorSuspenseQuery>;
export type GetInsurancePlansByPayorQueryResult = Apollo.QueryResult<GetInsurancePlansByPayorQuery, GetInsurancePlansByPayorQueryVariables>;
export const IsCouponPayorDocument = gql`
    query IsCouponPayor($payor: InsurancePayor!) {
  isCouponPayor(payor: $payor)
}
    `;

/**
 * __useIsCouponPayorQuery__
 *
 * To run a query within a React component, call `useIsCouponPayorQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCouponPayorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCouponPayorQuery({
 *   variables: {
 *      payor: // value for 'payor'
 *   },
 * });
 */
export function useIsCouponPayorQuery(baseOptions: Apollo.QueryHookOptions<IsCouponPayorQuery, IsCouponPayorQueryVariables> & ({ variables: IsCouponPayorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsCouponPayorQuery, IsCouponPayorQueryVariables>(IsCouponPayorDocument, options);
      }
export function useIsCouponPayorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsCouponPayorQuery, IsCouponPayorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsCouponPayorQuery, IsCouponPayorQueryVariables>(IsCouponPayorDocument, options);
        }
export function useIsCouponPayorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsCouponPayorQuery, IsCouponPayorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsCouponPayorQuery, IsCouponPayorQueryVariables>(IsCouponPayorDocument, options);
        }
export type IsCouponPayorQueryHookResult = ReturnType<typeof useIsCouponPayorQuery>;
export type IsCouponPayorLazyQueryHookResult = ReturnType<typeof useIsCouponPayorLazyQuery>;
export type IsCouponPayorSuspenseQueryHookResult = ReturnType<typeof useIsCouponPayorSuspenseQuery>;
export type IsCouponPayorQueryResult = Apollo.QueryResult<IsCouponPayorQuery, IsCouponPayorQueryVariables>;
export const GetInsuranceCouponsByPayorDocument = gql`
    query GetInsuranceCouponsByPayor($payor: InsurancePayor!) {
  insuranceCouponsByPayor(payor: $payor) {
    id
    payor
    couponCode
    startDate
    endDate
    appUserId
    appointmentId
    policyDetails {
      free_consultations
      free_consultations_per_year
      free_consultations_per_month
      free_consultations_per_week
    }
    isActive
    createdAt
    updatedAt
    plan {
      id
      name
      payor
      description
      planDetails {
        free_consultations
        free_consultations_per_year
        free_consultations_per_month
        free_consultations_per_week
      }
    }
    appointment {
      id
      date
      time
      status
      type
    }
  }
}
    `;

/**
 * __useGetInsuranceCouponsByPayorQuery__
 *
 * To run a query within a React component, call `useGetInsuranceCouponsByPayorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceCouponsByPayorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceCouponsByPayorQuery({
 *   variables: {
 *      payor: // value for 'payor'
 *   },
 * });
 */
export function useGetInsuranceCouponsByPayorQuery(baseOptions: Apollo.QueryHookOptions<GetInsuranceCouponsByPayorQuery, GetInsuranceCouponsByPayorQueryVariables> & ({ variables: GetInsuranceCouponsByPayorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsuranceCouponsByPayorQuery, GetInsuranceCouponsByPayorQueryVariables>(GetInsuranceCouponsByPayorDocument, options);
      }
export function useGetInsuranceCouponsByPayorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsuranceCouponsByPayorQuery, GetInsuranceCouponsByPayorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsuranceCouponsByPayorQuery, GetInsuranceCouponsByPayorQueryVariables>(GetInsuranceCouponsByPayorDocument, options);
        }
export function useGetInsuranceCouponsByPayorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsuranceCouponsByPayorQuery, GetInsuranceCouponsByPayorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsuranceCouponsByPayorQuery, GetInsuranceCouponsByPayorQueryVariables>(GetInsuranceCouponsByPayorDocument, options);
        }
export type GetInsuranceCouponsByPayorQueryHookResult = ReturnType<typeof useGetInsuranceCouponsByPayorQuery>;
export type GetInsuranceCouponsByPayorLazyQueryHookResult = ReturnType<typeof useGetInsuranceCouponsByPayorLazyQuery>;
export type GetInsuranceCouponsByPayorSuspenseQueryHookResult = ReturnType<typeof useGetInsuranceCouponsByPayorSuspenseQuery>;
export type GetInsuranceCouponsByPayorQueryResult = Apollo.QueryResult<GetInsuranceCouponsByPayorQuery, GetInsuranceCouponsByPayorQueryVariables>;
export const GetInsuranceCouponsByPlanDocument = gql`
    query GetInsuranceCouponsByPlan($planId: ID!) {
  insuranceCouponsByPlan(planId: $planId) {
    id
    payor
    couponCode
    startDate
    endDate
    appUserId
    appointmentId
    policyDetails {
      free_consultations
      free_consultations_per_year
      free_consultations_per_month
      free_consultations_per_week
    }
    isActive
    createdAt
    updatedAt
    plan {
      id
      name
      payor
      description
    }
    appUser {
      id
      firstname
      lastname
      email
      phone_number
    }
  }
}
    `;

/**
 * __useGetInsuranceCouponsByPlanQuery__
 *
 * To run a query within a React component, call `useGetInsuranceCouponsByPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceCouponsByPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceCouponsByPlanQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useGetInsuranceCouponsByPlanQuery(baseOptions: Apollo.QueryHookOptions<GetInsuranceCouponsByPlanQuery, GetInsuranceCouponsByPlanQueryVariables> & ({ variables: GetInsuranceCouponsByPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsuranceCouponsByPlanQuery, GetInsuranceCouponsByPlanQueryVariables>(GetInsuranceCouponsByPlanDocument, options);
      }
export function useGetInsuranceCouponsByPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsuranceCouponsByPlanQuery, GetInsuranceCouponsByPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsuranceCouponsByPlanQuery, GetInsuranceCouponsByPlanQueryVariables>(GetInsuranceCouponsByPlanDocument, options);
        }
export function useGetInsuranceCouponsByPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsuranceCouponsByPlanQuery, GetInsuranceCouponsByPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsuranceCouponsByPlanQuery, GetInsuranceCouponsByPlanQueryVariables>(GetInsuranceCouponsByPlanDocument, options);
        }
export type GetInsuranceCouponsByPlanQueryHookResult = ReturnType<typeof useGetInsuranceCouponsByPlanQuery>;
export type GetInsuranceCouponsByPlanLazyQueryHookResult = ReturnType<typeof useGetInsuranceCouponsByPlanLazyQuery>;
export type GetInsuranceCouponsByPlanSuspenseQueryHookResult = ReturnType<typeof useGetInsuranceCouponsByPlanSuspenseQuery>;
export type GetInsuranceCouponsByPlanQueryResult = Apollo.QueryResult<GetInsuranceCouponsByPlanQuery, GetInsuranceCouponsByPlanQueryVariables>;
export const GetPolicyConsumptionDetailsDocument = gql`
    query GetPolicyConsumptionDetails($policyId: ID!) {
  insuranceEligibilityCheckResult(policyId: $policyId) {
    insurancePolicyId
    copaymentAmount
    coverageDetails {
      freeConsultations
      freeConsultationsPerYear
      freeConsultationsPerMonth
      freeConsultationsPerWeek
      remainingCoverageAmount
    }
  }
}
    `;

/**
 * __useGetPolicyConsumptionDetailsQuery__
 *
 * To run a query within a React component, call `useGetPolicyConsumptionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyConsumptionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyConsumptionDetailsQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useGetPolicyConsumptionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetPolicyConsumptionDetailsQuery, GetPolicyConsumptionDetailsQueryVariables> & ({ variables: GetPolicyConsumptionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPolicyConsumptionDetailsQuery, GetPolicyConsumptionDetailsQueryVariables>(GetPolicyConsumptionDetailsDocument, options);
      }
export function useGetPolicyConsumptionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPolicyConsumptionDetailsQuery, GetPolicyConsumptionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPolicyConsumptionDetailsQuery, GetPolicyConsumptionDetailsQueryVariables>(GetPolicyConsumptionDetailsDocument, options);
        }
export function useGetPolicyConsumptionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPolicyConsumptionDetailsQuery, GetPolicyConsumptionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPolicyConsumptionDetailsQuery, GetPolicyConsumptionDetailsQueryVariables>(GetPolicyConsumptionDetailsDocument, options);
        }
export type GetPolicyConsumptionDetailsQueryHookResult = ReturnType<typeof useGetPolicyConsumptionDetailsQuery>;
export type GetPolicyConsumptionDetailsLazyQueryHookResult = ReturnType<typeof useGetPolicyConsumptionDetailsLazyQuery>;
export type GetPolicyConsumptionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPolicyConsumptionDetailsSuspenseQuery>;
export type GetPolicyConsumptionDetailsQueryResult = Apollo.QueryResult<GetPolicyConsumptionDetailsQuery, GetPolicyConsumptionDetailsQueryVariables>;
export const InsuranceEligibilityCheckByCategoryDocument = gql`
    query InsuranceEligibilityCheckByCategory($policyId: ID!, $category: CoverageType!) {
  insuranceEligibilityCheckByCategory(policyId: $policyId, category: $category) {
    insurancePolicyId
    copaymentAmount
    coverageDetails {
      freeConsultations
      freeConsultationsPerYear
      freeConsultationsPerMonth
      freeConsultationsPerWeek
      remainingCoverageAmount
    }
  }
}
    `;

/**
 * __useInsuranceEligibilityCheckByCategoryQuery__
 *
 * To run a query within a React component, call `useInsuranceEligibilityCheckByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsuranceEligibilityCheckByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsuranceEligibilityCheckByCategoryQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useInsuranceEligibilityCheckByCategoryQuery(baseOptions: Apollo.QueryHookOptions<InsuranceEligibilityCheckByCategoryQuery, InsuranceEligibilityCheckByCategoryQueryVariables> & ({ variables: InsuranceEligibilityCheckByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsuranceEligibilityCheckByCategoryQuery, InsuranceEligibilityCheckByCategoryQueryVariables>(InsuranceEligibilityCheckByCategoryDocument, options);
      }
export function useInsuranceEligibilityCheckByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsuranceEligibilityCheckByCategoryQuery, InsuranceEligibilityCheckByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsuranceEligibilityCheckByCategoryQuery, InsuranceEligibilityCheckByCategoryQueryVariables>(InsuranceEligibilityCheckByCategoryDocument, options);
        }
export function useInsuranceEligibilityCheckByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsuranceEligibilityCheckByCategoryQuery, InsuranceEligibilityCheckByCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsuranceEligibilityCheckByCategoryQuery, InsuranceEligibilityCheckByCategoryQueryVariables>(InsuranceEligibilityCheckByCategoryDocument, options);
        }
export type InsuranceEligibilityCheckByCategoryQueryHookResult = ReturnType<typeof useInsuranceEligibilityCheckByCategoryQuery>;
export type InsuranceEligibilityCheckByCategoryLazyQueryHookResult = ReturnType<typeof useInsuranceEligibilityCheckByCategoryLazyQuery>;
export type InsuranceEligibilityCheckByCategorySuspenseQueryHookResult = ReturnType<typeof useInsuranceEligibilityCheckByCategorySuspenseQuery>;
export type InsuranceEligibilityCheckByCategoryQueryResult = Apollo.QueryResult<InsuranceEligibilityCheckByCategoryQuery, InsuranceEligibilityCheckByCategoryQueryVariables>;
export const GetInsurancePoliciesByUserDocument = gql`
    query GetInsurancePoliciesByUser($appUserId: ID!) {
  insurancePoliciesByUser(appUserId: $appUserId) {
    id
    name
    payor
    planId
    policyNumber
    startDate
    endDate
    appUserId
    description
    policyDetails {
      free_consultations
      free_consultations_per_year
      free_consultations_per_month
      free_consultations_per_week
    }
    isActive
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetInsurancePoliciesByUserQuery__
 *
 * To run a query within a React component, call `useGetInsurancePoliciesByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancePoliciesByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancePoliciesByUserQuery({
 *   variables: {
 *      appUserId: // value for 'appUserId'
 *   },
 * });
 */
export function useGetInsurancePoliciesByUserQuery(baseOptions: Apollo.QueryHookOptions<GetInsurancePoliciesByUserQuery, GetInsurancePoliciesByUserQueryVariables> & ({ variables: GetInsurancePoliciesByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsurancePoliciesByUserQuery, GetInsurancePoliciesByUserQueryVariables>(GetInsurancePoliciesByUserDocument, options);
      }
export function useGetInsurancePoliciesByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsurancePoliciesByUserQuery, GetInsurancePoliciesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsurancePoliciesByUserQuery, GetInsurancePoliciesByUserQueryVariables>(GetInsurancePoliciesByUserDocument, options);
        }
export function useGetInsurancePoliciesByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsurancePoliciesByUserQuery, GetInsurancePoliciesByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsurancePoliciesByUserQuery, GetInsurancePoliciesByUserQueryVariables>(GetInsurancePoliciesByUserDocument, options);
        }
export type GetInsurancePoliciesByUserQueryHookResult = ReturnType<typeof useGetInsurancePoliciesByUserQuery>;
export type GetInsurancePoliciesByUserLazyQueryHookResult = ReturnType<typeof useGetInsurancePoliciesByUserLazyQuery>;
export type GetInsurancePoliciesByUserSuspenseQueryHookResult = ReturnType<typeof useGetInsurancePoliciesByUserSuspenseQuery>;
export type GetInsurancePoliciesByUserQueryResult = Apollo.QueryResult<GetInsurancePoliciesByUserQuery, GetInsurancePoliciesByUserQueryVariables>;
export const GetInsuranceClaimsByAppointmentDocument = gql`
    query GetInsuranceClaimsByAppointment($appointmentId: ID!) {
  insuranceClaimResultsByAppointment(appointmentId: $appointmentId) {
    id
    policyId
    appointmentId
    status
    claimResultDetails {
      approved_amount
      rejected_amount
      rejected_reason
    }
    isActive
    createdAt
    updatedAt
    items {
      id
      insuranceClaimId
      name
      category
      amount
      approvedAmount
      transactionId
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetInsuranceClaimsByAppointmentQuery__
 *
 * To run a query within a React component, call `useGetInsuranceClaimsByAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceClaimsByAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceClaimsByAppointmentQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetInsuranceClaimsByAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetInsuranceClaimsByAppointmentQuery, GetInsuranceClaimsByAppointmentQueryVariables> & ({ variables: GetInsuranceClaimsByAppointmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsuranceClaimsByAppointmentQuery, GetInsuranceClaimsByAppointmentQueryVariables>(GetInsuranceClaimsByAppointmentDocument, options);
      }
export function useGetInsuranceClaimsByAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsuranceClaimsByAppointmentQuery, GetInsuranceClaimsByAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsuranceClaimsByAppointmentQuery, GetInsuranceClaimsByAppointmentQueryVariables>(GetInsuranceClaimsByAppointmentDocument, options);
        }
export function useGetInsuranceClaimsByAppointmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsuranceClaimsByAppointmentQuery, GetInsuranceClaimsByAppointmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsuranceClaimsByAppointmentQuery, GetInsuranceClaimsByAppointmentQueryVariables>(GetInsuranceClaimsByAppointmentDocument, options);
        }
export type GetInsuranceClaimsByAppointmentQueryHookResult = ReturnType<typeof useGetInsuranceClaimsByAppointmentQuery>;
export type GetInsuranceClaimsByAppointmentLazyQueryHookResult = ReturnType<typeof useGetInsuranceClaimsByAppointmentLazyQuery>;
export type GetInsuranceClaimsByAppointmentSuspenseQueryHookResult = ReturnType<typeof useGetInsuranceClaimsByAppointmentSuspenseQuery>;
export type GetInsuranceClaimsByAppointmentQueryResult = Apollo.QueryResult<GetInsuranceClaimsByAppointmentQuery, GetInsuranceClaimsByAppointmentQueryVariables>;
export const GetInsuranceClaimsByPolicyDocument = gql`
    query GetInsuranceClaimsByPolicy($policyId: ID!) {
  insuranceClaimResultsByPolicy(policyId: $policyId) {
    id
    policyId
    appointmentId
    status
    claimResultDetails {
      approved_amount
      rejected_amount
      rejected_reason
    }
    isActive
    createdAt
    updatedAt
    items {
      id
      insuranceClaimId
      name
      category
      amount
      approvedAmount
      transactionId
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetInsuranceClaimsByPolicyQuery__
 *
 * To run a query within a React component, call `useGetInsuranceClaimsByPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceClaimsByPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceClaimsByPolicyQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useGetInsuranceClaimsByPolicyQuery(baseOptions: Apollo.QueryHookOptions<GetInsuranceClaimsByPolicyQuery, GetInsuranceClaimsByPolicyQueryVariables> & ({ variables: GetInsuranceClaimsByPolicyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsuranceClaimsByPolicyQuery, GetInsuranceClaimsByPolicyQueryVariables>(GetInsuranceClaimsByPolicyDocument, options);
      }
export function useGetInsuranceClaimsByPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsuranceClaimsByPolicyQuery, GetInsuranceClaimsByPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsuranceClaimsByPolicyQuery, GetInsuranceClaimsByPolicyQueryVariables>(GetInsuranceClaimsByPolicyDocument, options);
        }
export function useGetInsuranceClaimsByPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsuranceClaimsByPolicyQuery, GetInsuranceClaimsByPolicyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsuranceClaimsByPolicyQuery, GetInsuranceClaimsByPolicyQueryVariables>(GetInsuranceClaimsByPolicyDocument, options);
        }
export type GetInsuranceClaimsByPolicyQueryHookResult = ReturnType<typeof useGetInsuranceClaimsByPolicyQuery>;
export type GetInsuranceClaimsByPolicyLazyQueryHookResult = ReturnType<typeof useGetInsuranceClaimsByPolicyLazyQuery>;
export type GetInsuranceClaimsByPolicySuspenseQueryHookResult = ReturnType<typeof useGetInsuranceClaimsByPolicySuspenseQuery>;
export type GetInsuranceClaimsByPolicyQueryResult = Apollo.QueryResult<GetInsuranceClaimsByPolicyQuery, GetInsuranceClaimsByPolicyQueryVariables>;
export const GetInsuranceClaimByIdDocument = gql`
    query GetInsuranceClaimById($id: ID!) {
  insuranceClaimResult(id: $id) {
    id
    policyId
    appointmentId
    status
    claimResultDetails {
      approved_amount
      rejected_amount
      rejected_reason
    }
    isActive
    createdAt
    updatedAt
    items {
      id
      insuranceClaimId
      name
      category
      amount
      approvedAmount
      transactionId
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetInsuranceClaimByIdQuery__
 *
 * To run a query within a React component, call `useGetInsuranceClaimByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceClaimByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceClaimByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInsuranceClaimByIdQuery(baseOptions: Apollo.QueryHookOptions<GetInsuranceClaimByIdQuery, GetInsuranceClaimByIdQueryVariables> & ({ variables: GetInsuranceClaimByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsuranceClaimByIdQuery, GetInsuranceClaimByIdQueryVariables>(GetInsuranceClaimByIdDocument, options);
      }
export function useGetInsuranceClaimByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsuranceClaimByIdQuery, GetInsuranceClaimByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsuranceClaimByIdQuery, GetInsuranceClaimByIdQueryVariables>(GetInsuranceClaimByIdDocument, options);
        }
export function useGetInsuranceClaimByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsuranceClaimByIdQuery, GetInsuranceClaimByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsuranceClaimByIdQuery, GetInsuranceClaimByIdQueryVariables>(GetInsuranceClaimByIdDocument, options);
        }
export type GetInsuranceClaimByIdQueryHookResult = ReturnType<typeof useGetInsuranceClaimByIdQuery>;
export type GetInsuranceClaimByIdLazyQueryHookResult = ReturnType<typeof useGetInsuranceClaimByIdLazyQuery>;
export type GetInsuranceClaimByIdSuspenseQueryHookResult = ReturnType<typeof useGetInsuranceClaimByIdSuspenseQuery>;
export type GetInsuranceClaimByIdQueryResult = Apollo.QueryResult<GetInsuranceClaimByIdQuery, GetInsuranceClaimByIdQueryVariables>;
export const CreateSfExpressOrderFromAppointmentDocument = gql`
    mutation CreateSfExpressOrderFromAppointment($input: CreateSfExpressOrderFromAppointmentDto!) {
  createSfExpressOrderFromAppointment(input: $input) {
    success
    errorCode
    errorMsg
    data {
      orderId
      trackingNumber
      waybillNo
    }
  }
}
    `;
export type CreateSfExpressOrderFromAppointmentMutationFn = Apollo.MutationFunction<CreateSfExpressOrderFromAppointmentMutation, CreateSfExpressOrderFromAppointmentMutationVariables>;

/**
 * __useCreateSfExpressOrderFromAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateSfExpressOrderFromAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSfExpressOrderFromAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSfExpressOrderFromAppointmentMutation, { data, loading, error }] = useCreateSfExpressOrderFromAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSfExpressOrderFromAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSfExpressOrderFromAppointmentMutation, CreateSfExpressOrderFromAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSfExpressOrderFromAppointmentMutation, CreateSfExpressOrderFromAppointmentMutationVariables>(CreateSfExpressOrderFromAppointmentDocument, options);
      }
export type CreateSfExpressOrderFromAppointmentMutationHookResult = ReturnType<typeof useCreateSfExpressOrderFromAppointmentMutation>;
export type CreateSfExpressOrderFromAppointmentMutationResult = Apollo.MutationResult<CreateSfExpressOrderFromAppointmentMutation>;
export type CreateSfExpressOrderFromAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateSfExpressOrderFromAppointmentMutation, CreateSfExpressOrderFromAppointmentMutationVariables>;
export const CreateJdExpressOrderFromAppointmentDocument = gql`
    mutation CreateJdExpressOrderFromAppointment($input: CreateJdExpressOrderFromAppointmentDto!) {
  createJdExpressOrderFromAppointment(input: $input) {
    success
    errorCode
    errorMsg
    data {
      orderId
      trackingNumber
      waybillNo
      estimatedDelivery
      freight
      insuranceFee
      totalFee
      originCode
      destCode
      remark
    }
  }
}
    `;
export type CreateJdExpressOrderFromAppointmentMutationFn = Apollo.MutationFunction<CreateJdExpressOrderFromAppointmentMutation, CreateJdExpressOrderFromAppointmentMutationVariables>;

/**
 * __useCreateJdExpressOrderFromAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateJdExpressOrderFromAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJdExpressOrderFromAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJdExpressOrderFromAppointmentMutation, { data, loading, error }] = useCreateJdExpressOrderFromAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJdExpressOrderFromAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateJdExpressOrderFromAppointmentMutation, CreateJdExpressOrderFromAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJdExpressOrderFromAppointmentMutation, CreateJdExpressOrderFromAppointmentMutationVariables>(CreateJdExpressOrderFromAppointmentDocument, options);
      }
export type CreateJdExpressOrderFromAppointmentMutationHookResult = ReturnType<typeof useCreateJdExpressOrderFromAppointmentMutation>;
export type CreateJdExpressOrderFromAppointmentMutationResult = Apollo.MutationResult<CreateJdExpressOrderFromAppointmentMutation>;
export type CreateJdExpressOrderFromAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateJdExpressOrderFromAppointmentMutation, CreateJdExpressOrderFromAppointmentMutationVariables>;